import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  bigint: { input: any; output: any; }
  blood_group_enum: { input: any; output: any; }
  bytea: { input: any; output: any; }
  citext: { input: any; output: any; }
  date: { input: any; output: any; }
  document_status_enum: { input: any; output: any; }
  document_type_enum: { input: any; output: any; }
  geography: { input: any; output: any; }
  geometry: { input: any; output: any; }
  jsonb: { input: any; output: any; }
  numeric: { input: any; output: any; }
  payment_status_enum: { input: any; output: any; }
  ride_event_type_enum: { input: any; output: any; }
  ride_status_enum: { input: any; output: any; }
  time: { input: any; output: any; }
  timestamp: { input: any; output: any; }
  timestamptz: { input: any; output: any; }
  uuid: { input: any; output: any; }
  vehicle_type_enum: { input: any; output: any; }
};

export type AcceptFreeOrderResponse = {
  __typename?: 'AcceptFreeOrderResponse';
  success: Scalars['Boolean']['output'];
};

export type AcceptFreeRideResponse = {
  __typename?: 'AcceptFreeRideResponse';
  error?: Maybe<Scalars['String']['output']>;
  ride_id?: Maybe<Scalars['uuid']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type CreateCandidatesAndNotifyResponse = {
  __typename?: 'CreateCandidatesAndNotifyResponse';
  error?: Maybe<Scalars['String']['output']>;
  notified?: Maybe<Scalars['Int']['output']>;
  ride_id?: Maybe<Scalars['uuid']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Boolean expression to compare columns of type "Float". All fields are combined with logical 'AND'. */
export type Float_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Float']['input']>;
  _gt?: InputMaybe<Scalars['Float']['input']>;
  _gte?: InputMaybe<Scalars['Float']['input']>;
  _in?: InputMaybe<Array<Scalars['Float']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Float']['input']>;
  _lte?: InputMaybe<Scalars['Float']['input']>;
  _neq?: InputMaybe<Scalars['Float']['input']>;
  _nin?: InputMaybe<Array<Scalars['Float']['input']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "account_deletion_request" */
export type Account_Deletion_Request = {
  __typename?: 'account_deletion_request';
  created_at: Scalars['timestamptz']['output'];
  driver_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  driver_profile?: Maybe<Drivers>;
  id: Scalars['uuid']['output'];
  profile_id?: Maybe<Scalars['uuid']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user_profile?: Maybe<User_Profiles>;
};

/** aggregated selection of "account_deletion_request" */
export type Account_Deletion_Request_Aggregate = {
  __typename?: 'account_deletion_request_aggregate';
  aggregate?: Maybe<Account_Deletion_Request_Aggregate_Fields>;
  nodes: Array<Account_Deletion_Request>;
};

/** aggregate fields of "account_deletion_request" */
export type Account_Deletion_Request_Aggregate_Fields = {
  __typename?: 'account_deletion_request_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Account_Deletion_Request_Max_Fields>;
  min?: Maybe<Account_Deletion_Request_Min_Fields>;
};


/** aggregate fields of "account_deletion_request" */
export type Account_Deletion_Request_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Account_Deletion_Request_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "account_deletion_request". All fields are combined with a logical 'AND'. */
export type Account_Deletion_Request_Bool_Exp = {
  _and?: InputMaybe<Array<Account_Deletion_Request_Bool_Exp>>;
  _not?: InputMaybe<Account_Deletion_Request_Bool_Exp>;
  _or?: InputMaybe<Array<Account_Deletion_Request_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  driver_id?: InputMaybe<Uuid_Comparison_Exp>;
  driver_profile?: InputMaybe<Drivers_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  profile_id?: InputMaybe<Uuid_Comparison_Exp>;
  reason?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_profile?: InputMaybe<User_Profiles_Bool_Exp>;
};

/** unique or primary key constraints on table "account_deletion_request" */
export enum Account_Deletion_Request_Constraint {
  /** unique or primary key constraint on columns "id" */
  AccountDeletionRequestPkey = 'account_deletion_request_pkey'
}

/** input type for inserting data into table "account_deletion_request" */
export type Account_Deletion_Request_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  driver_id?: InputMaybe<Scalars['uuid']['input']>;
  driver_profile?: InputMaybe<Drivers_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  profile_id?: InputMaybe<Scalars['uuid']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_profile?: InputMaybe<User_Profiles_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Account_Deletion_Request_Max_Fields = {
  __typename?: 'account_deletion_request_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  driver_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  profile_id?: Maybe<Scalars['uuid']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Account_Deletion_Request_Min_Fields = {
  __typename?: 'account_deletion_request_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  driver_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  profile_id?: Maybe<Scalars['uuid']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "account_deletion_request" */
export type Account_Deletion_Request_Mutation_Response = {
  __typename?: 'account_deletion_request_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Account_Deletion_Request>;
};

/** on_conflict condition type for table "account_deletion_request" */
export type Account_Deletion_Request_On_Conflict = {
  constraint: Account_Deletion_Request_Constraint;
  update_columns?: Array<Account_Deletion_Request_Update_Column>;
  where?: InputMaybe<Account_Deletion_Request_Bool_Exp>;
};

/** Ordering options when selecting data from "account_deletion_request". */
export type Account_Deletion_Request_Order_By = {
  created_at?: InputMaybe<Order_By>;
  driver_id?: InputMaybe<Order_By>;
  driver_profile?: InputMaybe<Drivers_Order_By>;
  id?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_profile?: InputMaybe<User_Profiles_Order_By>;
};

/** primary key columns input for table: account_deletion_request */
export type Account_Deletion_Request_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "account_deletion_request" */
export enum Account_Deletion_Request_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DriverId = 'driver_id',
  /** column name */
  Id = 'id',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  Reason = 'reason',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "account_deletion_request" */
export type Account_Deletion_Request_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  driver_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  profile_id?: InputMaybe<Scalars['uuid']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "account_deletion_request" */
export type Account_Deletion_Request_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Account_Deletion_Request_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Account_Deletion_Request_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  driver_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  profile_id?: InputMaybe<Scalars['uuid']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "account_deletion_request" */
export enum Account_Deletion_Request_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DriverId = 'driver_id',
  /** column name */
  Id = 'id',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  Reason = 'reason',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Account_Deletion_Request_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Account_Deletion_Request_Set_Input>;
  /** filter the rows which have to be updated */
  where: Account_Deletion_Request_Bool_Exp;
};

/** columns and relationships of "app_settings" */
export type App_Settings = {
  __typename?: 'app_settings';
  allowed_vehicle_type?: Maybe<Scalars['jsonb']['output']>;
  base_fare?: Maybe<Scalars['numeric']['output']>;
  created_at: Scalars['timestamptz']['output'];
  driver_last_seen_seconds: Scalars['Int']['output'];
  driver_search_radius: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  per_km_fare?: Maybe<Scalars['numeric']['output']>;
  ride_request_timeout_seconds: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
  verification_types?: Maybe<Scalars['jsonb']['output']>;
};


/** columns and relationships of "app_settings" */
export type App_SettingsAllowed_Vehicle_TypeArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "app_settings" */
export type App_SettingsVerification_TypesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "app_settings" */
export type App_Settings_Aggregate = {
  __typename?: 'app_settings_aggregate';
  aggregate?: Maybe<App_Settings_Aggregate_Fields>;
  nodes: Array<App_Settings>;
};

/** aggregate fields of "app_settings" */
export type App_Settings_Aggregate_Fields = {
  __typename?: 'app_settings_aggregate_fields';
  avg?: Maybe<App_Settings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<App_Settings_Max_Fields>;
  min?: Maybe<App_Settings_Min_Fields>;
  stddev?: Maybe<App_Settings_Stddev_Fields>;
  stddev_pop?: Maybe<App_Settings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<App_Settings_Stddev_Samp_Fields>;
  sum?: Maybe<App_Settings_Sum_Fields>;
  var_pop?: Maybe<App_Settings_Var_Pop_Fields>;
  var_samp?: Maybe<App_Settings_Var_Samp_Fields>;
  variance?: Maybe<App_Settings_Variance_Fields>;
};


/** aggregate fields of "app_settings" */
export type App_Settings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<App_Settings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type App_Settings_Append_Input = {
  allowed_vehicle_type?: InputMaybe<Scalars['jsonb']['input']>;
  verification_types?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type App_Settings_Avg_Fields = {
  __typename?: 'app_settings_avg_fields';
  base_fare?: Maybe<Scalars['Float']['output']>;
  driver_last_seen_seconds?: Maybe<Scalars['Float']['output']>;
  driver_search_radius?: Maybe<Scalars['Float']['output']>;
  per_km_fare?: Maybe<Scalars['Float']['output']>;
  ride_request_timeout_seconds?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "app_settings". All fields are combined with a logical 'AND'. */
export type App_Settings_Bool_Exp = {
  _and?: InputMaybe<Array<App_Settings_Bool_Exp>>;
  _not?: InputMaybe<App_Settings_Bool_Exp>;
  _or?: InputMaybe<Array<App_Settings_Bool_Exp>>;
  allowed_vehicle_type?: InputMaybe<Jsonb_Comparison_Exp>;
  base_fare?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  driver_last_seen_seconds?: InputMaybe<Int_Comparison_Exp>;
  driver_search_radius?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  per_km_fare?: InputMaybe<Numeric_Comparison_Exp>;
  ride_request_timeout_seconds?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  verification_types?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "app_settings" */
export enum App_Settings_Constraint {
  /** unique or primary key constraint on columns "id" */
  AppSettingsPkey = 'app_settings_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type App_Settings_Delete_At_Path_Input = {
  allowed_vehicle_type?: InputMaybe<Array<Scalars['String']['input']>>;
  verification_types?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type App_Settings_Delete_Elem_Input = {
  allowed_vehicle_type?: InputMaybe<Scalars['Int']['input']>;
  verification_types?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type App_Settings_Delete_Key_Input = {
  allowed_vehicle_type?: InputMaybe<Scalars['String']['input']>;
  verification_types?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "app_settings" */
export type App_Settings_Inc_Input = {
  base_fare?: InputMaybe<Scalars['numeric']['input']>;
  driver_last_seen_seconds?: InputMaybe<Scalars['Int']['input']>;
  driver_search_radius?: InputMaybe<Scalars['Int']['input']>;
  per_km_fare?: InputMaybe<Scalars['numeric']['input']>;
  ride_request_timeout_seconds?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "app_settings" */
export type App_Settings_Insert_Input = {
  allowed_vehicle_type?: InputMaybe<Scalars['jsonb']['input']>;
  base_fare?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  driver_last_seen_seconds?: InputMaybe<Scalars['Int']['input']>;
  driver_search_radius?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  per_km_fare?: InputMaybe<Scalars['numeric']['input']>;
  ride_request_timeout_seconds?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  verification_types?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type App_Settings_Max_Fields = {
  __typename?: 'app_settings_max_fields';
  base_fare?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  driver_last_seen_seconds?: Maybe<Scalars['Int']['output']>;
  driver_search_radius?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  per_km_fare?: Maybe<Scalars['numeric']['output']>;
  ride_request_timeout_seconds?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type App_Settings_Min_Fields = {
  __typename?: 'app_settings_min_fields';
  base_fare?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  driver_last_seen_seconds?: Maybe<Scalars['Int']['output']>;
  driver_search_radius?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  per_km_fare?: Maybe<Scalars['numeric']['output']>;
  ride_request_timeout_seconds?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "app_settings" */
export type App_Settings_Mutation_Response = {
  __typename?: 'app_settings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<App_Settings>;
};

/** on_conflict condition type for table "app_settings" */
export type App_Settings_On_Conflict = {
  constraint: App_Settings_Constraint;
  update_columns?: Array<App_Settings_Update_Column>;
  where?: InputMaybe<App_Settings_Bool_Exp>;
};

/** Ordering options when selecting data from "app_settings". */
export type App_Settings_Order_By = {
  allowed_vehicle_type?: InputMaybe<Order_By>;
  base_fare?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  driver_last_seen_seconds?: InputMaybe<Order_By>;
  driver_search_radius?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  per_km_fare?: InputMaybe<Order_By>;
  ride_request_timeout_seconds?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  verification_types?: InputMaybe<Order_By>;
};

/** primary key columns input for table: app_settings */
export type App_Settings_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type App_Settings_Prepend_Input = {
  allowed_vehicle_type?: InputMaybe<Scalars['jsonb']['input']>;
  verification_types?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "app_settings" */
export enum App_Settings_Select_Column {
  /** column name */
  AllowedVehicleType = 'allowed_vehicle_type',
  /** column name */
  BaseFare = 'base_fare',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DriverLastSeenSeconds = 'driver_last_seen_seconds',
  /** column name */
  DriverSearchRadius = 'driver_search_radius',
  /** column name */
  Id = 'id',
  /** column name */
  PerKmFare = 'per_km_fare',
  /** column name */
  RideRequestTimeoutSeconds = 'ride_request_timeout_seconds',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VerificationTypes = 'verification_types'
}

/** input type for updating data in table "app_settings" */
export type App_Settings_Set_Input = {
  allowed_vehicle_type?: InputMaybe<Scalars['jsonb']['input']>;
  base_fare?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  driver_last_seen_seconds?: InputMaybe<Scalars['Int']['input']>;
  driver_search_radius?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  per_km_fare?: InputMaybe<Scalars['numeric']['input']>;
  ride_request_timeout_seconds?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  verification_types?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate stddev on columns */
export type App_Settings_Stddev_Fields = {
  __typename?: 'app_settings_stddev_fields';
  base_fare?: Maybe<Scalars['Float']['output']>;
  driver_last_seen_seconds?: Maybe<Scalars['Float']['output']>;
  driver_search_radius?: Maybe<Scalars['Float']['output']>;
  per_km_fare?: Maybe<Scalars['Float']['output']>;
  ride_request_timeout_seconds?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type App_Settings_Stddev_Pop_Fields = {
  __typename?: 'app_settings_stddev_pop_fields';
  base_fare?: Maybe<Scalars['Float']['output']>;
  driver_last_seen_seconds?: Maybe<Scalars['Float']['output']>;
  driver_search_radius?: Maybe<Scalars['Float']['output']>;
  per_km_fare?: Maybe<Scalars['Float']['output']>;
  ride_request_timeout_seconds?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type App_Settings_Stddev_Samp_Fields = {
  __typename?: 'app_settings_stddev_samp_fields';
  base_fare?: Maybe<Scalars['Float']['output']>;
  driver_last_seen_seconds?: Maybe<Scalars['Float']['output']>;
  driver_search_radius?: Maybe<Scalars['Float']['output']>;
  per_km_fare?: Maybe<Scalars['Float']['output']>;
  ride_request_timeout_seconds?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "app_settings" */
export type App_Settings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: App_Settings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type App_Settings_Stream_Cursor_Value_Input = {
  allowed_vehicle_type?: InputMaybe<Scalars['jsonb']['input']>;
  base_fare?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  driver_last_seen_seconds?: InputMaybe<Scalars['Int']['input']>;
  driver_search_radius?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  per_km_fare?: InputMaybe<Scalars['numeric']['input']>;
  ride_request_timeout_seconds?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  verification_types?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate sum on columns */
export type App_Settings_Sum_Fields = {
  __typename?: 'app_settings_sum_fields';
  base_fare?: Maybe<Scalars['numeric']['output']>;
  driver_last_seen_seconds?: Maybe<Scalars['Int']['output']>;
  driver_search_radius?: Maybe<Scalars['Int']['output']>;
  per_km_fare?: Maybe<Scalars['numeric']['output']>;
  ride_request_timeout_seconds?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "app_settings" */
export enum App_Settings_Update_Column {
  /** column name */
  AllowedVehicleType = 'allowed_vehicle_type',
  /** column name */
  BaseFare = 'base_fare',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DriverLastSeenSeconds = 'driver_last_seen_seconds',
  /** column name */
  DriverSearchRadius = 'driver_search_radius',
  /** column name */
  Id = 'id',
  /** column name */
  PerKmFare = 'per_km_fare',
  /** column name */
  RideRequestTimeoutSeconds = 'ride_request_timeout_seconds',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VerificationTypes = 'verification_types'
}

export type App_Settings_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<App_Settings_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<App_Settings_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<App_Settings_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<App_Settings_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<App_Settings_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<App_Settings_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<App_Settings_Set_Input>;
  /** filter the rows which have to be updated */
  where: App_Settings_Bool_Exp;
};

/** aggregate var_pop on columns */
export type App_Settings_Var_Pop_Fields = {
  __typename?: 'app_settings_var_pop_fields';
  base_fare?: Maybe<Scalars['Float']['output']>;
  driver_last_seen_seconds?: Maybe<Scalars['Float']['output']>;
  driver_search_radius?: Maybe<Scalars['Float']['output']>;
  per_km_fare?: Maybe<Scalars['Float']['output']>;
  ride_request_timeout_seconds?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type App_Settings_Var_Samp_Fields = {
  __typename?: 'app_settings_var_samp_fields';
  base_fare?: Maybe<Scalars['Float']['output']>;
  driver_last_seen_seconds?: Maybe<Scalars['Float']['output']>;
  driver_search_radius?: Maybe<Scalars['Float']['output']>;
  per_km_fare?: Maybe<Scalars['Float']['output']>;
  ride_request_timeout_seconds?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type App_Settings_Variance_Fields = {
  __typename?: 'app_settings_variance_fields';
  base_fare?: Maybe<Scalars['Float']['output']>;
  driver_last_seen_seconds?: Maybe<Scalars['Float']['output']>;
  driver_search_radius?: Maybe<Scalars['Float']['output']>;
  per_km_fare?: Maybe<Scalars['Float']['output']>;
  ride_request_timeout_seconds?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "app_versions" */
export type App_Versions = {
  __typename?: 'app_versions';
  app_for: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  is_critical_update: Scalars['Boolean']['output'];
  latest_version: Scalars['String']['output'];
  min_version: Scalars['String']['output'];
  platform?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "app_versions" */
export type App_Versions_Aggregate = {
  __typename?: 'app_versions_aggregate';
  aggregate?: Maybe<App_Versions_Aggregate_Fields>;
  nodes: Array<App_Versions>;
};

/** aggregate fields of "app_versions" */
export type App_Versions_Aggregate_Fields = {
  __typename?: 'app_versions_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<App_Versions_Max_Fields>;
  min?: Maybe<App_Versions_Min_Fields>;
};


/** aggregate fields of "app_versions" */
export type App_Versions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<App_Versions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "app_versions". All fields are combined with a logical 'AND'. */
export type App_Versions_Bool_Exp = {
  _and?: InputMaybe<Array<App_Versions_Bool_Exp>>;
  _not?: InputMaybe<App_Versions_Bool_Exp>;
  _or?: InputMaybe<Array<App_Versions_Bool_Exp>>;
  app_for?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_critical_update?: InputMaybe<Boolean_Comparison_Exp>;
  latest_version?: InputMaybe<String_Comparison_Exp>;
  min_version?: InputMaybe<String_Comparison_Exp>;
  platform?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "app_versions" */
export enum App_Versions_Constraint {
  /** unique or primary key constraint on columns "id" */
  AppVersionsPkey = 'app_versions_pkey'
}

/** input type for inserting data into table "app_versions" */
export type App_Versions_Insert_Input = {
  app_for?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_critical_update?: InputMaybe<Scalars['Boolean']['input']>;
  latest_version?: InputMaybe<Scalars['String']['input']>;
  min_version?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type App_Versions_Max_Fields = {
  __typename?: 'app_versions_max_fields';
  app_for?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  latest_version?: Maybe<Scalars['String']['output']>;
  min_version?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type App_Versions_Min_Fields = {
  __typename?: 'app_versions_min_fields';
  app_for?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  latest_version?: Maybe<Scalars['String']['output']>;
  min_version?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "app_versions" */
export type App_Versions_Mutation_Response = {
  __typename?: 'app_versions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<App_Versions>;
};

/** on_conflict condition type for table "app_versions" */
export type App_Versions_On_Conflict = {
  constraint: App_Versions_Constraint;
  update_columns?: Array<App_Versions_Update_Column>;
  where?: InputMaybe<App_Versions_Bool_Exp>;
};

/** Ordering options when selecting data from "app_versions". */
export type App_Versions_Order_By = {
  app_for?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_critical_update?: InputMaybe<Order_By>;
  latest_version?: InputMaybe<Order_By>;
  min_version?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
};

/** primary key columns input for table: app_versions */
export type App_Versions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "app_versions" */
export enum App_Versions_Select_Column {
  /** column name */
  AppFor = 'app_for',
  /** column name */
  Id = 'id',
  /** column name */
  IsCriticalUpdate = 'is_critical_update',
  /** column name */
  LatestVersion = 'latest_version',
  /** column name */
  MinVersion = 'min_version',
  /** column name */
  Platform = 'platform'
}

/** input type for updating data in table "app_versions" */
export type App_Versions_Set_Input = {
  app_for?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_critical_update?: InputMaybe<Scalars['Boolean']['input']>;
  latest_version?: InputMaybe<Scalars['String']['input']>;
  min_version?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "app_versions" */
export type App_Versions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: App_Versions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type App_Versions_Stream_Cursor_Value_Input = {
  app_for?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_critical_update?: InputMaybe<Scalars['Boolean']['input']>;
  latest_version?: InputMaybe<Scalars['String']['input']>;
  min_version?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "app_versions" */
export enum App_Versions_Update_Column {
  /** column name */
  AppFor = 'app_for',
  /** column name */
  Id = 'id',
  /** column name */
  IsCriticalUpdate = 'is_critical_update',
  /** column name */
  LatestVersion = 'latest_version',
  /** column name */
  MinVersion = 'min_version',
  /** column name */
  Platform = 'platform'
}

export type App_Versions_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<App_Versions_Set_Input>;
  /** filter the rows which have to be updated */
  where: App_Versions_Bool_Exp;
};

/** columns and relationships of "assignment" */
export type Assignment = {
  __typename?: 'assignment';
  /** An object relationship */
  carrier?: Maybe<Carrier>;
  carrierId?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  isActive: Scalars['Boolean']['output'];
  /** An object relationship */
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['uuid']['output']>;
  status: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "assignment" */
export type Assignment_Aggregate = {
  __typename?: 'assignment_aggregate';
  aggregate?: Maybe<Assignment_Aggregate_Fields>;
  nodes: Array<Assignment>;
};

/** aggregate fields of "assignment" */
export type Assignment_Aggregate_Fields = {
  __typename?: 'assignment_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Assignment_Max_Fields>;
  min?: Maybe<Assignment_Min_Fields>;
};


/** aggregate fields of "assignment" */
export type Assignment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Assignment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "assignment". All fields are combined with a logical 'AND'. */
export type Assignment_Bool_Exp = {
  _and?: InputMaybe<Array<Assignment_Bool_Exp>>;
  _not?: InputMaybe<Assignment_Bool_Exp>;
  _or?: InputMaybe<Array<Assignment_Bool_Exp>>;
  carrier?: InputMaybe<Carrier_Bool_Exp>;
  carrierId?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isActive?: InputMaybe<Boolean_Comparison_Exp>;
  order?: InputMaybe<Order_Bool_Exp>;
  orderId?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "assignment" */
export enum Assignment_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssignmentPkey = 'assignment_pkey'
}

/** input type for inserting data into table "assignment" */
export type Assignment_Insert_Input = {
  carrier?: InputMaybe<Carrier_Obj_Rel_Insert_Input>;
  carrierId?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Order_Obj_Rel_Insert_Input>;
  orderId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Assignment_Max_Fields = {
  __typename?: 'assignment_max_fields';
  carrierId?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  orderId?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Assignment_Min_Fields = {
  __typename?: 'assignment_min_fields';
  carrierId?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  orderId?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "assignment" */
export type Assignment_Mutation_Response = {
  __typename?: 'assignment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Assignment>;
};

/** input type for inserting object relation for remote table "assignment" */
export type Assignment_Obj_Rel_Insert_Input = {
  data: Assignment_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Assignment_On_Conflict>;
};

/** on_conflict condition type for table "assignment" */
export type Assignment_On_Conflict = {
  constraint: Assignment_Constraint;
  update_columns?: Array<Assignment_Update_Column>;
  where?: InputMaybe<Assignment_Bool_Exp>;
};

/** Ordering options when selecting data from "assignment". */
export type Assignment_Order_By = {
  carrier?: InputMaybe<Carrier_Order_By>;
  carrierId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isActive?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_Order_By>;
  orderId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: assignment */
export type Assignment_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "assignment" */
export enum Assignment_Select_Column {
  /** column name */
  CarrierId = 'carrierId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  OrderId = 'orderId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "assignment" */
export type Assignment_Set_Input = {
  carrierId?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  orderId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "assignment" */
export type Assignment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Assignment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Assignment_Stream_Cursor_Value_Input = {
  carrierId?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  orderId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "assignment" */
export enum Assignment_Update_Column {
  /** column name */
  CarrierId = 'carrierId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  OrderId = 'orderId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Assignment_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Assignment_Set_Input>;
  /** filter the rows which have to be updated */
  where: Assignment_Bool_Exp;
};

/** Oauth requests, inserted before redirecting to the provider's site. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthProviderRequests = {
  __typename?: 'authProviderRequests';
  id: Scalars['uuid']['output'];
  options?: Maybe<Scalars['jsonb']['output']>;
};


/** Oauth requests, inserted before redirecting to the provider's site. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthProviderRequestsOptionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "auth.provider_requests" */
export type AuthProviderRequests_Aggregate = {
  __typename?: 'authProviderRequests_aggregate';
  aggregate?: Maybe<AuthProviderRequests_Aggregate_Fields>;
  nodes: Array<AuthProviderRequests>;
};

/** aggregate fields of "auth.provider_requests" */
export type AuthProviderRequests_Aggregate_Fields = {
  __typename?: 'authProviderRequests_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AuthProviderRequests_Max_Fields>;
  min?: Maybe<AuthProviderRequests_Min_Fields>;
};


/** aggregate fields of "auth.provider_requests" */
export type AuthProviderRequests_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthProviderRequests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AuthProviderRequests_Append_Input = {
  options?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "auth.provider_requests". All fields are combined with a logical 'AND'. */
export type AuthProviderRequests_Bool_Exp = {
  _and?: InputMaybe<Array<AuthProviderRequests_Bool_Exp>>;
  _not?: InputMaybe<AuthProviderRequests_Bool_Exp>;
  _or?: InputMaybe<Array<AuthProviderRequests_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  options?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.provider_requests" */
export enum AuthProviderRequests_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProviderRequestsPkey = 'provider_requests_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AuthProviderRequests_Delete_At_Path_Input = {
  options?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AuthProviderRequests_Delete_Elem_Input = {
  options?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AuthProviderRequests_Delete_Key_Input = {
  options?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "auth.provider_requests" */
export type AuthProviderRequests_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  options?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type AuthProviderRequests_Max_Fields = {
  __typename?: 'authProviderRequests_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type AuthProviderRequests_Min_Fields = {
  __typename?: 'authProviderRequests_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "auth.provider_requests" */
export type AuthProviderRequests_Mutation_Response = {
  __typename?: 'authProviderRequests_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthProviderRequests>;
};

/** on_conflict condition type for table "auth.provider_requests" */
export type AuthProviderRequests_On_Conflict = {
  constraint: AuthProviderRequests_Constraint;
  update_columns?: Array<AuthProviderRequests_Update_Column>;
  where?: InputMaybe<AuthProviderRequests_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.provider_requests". */
export type AuthProviderRequests_Order_By = {
  id?: InputMaybe<Order_By>;
  options?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.provider_requests */
export type AuthProviderRequests_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AuthProviderRequests_Prepend_Input = {
  options?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "auth.provider_requests" */
export enum AuthProviderRequests_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Options = 'options'
}

/** input type for updating data in table "auth.provider_requests" */
export type AuthProviderRequests_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  options?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "authProviderRequests" */
export type AuthProviderRequests_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthProviderRequests_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthProviderRequests_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  options?: InputMaybe<Scalars['jsonb']['input']>;
};

/** update columns of table "auth.provider_requests" */
export enum AuthProviderRequests_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Options = 'options'
}

export type AuthProviderRequests_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AuthProviderRequests_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AuthProviderRequests_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AuthProviderRequests_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AuthProviderRequests_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AuthProviderRequests_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthProviderRequests_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthProviderRequests_Bool_Exp;
};

/** List of available Oauth providers. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthProviders = {
  __typename?: 'authProviders';
  id: Scalars['String']['output'];
  /** An array relationship */
  userProviders: Array<AuthUserProviders>;
  /** An aggregate relationship */
  userProviders_aggregate: AuthUserProviders_Aggregate;
};


/** List of available Oauth providers. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthProvidersUserProvidersArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};


/** List of available Oauth providers. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthProvidersUserProviders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};

/** aggregated selection of "auth.providers" */
export type AuthProviders_Aggregate = {
  __typename?: 'authProviders_aggregate';
  aggregate?: Maybe<AuthProviders_Aggregate_Fields>;
  nodes: Array<AuthProviders>;
};

/** aggregate fields of "auth.providers" */
export type AuthProviders_Aggregate_Fields = {
  __typename?: 'authProviders_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AuthProviders_Max_Fields>;
  min?: Maybe<AuthProviders_Min_Fields>;
};


/** aggregate fields of "auth.providers" */
export type AuthProviders_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthProviders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "auth.providers". All fields are combined with a logical 'AND'. */
export type AuthProviders_Bool_Exp = {
  _and?: InputMaybe<Array<AuthProviders_Bool_Exp>>;
  _not?: InputMaybe<AuthProviders_Bool_Exp>;
  _or?: InputMaybe<Array<AuthProviders_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  userProviders?: InputMaybe<AuthUserProviders_Bool_Exp>;
  userProviders_aggregate?: InputMaybe<AuthUserProviders_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "auth.providers" */
export enum AuthProviders_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProvidersPkey = 'providers_pkey'
}

/** input type for inserting data into table "auth.providers" */
export type AuthProviders_Insert_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  userProviders?: InputMaybe<AuthUserProviders_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type AuthProviders_Max_Fields = {
  __typename?: 'authProviders_max_fields';
  id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type AuthProviders_Min_Fields = {
  __typename?: 'authProviders_min_fields';
  id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "auth.providers" */
export type AuthProviders_Mutation_Response = {
  __typename?: 'authProviders_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthProviders>;
};

/** input type for inserting object relation for remote table "auth.providers" */
export type AuthProviders_Obj_Rel_Insert_Input = {
  data: AuthProviders_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthProviders_On_Conflict>;
};

/** on_conflict condition type for table "auth.providers" */
export type AuthProviders_On_Conflict = {
  constraint: AuthProviders_Constraint;
  update_columns?: Array<AuthProviders_Update_Column>;
  where?: InputMaybe<AuthProviders_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.providers". */
export type AuthProviders_Order_By = {
  id?: InputMaybe<Order_By>;
  userProviders_aggregate?: InputMaybe<AuthUserProviders_Aggregate_Order_By>;
};

/** primary key columns input for table: auth.providers */
export type AuthProviders_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "auth.providers" */
export enum AuthProviders_Select_Column {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "auth.providers" */
export type AuthProviders_Set_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "authProviders" */
export type AuthProviders_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthProviders_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthProviders_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "auth.providers" */
export enum AuthProviders_Update_Column {
  /** column name */
  Id = 'id'
}

export type AuthProviders_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthProviders_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthProviders_Bool_Exp;
};

/** columns and relationships of "auth.refresh_token_types" */
export type AuthRefreshTokenTypes = {
  __typename?: 'authRefreshTokenTypes';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  refreshTokens: Array<AuthRefreshTokens>;
  /** An aggregate relationship */
  refreshTokens_aggregate: AuthRefreshTokens_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "auth.refresh_token_types" */
export type AuthRefreshTokenTypesRefreshTokensArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};


/** columns and relationships of "auth.refresh_token_types" */
export type AuthRefreshTokenTypesRefreshTokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};

/** aggregated selection of "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Aggregate = {
  __typename?: 'authRefreshTokenTypes_aggregate';
  aggregate?: Maybe<AuthRefreshTokenTypes_Aggregate_Fields>;
  nodes: Array<AuthRefreshTokenTypes>;
};

/** aggregate fields of "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Aggregate_Fields = {
  __typename?: 'authRefreshTokenTypes_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AuthRefreshTokenTypes_Max_Fields>;
  min?: Maybe<AuthRefreshTokenTypes_Min_Fields>;
};


/** aggregate fields of "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthRefreshTokenTypes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "auth.refresh_token_types". All fields are combined with a logical 'AND'. */
export type AuthRefreshTokenTypes_Bool_Exp = {
  _and?: InputMaybe<Array<AuthRefreshTokenTypes_Bool_Exp>>;
  _not?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>;
  _or?: InputMaybe<Array<AuthRefreshTokenTypes_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  refreshTokens?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
  refreshTokens_aggregate?: InputMaybe<AuthRefreshTokens_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.refresh_token_types" */
export enum AuthRefreshTokenTypes_Constraint {
  /** unique or primary key constraint on columns "value" */
  RefreshTokenTypesPkey = 'refresh_token_types_pkey'
}

export enum AuthRefreshTokenTypes_Enum {
  /** Personal access token */
  Pat = 'pat',
  /** Regular refresh token */
  Regular = 'regular'
}

/** Boolean expression to compare columns of type "authRefreshTokenTypes_enum". All fields are combined with logical 'AND'. */
export type AuthRefreshTokenTypes_Enum_Comparison_Exp = {
  _eq?: InputMaybe<AuthRefreshTokenTypes_Enum>;
  _in?: InputMaybe<Array<AuthRefreshTokenTypes_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<AuthRefreshTokenTypes_Enum>;
  _nin?: InputMaybe<Array<AuthRefreshTokenTypes_Enum>>;
};

/** input type for inserting data into table "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  refreshTokens?: InputMaybe<AuthRefreshTokens_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type AuthRefreshTokenTypes_Max_Fields = {
  __typename?: 'authRefreshTokenTypes_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type AuthRefreshTokenTypes_Min_Fields = {
  __typename?: 'authRefreshTokenTypes_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Mutation_Response = {
  __typename?: 'authRefreshTokenTypes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthRefreshTokenTypes>;
};

/** on_conflict condition type for table "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_On_Conflict = {
  constraint: AuthRefreshTokenTypes_Constraint;
  update_columns?: Array<AuthRefreshTokenTypes_Update_Column>;
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.refresh_token_types". */
export type AuthRefreshTokenTypes_Order_By = {
  comment?: InputMaybe<Order_By>;
  refreshTokens_aggregate?: InputMaybe<AuthRefreshTokens_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.refresh_token_types */
export type AuthRefreshTokenTypes_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "auth.refresh_token_types" */
export enum AuthRefreshTokenTypes_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "authRefreshTokenTypes" */
export type AuthRefreshTokenTypes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthRefreshTokenTypes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthRefreshTokenTypes_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "auth.refresh_token_types" */
export enum AuthRefreshTokenTypes_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type AuthRefreshTokenTypes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthRefreshTokenTypes_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthRefreshTokenTypes_Bool_Exp;
};

/** User refresh tokens. Hasura auth uses them to rotate new access tokens as long as the refresh token is not expired. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRefreshTokens = {
  __typename?: 'authRefreshTokens';
  createdAt: Scalars['timestamptz']['output'];
  expiresAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  metadata?: Maybe<Scalars['jsonb']['output']>;
  refreshTokenHash?: Maybe<Scalars['String']['output']>;
  type: AuthRefreshTokenTypes_Enum;
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};


/** User refresh tokens. Hasura auth uses them to rotate new access tokens as long as the refresh token is not expired. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRefreshTokensMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "auth.refresh_tokens" */
export type AuthRefreshTokens_Aggregate = {
  __typename?: 'authRefreshTokens_aggregate';
  aggregate?: Maybe<AuthRefreshTokens_Aggregate_Fields>;
  nodes: Array<AuthRefreshTokens>;
};

export type AuthRefreshTokens_Aggregate_Bool_Exp = {
  count?: InputMaybe<AuthRefreshTokens_Aggregate_Bool_Exp_Count>;
};

export type AuthRefreshTokens_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.refresh_tokens" */
export type AuthRefreshTokens_Aggregate_Fields = {
  __typename?: 'authRefreshTokens_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AuthRefreshTokens_Max_Fields>;
  min?: Maybe<AuthRefreshTokens_Min_Fields>;
};


/** aggregate fields of "auth.refresh_tokens" */
export type AuthRefreshTokens_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "auth.refresh_tokens" */
export type AuthRefreshTokens_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AuthRefreshTokens_Max_Order_By>;
  min?: InputMaybe<AuthRefreshTokens_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AuthRefreshTokens_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "auth.refresh_tokens" */
export type AuthRefreshTokens_Arr_Rel_Insert_Input = {
  data: Array<AuthRefreshTokens_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthRefreshTokens_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.refresh_tokens". All fields are combined with a logical 'AND'. */
export type AuthRefreshTokens_Bool_Exp = {
  _and?: InputMaybe<Array<AuthRefreshTokens_Bool_Exp>>;
  _not?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
  _or?: InputMaybe<Array<AuthRefreshTokens_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  expiresAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  refreshTokenHash?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<AuthRefreshTokenTypes_Enum_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.refresh_tokens" */
export enum AuthRefreshTokens_Constraint {
  /** unique or primary key constraint on columns "id" */
  RefreshTokensPkey = 'refresh_tokens_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AuthRefreshTokens_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AuthRefreshTokens_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AuthRefreshTokens_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "auth.refresh_tokens" */
export type AuthRefreshTokens_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  refreshTokenHash?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AuthRefreshTokenTypes_Enum>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type AuthRefreshTokens_Max_Fields = {
  __typename?: 'authRefreshTokens_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  expiresAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  refreshTokenHash?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "auth.refresh_tokens" */
export type AuthRefreshTokens_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  refreshTokenHash?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AuthRefreshTokens_Min_Fields = {
  __typename?: 'authRefreshTokens_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  expiresAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  refreshTokenHash?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "auth.refresh_tokens" */
export type AuthRefreshTokens_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  refreshTokenHash?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.refresh_tokens" */
export type AuthRefreshTokens_Mutation_Response = {
  __typename?: 'authRefreshTokens_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthRefreshTokens>;
};

/** on_conflict condition type for table "auth.refresh_tokens" */
export type AuthRefreshTokens_On_Conflict = {
  constraint: AuthRefreshTokens_Constraint;
  update_columns?: Array<AuthRefreshTokens_Update_Column>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.refresh_tokens". */
export type AuthRefreshTokens_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  refreshTokenHash?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.refresh_tokens */
export type AuthRefreshTokens_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AuthRefreshTokens_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "auth.refresh_tokens" */
export enum AuthRefreshTokens_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  RefreshTokenHash = 'refreshTokenHash',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "auth.refresh_tokens" */
export type AuthRefreshTokens_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  refreshTokenHash?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AuthRefreshTokenTypes_Enum>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "authRefreshTokens" */
export type AuthRefreshTokens_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthRefreshTokens_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthRefreshTokens_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  refreshTokenHash?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AuthRefreshTokenTypes_Enum>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "auth.refresh_tokens" */
export enum AuthRefreshTokens_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  RefreshTokenHash = 'refreshTokenHash',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'userId'
}

export type AuthRefreshTokens_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AuthRefreshTokens_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AuthRefreshTokens_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AuthRefreshTokens_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AuthRefreshTokens_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AuthRefreshTokens_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthRefreshTokens_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthRefreshTokens_Bool_Exp;
};

/** Persistent Hasura roles for users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRoles = {
  __typename?: 'authRoles';
  role: Scalars['String']['output'];
  /** An array relationship */
  userRoles: Array<AuthUserRoles>;
  /** An aggregate relationship */
  userRoles_aggregate: AuthUserRoles_Aggregate;
  /** An array relationship */
  usersByDefaultRole: Array<Users>;
  /** An aggregate relationship */
  usersByDefaultRole_aggregate: Users_Aggregate;
};


/** Persistent Hasura roles for users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRolesUserRolesArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


/** Persistent Hasura roles for users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRolesUserRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


/** Persistent Hasura roles for users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRolesUsersByDefaultRoleArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


/** Persistent Hasura roles for users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRolesUsersByDefaultRole_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** aggregated selection of "auth.roles" */
export type AuthRoles_Aggregate = {
  __typename?: 'authRoles_aggregate';
  aggregate?: Maybe<AuthRoles_Aggregate_Fields>;
  nodes: Array<AuthRoles>;
};

/** aggregate fields of "auth.roles" */
export type AuthRoles_Aggregate_Fields = {
  __typename?: 'authRoles_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AuthRoles_Max_Fields>;
  min?: Maybe<AuthRoles_Min_Fields>;
};


/** aggregate fields of "auth.roles" */
export type AuthRoles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthRoles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "auth.roles". All fields are combined with a logical 'AND'. */
export type AuthRoles_Bool_Exp = {
  _and?: InputMaybe<Array<AuthRoles_Bool_Exp>>;
  _not?: InputMaybe<AuthRoles_Bool_Exp>;
  _or?: InputMaybe<Array<AuthRoles_Bool_Exp>>;
  role?: InputMaybe<String_Comparison_Exp>;
  userRoles?: InputMaybe<AuthUserRoles_Bool_Exp>;
  userRoles_aggregate?: InputMaybe<AuthUserRoles_Aggregate_Bool_Exp>;
  usersByDefaultRole?: InputMaybe<Users_Bool_Exp>;
  usersByDefaultRole_aggregate?: InputMaybe<Users_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "auth.roles" */
export enum AuthRoles_Constraint {
  /** unique or primary key constraint on columns "role" */
  RolesPkey = 'roles_pkey'
}

/** input type for inserting data into table "auth.roles" */
export type AuthRoles_Insert_Input = {
  role?: InputMaybe<Scalars['String']['input']>;
  userRoles?: InputMaybe<AuthUserRoles_Arr_Rel_Insert_Input>;
  usersByDefaultRole?: InputMaybe<Users_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type AuthRoles_Max_Fields = {
  __typename?: 'authRoles_max_fields';
  role?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type AuthRoles_Min_Fields = {
  __typename?: 'authRoles_min_fields';
  role?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "auth.roles" */
export type AuthRoles_Mutation_Response = {
  __typename?: 'authRoles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthRoles>;
};

/** input type for inserting object relation for remote table "auth.roles" */
export type AuthRoles_Obj_Rel_Insert_Input = {
  data: AuthRoles_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthRoles_On_Conflict>;
};

/** on_conflict condition type for table "auth.roles" */
export type AuthRoles_On_Conflict = {
  constraint: AuthRoles_Constraint;
  update_columns?: Array<AuthRoles_Update_Column>;
  where?: InputMaybe<AuthRoles_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.roles". */
export type AuthRoles_Order_By = {
  role?: InputMaybe<Order_By>;
  userRoles_aggregate?: InputMaybe<AuthUserRoles_Aggregate_Order_By>;
  usersByDefaultRole_aggregate?: InputMaybe<Users_Aggregate_Order_By>;
};

/** primary key columns input for table: auth.roles */
export type AuthRoles_Pk_Columns_Input = {
  role: Scalars['String']['input'];
};

/** select columns of table "auth.roles" */
export enum AuthRoles_Select_Column {
  /** column name */
  Role = 'role'
}

/** input type for updating data in table "auth.roles" */
export type AuthRoles_Set_Input = {
  role?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "authRoles" */
export type AuthRoles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthRoles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthRoles_Stream_Cursor_Value_Input = {
  role?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "auth.roles" */
export enum AuthRoles_Update_Column {
  /** column name */
  Role = 'role'
}

export type AuthRoles_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthRoles_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthRoles_Bool_Exp;
};

/** Active providers for a given user. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthUserProviders = {
  __typename?: 'authUserProviders';
  accessToken: Scalars['String']['output'];
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  provider: AuthProviders;
  providerId: Scalars['String']['output'];
  providerUserId: Scalars['String']['output'];
  refreshToken?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "auth.user_providers" */
export type AuthUserProviders_Aggregate = {
  __typename?: 'authUserProviders_aggregate';
  aggregate?: Maybe<AuthUserProviders_Aggregate_Fields>;
  nodes: Array<AuthUserProviders>;
};

export type AuthUserProviders_Aggregate_Bool_Exp = {
  count?: InputMaybe<AuthUserProviders_Aggregate_Bool_Exp_Count>;
};

export type AuthUserProviders_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AuthUserProviders_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.user_providers" */
export type AuthUserProviders_Aggregate_Fields = {
  __typename?: 'authUserProviders_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AuthUserProviders_Max_Fields>;
  min?: Maybe<AuthUserProviders_Min_Fields>;
};


/** aggregate fields of "auth.user_providers" */
export type AuthUserProviders_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "auth.user_providers" */
export type AuthUserProviders_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AuthUserProviders_Max_Order_By>;
  min?: InputMaybe<AuthUserProviders_Min_Order_By>;
};

/** input type for inserting array relation for remote table "auth.user_providers" */
export type AuthUserProviders_Arr_Rel_Insert_Input = {
  data: Array<AuthUserProviders_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthUserProviders_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.user_providers". All fields are combined with a logical 'AND'. */
export type AuthUserProviders_Bool_Exp = {
  _and?: InputMaybe<Array<AuthUserProviders_Bool_Exp>>;
  _not?: InputMaybe<AuthUserProviders_Bool_Exp>;
  _or?: InputMaybe<Array<AuthUserProviders_Bool_Exp>>;
  accessToken?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  provider?: InputMaybe<AuthProviders_Bool_Exp>;
  providerId?: InputMaybe<String_Comparison_Exp>;
  providerUserId?: InputMaybe<String_Comparison_Exp>;
  refreshToken?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.user_providers" */
export enum AuthUserProviders_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserProvidersPkey = 'user_providers_pkey',
  /** unique or primary key constraint on columns "provider_user_id", "provider_id" */
  UserProvidersProviderIdProviderUserIdKey = 'user_providers_provider_id_provider_user_id_key'
}

/** input type for inserting data into table "auth.user_providers" */
export type AuthUserProviders_Insert_Input = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  provider?: InputMaybe<AuthProviders_Obj_Rel_Insert_Input>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerUserId?: InputMaybe<Scalars['String']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type AuthUserProviders_Max_Fields = {
  __typename?: 'authUserProviders_max_fields';
  accessToken?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  providerUserId?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "auth.user_providers" */
export type AuthUserProviders_Max_Order_By = {
  accessToken?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  providerId?: InputMaybe<Order_By>;
  providerUserId?: InputMaybe<Order_By>;
  refreshToken?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AuthUserProviders_Min_Fields = {
  __typename?: 'authUserProviders_min_fields';
  accessToken?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  providerUserId?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "auth.user_providers" */
export type AuthUserProviders_Min_Order_By = {
  accessToken?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  providerId?: InputMaybe<Order_By>;
  providerUserId?: InputMaybe<Order_By>;
  refreshToken?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.user_providers" */
export type AuthUserProviders_Mutation_Response = {
  __typename?: 'authUserProviders_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthUserProviders>;
};

/** on_conflict condition type for table "auth.user_providers" */
export type AuthUserProviders_On_Conflict = {
  constraint: AuthUserProviders_Constraint;
  update_columns?: Array<AuthUserProviders_Update_Column>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.user_providers". */
export type AuthUserProviders_Order_By = {
  accessToken?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provider?: InputMaybe<AuthProviders_Order_By>;
  providerId?: InputMaybe<Order_By>;
  providerUserId?: InputMaybe<Order_By>;
  refreshToken?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.user_providers */
export type AuthUserProviders_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "auth.user_providers" */
export enum AuthUserProviders_Select_Column {
  /** column name */
  AccessToken = 'accessToken',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  ProviderUserId = 'providerUserId',
  /** column name */
  RefreshToken = 'refreshToken',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "auth.user_providers" */
export type AuthUserProviders_Set_Input = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerUserId?: InputMaybe<Scalars['String']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "authUserProviders" */
export type AuthUserProviders_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthUserProviders_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthUserProviders_Stream_Cursor_Value_Input = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerUserId?: InputMaybe<Scalars['String']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "auth.user_providers" */
export enum AuthUserProviders_Update_Column {
  /** column name */
  AccessToken = 'accessToken',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  ProviderUserId = 'providerUserId',
  /** column name */
  RefreshToken = 'refreshToken',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type AuthUserProviders_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthUserProviders_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthUserProviders_Bool_Exp;
};

/** Roles of users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthUserRoles = {
  __typename?: 'authUserRoles';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  role: Scalars['String']['output'];
  /** An object relationship */
  roleByRole: AuthRoles;
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "auth.user_roles" */
export type AuthUserRoles_Aggregate = {
  __typename?: 'authUserRoles_aggregate';
  aggregate?: Maybe<AuthUserRoles_Aggregate_Fields>;
  nodes: Array<AuthUserRoles>;
};

export type AuthUserRoles_Aggregate_Bool_Exp = {
  count?: InputMaybe<AuthUserRoles_Aggregate_Bool_Exp_Count>;
};

export type AuthUserRoles_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AuthUserRoles_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.user_roles" */
export type AuthUserRoles_Aggregate_Fields = {
  __typename?: 'authUserRoles_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AuthUserRoles_Max_Fields>;
  min?: Maybe<AuthUserRoles_Min_Fields>;
};


/** aggregate fields of "auth.user_roles" */
export type AuthUserRoles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "auth.user_roles" */
export type AuthUserRoles_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AuthUserRoles_Max_Order_By>;
  min?: InputMaybe<AuthUserRoles_Min_Order_By>;
};

/** input type for inserting array relation for remote table "auth.user_roles" */
export type AuthUserRoles_Arr_Rel_Insert_Input = {
  data: Array<AuthUserRoles_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthUserRoles_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.user_roles". All fields are combined with a logical 'AND'. */
export type AuthUserRoles_Bool_Exp = {
  _and?: InputMaybe<Array<AuthUserRoles_Bool_Exp>>;
  _not?: InputMaybe<AuthUserRoles_Bool_Exp>;
  _or?: InputMaybe<Array<AuthUserRoles_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  roleByRole?: InputMaybe<AuthRoles_Bool_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.user_roles" */
export enum AuthUserRoles_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserRolesPkey = 'user_roles_pkey',
  /** unique or primary key constraint on columns "user_id", "role" */
  UserRolesUserIdRoleKey = 'user_roles_user_id_role_key'
}

/** input type for inserting data into table "auth.user_roles" */
export type AuthUserRoles_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  roleByRole?: InputMaybe<AuthRoles_Obj_Rel_Insert_Input>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type AuthUserRoles_Max_Fields = {
  __typename?: 'authUserRoles_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "auth.user_roles" */
export type AuthUserRoles_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AuthUserRoles_Min_Fields = {
  __typename?: 'authUserRoles_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "auth.user_roles" */
export type AuthUserRoles_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.user_roles" */
export type AuthUserRoles_Mutation_Response = {
  __typename?: 'authUserRoles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthUserRoles>;
};

/** on_conflict condition type for table "auth.user_roles" */
export type AuthUserRoles_On_Conflict = {
  constraint: AuthUserRoles_Constraint;
  update_columns?: Array<AuthUserRoles_Update_Column>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.user_roles". */
export type AuthUserRoles_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  roleByRole?: InputMaybe<AuthRoles_Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.user_roles */
export type AuthUserRoles_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "auth.user_roles" */
export enum AuthUserRoles_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Role = 'role',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "auth.user_roles" */
export type AuthUserRoles_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "authUserRoles" */
export type AuthUserRoles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthUserRoles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthUserRoles_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "auth.user_roles" */
export enum AuthUserRoles_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Role = 'role',
  /** column name */
  UserId = 'userId'
}

export type AuthUserRoles_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthUserRoles_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthUserRoles_Bool_Exp;
};

/** User webauthn security keys. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthUserSecurityKeys = {
  __typename?: 'authUserSecurityKeys';
  counter: Scalars['bigint']['output'];
  credentialId: Scalars['String']['output'];
  credentialPublicKey?: Maybe<Scalars['bytea']['output']>;
  id: Scalars['uuid']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
  transports: Scalars['String']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "auth.user_security_keys" */
export type AuthUserSecurityKeys_Aggregate = {
  __typename?: 'authUserSecurityKeys_aggregate';
  aggregate?: Maybe<AuthUserSecurityKeys_Aggregate_Fields>;
  nodes: Array<AuthUserSecurityKeys>;
};

export type AuthUserSecurityKeys_Aggregate_Bool_Exp = {
  count?: InputMaybe<AuthUserSecurityKeys_Aggregate_Bool_Exp_Count>;
};

export type AuthUserSecurityKeys_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.user_security_keys" */
export type AuthUserSecurityKeys_Aggregate_Fields = {
  __typename?: 'authUserSecurityKeys_aggregate_fields';
  avg?: Maybe<AuthUserSecurityKeys_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<AuthUserSecurityKeys_Max_Fields>;
  min?: Maybe<AuthUserSecurityKeys_Min_Fields>;
  stddev?: Maybe<AuthUserSecurityKeys_Stddev_Fields>;
  stddev_pop?: Maybe<AuthUserSecurityKeys_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AuthUserSecurityKeys_Stddev_Samp_Fields>;
  sum?: Maybe<AuthUserSecurityKeys_Sum_Fields>;
  var_pop?: Maybe<AuthUserSecurityKeys_Var_Pop_Fields>;
  var_samp?: Maybe<AuthUserSecurityKeys_Var_Samp_Fields>;
  variance?: Maybe<AuthUserSecurityKeys_Variance_Fields>;
};


/** aggregate fields of "auth.user_security_keys" */
export type AuthUserSecurityKeys_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Aggregate_Order_By = {
  avg?: InputMaybe<AuthUserSecurityKeys_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AuthUserSecurityKeys_Max_Order_By>;
  min?: InputMaybe<AuthUserSecurityKeys_Min_Order_By>;
  stddev?: InputMaybe<AuthUserSecurityKeys_Stddev_Order_By>;
  stddev_pop?: InputMaybe<AuthUserSecurityKeys_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<AuthUserSecurityKeys_Stddev_Samp_Order_By>;
  sum?: InputMaybe<AuthUserSecurityKeys_Sum_Order_By>;
  var_pop?: InputMaybe<AuthUserSecurityKeys_Var_Pop_Order_By>;
  var_samp?: InputMaybe<AuthUserSecurityKeys_Var_Samp_Order_By>;
  variance?: InputMaybe<AuthUserSecurityKeys_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Arr_Rel_Insert_Input = {
  data: Array<AuthUserSecurityKeys_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthUserSecurityKeys_On_Conflict>;
};

/** aggregate avg on columns */
export type AuthUserSecurityKeys_Avg_Fields = {
  __typename?: 'authUserSecurityKeys_avg_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Avg_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "auth.user_security_keys". All fields are combined with a logical 'AND'. */
export type AuthUserSecurityKeys_Bool_Exp = {
  _and?: InputMaybe<Array<AuthUserSecurityKeys_Bool_Exp>>;
  _not?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
  _or?: InputMaybe<Array<AuthUserSecurityKeys_Bool_Exp>>;
  counter?: InputMaybe<Bigint_Comparison_Exp>;
  credentialId?: InputMaybe<String_Comparison_Exp>;
  credentialPublicKey?: InputMaybe<Bytea_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  nickname?: InputMaybe<String_Comparison_Exp>;
  transports?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.user_security_keys" */
export enum AuthUserSecurityKeys_Constraint {
  /** unique or primary key constraint on columns "credential_id" */
  UserSecurityKeyCredentialIdKey = 'user_security_key_credential_id_key',
  /** unique or primary key constraint on columns "id" */
  UserSecurityKeysPkey = 'user_security_keys_pkey'
}

/** input type for incrementing numeric columns in table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Inc_Input = {
  counter?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Insert_Input = {
  counter?: InputMaybe<Scalars['bigint']['input']>;
  credentialId?: InputMaybe<Scalars['String']['input']>;
  credentialPublicKey?: InputMaybe<Scalars['bytea']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  transports?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type AuthUserSecurityKeys_Max_Fields = {
  __typename?: 'authUserSecurityKeys_max_fields';
  counter?: Maybe<Scalars['bigint']['output']>;
  credentialId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  transports?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Max_Order_By = {
  counter?: InputMaybe<Order_By>;
  credentialId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nickname?: InputMaybe<Order_By>;
  transports?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AuthUserSecurityKeys_Min_Fields = {
  __typename?: 'authUserSecurityKeys_min_fields';
  counter?: Maybe<Scalars['bigint']['output']>;
  credentialId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  transports?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Min_Order_By = {
  counter?: InputMaybe<Order_By>;
  credentialId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nickname?: InputMaybe<Order_By>;
  transports?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Mutation_Response = {
  __typename?: 'authUserSecurityKeys_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthUserSecurityKeys>;
};

/** on_conflict condition type for table "auth.user_security_keys" */
export type AuthUserSecurityKeys_On_Conflict = {
  constraint: AuthUserSecurityKeys_Constraint;
  update_columns?: Array<AuthUserSecurityKeys_Update_Column>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.user_security_keys". */
export type AuthUserSecurityKeys_Order_By = {
  counter?: InputMaybe<Order_By>;
  credentialId?: InputMaybe<Order_By>;
  credentialPublicKey?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nickname?: InputMaybe<Order_By>;
  transports?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.user_security_keys */
export type AuthUserSecurityKeys_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "auth.user_security_keys" */
export enum AuthUserSecurityKeys_Select_Column {
  /** column name */
  Counter = 'counter',
  /** column name */
  CredentialId = 'credentialId',
  /** column name */
  CredentialPublicKey = 'credentialPublicKey',
  /** column name */
  Id = 'id',
  /** column name */
  Nickname = 'nickname',
  /** column name */
  Transports = 'transports',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Set_Input = {
  counter?: InputMaybe<Scalars['bigint']['input']>;
  credentialId?: InputMaybe<Scalars['String']['input']>;
  credentialPublicKey?: InputMaybe<Scalars['bytea']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  transports?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type AuthUserSecurityKeys_Stddev_Fields = {
  __typename?: 'authUserSecurityKeys_stddev_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Stddev_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type AuthUserSecurityKeys_Stddev_Pop_Fields = {
  __typename?: 'authUserSecurityKeys_stddev_pop_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Stddev_Pop_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type AuthUserSecurityKeys_Stddev_Samp_Fields = {
  __typename?: 'authUserSecurityKeys_stddev_samp_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Stddev_Samp_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "authUserSecurityKeys" */
export type AuthUserSecurityKeys_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthUserSecurityKeys_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthUserSecurityKeys_Stream_Cursor_Value_Input = {
  counter?: InputMaybe<Scalars['bigint']['input']>;
  credentialId?: InputMaybe<Scalars['String']['input']>;
  credentialPublicKey?: InputMaybe<Scalars['bytea']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  transports?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type AuthUserSecurityKeys_Sum_Fields = {
  __typename?: 'authUserSecurityKeys_sum_fields';
  counter?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Sum_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** update columns of table "auth.user_security_keys" */
export enum AuthUserSecurityKeys_Update_Column {
  /** column name */
  Counter = 'counter',
  /** column name */
  CredentialId = 'credentialId',
  /** column name */
  CredentialPublicKey = 'credentialPublicKey',
  /** column name */
  Id = 'id',
  /** column name */
  Nickname = 'nickname',
  /** column name */
  Transports = 'transports',
  /** column name */
  UserId = 'userId'
}

export type AuthUserSecurityKeys_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AuthUserSecurityKeys_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthUserSecurityKeys_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthUserSecurityKeys_Bool_Exp;
};

/** aggregate var_pop on columns */
export type AuthUserSecurityKeys_Var_Pop_Fields = {
  __typename?: 'authUserSecurityKeys_var_pop_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Var_Pop_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type AuthUserSecurityKeys_Var_Samp_Fields = {
  __typename?: 'authUserSecurityKeys_var_samp_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Var_Samp_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type AuthUserSecurityKeys_Variance_Fields = {
  __typename?: 'authUserSecurityKeys_variance_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Variance_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** columns and relationships of "basket" */
export type Basket = {
  __typename?: 'basket';
  /** An array relationship */
  basket_dishes: Array<Basket_Dish>;
  /** An aggregate relationship */
  basket_dishes_aggregate: Basket_Dish_Aggregate;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  isActive: Scalars['Boolean']['output'];
  /** An object relationship */
  receiver?: Maybe<User_Profiles>;
  /** An object relationship */
  restaurant: Restaurant;
  restaurantId: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  userId: Scalars['uuid']['output'];
};


/** columns and relationships of "basket" */
export type BasketBasket_DishesArgs = {
  distinct_on?: InputMaybe<Array<Basket_Dish_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Basket_Dish_Order_By>>;
  where?: InputMaybe<Basket_Dish_Bool_Exp>;
};


/** columns and relationships of "basket" */
export type BasketBasket_Dishes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Basket_Dish_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Basket_Dish_Order_By>>;
  where?: InputMaybe<Basket_Dish_Bool_Exp>;
};

/** aggregated selection of "basket" */
export type Basket_Aggregate = {
  __typename?: 'basket_aggregate';
  aggregate?: Maybe<Basket_Aggregate_Fields>;
  nodes: Array<Basket>;
};

export type Basket_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Basket_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Basket_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Basket_Aggregate_Bool_Exp_Count>;
};

export type Basket_Aggregate_Bool_Exp_Bool_And = {
  arguments: Basket_Select_Column_Basket_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Basket_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Basket_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Basket_Select_Column_Basket_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Basket_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Basket_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Basket_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Basket_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "basket" */
export type Basket_Aggregate_Fields = {
  __typename?: 'basket_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Basket_Max_Fields>;
  min?: Maybe<Basket_Min_Fields>;
};


/** aggregate fields of "basket" */
export type Basket_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Basket_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "basket" */
export type Basket_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Basket_Max_Order_By>;
  min?: InputMaybe<Basket_Min_Order_By>;
};

/** input type for inserting array relation for remote table "basket" */
export type Basket_Arr_Rel_Insert_Input = {
  data: Array<Basket_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Basket_On_Conflict>;
};

/** Boolean expression to filter rows from the table "basket". All fields are combined with a logical 'AND'. */
export type Basket_Bool_Exp = {
  _and?: InputMaybe<Array<Basket_Bool_Exp>>;
  _not?: InputMaybe<Basket_Bool_Exp>;
  _or?: InputMaybe<Array<Basket_Bool_Exp>>;
  basket_dishes?: InputMaybe<Basket_Dish_Bool_Exp>;
  basket_dishes_aggregate?: InputMaybe<Basket_Dish_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isActive?: InputMaybe<Boolean_Comparison_Exp>;
  receiver?: InputMaybe<User_Profiles_Bool_Exp>;
  restaurant?: InputMaybe<Restaurant_Bool_Exp>;
  restaurantId?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "basket" */
export enum Basket_Constraint {
  /** unique or primary key constraint on columns "id" */
  BasketPkey = 'basket_pkey'
}

/** columns and relationships of "basket_dish" */
export type Basket_Dish = {
  __typename?: 'basket_dish';
  basketId: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  dish: Dish;
  dishId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  quantity: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "basket_dish" */
export type Basket_Dish_Aggregate = {
  __typename?: 'basket_dish_aggregate';
  aggregate?: Maybe<Basket_Dish_Aggregate_Fields>;
  nodes: Array<Basket_Dish>;
};

export type Basket_Dish_Aggregate_Bool_Exp = {
  count?: InputMaybe<Basket_Dish_Aggregate_Bool_Exp_Count>;
};

export type Basket_Dish_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Basket_Dish_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Basket_Dish_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "basket_dish" */
export type Basket_Dish_Aggregate_Fields = {
  __typename?: 'basket_dish_aggregate_fields';
  avg?: Maybe<Basket_Dish_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Basket_Dish_Max_Fields>;
  min?: Maybe<Basket_Dish_Min_Fields>;
  stddev?: Maybe<Basket_Dish_Stddev_Fields>;
  stddev_pop?: Maybe<Basket_Dish_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Basket_Dish_Stddev_Samp_Fields>;
  sum?: Maybe<Basket_Dish_Sum_Fields>;
  var_pop?: Maybe<Basket_Dish_Var_Pop_Fields>;
  var_samp?: Maybe<Basket_Dish_Var_Samp_Fields>;
  variance?: Maybe<Basket_Dish_Variance_Fields>;
};


/** aggregate fields of "basket_dish" */
export type Basket_Dish_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Basket_Dish_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "basket_dish" */
export type Basket_Dish_Aggregate_Order_By = {
  avg?: InputMaybe<Basket_Dish_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Basket_Dish_Max_Order_By>;
  min?: InputMaybe<Basket_Dish_Min_Order_By>;
  stddev?: InputMaybe<Basket_Dish_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Basket_Dish_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Basket_Dish_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Basket_Dish_Sum_Order_By>;
  var_pop?: InputMaybe<Basket_Dish_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Basket_Dish_Var_Samp_Order_By>;
  variance?: InputMaybe<Basket_Dish_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "basket_dish" */
export type Basket_Dish_Arr_Rel_Insert_Input = {
  data: Array<Basket_Dish_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Basket_Dish_On_Conflict>;
};

/** aggregate avg on columns */
export type Basket_Dish_Avg_Fields = {
  __typename?: 'basket_dish_avg_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "basket_dish" */
export type Basket_Dish_Avg_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "basket_dish". All fields are combined with a logical 'AND'. */
export type Basket_Dish_Bool_Exp = {
  _and?: InputMaybe<Array<Basket_Dish_Bool_Exp>>;
  _not?: InputMaybe<Basket_Dish_Bool_Exp>;
  _or?: InputMaybe<Array<Basket_Dish_Bool_Exp>>;
  basketId?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  dish?: InputMaybe<Dish_Bool_Exp>;
  dishId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  quantity?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "basket_dish" */
export enum Basket_Dish_Constraint {
  /** unique or primary key constraint on columns "id" */
  BasketDishPkey = 'basket_dish_pkey'
}

/** input type for incrementing numeric columns in table "basket_dish" */
export type Basket_Dish_Inc_Input = {
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "basket_dish" */
export type Basket_Dish_Insert_Input = {
  basketId?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dish?: InputMaybe<Dish_Obj_Rel_Insert_Input>;
  dishId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Basket_Dish_Max_Fields = {
  __typename?: 'basket_dish_max_fields';
  basketId?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  dishId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "basket_dish" */
export type Basket_Dish_Max_Order_By = {
  basketId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dishId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Basket_Dish_Min_Fields = {
  __typename?: 'basket_dish_min_fields';
  basketId?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  dishId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "basket_dish" */
export type Basket_Dish_Min_Order_By = {
  basketId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dishId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "basket_dish" */
export type Basket_Dish_Mutation_Response = {
  __typename?: 'basket_dish_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Basket_Dish>;
};

/** on_conflict condition type for table "basket_dish" */
export type Basket_Dish_On_Conflict = {
  constraint: Basket_Dish_Constraint;
  update_columns?: Array<Basket_Dish_Update_Column>;
  where?: InputMaybe<Basket_Dish_Bool_Exp>;
};

/** Ordering options when selecting data from "basket_dish". */
export type Basket_Dish_Order_By = {
  basketId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dish?: InputMaybe<Dish_Order_By>;
  dishId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: basket_dish */
export type Basket_Dish_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "basket_dish" */
export enum Basket_Dish_Select_Column {
  /** column name */
  BasketId = 'basketId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DishId = 'dishId',
  /** column name */
  Id = 'id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "basket_dish" */
export type Basket_Dish_Set_Input = {
  basketId?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dishId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Basket_Dish_Stddev_Fields = {
  __typename?: 'basket_dish_stddev_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "basket_dish" */
export type Basket_Dish_Stddev_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Basket_Dish_Stddev_Pop_Fields = {
  __typename?: 'basket_dish_stddev_pop_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "basket_dish" */
export type Basket_Dish_Stddev_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Basket_Dish_Stddev_Samp_Fields = {
  __typename?: 'basket_dish_stddev_samp_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "basket_dish" */
export type Basket_Dish_Stddev_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "basket_dish" */
export type Basket_Dish_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Basket_Dish_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Basket_Dish_Stream_Cursor_Value_Input = {
  basketId?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dishId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Basket_Dish_Sum_Fields = {
  __typename?: 'basket_dish_sum_fields';
  quantity?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "basket_dish" */
export type Basket_Dish_Sum_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** update columns of table "basket_dish" */
export enum Basket_Dish_Update_Column {
  /** column name */
  BasketId = 'basketId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DishId = 'dishId',
  /** column name */
  Id = 'id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Basket_Dish_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Basket_Dish_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Basket_Dish_Set_Input>;
  /** filter the rows which have to be updated */
  where: Basket_Dish_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Basket_Dish_Var_Pop_Fields = {
  __typename?: 'basket_dish_var_pop_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "basket_dish" */
export type Basket_Dish_Var_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Basket_Dish_Var_Samp_Fields = {
  __typename?: 'basket_dish_var_samp_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "basket_dish" */
export type Basket_Dish_Var_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Basket_Dish_Variance_Fields = {
  __typename?: 'basket_dish_variance_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "basket_dish" */
export type Basket_Dish_Variance_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** input type for inserting data into table "basket" */
export type Basket_Insert_Input = {
  basket_dishes?: InputMaybe<Basket_Dish_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  receiver?: InputMaybe<User_Profiles_Obj_Rel_Insert_Input>;
  restaurant?: InputMaybe<Restaurant_Obj_Rel_Insert_Input>;
  restaurantId?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Basket_Max_Fields = {
  __typename?: 'basket_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  restaurantId?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "basket" */
export type Basket_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  restaurantId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Basket_Min_Fields = {
  __typename?: 'basket_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  restaurantId?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "basket" */
export type Basket_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  restaurantId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "basket" */
export type Basket_Mutation_Response = {
  __typename?: 'basket_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Basket>;
};

/** input type for inserting object relation for remote table "basket" */
export type Basket_Obj_Rel_Insert_Input = {
  data: Basket_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Basket_On_Conflict>;
};

/** on_conflict condition type for table "basket" */
export type Basket_On_Conflict = {
  constraint: Basket_Constraint;
  update_columns?: Array<Basket_Update_Column>;
  where?: InputMaybe<Basket_Bool_Exp>;
};

/** Ordering options when selecting data from "basket". */
export type Basket_Order_By = {
  basket_dishes_aggregate?: InputMaybe<Basket_Dish_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isActive?: InputMaybe<Order_By>;
  receiver?: InputMaybe<User_Profiles_Order_By>;
  restaurant?: InputMaybe<Restaurant_Order_By>;
  restaurantId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: basket */
export type Basket_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "basket" */
export enum Basket_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  RestaurantId = 'restaurantId',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'userId'
}

/** select "basket_aggregate_bool_exp_bool_and_arguments_columns" columns of table "basket" */
export enum Basket_Select_Column_Basket_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'isActive'
}

/** select "basket_aggregate_bool_exp_bool_or_arguments_columns" columns of table "basket" */
export enum Basket_Select_Column_Basket_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'isActive'
}

/** input type for updating data in table "basket" */
export type Basket_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  restaurantId?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "basket" */
export type Basket_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Basket_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Basket_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  restaurantId?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "basket" */
export enum Basket_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  RestaurantId = 'restaurantId',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'userId'
}

export type Basket_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Basket_Set_Input>;
  /** filter the rows which have to be updated */
  where: Basket_Bool_Exp;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

/** Boolean expression to compare columns of type "blood_group_enum". All fields are combined with logical 'AND'. */
export type Blood_Group_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['blood_group_enum']['input']>;
  _gt?: InputMaybe<Scalars['blood_group_enum']['input']>;
  _gte?: InputMaybe<Scalars['blood_group_enum']['input']>;
  _in?: InputMaybe<Array<Scalars['blood_group_enum']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['blood_group_enum']['input']>;
  _lte?: InputMaybe<Scalars['blood_group_enum']['input']>;
  _neq?: InputMaybe<Scalars['blood_group_enum']['input']>;
  _nin?: InputMaybe<Array<Scalars['blood_group_enum']['input']>>;
};

/** columns and relationships of "storage.buckets" */
export type Buckets = {
  __typename?: 'buckets';
  cacheControl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  downloadExpiration: Scalars['Int']['output'];
  /** An array relationship */
  files: Array<Files>;
  /** An aggregate relationship */
  files_aggregate: Files_Aggregate;
  id: Scalars['String']['output'];
  maxUploadFileSize: Scalars['Int']['output'];
  minUploadFileSize: Scalars['Int']['output'];
  presignedUrlsEnabled: Scalars['Boolean']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "storage.buckets" */
export type BucketsFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


/** columns and relationships of "storage.buckets" */
export type BucketsFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};

/** aggregated selection of "storage.buckets" */
export type Buckets_Aggregate = {
  __typename?: 'buckets_aggregate';
  aggregate?: Maybe<Buckets_Aggregate_Fields>;
  nodes: Array<Buckets>;
};

/** aggregate fields of "storage.buckets" */
export type Buckets_Aggregate_Fields = {
  __typename?: 'buckets_aggregate_fields';
  avg?: Maybe<Buckets_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Buckets_Max_Fields>;
  min?: Maybe<Buckets_Min_Fields>;
  stddev?: Maybe<Buckets_Stddev_Fields>;
  stddev_pop?: Maybe<Buckets_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Buckets_Stddev_Samp_Fields>;
  sum?: Maybe<Buckets_Sum_Fields>;
  var_pop?: Maybe<Buckets_Var_Pop_Fields>;
  var_samp?: Maybe<Buckets_Var_Samp_Fields>;
  variance?: Maybe<Buckets_Variance_Fields>;
};


/** aggregate fields of "storage.buckets" */
export type Buckets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Buckets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Buckets_Avg_Fields = {
  __typename?: 'buckets_avg_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "storage.buckets". All fields are combined with a logical 'AND'. */
export type Buckets_Bool_Exp = {
  _and?: InputMaybe<Array<Buckets_Bool_Exp>>;
  _not?: InputMaybe<Buckets_Bool_Exp>;
  _or?: InputMaybe<Array<Buckets_Bool_Exp>>;
  cacheControl?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  downloadExpiration?: InputMaybe<Int_Comparison_Exp>;
  files?: InputMaybe<Files_Bool_Exp>;
  files_aggregate?: InputMaybe<Files_Aggregate_Bool_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  maxUploadFileSize?: InputMaybe<Int_Comparison_Exp>;
  minUploadFileSize?: InputMaybe<Int_Comparison_Exp>;
  presignedUrlsEnabled?: InputMaybe<Boolean_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "storage.buckets" */
export enum Buckets_Constraint {
  /** unique or primary key constraint on columns "id" */
  BucketsPkey = 'buckets_pkey'
}

/** input type for incrementing numeric columns in table "storage.buckets" */
export type Buckets_Inc_Input = {
  downloadExpiration?: InputMaybe<Scalars['Int']['input']>;
  maxUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  minUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "storage.buckets" */
export type Buckets_Insert_Input = {
  cacheControl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  downloadExpiration?: InputMaybe<Scalars['Int']['input']>;
  files?: InputMaybe<Files_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  minUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  presignedUrlsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Buckets_Max_Fields = {
  __typename?: 'buckets_max_fields';
  cacheControl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  downloadExpiration?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Int']['output']>;
  minUploadFileSize?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Buckets_Min_Fields = {
  __typename?: 'buckets_min_fields';
  cacheControl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  downloadExpiration?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Int']['output']>;
  minUploadFileSize?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "storage.buckets" */
export type Buckets_Mutation_Response = {
  __typename?: 'buckets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Buckets>;
};

/** input type for inserting object relation for remote table "storage.buckets" */
export type Buckets_Obj_Rel_Insert_Input = {
  data: Buckets_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Buckets_On_Conflict>;
};

/** on_conflict condition type for table "storage.buckets" */
export type Buckets_On_Conflict = {
  constraint: Buckets_Constraint;
  update_columns?: Array<Buckets_Update_Column>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};

/** Ordering options when selecting data from "storage.buckets". */
export type Buckets_Order_By = {
  cacheControl?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  downloadExpiration?: InputMaybe<Order_By>;
  files_aggregate?: InputMaybe<Files_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  maxUploadFileSize?: InputMaybe<Order_By>;
  minUploadFileSize?: InputMaybe<Order_By>;
  presignedUrlsEnabled?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storage.buckets */
export type Buckets_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "storage.buckets" */
export enum Buckets_Select_Column {
  /** column name */
  CacheControl = 'cacheControl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DownloadExpiration = 'downloadExpiration',
  /** column name */
  Id = 'id',
  /** column name */
  MaxUploadFileSize = 'maxUploadFileSize',
  /** column name */
  MinUploadFileSize = 'minUploadFileSize',
  /** column name */
  PresignedUrlsEnabled = 'presignedUrlsEnabled',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "storage.buckets" */
export type Buckets_Set_Input = {
  cacheControl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  downloadExpiration?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  minUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  presignedUrlsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Buckets_Stddev_Fields = {
  __typename?: 'buckets_stddev_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Buckets_Stddev_Pop_Fields = {
  __typename?: 'buckets_stddev_pop_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Buckets_Stddev_Samp_Fields = {
  __typename?: 'buckets_stddev_samp_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "buckets" */
export type Buckets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Buckets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Buckets_Stream_Cursor_Value_Input = {
  cacheControl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  downloadExpiration?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  minUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  presignedUrlsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Buckets_Sum_Fields = {
  __typename?: 'buckets_sum_fields';
  downloadExpiration?: Maybe<Scalars['Int']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Int']['output']>;
  minUploadFileSize?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "storage.buckets" */
export enum Buckets_Update_Column {
  /** column name */
  CacheControl = 'cacheControl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DownloadExpiration = 'downloadExpiration',
  /** column name */
  Id = 'id',
  /** column name */
  MaxUploadFileSize = 'maxUploadFileSize',
  /** column name */
  MinUploadFileSize = 'minUploadFileSize',
  /** column name */
  PresignedUrlsEnabled = 'presignedUrlsEnabled',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Buckets_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Buckets_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Buckets_Set_Input>;
  /** filter the rows which have to be updated */
  where: Buckets_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Buckets_Var_Pop_Fields = {
  __typename?: 'buckets_var_pop_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Buckets_Var_Samp_Fields = {
  __typename?: 'buckets_var_samp_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Buckets_Variance_Fields = {
  __typename?: 'buckets_variance_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "bytea". All fields are combined with logical 'AND'. */
export type Bytea_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bytea']['input']>;
  _gt?: InputMaybe<Scalars['bytea']['input']>;
  _gte?: InputMaybe<Scalars['bytea']['input']>;
  _in?: InputMaybe<Array<Scalars['bytea']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bytea']['input']>;
  _lte?: InputMaybe<Scalars['bytea']['input']>;
  _neq?: InputMaybe<Scalars['bytea']['input']>;
  _nin?: InputMaybe<Array<Scalars['bytea']['input']>>;
};

/** columns and relationships of "carrier" */
export type Carrier = {
  __typename?: 'carrier';
  address?: Maybe<Scalars['String']['output']>;
  blood_donation_consent?: Maybe<Scalars['Boolean']['output']>;
  blood_group?: Maybe<Scalars['blood_group_enum']['output']>;
  created_at: Scalars['timestamptz']['output'];
  dob?: Maybe<Scalars['String']['output']>;
  gender: Scalars['String']['output'];
  heading?: Maybe<Scalars['Float']['output']>;
  id: Scalars['uuid']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isOnline: Scalars['Boolean']['output'];
  location?: Maybe<Scalars['geography']['output']>;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  name: Scalars['String']['output'];
  notification_token?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  restaurant?: Maybe<Restaurant>;
  restaurantId?: Maybe<Scalars['uuid']['output']>;
  status: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  userId?: Maybe<Scalars['uuid']['output']>;
  verification_status?: Maybe<Scalars['document_status_enum']['output']>;
};


/** columns and relationships of "carrier" */
export type CarrierMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "carrier" */
export type Carrier_Aggregate = {
  __typename?: 'carrier_aggregate';
  aggregate?: Maybe<Carrier_Aggregate_Fields>;
  nodes: Array<Carrier>;
};

export type Carrier_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Carrier_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Carrier_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Carrier_Aggregate_Bool_Exp_Count>;
};

export type Carrier_Aggregate_Bool_Exp_Bool_And = {
  arguments: Carrier_Select_Column_Carrier_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Carrier_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Carrier_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Carrier_Select_Column_Carrier_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Carrier_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Carrier_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Carrier_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Carrier_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "carrier" */
export type Carrier_Aggregate_Fields = {
  __typename?: 'carrier_aggregate_fields';
  avg?: Maybe<Carrier_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Carrier_Max_Fields>;
  min?: Maybe<Carrier_Min_Fields>;
  stddev?: Maybe<Carrier_Stddev_Fields>;
  stddev_pop?: Maybe<Carrier_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Carrier_Stddev_Samp_Fields>;
  sum?: Maybe<Carrier_Sum_Fields>;
  var_pop?: Maybe<Carrier_Var_Pop_Fields>;
  var_samp?: Maybe<Carrier_Var_Samp_Fields>;
  variance?: Maybe<Carrier_Variance_Fields>;
};


/** aggregate fields of "carrier" */
export type Carrier_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Carrier_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "carrier" */
export type Carrier_Aggregate_Order_By = {
  avg?: InputMaybe<Carrier_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Carrier_Max_Order_By>;
  min?: InputMaybe<Carrier_Min_Order_By>;
  stddev?: InputMaybe<Carrier_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Carrier_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Carrier_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Carrier_Sum_Order_By>;
  var_pop?: InputMaybe<Carrier_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Carrier_Var_Samp_Order_By>;
  variance?: InputMaybe<Carrier_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Carrier_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "carrier" */
export type Carrier_Arr_Rel_Insert_Input = {
  data: Array<Carrier_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Carrier_On_Conflict>;
};

/** aggregate avg on columns */
export type Carrier_Avg_Fields = {
  __typename?: 'carrier_avg_fields';
  heading?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "carrier" */
export type Carrier_Avg_Order_By = {
  heading?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "carrier". All fields are combined with a logical 'AND'. */
export type Carrier_Bool_Exp = {
  _and?: InputMaybe<Array<Carrier_Bool_Exp>>;
  _not?: InputMaybe<Carrier_Bool_Exp>;
  _or?: InputMaybe<Array<Carrier_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  blood_donation_consent?: InputMaybe<Boolean_Comparison_Exp>;
  blood_group?: InputMaybe<Blood_Group_Enum_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  dob?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  heading?: InputMaybe<Float_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image?: InputMaybe<String_Comparison_Exp>;
  isOnline?: InputMaybe<Boolean_Comparison_Exp>;
  location?: InputMaybe<Geography_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notification_token?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  restaurant?: InputMaybe<Restaurant_Bool_Exp>;
  restaurantId?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
  verification_status?: InputMaybe<Document_Status_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "carrier" */
export enum Carrier_Constraint {
  /** unique or primary key constraint on columns "id" */
  CarrierPkey = 'carrier_pkey',
  /** unique or primary key constraint on columns "userId" */
  CarrierUserIdKey = 'carrier_userId_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Carrier_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Carrier_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Carrier_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "carrier" */
export type Carrier_Inc_Input = {
  heading?: InputMaybe<Scalars['Float']['input']>;
};

/** input type for inserting data into table "carrier" */
export type Carrier_Insert_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  blood_donation_consent?: InputMaybe<Scalars['Boolean']['input']>;
  blood_group?: InputMaybe<Scalars['blood_group_enum']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  isOnline?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['geography']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notification_token?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  restaurant?: InputMaybe<Restaurant_Obj_Rel_Insert_Input>;
  restaurantId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  verification_status?: InputMaybe<Scalars['document_status_enum']['input']>;
};

/** aggregate max on columns */
export type Carrier_Max_Fields = {
  __typename?: 'carrier_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  blood_group?: Maybe<Scalars['blood_group_enum']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  dob?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notification_token?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  restaurantId?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  verification_status?: Maybe<Scalars['document_status_enum']['output']>;
};

/** order by max() on columns of table "carrier" */
export type Carrier_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  blood_group?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dob?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  heading?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notification_token?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  restaurantId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  verification_status?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Carrier_Min_Fields = {
  __typename?: 'carrier_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  blood_group?: Maybe<Scalars['blood_group_enum']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  dob?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notification_token?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  restaurantId?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  verification_status?: Maybe<Scalars['document_status_enum']['output']>;
};

/** order by min() on columns of table "carrier" */
export type Carrier_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  blood_group?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dob?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  heading?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notification_token?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  restaurantId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  verification_status?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "carrier" */
export type Carrier_Mutation_Response = {
  __typename?: 'carrier_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Carrier>;
};

/** input type for inserting object relation for remote table "carrier" */
export type Carrier_Obj_Rel_Insert_Input = {
  data: Carrier_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Carrier_On_Conflict>;
};

/** on_conflict condition type for table "carrier" */
export type Carrier_On_Conflict = {
  constraint: Carrier_Constraint;
  update_columns?: Array<Carrier_Update_Column>;
  where?: InputMaybe<Carrier_Bool_Exp>;
};

/** Ordering options when selecting data from "carrier". */
export type Carrier_Order_By = {
  address?: InputMaybe<Order_By>;
  blood_donation_consent?: InputMaybe<Order_By>;
  blood_group?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dob?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  heading?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  isOnline?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notification_token?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  restaurant?: InputMaybe<Restaurant_Order_By>;
  restaurantId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
  verification_status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: carrier */
export type Carrier_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Carrier_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "carrier" */
export enum Carrier_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  BloodDonationConsent = 'blood_donation_consent',
  /** column name */
  BloodGroup = 'blood_group',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Dob = 'dob',
  /** column name */
  Gender = 'gender',
  /** column name */
  Heading = 'heading',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  IsOnline = 'isOnline',
  /** column name */
  Location = 'location',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  NotificationToken = 'notification_token',
  /** column name */
  Phone = 'phone',
  /** column name */
  RestaurantId = 'restaurantId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'userId',
  /** column name */
  VerificationStatus = 'verification_status'
}

/** select "carrier_aggregate_bool_exp_bool_and_arguments_columns" columns of table "carrier" */
export enum Carrier_Select_Column_Carrier_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  BloodDonationConsent = 'blood_donation_consent',
  /** column name */
  IsOnline = 'isOnline'
}

/** select "carrier_aggregate_bool_exp_bool_or_arguments_columns" columns of table "carrier" */
export enum Carrier_Select_Column_Carrier_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  BloodDonationConsent = 'blood_donation_consent',
  /** column name */
  IsOnline = 'isOnline'
}

/** input type for updating data in table "carrier" */
export type Carrier_Set_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  blood_donation_consent?: InputMaybe<Scalars['Boolean']['input']>;
  blood_group?: InputMaybe<Scalars['blood_group_enum']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  isOnline?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['geography']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notification_token?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  restaurantId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  verification_status?: InputMaybe<Scalars['document_status_enum']['input']>;
};

/** aggregate stddev on columns */
export type Carrier_Stddev_Fields = {
  __typename?: 'carrier_stddev_fields';
  heading?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "carrier" */
export type Carrier_Stddev_Order_By = {
  heading?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Carrier_Stddev_Pop_Fields = {
  __typename?: 'carrier_stddev_pop_fields';
  heading?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "carrier" */
export type Carrier_Stddev_Pop_Order_By = {
  heading?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Carrier_Stddev_Samp_Fields = {
  __typename?: 'carrier_stddev_samp_fields';
  heading?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "carrier" */
export type Carrier_Stddev_Samp_Order_By = {
  heading?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "carrier" */
export type Carrier_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Carrier_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Carrier_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  blood_donation_consent?: InputMaybe<Scalars['Boolean']['input']>;
  blood_group?: InputMaybe<Scalars['blood_group_enum']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  isOnline?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['geography']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notification_token?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  restaurantId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  verification_status?: InputMaybe<Scalars['document_status_enum']['input']>;
};

/** aggregate sum on columns */
export type Carrier_Sum_Fields = {
  __typename?: 'carrier_sum_fields';
  heading?: Maybe<Scalars['Float']['output']>;
};

/** order by sum() on columns of table "carrier" */
export type Carrier_Sum_Order_By = {
  heading?: InputMaybe<Order_By>;
};

/** update columns of table "carrier" */
export enum Carrier_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  BloodDonationConsent = 'blood_donation_consent',
  /** column name */
  BloodGroup = 'blood_group',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Dob = 'dob',
  /** column name */
  Gender = 'gender',
  /** column name */
  Heading = 'heading',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  IsOnline = 'isOnline',
  /** column name */
  Location = 'location',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  NotificationToken = 'notification_token',
  /** column name */
  Phone = 'phone',
  /** column name */
  RestaurantId = 'restaurantId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'userId',
  /** column name */
  VerificationStatus = 'verification_status'
}

export type Carrier_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Carrier_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Carrier_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Carrier_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Carrier_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Carrier_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Carrier_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Carrier_Set_Input>;
  /** filter the rows which have to be updated */
  where: Carrier_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Carrier_Var_Pop_Fields = {
  __typename?: 'carrier_var_pop_fields';
  heading?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "carrier" */
export type Carrier_Var_Pop_Order_By = {
  heading?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Carrier_Var_Samp_Fields = {
  __typename?: 'carrier_var_samp_fields';
  heading?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "carrier" */
export type Carrier_Var_Samp_Order_By = {
  heading?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Carrier_Variance_Fields = {
  __typename?: 'carrier_variance_fields';
  heading?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "carrier" */
export type Carrier_Variance_Order_By = {
  heading?: InputMaybe<Order_By>;
};

/** columns and relationships of "category" */
export type Category = {
  __typename?: 'category';
  /** An array relationship */
  dishes: Array<Dish>;
  /** An aggregate relationship */
  dishes_aggregate: Dish_Aggregate;
  id: Scalars['uuid']['output'];
  image?: Maybe<Scalars['uuid']['output']>;
  name: Scalars['String']['output'];
};


/** columns and relationships of "category" */
export type CategoryDishesArgs = {
  distinct_on?: InputMaybe<Array<Dish_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dish_Order_By>>;
  where?: InputMaybe<Dish_Bool_Exp>;
};


/** columns and relationships of "category" */
export type CategoryDishes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dish_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dish_Order_By>>;
  where?: InputMaybe<Dish_Bool_Exp>;
};

/** aggregated selection of "category" */
export type Category_Aggregate = {
  __typename?: 'category_aggregate';
  aggregate?: Maybe<Category_Aggregate_Fields>;
  nodes: Array<Category>;
};

/** aggregate fields of "category" */
export type Category_Aggregate_Fields = {
  __typename?: 'category_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Category_Max_Fields>;
  min?: Maybe<Category_Min_Fields>;
};


/** aggregate fields of "category" */
export type Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "category". All fields are combined with a logical 'AND'. */
export type Category_Bool_Exp = {
  _and?: InputMaybe<Array<Category_Bool_Exp>>;
  _not?: InputMaybe<Category_Bool_Exp>;
  _or?: InputMaybe<Array<Category_Bool_Exp>>;
  dishes?: InputMaybe<Dish_Bool_Exp>;
  dishes_aggregate?: InputMaybe<Dish_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "category" */
export enum Category_Constraint {
  /** unique or primary key constraint on columns "id" */
  CategoryPkey = 'category_pkey'
}

/** input type for inserting data into table "category" */
export type Category_Insert_Input = {
  dishes?: InputMaybe<Dish_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Category_Max_Fields = {
  __typename?: 'category_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  image?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Category_Min_Fields = {
  __typename?: 'category_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  image?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "category" */
export type Category_Mutation_Response = {
  __typename?: 'category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Category>;
};

/** input type for inserting object relation for remote table "category" */
export type Category_Obj_Rel_Insert_Input = {
  data: Category_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Category_On_Conflict>;
};

/** on_conflict condition type for table "category" */
export type Category_On_Conflict = {
  constraint: Category_Constraint;
  update_columns?: Array<Category_Update_Column>;
  where?: InputMaybe<Category_Bool_Exp>;
};

/** Ordering options when selecting data from "category". */
export type Category_Order_By = {
  dishes_aggregate?: InputMaybe<Dish_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: category */
export type Category_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "category" */
export enum Category_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "category" */
export type Category_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "category" */
export type Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Category_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "category" */
export enum Category_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  Name = 'name'
}

export type Category_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Category_Set_Input>;
  /** filter the rows which have to be updated */
  where: Category_Bool_Exp;
};

/** Boolean expression to compare columns of type "citext". All fields are combined with logical 'AND'. */
export type Citext_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['citext']['input']>;
  _gt?: InputMaybe<Scalars['citext']['input']>;
  _gte?: InputMaybe<Scalars['citext']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['citext']['input']>;
  _in?: InputMaybe<Array<Scalars['citext']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['citext']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['citext']['input']>;
  _lt?: InputMaybe<Scalars['citext']['input']>;
  _lte?: InputMaybe<Scalars['citext']['input']>;
  _neq?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['citext']['input']>;
  _nin?: InputMaybe<Array<Scalars['citext']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['citext']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['citext']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['citext']['input']>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

/** columns and relationships of "dish" */
export type Dish = {
  __typename?: 'dish';
  /** An object relationship */
  category?: Maybe<Category>;
  categoryId?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  image?: Maybe<Scalars['uuid']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  price: Scalars['String']['output'];
  /** An object relationship */
  restaurant: Restaurant;
  restaurantId: Scalars['uuid']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "dish" */
export type Dish_Aggregate = {
  __typename?: 'dish_aggregate';
  aggregate?: Maybe<Dish_Aggregate_Fields>;
  nodes: Array<Dish>;
};

export type Dish_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Dish_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Dish_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Dish_Aggregate_Bool_Exp_Count>;
};

export type Dish_Aggregate_Bool_Exp_Bool_And = {
  arguments: Dish_Select_Column_Dish_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Dish_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Dish_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Dish_Select_Column_Dish_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Dish_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Dish_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Dish_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Dish_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "dish" */
export type Dish_Aggregate_Fields = {
  __typename?: 'dish_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Dish_Max_Fields>;
  min?: Maybe<Dish_Min_Fields>;
};


/** aggregate fields of "dish" */
export type Dish_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Dish_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "dish" */
export type Dish_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Dish_Max_Order_By>;
  min?: InputMaybe<Dish_Min_Order_By>;
};

/** input type for inserting array relation for remote table "dish" */
export type Dish_Arr_Rel_Insert_Input = {
  data: Array<Dish_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Dish_On_Conflict>;
};

/** Boolean expression to filter rows from the table "dish". All fields are combined with a logical 'AND'. */
export type Dish_Bool_Exp = {
  _and?: InputMaybe<Array<Dish_Bool_Exp>>;
  _not?: InputMaybe<Dish_Bool_Exp>;
  _or?: InputMaybe<Array<Dish_Bool_Exp>>;
  category?: InputMaybe<Category_Bool_Exp>;
  categoryId?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image?: InputMaybe<Uuid_Comparison_Exp>;
  isActive?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  price?: InputMaybe<String_Comparison_Exp>;
  restaurant?: InputMaybe<Restaurant_Bool_Exp>;
  restaurantId?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "dish" */
export enum Dish_Constraint {
  /** unique or primary key constraint on columns "id" */
  DishPkey = 'dish_pkey'
}

/** input type for inserting data into table "dish" */
export type Dish_Insert_Input = {
  category?: InputMaybe<Category_Obj_Rel_Insert_Input>;
  categoryId?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Scalars['uuid']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  restaurant?: InputMaybe<Restaurant_Obj_Rel_Insert_Input>;
  restaurantId?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Dish_Max_Fields = {
  __typename?: 'dish_max_fields';
  categoryId?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  restaurantId?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "dish" */
export type Dish_Max_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  restaurantId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Dish_Min_Fields = {
  __typename?: 'dish_min_fields';
  categoryId?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  restaurantId?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "dish" */
export type Dish_Min_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  restaurantId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "dish" */
export type Dish_Mutation_Response = {
  __typename?: 'dish_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Dish>;
};

/** input type for inserting object relation for remote table "dish" */
export type Dish_Obj_Rel_Insert_Input = {
  data: Dish_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Dish_On_Conflict>;
};

/** on_conflict condition type for table "dish" */
export type Dish_On_Conflict = {
  constraint: Dish_Constraint;
  update_columns?: Array<Dish_Update_Column>;
  where?: InputMaybe<Dish_Bool_Exp>;
};

/** Ordering options when selecting data from "dish". */
export type Dish_Order_By = {
  category?: InputMaybe<Category_Order_By>;
  categoryId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  isActive?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  restaurant?: InputMaybe<Restaurant_Order_By>;
  restaurantId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: dish */
export type Dish_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "dish" */
export enum Dish_Select_Column {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  Name = 'name',
  /** column name */
  Price = 'price',
  /** column name */
  RestaurantId = 'restaurantId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "dish_aggregate_bool_exp_bool_and_arguments_columns" columns of table "dish" */
export enum Dish_Select_Column_Dish_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'isActive'
}

/** select "dish_aggregate_bool_exp_bool_or_arguments_columns" columns of table "dish" */
export enum Dish_Select_Column_Dish_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'isActive'
}

/** input type for updating data in table "dish" */
export type Dish_Set_Input = {
  categoryId?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Scalars['uuid']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  restaurantId?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "dish" */
export type Dish_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dish_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dish_Stream_Cursor_Value_Input = {
  categoryId?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Scalars['uuid']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  restaurantId?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "dish" */
export enum Dish_Update_Column {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  Name = 'name',
  /** column name */
  Price = 'price',
  /** column name */
  RestaurantId = 'restaurantId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Dish_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Dish_Set_Input>;
  /** filter the rows which have to be updated */
  where: Dish_Bool_Exp;
};

/** Boolean expression to compare columns of type "document_status_enum". All fields are combined with logical 'AND'. */
export type Document_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['document_status_enum']['input']>;
  _gt?: InputMaybe<Scalars['document_status_enum']['input']>;
  _gte?: InputMaybe<Scalars['document_status_enum']['input']>;
  _in?: InputMaybe<Array<Scalars['document_status_enum']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['document_status_enum']['input']>;
  _lte?: InputMaybe<Scalars['document_status_enum']['input']>;
  _neq?: InputMaybe<Scalars['document_status_enum']['input']>;
  _nin?: InputMaybe<Array<Scalars['document_status_enum']['input']>>;
};

/** Boolean expression to compare columns of type "document_type_enum". All fields are combined with logical 'AND'. */
export type Document_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['document_type_enum']['input']>;
  _gt?: InputMaybe<Scalars['document_type_enum']['input']>;
  _gte?: InputMaybe<Scalars['document_type_enum']['input']>;
  _in?: InputMaybe<Array<Scalars['document_type_enum']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['document_type_enum']['input']>;
  _lte?: InputMaybe<Scalars['document_type_enum']['input']>;
  _neq?: InputMaybe<Scalars['document_type_enum']['input']>;
  _nin?: InputMaybe<Array<Scalars['document_type_enum']['input']>>;
};

/** columns and relationships of "driver_documents" */
export type Driver_Documents = {
  __typename?: 'driver_documents';
  created_at: Scalars['timestamptz']['output'];
  document_type?: Maybe<Scalars['document_type_enum']['output']>;
  document_url?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  driver: Drivers;
  driver_id: Scalars['uuid']['output'];
  expiry_date?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  status?: Maybe<Scalars['document_status_enum']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  verified_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "driver_documents" */
export type Driver_Documents_Aggregate = {
  __typename?: 'driver_documents_aggregate';
  aggregate?: Maybe<Driver_Documents_Aggregate_Fields>;
  nodes: Array<Driver_Documents>;
};

export type Driver_Documents_Aggregate_Bool_Exp = {
  count?: InputMaybe<Driver_Documents_Aggregate_Bool_Exp_Count>;
};

export type Driver_Documents_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Driver_Documents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Driver_Documents_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "driver_documents" */
export type Driver_Documents_Aggregate_Fields = {
  __typename?: 'driver_documents_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Driver_Documents_Max_Fields>;
  min?: Maybe<Driver_Documents_Min_Fields>;
};


/** aggregate fields of "driver_documents" */
export type Driver_Documents_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Driver_Documents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "driver_documents" */
export type Driver_Documents_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Driver_Documents_Max_Order_By>;
  min?: InputMaybe<Driver_Documents_Min_Order_By>;
};

/** input type for inserting array relation for remote table "driver_documents" */
export type Driver_Documents_Arr_Rel_Insert_Input = {
  data: Array<Driver_Documents_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Driver_Documents_On_Conflict>;
};

/** Boolean expression to filter rows from the table "driver_documents". All fields are combined with a logical 'AND'. */
export type Driver_Documents_Bool_Exp = {
  _and?: InputMaybe<Array<Driver_Documents_Bool_Exp>>;
  _not?: InputMaybe<Driver_Documents_Bool_Exp>;
  _or?: InputMaybe<Array<Driver_Documents_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  document_type?: InputMaybe<Document_Type_Enum_Comparison_Exp>;
  document_url?: InputMaybe<String_Comparison_Exp>;
  driver?: InputMaybe<Drivers_Bool_Exp>;
  driver_id?: InputMaybe<Uuid_Comparison_Exp>;
  expiry_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Document_Status_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  verified_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "driver_documents" */
export enum Driver_Documents_Constraint {
  /** unique or primary key constraint on columns "id" */
  DriverDocumentsPkey = 'driver_documents_pkey'
}

/** input type for inserting data into table "driver_documents" */
export type Driver_Documents_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  document_type?: InputMaybe<Scalars['document_type_enum']['input']>;
  document_url?: InputMaybe<Scalars['String']['input']>;
  driver?: InputMaybe<Drivers_Obj_Rel_Insert_Input>;
  driver_id?: InputMaybe<Scalars['uuid']['input']>;
  expiry_date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['document_status_enum']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  verified_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Driver_Documents_Max_Fields = {
  __typename?: 'driver_documents_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  document_type?: Maybe<Scalars['document_type_enum']['output']>;
  document_url?: Maybe<Scalars['String']['output']>;
  driver_id?: Maybe<Scalars['uuid']['output']>;
  expiry_date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['document_status_enum']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  verified_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "driver_documents" */
export type Driver_Documents_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  document_url?: InputMaybe<Order_By>;
  driver_id?: InputMaybe<Order_By>;
  expiry_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  verified_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Driver_Documents_Min_Fields = {
  __typename?: 'driver_documents_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  document_type?: Maybe<Scalars['document_type_enum']['output']>;
  document_url?: Maybe<Scalars['String']['output']>;
  driver_id?: Maybe<Scalars['uuid']['output']>;
  expiry_date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['document_status_enum']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  verified_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "driver_documents" */
export type Driver_Documents_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  document_url?: InputMaybe<Order_By>;
  driver_id?: InputMaybe<Order_By>;
  expiry_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  verified_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "driver_documents" */
export type Driver_Documents_Mutation_Response = {
  __typename?: 'driver_documents_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Driver_Documents>;
};

/** on_conflict condition type for table "driver_documents" */
export type Driver_Documents_On_Conflict = {
  constraint: Driver_Documents_Constraint;
  update_columns?: Array<Driver_Documents_Update_Column>;
  where?: InputMaybe<Driver_Documents_Bool_Exp>;
};

/** Ordering options when selecting data from "driver_documents". */
export type Driver_Documents_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  document_url?: InputMaybe<Order_By>;
  driver?: InputMaybe<Drivers_Order_By>;
  driver_id?: InputMaybe<Order_By>;
  expiry_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  verified_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: driver_documents */
export type Driver_Documents_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "driver_documents" */
export enum Driver_Documents_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentType = 'document_type',
  /** column name */
  DocumentUrl = 'document_url',
  /** column name */
  DriverId = 'driver_id',
  /** column name */
  ExpiryDate = 'expiry_date',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VerifiedAt = 'verified_at'
}

/** input type for updating data in table "driver_documents" */
export type Driver_Documents_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  document_type?: InputMaybe<Scalars['document_type_enum']['input']>;
  document_url?: InputMaybe<Scalars['String']['input']>;
  driver_id?: InputMaybe<Scalars['uuid']['input']>;
  expiry_date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['document_status_enum']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  verified_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "driver_documents" */
export type Driver_Documents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Driver_Documents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Driver_Documents_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  document_type?: InputMaybe<Scalars['document_type_enum']['input']>;
  document_url?: InputMaybe<Scalars['String']['input']>;
  driver_id?: InputMaybe<Scalars['uuid']['input']>;
  expiry_date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['document_status_enum']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  verified_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "driver_documents" */
export enum Driver_Documents_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentType = 'document_type',
  /** column name */
  DocumentUrl = 'document_url',
  /** column name */
  DriverId = 'driver_id',
  /** column name */
  ExpiryDate = 'expiry_date',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VerifiedAt = 'verified_at'
}

export type Driver_Documents_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Driver_Documents_Set_Input>;
  /** filter the rows which have to be updated */
  where: Driver_Documents_Bool_Exp;
};

/** columns and relationships of "driver_locations_current" */
export type Driver_Locations_Current = {
  __typename?: 'driver_locations_current';
  accuracy?: Maybe<Scalars['numeric']['output']>;
  battery_level?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  device_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  driver: Drivers;
  driver_id: Scalars['uuid']['output'];
  heading?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['uuid']['output'];
  location?: Maybe<Scalars['geography']['output']>;
  speed?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user_device?: Maybe<User_Devices>;
};

/** aggregated selection of "driver_locations_current" */
export type Driver_Locations_Current_Aggregate = {
  __typename?: 'driver_locations_current_aggregate';
  aggregate?: Maybe<Driver_Locations_Current_Aggregate_Fields>;
  nodes: Array<Driver_Locations_Current>;
};

export type Driver_Locations_Current_Aggregate_Bool_Exp = {
  count?: InputMaybe<Driver_Locations_Current_Aggregate_Bool_Exp_Count>;
};

export type Driver_Locations_Current_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Driver_Locations_Current_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Driver_Locations_Current_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "driver_locations_current" */
export type Driver_Locations_Current_Aggregate_Fields = {
  __typename?: 'driver_locations_current_aggregate_fields';
  avg?: Maybe<Driver_Locations_Current_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Driver_Locations_Current_Max_Fields>;
  min?: Maybe<Driver_Locations_Current_Min_Fields>;
  stddev?: Maybe<Driver_Locations_Current_Stddev_Fields>;
  stddev_pop?: Maybe<Driver_Locations_Current_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Driver_Locations_Current_Stddev_Samp_Fields>;
  sum?: Maybe<Driver_Locations_Current_Sum_Fields>;
  var_pop?: Maybe<Driver_Locations_Current_Var_Pop_Fields>;
  var_samp?: Maybe<Driver_Locations_Current_Var_Samp_Fields>;
  variance?: Maybe<Driver_Locations_Current_Variance_Fields>;
};


/** aggregate fields of "driver_locations_current" */
export type Driver_Locations_Current_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Driver_Locations_Current_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "driver_locations_current" */
export type Driver_Locations_Current_Aggregate_Order_By = {
  avg?: InputMaybe<Driver_Locations_Current_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Driver_Locations_Current_Max_Order_By>;
  min?: InputMaybe<Driver_Locations_Current_Min_Order_By>;
  stddev?: InputMaybe<Driver_Locations_Current_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Driver_Locations_Current_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Driver_Locations_Current_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Driver_Locations_Current_Sum_Order_By>;
  var_pop?: InputMaybe<Driver_Locations_Current_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Driver_Locations_Current_Var_Samp_Order_By>;
  variance?: InputMaybe<Driver_Locations_Current_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "driver_locations_current" */
export type Driver_Locations_Current_Arr_Rel_Insert_Input = {
  data: Array<Driver_Locations_Current_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Driver_Locations_Current_On_Conflict>;
};

/** aggregate avg on columns */
export type Driver_Locations_Current_Avg_Fields = {
  __typename?: 'driver_locations_current_avg_fields';
  accuracy?: Maybe<Scalars['Float']['output']>;
  battery_level?: Maybe<Scalars['Float']['output']>;
  heading?: Maybe<Scalars['Float']['output']>;
  speed?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "driver_locations_current" */
export type Driver_Locations_Current_Avg_Order_By = {
  accuracy?: InputMaybe<Order_By>;
  battery_level?: InputMaybe<Order_By>;
  heading?: InputMaybe<Order_By>;
  speed?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "driver_locations_current". All fields are combined with a logical 'AND'. */
export type Driver_Locations_Current_Bool_Exp = {
  _and?: InputMaybe<Array<Driver_Locations_Current_Bool_Exp>>;
  _not?: InputMaybe<Driver_Locations_Current_Bool_Exp>;
  _or?: InputMaybe<Array<Driver_Locations_Current_Bool_Exp>>;
  accuracy?: InputMaybe<Numeric_Comparison_Exp>;
  battery_level?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  device_id?: InputMaybe<Uuid_Comparison_Exp>;
  driver?: InputMaybe<Drivers_Bool_Exp>;
  driver_id?: InputMaybe<Uuid_Comparison_Exp>;
  heading?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<Geography_Comparison_Exp>;
  speed?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_device?: InputMaybe<User_Devices_Bool_Exp>;
};

/** unique or primary key constraints on table "driver_locations_current" */
export enum Driver_Locations_Current_Constraint {
  /** unique or primary key constraint on columns "driver_id" */
  DriverLocationsCurrentDriverIdKey = 'driver_locations_current_driver_id_key',
  /** unique or primary key constraint on columns "id" */
  DriverLocationsCurrentPkey = 'driver_locations_current_pkey'
}

/** input type for incrementing numeric columns in table "driver_locations_current" */
export type Driver_Locations_Current_Inc_Input = {
  accuracy?: InputMaybe<Scalars['numeric']['input']>;
  battery_level?: InputMaybe<Scalars['Int']['input']>;
  heading?: InputMaybe<Scalars['numeric']['input']>;
  speed?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "driver_locations_current" */
export type Driver_Locations_Current_Insert_Input = {
  accuracy?: InputMaybe<Scalars['numeric']['input']>;
  battery_level?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  device_id?: InputMaybe<Scalars['uuid']['input']>;
  driver?: InputMaybe<Drivers_Obj_Rel_Insert_Input>;
  driver_id?: InputMaybe<Scalars['uuid']['input']>;
  heading?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['geography']['input']>;
  speed?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_device?: InputMaybe<User_Devices_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Driver_Locations_Current_Max_Fields = {
  __typename?: 'driver_locations_current_max_fields';
  accuracy?: Maybe<Scalars['numeric']['output']>;
  battery_level?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  device_id?: Maybe<Scalars['uuid']['output']>;
  driver_id?: Maybe<Scalars['uuid']['output']>;
  heading?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  speed?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "driver_locations_current" */
export type Driver_Locations_Current_Max_Order_By = {
  accuracy?: InputMaybe<Order_By>;
  battery_level?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  driver_id?: InputMaybe<Order_By>;
  heading?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  speed?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Driver_Locations_Current_Min_Fields = {
  __typename?: 'driver_locations_current_min_fields';
  accuracy?: Maybe<Scalars['numeric']['output']>;
  battery_level?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  device_id?: Maybe<Scalars['uuid']['output']>;
  driver_id?: Maybe<Scalars['uuid']['output']>;
  heading?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  speed?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "driver_locations_current" */
export type Driver_Locations_Current_Min_Order_By = {
  accuracy?: InputMaybe<Order_By>;
  battery_level?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  driver_id?: InputMaybe<Order_By>;
  heading?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  speed?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "driver_locations_current" */
export type Driver_Locations_Current_Mutation_Response = {
  __typename?: 'driver_locations_current_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Driver_Locations_Current>;
};

/** input type for inserting object relation for remote table "driver_locations_current" */
export type Driver_Locations_Current_Obj_Rel_Insert_Input = {
  data: Driver_Locations_Current_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Driver_Locations_Current_On_Conflict>;
};

/** on_conflict condition type for table "driver_locations_current" */
export type Driver_Locations_Current_On_Conflict = {
  constraint: Driver_Locations_Current_Constraint;
  update_columns?: Array<Driver_Locations_Current_Update_Column>;
  where?: InputMaybe<Driver_Locations_Current_Bool_Exp>;
};

/** Ordering options when selecting data from "driver_locations_current". */
export type Driver_Locations_Current_Order_By = {
  accuracy?: InputMaybe<Order_By>;
  battery_level?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  driver?: InputMaybe<Drivers_Order_By>;
  driver_id?: InputMaybe<Order_By>;
  heading?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  speed?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_device?: InputMaybe<User_Devices_Order_By>;
};

/** primary key columns input for table: driver_locations_current */
export type Driver_Locations_Current_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "driver_locations_current" */
export enum Driver_Locations_Current_Select_Column {
  /** column name */
  Accuracy = 'accuracy',
  /** column name */
  BatteryLevel = 'battery_level',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeviceId = 'device_id',
  /** column name */
  DriverId = 'driver_id',
  /** column name */
  Heading = 'heading',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  Speed = 'speed',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "driver_locations_current" */
export type Driver_Locations_Current_Set_Input = {
  accuracy?: InputMaybe<Scalars['numeric']['input']>;
  battery_level?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  device_id?: InputMaybe<Scalars['uuid']['input']>;
  driver_id?: InputMaybe<Scalars['uuid']['input']>;
  heading?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['geography']['input']>;
  speed?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Driver_Locations_Current_Stddev_Fields = {
  __typename?: 'driver_locations_current_stddev_fields';
  accuracy?: Maybe<Scalars['Float']['output']>;
  battery_level?: Maybe<Scalars['Float']['output']>;
  heading?: Maybe<Scalars['Float']['output']>;
  speed?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "driver_locations_current" */
export type Driver_Locations_Current_Stddev_Order_By = {
  accuracy?: InputMaybe<Order_By>;
  battery_level?: InputMaybe<Order_By>;
  heading?: InputMaybe<Order_By>;
  speed?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Driver_Locations_Current_Stddev_Pop_Fields = {
  __typename?: 'driver_locations_current_stddev_pop_fields';
  accuracy?: Maybe<Scalars['Float']['output']>;
  battery_level?: Maybe<Scalars['Float']['output']>;
  heading?: Maybe<Scalars['Float']['output']>;
  speed?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "driver_locations_current" */
export type Driver_Locations_Current_Stddev_Pop_Order_By = {
  accuracy?: InputMaybe<Order_By>;
  battery_level?: InputMaybe<Order_By>;
  heading?: InputMaybe<Order_By>;
  speed?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Driver_Locations_Current_Stddev_Samp_Fields = {
  __typename?: 'driver_locations_current_stddev_samp_fields';
  accuracy?: Maybe<Scalars['Float']['output']>;
  battery_level?: Maybe<Scalars['Float']['output']>;
  heading?: Maybe<Scalars['Float']['output']>;
  speed?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "driver_locations_current" */
export type Driver_Locations_Current_Stddev_Samp_Order_By = {
  accuracy?: InputMaybe<Order_By>;
  battery_level?: InputMaybe<Order_By>;
  heading?: InputMaybe<Order_By>;
  speed?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "driver_locations_current" */
export type Driver_Locations_Current_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Driver_Locations_Current_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Driver_Locations_Current_Stream_Cursor_Value_Input = {
  accuracy?: InputMaybe<Scalars['numeric']['input']>;
  battery_level?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  device_id?: InputMaybe<Scalars['uuid']['input']>;
  driver_id?: InputMaybe<Scalars['uuid']['input']>;
  heading?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['geography']['input']>;
  speed?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Driver_Locations_Current_Sum_Fields = {
  __typename?: 'driver_locations_current_sum_fields';
  accuracy?: Maybe<Scalars['numeric']['output']>;
  battery_level?: Maybe<Scalars['Int']['output']>;
  heading?: Maybe<Scalars['numeric']['output']>;
  speed?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "driver_locations_current" */
export type Driver_Locations_Current_Sum_Order_By = {
  accuracy?: InputMaybe<Order_By>;
  battery_level?: InputMaybe<Order_By>;
  heading?: InputMaybe<Order_By>;
  speed?: InputMaybe<Order_By>;
};

/** update columns of table "driver_locations_current" */
export enum Driver_Locations_Current_Update_Column {
  /** column name */
  Accuracy = 'accuracy',
  /** column name */
  BatteryLevel = 'battery_level',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeviceId = 'device_id',
  /** column name */
  DriverId = 'driver_id',
  /** column name */
  Heading = 'heading',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  Speed = 'speed',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Driver_Locations_Current_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Driver_Locations_Current_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Driver_Locations_Current_Set_Input>;
  /** filter the rows which have to be updated */
  where: Driver_Locations_Current_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Driver_Locations_Current_Var_Pop_Fields = {
  __typename?: 'driver_locations_current_var_pop_fields';
  accuracy?: Maybe<Scalars['Float']['output']>;
  battery_level?: Maybe<Scalars['Float']['output']>;
  heading?: Maybe<Scalars['Float']['output']>;
  speed?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "driver_locations_current" */
export type Driver_Locations_Current_Var_Pop_Order_By = {
  accuracy?: InputMaybe<Order_By>;
  battery_level?: InputMaybe<Order_By>;
  heading?: InputMaybe<Order_By>;
  speed?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Driver_Locations_Current_Var_Samp_Fields = {
  __typename?: 'driver_locations_current_var_samp_fields';
  accuracy?: Maybe<Scalars['Float']['output']>;
  battery_level?: Maybe<Scalars['Float']['output']>;
  heading?: Maybe<Scalars['Float']['output']>;
  speed?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "driver_locations_current" */
export type Driver_Locations_Current_Var_Samp_Order_By = {
  accuracy?: InputMaybe<Order_By>;
  battery_level?: InputMaybe<Order_By>;
  heading?: InputMaybe<Order_By>;
  speed?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Driver_Locations_Current_Variance_Fields = {
  __typename?: 'driver_locations_current_variance_fields';
  accuracy?: Maybe<Scalars['Float']['output']>;
  battery_level?: Maybe<Scalars['Float']['output']>;
  heading?: Maybe<Scalars['Float']['output']>;
  speed?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "driver_locations_current" */
export type Driver_Locations_Current_Variance_Order_By = {
  accuracy?: InputMaybe<Order_By>;
  battery_level?: InputMaybe<Order_By>;
  heading?: InputMaybe<Order_By>;
  speed?: InputMaybe<Order_By>;
};

/** columns and relationships of "drivers" */
export type Drivers = {
  __typename?: 'drivers';
  average_rating?: Maybe<Scalars['Int']['output']>;
  blood_donation_consent: Scalars['Boolean']['output'];
  blood_group?: Maybe<Scalars['blood_group_enum']['output']>;
  created_at: Scalars['timestamptz']['output'];
  current_ride_id?: Maybe<Scalars['uuid']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  driver_documents: Array<Driver_Documents>;
  /** An aggregate relationship */
  driver_documents_aggregate: Driver_Documents_Aggregate;
  /** An object relationship */
  driver_locations_current?: Maybe<Driver_Locations_Current>;
  /** An array relationship */
  driver_locations_currents: Array<Driver_Locations_Current>;
  /** An aggregate relationship */
  driver_locations_currents_aggregate: Driver_Locations_Current_Aggregate;
  /** An array relationship */
  free_rides: Array<Free_Rides>;
  /** An aggregate relationship */
  free_rides_aggregate: Free_Rides_Aggregate;
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  insurance_number?: Maybe<Scalars['String']['output']>;
  is_active: Scalars['Boolean']['output'];
  is_busy: Scalars['Boolean']['output'];
  license?: Maybe<Scalars['uuid']['output']>;
  license_expiry?: Maybe<Scalars['date']['output']>;
  license_number?: Maybe<Scalars['String']['output']>;
  local_unit?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notification_token?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<Scalars['uuid']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  ratings: Array<Ratings>;
  /** An aggregate relationship */
  ratings_aggregate: Ratings_Aggregate;
  rejection_reason?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  ride?: Maybe<Rides>;
  /** An array relationship */
  rides: Array<Rides>;
  /** An aggregate relationship */
  rides_aggregate: Rides_Aggregate;
  selfie?: Maybe<Scalars['uuid']['output']>;
  street_address?: Maybe<Scalars['String']['output']>;
  total_rides: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
  /** An object relationship */
  vehicle?: Maybe<Vehicles>;
  /** An array relationship */
  vehicles: Array<Vehicles>;
  /** An aggregate relationship */
  vehicles_aggregate: Vehicles_Aggregate;
  verification_status?: Maybe<Scalars['document_status_enum']['output']>;
  ward_no?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "drivers" */
export type DriversDriver_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Driver_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Documents_Order_By>>;
  where?: InputMaybe<Driver_Documents_Bool_Exp>;
};


/** columns and relationships of "drivers" */
export type DriversDriver_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Driver_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Documents_Order_By>>;
  where?: InputMaybe<Driver_Documents_Bool_Exp>;
};


/** columns and relationships of "drivers" */
export type DriversDriver_Locations_CurrentsArgs = {
  distinct_on?: InputMaybe<Array<Driver_Locations_Current_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Locations_Current_Order_By>>;
  where?: InputMaybe<Driver_Locations_Current_Bool_Exp>;
};


/** columns and relationships of "drivers" */
export type DriversDriver_Locations_Currents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Driver_Locations_Current_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Locations_Current_Order_By>>;
  where?: InputMaybe<Driver_Locations_Current_Bool_Exp>;
};


/** columns and relationships of "drivers" */
export type DriversFree_RidesArgs = {
  distinct_on?: InputMaybe<Array<Free_Rides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Free_Rides_Order_By>>;
  where?: InputMaybe<Free_Rides_Bool_Exp>;
};


/** columns and relationships of "drivers" */
export type DriversFree_Rides_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Free_Rides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Free_Rides_Order_By>>;
  where?: InputMaybe<Free_Rides_Bool_Exp>;
};


/** columns and relationships of "drivers" */
export type DriversMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "drivers" */
export type DriversRatingsArgs = {
  distinct_on?: InputMaybe<Array<Ratings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ratings_Order_By>>;
  where?: InputMaybe<Ratings_Bool_Exp>;
};


/** columns and relationships of "drivers" */
export type DriversRatings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ratings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ratings_Order_By>>;
  where?: InputMaybe<Ratings_Bool_Exp>;
};


/** columns and relationships of "drivers" */
export type DriversRidesArgs = {
  distinct_on?: InputMaybe<Array<Rides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rides_Order_By>>;
  where?: InputMaybe<Rides_Bool_Exp>;
};


/** columns and relationships of "drivers" */
export type DriversRides_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rides_Order_By>>;
  where?: InputMaybe<Rides_Bool_Exp>;
};


/** columns and relationships of "drivers" */
export type DriversVehiclesArgs = {
  distinct_on?: InputMaybe<Array<Vehicles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicles_Order_By>>;
  where?: InputMaybe<Vehicles_Bool_Exp>;
};


/** columns and relationships of "drivers" */
export type DriversVehicles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicles_Order_By>>;
  where?: InputMaybe<Vehicles_Bool_Exp>;
};

/** aggregated selection of "drivers" */
export type Drivers_Aggregate = {
  __typename?: 'drivers_aggregate';
  aggregate?: Maybe<Drivers_Aggregate_Fields>;
  nodes: Array<Drivers>;
};

export type Drivers_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Drivers_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Drivers_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Drivers_Aggregate_Bool_Exp_Count>;
};

export type Drivers_Aggregate_Bool_Exp_Bool_And = {
  arguments: Drivers_Select_Column_Drivers_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Drivers_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Drivers_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Drivers_Select_Column_Drivers_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Drivers_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Drivers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Drivers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Drivers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "drivers" */
export type Drivers_Aggregate_Fields = {
  __typename?: 'drivers_aggregate_fields';
  avg?: Maybe<Drivers_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Drivers_Max_Fields>;
  min?: Maybe<Drivers_Min_Fields>;
  stddev?: Maybe<Drivers_Stddev_Fields>;
  stddev_pop?: Maybe<Drivers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Drivers_Stddev_Samp_Fields>;
  sum?: Maybe<Drivers_Sum_Fields>;
  var_pop?: Maybe<Drivers_Var_Pop_Fields>;
  var_samp?: Maybe<Drivers_Var_Samp_Fields>;
  variance?: Maybe<Drivers_Variance_Fields>;
};


/** aggregate fields of "drivers" */
export type Drivers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Drivers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "drivers" */
export type Drivers_Aggregate_Order_By = {
  avg?: InputMaybe<Drivers_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Drivers_Max_Order_By>;
  min?: InputMaybe<Drivers_Min_Order_By>;
  stddev?: InputMaybe<Drivers_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Drivers_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Drivers_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Drivers_Sum_Order_By>;
  var_pop?: InputMaybe<Drivers_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Drivers_Var_Samp_Order_By>;
  variance?: InputMaybe<Drivers_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Drivers_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "drivers" */
export type Drivers_Arr_Rel_Insert_Input = {
  data: Array<Drivers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Drivers_On_Conflict>;
};

/** aggregate avg on columns */
export type Drivers_Avg_Fields = {
  __typename?: 'drivers_avg_fields';
  average_rating?: Maybe<Scalars['Float']['output']>;
  total_rides?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "drivers" */
export type Drivers_Avg_Order_By = {
  average_rating?: InputMaybe<Order_By>;
  total_rides?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "drivers". All fields are combined with a logical 'AND'. */
export type Drivers_Bool_Exp = {
  _and?: InputMaybe<Array<Drivers_Bool_Exp>>;
  _not?: InputMaybe<Drivers_Bool_Exp>;
  _or?: InputMaybe<Array<Drivers_Bool_Exp>>;
  average_rating?: InputMaybe<Int_Comparison_Exp>;
  blood_donation_consent?: InputMaybe<Boolean_Comparison_Exp>;
  blood_group?: InputMaybe<Blood_Group_Enum_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  current_ride_id?: InputMaybe<Uuid_Comparison_Exp>;
  district?: InputMaybe<String_Comparison_Exp>;
  dob?: InputMaybe<String_Comparison_Exp>;
  driver_documents?: InputMaybe<Driver_Documents_Bool_Exp>;
  driver_documents_aggregate?: InputMaybe<Driver_Documents_Aggregate_Bool_Exp>;
  driver_locations_current?: InputMaybe<Driver_Locations_Current_Bool_Exp>;
  driver_locations_currents?: InputMaybe<Driver_Locations_Current_Bool_Exp>;
  driver_locations_currents_aggregate?: InputMaybe<Driver_Locations_Current_Aggregate_Bool_Exp>;
  free_rides?: InputMaybe<Free_Rides_Bool_Exp>;
  free_rides_aggregate?: InputMaybe<Free_Rides_Aggregate_Bool_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  insurance_number?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_busy?: InputMaybe<Boolean_Comparison_Exp>;
  license?: InputMaybe<Uuid_Comparison_Exp>;
  license_expiry?: InputMaybe<Date_Comparison_Exp>;
  license_number?: InputMaybe<String_Comparison_Exp>;
  local_unit?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notification_token?: InputMaybe<String_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  profile?: InputMaybe<Uuid_Comparison_Exp>;
  province?: InputMaybe<String_Comparison_Exp>;
  ratings?: InputMaybe<Ratings_Bool_Exp>;
  ratings_aggregate?: InputMaybe<Ratings_Aggregate_Bool_Exp>;
  rejection_reason?: InputMaybe<String_Comparison_Exp>;
  ride?: InputMaybe<Rides_Bool_Exp>;
  rides?: InputMaybe<Rides_Bool_Exp>;
  rides_aggregate?: InputMaybe<Rides_Aggregate_Bool_Exp>;
  selfie?: InputMaybe<Uuid_Comparison_Exp>;
  street_address?: InputMaybe<String_Comparison_Exp>;
  total_rides?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  vehicle?: InputMaybe<Vehicles_Bool_Exp>;
  vehicles?: InputMaybe<Vehicles_Bool_Exp>;
  vehicles_aggregate?: InputMaybe<Vehicles_Aggregate_Bool_Exp>;
  verification_status?: InputMaybe<Document_Status_Enum_Comparison_Exp>;
  ward_no?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "drivers" */
export enum Drivers_Constraint {
  /** unique or primary key constraint on columns "id" */
  DriversPkey = 'drivers_pkey',
  /** unique or primary key constraint on columns "user_id" */
  DriversUserIdKey = 'drivers_user_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Drivers_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Drivers_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Drivers_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "drivers" */
export type Drivers_Inc_Input = {
  average_rating?: InputMaybe<Scalars['Int']['input']>;
  total_rides?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "drivers" */
export type Drivers_Insert_Input = {
  average_rating?: InputMaybe<Scalars['Int']['input']>;
  blood_donation_consent?: InputMaybe<Scalars['Boolean']['input']>;
  blood_group?: InputMaybe<Scalars['blood_group_enum']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  current_ride_id?: InputMaybe<Scalars['uuid']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  driver_documents?: InputMaybe<Driver_Documents_Arr_Rel_Insert_Input>;
  driver_locations_current?: InputMaybe<Driver_Locations_Current_Obj_Rel_Insert_Input>;
  driver_locations_currents?: InputMaybe<Driver_Locations_Current_Arr_Rel_Insert_Input>;
  free_rides?: InputMaybe<Free_Rides_Arr_Rel_Insert_Input>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  insurance_number?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_busy?: InputMaybe<Scalars['Boolean']['input']>;
  license?: InputMaybe<Scalars['uuid']['input']>;
  license_expiry?: InputMaybe<Scalars['date']['input']>;
  license_number?: InputMaybe<Scalars['String']['input']>;
  local_unit?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notification_token?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  profile?: InputMaybe<Scalars['uuid']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  ratings?: InputMaybe<Ratings_Arr_Rel_Insert_Input>;
  rejection_reason?: InputMaybe<Scalars['String']['input']>;
  ride?: InputMaybe<Rides_Obj_Rel_Insert_Input>;
  rides?: InputMaybe<Rides_Arr_Rel_Insert_Input>;
  selfie?: InputMaybe<Scalars['uuid']['input']>;
  street_address?: InputMaybe<Scalars['String']['input']>;
  total_rides?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  vehicle?: InputMaybe<Vehicles_Obj_Rel_Insert_Input>;
  vehicles?: InputMaybe<Vehicles_Arr_Rel_Insert_Input>;
  verification_status?: InputMaybe<Scalars['document_status_enum']['input']>;
  ward_no?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Drivers_Max_Fields = {
  __typename?: 'drivers_max_fields';
  average_rating?: Maybe<Scalars['Int']['output']>;
  blood_group?: Maybe<Scalars['blood_group_enum']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  current_ride_id?: Maybe<Scalars['uuid']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  insurance_number?: Maybe<Scalars['String']['output']>;
  license?: Maybe<Scalars['uuid']['output']>;
  license_expiry?: Maybe<Scalars['date']['output']>;
  license_number?: Maybe<Scalars['String']['output']>;
  local_unit?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notification_token?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<Scalars['uuid']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  rejection_reason?: Maybe<Scalars['String']['output']>;
  selfie?: Maybe<Scalars['uuid']['output']>;
  street_address?: Maybe<Scalars['String']['output']>;
  total_rides?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  verification_status?: Maybe<Scalars['document_status_enum']['output']>;
  ward_no?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "drivers" */
export type Drivers_Max_Order_By = {
  average_rating?: InputMaybe<Order_By>;
  blood_group?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  current_ride_id?: InputMaybe<Order_By>;
  district?: InputMaybe<Order_By>;
  dob?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insurance_number?: InputMaybe<Order_By>;
  license?: InputMaybe<Order_By>;
  license_expiry?: InputMaybe<Order_By>;
  license_number?: InputMaybe<Order_By>;
  local_unit?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notification_token?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  profile?: InputMaybe<Order_By>;
  province?: InputMaybe<Order_By>;
  rejection_reason?: InputMaybe<Order_By>;
  selfie?: InputMaybe<Order_By>;
  street_address?: InputMaybe<Order_By>;
  total_rides?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  verification_status?: InputMaybe<Order_By>;
  ward_no?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Drivers_Min_Fields = {
  __typename?: 'drivers_min_fields';
  average_rating?: Maybe<Scalars['Int']['output']>;
  blood_group?: Maybe<Scalars['blood_group_enum']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  current_ride_id?: Maybe<Scalars['uuid']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  insurance_number?: Maybe<Scalars['String']['output']>;
  license?: Maybe<Scalars['uuid']['output']>;
  license_expiry?: Maybe<Scalars['date']['output']>;
  license_number?: Maybe<Scalars['String']['output']>;
  local_unit?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notification_token?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<Scalars['uuid']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  rejection_reason?: Maybe<Scalars['String']['output']>;
  selfie?: Maybe<Scalars['uuid']['output']>;
  street_address?: Maybe<Scalars['String']['output']>;
  total_rides?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  verification_status?: Maybe<Scalars['document_status_enum']['output']>;
  ward_no?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "drivers" */
export type Drivers_Min_Order_By = {
  average_rating?: InputMaybe<Order_By>;
  blood_group?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  current_ride_id?: InputMaybe<Order_By>;
  district?: InputMaybe<Order_By>;
  dob?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insurance_number?: InputMaybe<Order_By>;
  license?: InputMaybe<Order_By>;
  license_expiry?: InputMaybe<Order_By>;
  license_number?: InputMaybe<Order_By>;
  local_unit?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notification_token?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  profile?: InputMaybe<Order_By>;
  province?: InputMaybe<Order_By>;
  rejection_reason?: InputMaybe<Order_By>;
  selfie?: InputMaybe<Order_By>;
  street_address?: InputMaybe<Order_By>;
  total_rides?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  verification_status?: InputMaybe<Order_By>;
  ward_no?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "drivers" */
export type Drivers_Mutation_Response = {
  __typename?: 'drivers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Drivers>;
};

/** input type for inserting object relation for remote table "drivers" */
export type Drivers_Obj_Rel_Insert_Input = {
  data: Drivers_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Drivers_On_Conflict>;
};

/** on_conflict condition type for table "drivers" */
export type Drivers_On_Conflict = {
  constraint: Drivers_Constraint;
  update_columns?: Array<Drivers_Update_Column>;
  where?: InputMaybe<Drivers_Bool_Exp>;
};

/** Ordering options when selecting data from "drivers". */
export type Drivers_Order_By = {
  average_rating?: InputMaybe<Order_By>;
  blood_donation_consent?: InputMaybe<Order_By>;
  blood_group?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  current_ride_id?: InputMaybe<Order_By>;
  district?: InputMaybe<Order_By>;
  dob?: InputMaybe<Order_By>;
  driver_documents_aggregate?: InputMaybe<Driver_Documents_Aggregate_Order_By>;
  driver_locations_current?: InputMaybe<Driver_Locations_Current_Order_By>;
  driver_locations_currents_aggregate?: InputMaybe<Driver_Locations_Current_Aggregate_Order_By>;
  free_rides_aggregate?: InputMaybe<Free_Rides_Aggregate_Order_By>;
  gender?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insurance_number?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_busy?: InputMaybe<Order_By>;
  license?: InputMaybe<Order_By>;
  license_expiry?: InputMaybe<Order_By>;
  license_number?: InputMaybe<Order_By>;
  local_unit?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notification_token?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  profile?: InputMaybe<Order_By>;
  province?: InputMaybe<Order_By>;
  ratings_aggregate?: InputMaybe<Ratings_Aggregate_Order_By>;
  rejection_reason?: InputMaybe<Order_By>;
  ride?: InputMaybe<Rides_Order_By>;
  rides_aggregate?: InputMaybe<Rides_Aggregate_Order_By>;
  selfie?: InputMaybe<Order_By>;
  street_address?: InputMaybe<Order_By>;
  total_rides?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  vehicle?: InputMaybe<Vehicles_Order_By>;
  vehicles_aggregate?: InputMaybe<Vehicles_Aggregate_Order_By>;
  verification_status?: InputMaybe<Order_By>;
  ward_no?: InputMaybe<Order_By>;
};

/** primary key columns input for table: drivers */
export type Drivers_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Drivers_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "drivers" */
export enum Drivers_Select_Column {
  /** column name */
  AverageRating = 'average_rating',
  /** column name */
  BloodDonationConsent = 'blood_donation_consent',
  /** column name */
  BloodGroup = 'blood_group',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentRideId = 'current_ride_id',
  /** column name */
  District = 'district',
  /** column name */
  Dob = 'dob',
  /** column name */
  Gender = 'gender',
  /** column name */
  Id = 'id',
  /** column name */
  InsuranceNumber = 'insurance_number',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsBusy = 'is_busy',
  /** column name */
  License = 'license',
  /** column name */
  LicenseExpiry = 'license_expiry',
  /** column name */
  LicenseNumber = 'license_number',
  /** column name */
  LocalUnit = 'local_unit',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  NotificationToken = 'notification_token',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  Profile = 'profile',
  /** column name */
  Province = 'province',
  /** column name */
  RejectionReason = 'rejection_reason',
  /** column name */
  Selfie = 'selfie',
  /** column name */
  StreetAddress = 'street_address',
  /** column name */
  TotalRides = 'total_rides',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VerificationStatus = 'verification_status',
  /** column name */
  WardNo = 'ward_no'
}

/** select "drivers_aggregate_bool_exp_bool_and_arguments_columns" columns of table "drivers" */
export enum Drivers_Select_Column_Drivers_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  BloodDonationConsent = 'blood_donation_consent',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsBusy = 'is_busy'
}

/** select "drivers_aggregate_bool_exp_bool_or_arguments_columns" columns of table "drivers" */
export enum Drivers_Select_Column_Drivers_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  BloodDonationConsent = 'blood_donation_consent',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsBusy = 'is_busy'
}

/** input type for updating data in table "drivers" */
export type Drivers_Set_Input = {
  average_rating?: InputMaybe<Scalars['Int']['input']>;
  blood_donation_consent?: InputMaybe<Scalars['Boolean']['input']>;
  blood_group?: InputMaybe<Scalars['blood_group_enum']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  current_ride_id?: InputMaybe<Scalars['uuid']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  insurance_number?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_busy?: InputMaybe<Scalars['Boolean']['input']>;
  license?: InputMaybe<Scalars['uuid']['input']>;
  license_expiry?: InputMaybe<Scalars['date']['input']>;
  license_number?: InputMaybe<Scalars['String']['input']>;
  local_unit?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notification_token?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  profile?: InputMaybe<Scalars['uuid']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  rejection_reason?: InputMaybe<Scalars['String']['input']>;
  selfie?: InputMaybe<Scalars['uuid']['input']>;
  street_address?: InputMaybe<Scalars['String']['input']>;
  total_rides?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  verification_status?: InputMaybe<Scalars['document_status_enum']['input']>;
  ward_no?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Drivers_Stddev_Fields = {
  __typename?: 'drivers_stddev_fields';
  average_rating?: Maybe<Scalars['Float']['output']>;
  total_rides?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "drivers" */
export type Drivers_Stddev_Order_By = {
  average_rating?: InputMaybe<Order_By>;
  total_rides?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Drivers_Stddev_Pop_Fields = {
  __typename?: 'drivers_stddev_pop_fields';
  average_rating?: Maybe<Scalars['Float']['output']>;
  total_rides?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "drivers" */
export type Drivers_Stddev_Pop_Order_By = {
  average_rating?: InputMaybe<Order_By>;
  total_rides?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Drivers_Stddev_Samp_Fields = {
  __typename?: 'drivers_stddev_samp_fields';
  average_rating?: Maybe<Scalars['Float']['output']>;
  total_rides?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "drivers" */
export type Drivers_Stddev_Samp_Order_By = {
  average_rating?: InputMaybe<Order_By>;
  total_rides?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "drivers" */
export type Drivers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Drivers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Drivers_Stream_Cursor_Value_Input = {
  average_rating?: InputMaybe<Scalars['Int']['input']>;
  blood_donation_consent?: InputMaybe<Scalars['Boolean']['input']>;
  blood_group?: InputMaybe<Scalars['blood_group_enum']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  current_ride_id?: InputMaybe<Scalars['uuid']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  insurance_number?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_busy?: InputMaybe<Scalars['Boolean']['input']>;
  license?: InputMaybe<Scalars['uuid']['input']>;
  license_expiry?: InputMaybe<Scalars['date']['input']>;
  license_number?: InputMaybe<Scalars['String']['input']>;
  local_unit?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notification_token?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  profile?: InputMaybe<Scalars['uuid']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  rejection_reason?: InputMaybe<Scalars['String']['input']>;
  selfie?: InputMaybe<Scalars['uuid']['input']>;
  street_address?: InputMaybe<Scalars['String']['input']>;
  total_rides?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  verification_status?: InputMaybe<Scalars['document_status_enum']['input']>;
  ward_no?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Drivers_Sum_Fields = {
  __typename?: 'drivers_sum_fields';
  average_rating?: Maybe<Scalars['Int']['output']>;
  total_rides?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "drivers" */
export type Drivers_Sum_Order_By = {
  average_rating?: InputMaybe<Order_By>;
  total_rides?: InputMaybe<Order_By>;
};

/** update columns of table "drivers" */
export enum Drivers_Update_Column {
  /** column name */
  AverageRating = 'average_rating',
  /** column name */
  BloodDonationConsent = 'blood_donation_consent',
  /** column name */
  BloodGroup = 'blood_group',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentRideId = 'current_ride_id',
  /** column name */
  District = 'district',
  /** column name */
  Dob = 'dob',
  /** column name */
  Gender = 'gender',
  /** column name */
  Id = 'id',
  /** column name */
  InsuranceNumber = 'insurance_number',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsBusy = 'is_busy',
  /** column name */
  License = 'license',
  /** column name */
  LicenseExpiry = 'license_expiry',
  /** column name */
  LicenseNumber = 'license_number',
  /** column name */
  LocalUnit = 'local_unit',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  NotificationToken = 'notification_token',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  Profile = 'profile',
  /** column name */
  Province = 'province',
  /** column name */
  RejectionReason = 'rejection_reason',
  /** column name */
  Selfie = 'selfie',
  /** column name */
  StreetAddress = 'street_address',
  /** column name */
  TotalRides = 'total_rides',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VerificationStatus = 'verification_status',
  /** column name */
  WardNo = 'ward_no'
}

export type Drivers_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Drivers_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Drivers_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Drivers_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Drivers_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Drivers_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Drivers_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Drivers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Drivers_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Drivers_Var_Pop_Fields = {
  __typename?: 'drivers_var_pop_fields';
  average_rating?: Maybe<Scalars['Float']['output']>;
  total_rides?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "drivers" */
export type Drivers_Var_Pop_Order_By = {
  average_rating?: InputMaybe<Order_By>;
  total_rides?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Drivers_Var_Samp_Fields = {
  __typename?: 'drivers_var_samp_fields';
  average_rating?: Maybe<Scalars['Float']['output']>;
  total_rides?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "drivers" */
export type Drivers_Var_Samp_Order_By = {
  average_rating?: InputMaybe<Order_By>;
  total_rides?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Drivers_Variance_Fields = {
  __typename?: 'drivers_variance_fields';
  average_rating?: Maybe<Scalars['Float']['output']>;
  total_rides?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "drivers" */
export type Drivers_Variance_Order_By = {
  average_rating?: InputMaybe<Order_By>;
  total_rides?: InputMaybe<Order_By>;
};

/** columns and relationships of "fare_bands" */
export type Fare_Bands = {
  __typename?: 'fare_bands';
  band_end_km?: Maybe<Scalars['numeric']['output']>;
  band_start_km: Scalars['numeric']['output'];
  base_fare: Scalars['numeric']['output'];
  id: Scalars['uuid']['output'];
  per_km_fare: Scalars['numeric']['output'];
  vehicle_type: Scalars['String']['output'];
};

/** aggregated selection of "fare_bands" */
export type Fare_Bands_Aggregate = {
  __typename?: 'fare_bands_aggregate';
  aggregate?: Maybe<Fare_Bands_Aggregate_Fields>;
  nodes: Array<Fare_Bands>;
};

/** aggregate fields of "fare_bands" */
export type Fare_Bands_Aggregate_Fields = {
  __typename?: 'fare_bands_aggregate_fields';
  avg?: Maybe<Fare_Bands_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Fare_Bands_Max_Fields>;
  min?: Maybe<Fare_Bands_Min_Fields>;
  stddev?: Maybe<Fare_Bands_Stddev_Fields>;
  stddev_pop?: Maybe<Fare_Bands_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fare_Bands_Stddev_Samp_Fields>;
  sum?: Maybe<Fare_Bands_Sum_Fields>;
  var_pop?: Maybe<Fare_Bands_Var_Pop_Fields>;
  var_samp?: Maybe<Fare_Bands_Var_Samp_Fields>;
  variance?: Maybe<Fare_Bands_Variance_Fields>;
};


/** aggregate fields of "fare_bands" */
export type Fare_Bands_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fare_Bands_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Fare_Bands_Avg_Fields = {
  __typename?: 'fare_bands_avg_fields';
  band_end_km?: Maybe<Scalars['Float']['output']>;
  band_start_km?: Maybe<Scalars['Float']['output']>;
  base_fare?: Maybe<Scalars['Float']['output']>;
  per_km_fare?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "fare_bands". All fields are combined with a logical 'AND'. */
export type Fare_Bands_Bool_Exp = {
  _and?: InputMaybe<Array<Fare_Bands_Bool_Exp>>;
  _not?: InputMaybe<Fare_Bands_Bool_Exp>;
  _or?: InputMaybe<Array<Fare_Bands_Bool_Exp>>;
  band_end_km?: InputMaybe<Numeric_Comparison_Exp>;
  band_start_km?: InputMaybe<Numeric_Comparison_Exp>;
  base_fare?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  per_km_fare?: InputMaybe<Numeric_Comparison_Exp>;
  vehicle_type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "fare_bands" */
export enum Fare_Bands_Constraint {
  /** unique or primary key constraint on columns "id" */
  FareBandsPkey = 'fare_bands_pkey'
}

/** input type for incrementing numeric columns in table "fare_bands" */
export type Fare_Bands_Inc_Input = {
  band_end_km?: InputMaybe<Scalars['numeric']['input']>;
  band_start_km?: InputMaybe<Scalars['numeric']['input']>;
  base_fare?: InputMaybe<Scalars['numeric']['input']>;
  per_km_fare?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "fare_bands" */
export type Fare_Bands_Insert_Input = {
  band_end_km?: InputMaybe<Scalars['numeric']['input']>;
  band_start_km?: InputMaybe<Scalars['numeric']['input']>;
  base_fare?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  per_km_fare?: InputMaybe<Scalars['numeric']['input']>;
  vehicle_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Fare_Bands_Max_Fields = {
  __typename?: 'fare_bands_max_fields';
  band_end_km?: Maybe<Scalars['numeric']['output']>;
  band_start_km?: Maybe<Scalars['numeric']['output']>;
  base_fare?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  per_km_fare?: Maybe<Scalars['numeric']['output']>;
  vehicle_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Fare_Bands_Min_Fields = {
  __typename?: 'fare_bands_min_fields';
  band_end_km?: Maybe<Scalars['numeric']['output']>;
  band_start_km?: Maybe<Scalars['numeric']['output']>;
  base_fare?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  per_km_fare?: Maybe<Scalars['numeric']['output']>;
  vehicle_type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "fare_bands" */
export type Fare_Bands_Mutation_Response = {
  __typename?: 'fare_bands_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Fare_Bands>;
};

/** on_conflict condition type for table "fare_bands" */
export type Fare_Bands_On_Conflict = {
  constraint: Fare_Bands_Constraint;
  update_columns?: Array<Fare_Bands_Update_Column>;
  where?: InputMaybe<Fare_Bands_Bool_Exp>;
};

/** Ordering options when selecting data from "fare_bands". */
export type Fare_Bands_Order_By = {
  band_end_km?: InputMaybe<Order_By>;
  band_start_km?: InputMaybe<Order_By>;
  base_fare?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  per_km_fare?: InputMaybe<Order_By>;
  vehicle_type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: fare_bands */
export type Fare_Bands_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "fare_bands" */
export enum Fare_Bands_Select_Column {
  /** column name */
  BandEndKm = 'band_end_km',
  /** column name */
  BandStartKm = 'band_start_km',
  /** column name */
  BaseFare = 'base_fare',
  /** column name */
  Id = 'id',
  /** column name */
  PerKmFare = 'per_km_fare',
  /** column name */
  VehicleType = 'vehicle_type'
}

/** input type for updating data in table "fare_bands" */
export type Fare_Bands_Set_Input = {
  band_end_km?: InputMaybe<Scalars['numeric']['input']>;
  band_start_km?: InputMaybe<Scalars['numeric']['input']>;
  base_fare?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  per_km_fare?: InputMaybe<Scalars['numeric']['input']>;
  vehicle_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Fare_Bands_Stddev_Fields = {
  __typename?: 'fare_bands_stddev_fields';
  band_end_km?: Maybe<Scalars['Float']['output']>;
  band_start_km?: Maybe<Scalars['Float']['output']>;
  base_fare?: Maybe<Scalars['Float']['output']>;
  per_km_fare?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Fare_Bands_Stddev_Pop_Fields = {
  __typename?: 'fare_bands_stddev_pop_fields';
  band_end_km?: Maybe<Scalars['Float']['output']>;
  band_start_km?: Maybe<Scalars['Float']['output']>;
  base_fare?: Maybe<Scalars['Float']['output']>;
  per_km_fare?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Fare_Bands_Stddev_Samp_Fields = {
  __typename?: 'fare_bands_stddev_samp_fields';
  band_end_km?: Maybe<Scalars['Float']['output']>;
  band_start_km?: Maybe<Scalars['Float']['output']>;
  base_fare?: Maybe<Scalars['Float']['output']>;
  per_km_fare?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "fare_bands" */
export type Fare_Bands_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fare_Bands_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fare_Bands_Stream_Cursor_Value_Input = {
  band_end_km?: InputMaybe<Scalars['numeric']['input']>;
  band_start_km?: InputMaybe<Scalars['numeric']['input']>;
  base_fare?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  per_km_fare?: InputMaybe<Scalars['numeric']['input']>;
  vehicle_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Fare_Bands_Sum_Fields = {
  __typename?: 'fare_bands_sum_fields';
  band_end_km?: Maybe<Scalars['numeric']['output']>;
  band_start_km?: Maybe<Scalars['numeric']['output']>;
  base_fare?: Maybe<Scalars['numeric']['output']>;
  per_km_fare?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "fare_bands" */
export enum Fare_Bands_Update_Column {
  /** column name */
  BandEndKm = 'band_end_km',
  /** column name */
  BandStartKm = 'band_start_km',
  /** column name */
  BaseFare = 'base_fare',
  /** column name */
  Id = 'id',
  /** column name */
  PerKmFare = 'per_km_fare',
  /** column name */
  VehicleType = 'vehicle_type'
}

export type Fare_Bands_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Fare_Bands_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Fare_Bands_Set_Input>;
  /** filter the rows which have to be updated */
  where: Fare_Bands_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Fare_Bands_Var_Pop_Fields = {
  __typename?: 'fare_bands_var_pop_fields';
  band_end_km?: Maybe<Scalars['Float']['output']>;
  band_start_km?: Maybe<Scalars['Float']['output']>;
  base_fare?: Maybe<Scalars['Float']['output']>;
  per_km_fare?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Fare_Bands_Var_Samp_Fields = {
  __typename?: 'fare_bands_var_samp_fields';
  band_end_km?: Maybe<Scalars['Float']['output']>;
  band_start_km?: Maybe<Scalars['Float']['output']>;
  base_fare?: Maybe<Scalars['Float']['output']>;
  per_km_fare?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Fare_Bands_Variance_Fields = {
  __typename?: 'fare_bands_variance_fields';
  band_end_km?: Maybe<Scalars['Float']['output']>;
  band_start_km?: Maybe<Scalars['Float']['output']>;
  base_fare?: Maybe<Scalars['Float']['output']>;
  per_km_fare?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "feedback" */
export type Feedback = {
  __typename?: 'feedback';
  address?: Maybe<Scalars['String']['output']>;
  category: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  feedback_number: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  is_report: Scalars['Boolean']['output'];
  location?: Maybe<Scalars['geography']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user_profile?: Maybe<User_Profiles>;
  user_profile_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "feedback" */
export type Feedback_Aggregate = {
  __typename?: 'feedback_aggregate';
  aggregate?: Maybe<Feedback_Aggregate_Fields>;
  nodes: Array<Feedback>;
};

/** aggregate fields of "feedback" */
export type Feedback_Aggregate_Fields = {
  __typename?: 'feedback_aggregate_fields';
  avg?: Maybe<Feedback_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Feedback_Max_Fields>;
  min?: Maybe<Feedback_Min_Fields>;
  stddev?: Maybe<Feedback_Stddev_Fields>;
  stddev_pop?: Maybe<Feedback_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Feedback_Stddev_Samp_Fields>;
  sum?: Maybe<Feedback_Sum_Fields>;
  var_pop?: Maybe<Feedback_Var_Pop_Fields>;
  var_samp?: Maybe<Feedback_Var_Samp_Fields>;
  variance?: Maybe<Feedback_Variance_Fields>;
};


/** aggregate fields of "feedback" */
export type Feedback_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Feedback_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Feedback_Avg_Fields = {
  __typename?: 'feedback_avg_fields';
  feedback_number?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "feedback". All fields are combined with a logical 'AND'. */
export type Feedback_Bool_Exp = {
  _and?: InputMaybe<Array<Feedback_Bool_Exp>>;
  _not?: InputMaybe<Feedback_Bool_Exp>;
  _or?: InputMaybe<Array<Feedback_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  category?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  feedback_number?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_report?: InputMaybe<Boolean_Comparison_Exp>;
  location?: InputMaybe<Geography_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_profile?: InputMaybe<User_Profiles_Bool_Exp>;
  user_profile_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "feedback" */
export enum Feedback_Constraint {
  /** unique or primary key constraint on columns "id" */
  FeedbackPkey = 'feedback_pkey'
}

/** input type for incrementing numeric columns in table "feedback" */
export type Feedback_Inc_Input = {
  feedback_number?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "feedback" */
export type Feedback_Insert_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  feedback_number?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_report?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['geography']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_profile?: InputMaybe<User_Profiles_Obj_Rel_Insert_Input>;
  user_profile_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Feedback_Max_Fields = {
  __typename?: 'feedback_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  feedback_number?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_profile_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Feedback_Min_Fields = {
  __typename?: 'feedback_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  feedback_number?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_profile_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "feedback" */
export type Feedback_Mutation_Response = {
  __typename?: 'feedback_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Feedback>;
};

/** on_conflict condition type for table "feedback" */
export type Feedback_On_Conflict = {
  constraint: Feedback_Constraint;
  update_columns?: Array<Feedback_Update_Column>;
  where?: InputMaybe<Feedback_Bool_Exp>;
};

/** Ordering options when selecting data from "feedback". */
export type Feedback_Order_By = {
  address?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  feedback_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_report?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_profile?: InputMaybe<User_Profiles_Order_By>;
  user_profile_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: feedback */
export type Feedback_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "feedback" */
export enum Feedback_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FeedbackNumber = 'feedback_number',
  /** column name */
  Id = 'id',
  /** column name */
  IsReport = 'is_report',
  /** column name */
  Location = 'location',
  /** column name */
  Message = 'message',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserProfileId = 'user_profile_id'
}

/** input type for updating data in table "feedback" */
export type Feedback_Set_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  feedback_number?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_report?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['geography']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_profile_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Feedback_Stddev_Fields = {
  __typename?: 'feedback_stddev_fields';
  feedback_number?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Feedback_Stddev_Pop_Fields = {
  __typename?: 'feedback_stddev_pop_fields';
  feedback_number?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Feedback_Stddev_Samp_Fields = {
  __typename?: 'feedback_stddev_samp_fields';
  feedback_number?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "feedback" */
export type Feedback_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Feedback_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Feedback_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  feedback_number?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_report?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['geography']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_profile_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Feedback_Sum_Fields = {
  __typename?: 'feedback_sum_fields';
  feedback_number?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "feedback" */
export enum Feedback_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FeedbackNumber = 'feedback_number',
  /** column name */
  Id = 'id',
  /** column name */
  IsReport = 'is_report',
  /** column name */
  Location = 'location',
  /** column name */
  Message = 'message',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserProfileId = 'user_profile_id'
}

export type Feedback_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Feedback_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Feedback_Set_Input>;
  /** filter the rows which have to be updated */
  where: Feedback_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Feedback_Var_Pop_Fields = {
  __typename?: 'feedback_var_pop_fields';
  feedback_number?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Feedback_Var_Samp_Fields = {
  __typename?: 'feedback_var_samp_fields';
  feedback_number?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Feedback_Variance_Fields = {
  __typename?: 'feedback_variance_fields';
  feedback_number?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "storage.files" */
export type Files = {
  __typename?: 'files';
  /** An object relationship */
  bucket: Buckets;
  bucketId: Scalars['String']['output'];
  createdAt: Scalars['timestamptz']['output'];
  etag?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  isUploaded?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  uploadedByUserId?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "storage.files" */
export type FilesMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "storage.files" */
export type Files_Aggregate = {
  __typename?: 'files_aggregate';
  aggregate?: Maybe<Files_Aggregate_Fields>;
  nodes: Array<Files>;
};

export type Files_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Files_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Files_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Files_Aggregate_Bool_Exp_Count>;
};

export type Files_Aggregate_Bool_Exp_Bool_And = {
  arguments: Files_Select_Column_Files_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Files_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Files_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Files_Select_Column_Files_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Files_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Files_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Files_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Files_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "storage.files" */
export type Files_Aggregate_Fields = {
  __typename?: 'files_aggregate_fields';
  avg?: Maybe<Files_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Files_Max_Fields>;
  min?: Maybe<Files_Min_Fields>;
  stddev?: Maybe<Files_Stddev_Fields>;
  stddev_pop?: Maybe<Files_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Files_Stddev_Samp_Fields>;
  sum?: Maybe<Files_Sum_Fields>;
  var_pop?: Maybe<Files_Var_Pop_Fields>;
  var_samp?: Maybe<Files_Var_Samp_Fields>;
  variance?: Maybe<Files_Variance_Fields>;
};


/** aggregate fields of "storage.files" */
export type Files_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Files_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "storage.files" */
export type Files_Aggregate_Order_By = {
  avg?: InputMaybe<Files_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Files_Max_Order_By>;
  min?: InputMaybe<Files_Min_Order_By>;
  stddev?: InputMaybe<Files_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Files_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Files_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Files_Sum_Order_By>;
  var_pop?: InputMaybe<Files_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Files_Var_Samp_Order_By>;
  variance?: InputMaybe<Files_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Files_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "storage.files" */
export type Files_Arr_Rel_Insert_Input = {
  data: Array<Files_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Files_On_Conflict>;
};

/** aggregate avg on columns */
export type Files_Avg_Fields = {
  __typename?: 'files_avg_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "storage.files" */
export type Files_Avg_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "storage.files". All fields are combined with a logical 'AND'. */
export type Files_Bool_Exp = {
  _and?: InputMaybe<Array<Files_Bool_Exp>>;
  _not?: InputMaybe<Files_Bool_Exp>;
  _or?: InputMaybe<Array<Files_Bool_Exp>>;
  bucket?: InputMaybe<Buckets_Bool_Exp>;
  bucketId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  etag?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isUploaded?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mimeType?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  uploadedByUserId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "storage.files" */
export enum Files_Constraint {
  /** unique or primary key constraint on columns "id" */
  FilesPkey = 'files_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Files_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Files_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Files_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "storage.files" */
export type Files_Inc_Input = {
  size?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "storage.files" */
export type Files_Insert_Input = {
  bucket?: InputMaybe<Buckets_Obj_Rel_Insert_Input>;
  bucketId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  uploadedByUserId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Files_Max_Fields = {
  __typename?: 'files_max_fields';
  bucketId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  uploadedByUserId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "storage.files" */
export type Files_Max_Order_By = {
  bucketId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  etag?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mimeType?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  uploadedByUserId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Files_Min_Fields = {
  __typename?: 'files_min_fields';
  bucketId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  uploadedByUserId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "storage.files" */
export type Files_Min_Order_By = {
  bucketId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  etag?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mimeType?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  uploadedByUserId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "storage.files" */
export type Files_Mutation_Response = {
  __typename?: 'files_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Files>;
};

/** input type for inserting object relation for remote table "storage.files" */
export type Files_Obj_Rel_Insert_Input = {
  data: Files_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Files_On_Conflict>;
};

/** on_conflict condition type for table "storage.files" */
export type Files_On_Conflict = {
  constraint: Files_Constraint;
  update_columns?: Array<Files_Update_Column>;
  where?: InputMaybe<Files_Bool_Exp>;
};

/** Ordering options when selecting data from "storage.files". */
export type Files_Order_By = {
  bucket?: InputMaybe<Buckets_Order_By>;
  bucketId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  etag?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isUploaded?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  mimeType?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  uploadedByUserId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storage.files */
export type Files_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Files_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "storage.files" */
export enum Files_Select_Column {
  /** column name */
  BucketId = 'bucketId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Etag = 'etag',
  /** column name */
  Id = 'id',
  /** column name */
  IsUploaded = 'isUploaded',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MimeType = 'mimeType',
  /** column name */
  Name = 'name',
  /** column name */
  Size = 'size',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UploadedByUserId = 'uploadedByUserId'
}

/** select "files_aggregate_bool_exp_bool_and_arguments_columns" columns of table "storage.files" */
export enum Files_Select_Column_Files_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsUploaded = 'isUploaded'
}

/** select "files_aggregate_bool_exp_bool_or_arguments_columns" columns of table "storage.files" */
export enum Files_Select_Column_Files_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsUploaded = 'isUploaded'
}

/** input type for updating data in table "storage.files" */
export type Files_Set_Input = {
  bucketId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  uploadedByUserId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Files_Stddev_Fields = {
  __typename?: 'files_stddev_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "storage.files" */
export type Files_Stddev_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Files_Stddev_Pop_Fields = {
  __typename?: 'files_stddev_pop_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "storage.files" */
export type Files_Stddev_Pop_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Files_Stddev_Samp_Fields = {
  __typename?: 'files_stddev_samp_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "storage.files" */
export type Files_Stddev_Samp_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "files" */
export type Files_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Files_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Files_Stream_Cursor_Value_Input = {
  bucketId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  uploadedByUserId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Files_Sum_Fields = {
  __typename?: 'files_sum_fields';
  size?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "storage.files" */
export type Files_Sum_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** update columns of table "storage.files" */
export enum Files_Update_Column {
  /** column name */
  BucketId = 'bucketId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Etag = 'etag',
  /** column name */
  Id = 'id',
  /** column name */
  IsUploaded = 'isUploaded',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MimeType = 'mimeType',
  /** column name */
  Name = 'name',
  /** column name */
  Size = 'size',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UploadedByUserId = 'uploadedByUserId'
}

export type Files_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Files_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Files_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Files_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Files_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Files_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Files_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Files_Set_Input>;
  /** filter the rows which have to be updated */
  where: Files_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Files_Var_Pop_Fields = {
  __typename?: 'files_var_pop_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "storage.files" */
export type Files_Var_Pop_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Files_Var_Samp_Fields = {
  __typename?: 'files_var_samp_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "storage.files" */
export type Files_Var_Samp_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Files_Variance_Fields = {
  __typename?: 'files_variance_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "storage.files" */
export type Files_Variance_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** columns and relationships of "free_rides" */
export type Free_Rides = {
  __typename?: 'free_rides';
  cancel_reason?: Maybe<Scalars['String']['output']>;
  candidate_driver_ids?: Maybe<Scalars['jsonb']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  driver?: Maybe<Drivers>;
  driver_address?: Maybe<Scalars['String']['output']>;
  driver_distance?: Maybe<Scalars['numeric']['output']>;
  driver_id?: Maybe<Scalars['uuid']['output']>;
  driver_location?: Maybe<Scalars['geography']['output']>;
  dropoff_address?: Maybe<Scalars['String']['output']>;
  dropoff_location?: Maybe<Scalars['geography']['output']>;
  estimated_distance?: Maybe<Scalars['numeric']['output']>;
  estimated_duration?: Maybe<Scalars['numeric']['output']>;
  estimated_fare?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  passenger_count?: Maybe<Scalars['numeric']['output']>;
  pickup_address?: Maybe<Scalars['String']['output']>;
  pickup_location?: Maybe<Scalars['geography']['output']>;
  profile_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  rating?: Maybe<Ratings>;
  route_geometry?: Maybe<Scalars['geometry']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user_profile?: Maybe<User_Profiles>;
  vehicle_type?: Maybe<Scalars['vehicle_type_enum']['output']>;
};


/** columns and relationships of "free_rides" */
export type Free_RidesCandidate_Driver_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "free_rides" */
export type Free_Rides_Aggregate = {
  __typename?: 'free_rides_aggregate';
  aggregate?: Maybe<Free_Rides_Aggregate_Fields>;
  nodes: Array<Free_Rides>;
};

export type Free_Rides_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Free_Rides_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Free_Rides_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Free_Rides_Aggregate_Bool_Exp_Count>;
};

export type Free_Rides_Aggregate_Bool_Exp_Bool_And = {
  arguments: Free_Rides_Select_Column_Free_Rides_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Free_Rides_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Free_Rides_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Free_Rides_Select_Column_Free_Rides_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Free_Rides_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Free_Rides_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Free_Rides_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Free_Rides_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "free_rides" */
export type Free_Rides_Aggregate_Fields = {
  __typename?: 'free_rides_aggregate_fields';
  avg?: Maybe<Free_Rides_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Free_Rides_Max_Fields>;
  min?: Maybe<Free_Rides_Min_Fields>;
  stddev?: Maybe<Free_Rides_Stddev_Fields>;
  stddev_pop?: Maybe<Free_Rides_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Free_Rides_Stddev_Samp_Fields>;
  sum?: Maybe<Free_Rides_Sum_Fields>;
  var_pop?: Maybe<Free_Rides_Var_Pop_Fields>;
  var_samp?: Maybe<Free_Rides_Var_Samp_Fields>;
  variance?: Maybe<Free_Rides_Variance_Fields>;
};


/** aggregate fields of "free_rides" */
export type Free_Rides_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Free_Rides_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "free_rides" */
export type Free_Rides_Aggregate_Order_By = {
  avg?: InputMaybe<Free_Rides_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Free_Rides_Max_Order_By>;
  min?: InputMaybe<Free_Rides_Min_Order_By>;
  stddev?: InputMaybe<Free_Rides_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Free_Rides_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Free_Rides_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Free_Rides_Sum_Order_By>;
  var_pop?: InputMaybe<Free_Rides_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Free_Rides_Var_Samp_Order_By>;
  variance?: InputMaybe<Free_Rides_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Free_Rides_Append_Input = {
  candidate_driver_ids?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "free_rides" */
export type Free_Rides_Arr_Rel_Insert_Input = {
  data: Array<Free_Rides_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Free_Rides_On_Conflict>;
};

/** aggregate avg on columns */
export type Free_Rides_Avg_Fields = {
  __typename?: 'free_rides_avg_fields';
  driver_distance?: Maybe<Scalars['Float']['output']>;
  estimated_distance?: Maybe<Scalars['Float']['output']>;
  estimated_duration?: Maybe<Scalars['Float']['output']>;
  estimated_fare?: Maybe<Scalars['Float']['output']>;
  passenger_count?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "free_rides" */
export type Free_Rides_Avg_Order_By = {
  driver_distance?: InputMaybe<Order_By>;
  estimated_distance?: InputMaybe<Order_By>;
  estimated_duration?: InputMaybe<Order_By>;
  estimated_fare?: InputMaybe<Order_By>;
  passenger_count?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "free_rides". All fields are combined with a logical 'AND'. */
export type Free_Rides_Bool_Exp = {
  _and?: InputMaybe<Array<Free_Rides_Bool_Exp>>;
  _not?: InputMaybe<Free_Rides_Bool_Exp>;
  _or?: InputMaybe<Array<Free_Rides_Bool_Exp>>;
  cancel_reason?: InputMaybe<String_Comparison_Exp>;
  candidate_driver_ids?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  driver?: InputMaybe<Drivers_Bool_Exp>;
  driver_address?: InputMaybe<String_Comparison_Exp>;
  driver_distance?: InputMaybe<Numeric_Comparison_Exp>;
  driver_id?: InputMaybe<Uuid_Comparison_Exp>;
  driver_location?: InputMaybe<Geography_Comparison_Exp>;
  dropoff_address?: InputMaybe<String_Comparison_Exp>;
  dropoff_location?: InputMaybe<Geography_Comparison_Exp>;
  estimated_distance?: InputMaybe<Numeric_Comparison_Exp>;
  estimated_duration?: InputMaybe<Numeric_Comparison_Exp>;
  estimated_fare?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  passenger_count?: InputMaybe<Numeric_Comparison_Exp>;
  pickup_address?: InputMaybe<String_Comparison_Exp>;
  pickup_location?: InputMaybe<Geography_Comparison_Exp>;
  profile_id?: InputMaybe<Uuid_Comparison_Exp>;
  rating?: InputMaybe<Ratings_Bool_Exp>;
  route_geometry?: InputMaybe<Geometry_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_profile?: InputMaybe<User_Profiles_Bool_Exp>;
  vehicle_type?: InputMaybe<Vehicle_Type_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "free_rides" */
export enum Free_Rides_Constraint {
  /** unique or primary key constraint on columns "id" */
  FreeRidesPkey = 'free_rides_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Free_Rides_Delete_At_Path_Input = {
  candidate_driver_ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Free_Rides_Delete_Elem_Input = {
  candidate_driver_ids?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Free_Rides_Delete_Key_Input = {
  candidate_driver_ids?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "free_rides" */
export type Free_Rides_Inc_Input = {
  driver_distance?: InputMaybe<Scalars['numeric']['input']>;
  estimated_distance?: InputMaybe<Scalars['numeric']['input']>;
  estimated_duration?: InputMaybe<Scalars['numeric']['input']>;
  estimated_fare?: InputMaybe<Scalars['numeric']['input']>;
  passenger_count?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "free_rides" */
export type Free_Rides_Insert_Input = {
  cancel_reason?: InputMaybe<Scalars['String']['input']>;
  candidate_driver_ids?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  driver?: InputMaybe<Drivers_Obj_Rel_Insert_Input>;
  driver_address?: InputMaybe<Scalars['String']['input']>;
  driver_distance?: InputMaybe<Scalars['numeric']['input']>;
  driver_id?: InputMaybe<Scalars['uuid']['input']>;
  driver_location?: InputMaybe<Scalars['geography']['input']>;
  dropoff_address?: InputMaybe<Scalars['String']['input']>;
  dropoff_location?: InputMaybe<Scalars['geography']['input']>;
  estimated_distance?: InputMaybe<Scalars['numeric']['input']>;
  estimated_duration?: InputMaybe<Scalars['numeric']['input']>;
  estimated_fare?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  passenger_count?: InputMaybe<Scalars['numeric']['input']>;
  pickup_address?: InputMaybe<Scalars['String']['input']>;
  pickup_location?: InputMaybe<Scalars['geography']['input']>;
  profile_id?: InputMaybe<Scalars['uuid']['input']>;
  rating?: InputMaybe<Ratings_Obj_Rel_Insert_Input>;
  route_geometry?: InputMaybe<Scalars['geometry']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_profile?: InputMaybe<User_Profiles_Obj_Rel_Insert_Input>;
  vehicle_type?: InputMaybe<Scalars['vehicle_type_enum']['input']>;
};

/** aggregate max on columns */
export type Free_Rides_Max_Fields = {
  __typename?: 'free_rides_max_fields';
  cancel_reason?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  driver_address?: Maybe<Scalars['String']['output']>;
  driver_distance?: Maybe<Scalars['numeric']['output']>;
  driver_id?: Maybe<Scalars['uuid']['output']>;
  dropoff_address?: Maybe<Scalars['String']['output']>;
  estimated_distance?: Maybe<Scalars['numeric']['output']>;
  estimated_duration?: Maybe<Scalars['numeric']['output']>;
  estimated_fare?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  passenger_count?: Maybe<Scalars['numeric']['output']>;
  pickup_address?: Maybe<Scalars['String']['output']>;
  profile_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  vehicle_type?: Maybe<Scalars['vehicle_type_enum']['output']>;
};

/** order by max() on columns of table "free_rides" */
export type Free_Rides_Max_Order_By = {
  cancel_reason?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  driver_address?: InputMaybe<Order_By>;
  driver_distance?: InputMaybe<Order_By>;
  driver_id?: InputMaybe<Order_By>;
  dropoff_address?: InputMaybe<Order_By>;
  estimated_distance?: InputMaybe<Order_By>;
  estimated_duration?: InputMaybe<Order_By>;
  estimated_fare?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  passenger_count?: InputMaybe<Order_By>;
  pickup_address?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vehicle_type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Free_Rides_Min_Fields = {
  __typename?: 'free_rides_min_fields';
  cancel_reason?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  driver_address?: Maybe<Scalars['String']['output']>;
  driver_distance?: Maybe<Scalars['numeric']['output']>;
  driver_id?: Maybe<Scalars['uuid']['output']>;
  dropoff_address?: Maybe<Scalars['String']['output']>;
  estimated_distance?: Maybe<Scalars['numeric']['output']>;
  estimated_duration?: Maybe<Scalars['numeric']['output']>;
  estimated_fare?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  passenger_count?: Maybe<Scalars['numeric']['output']>;
  pickup_address?: Maybe<Scalars['String']['output']>;
  profile_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  vehicle_type?: Maybe<Scalars['vehicle_type_enum']['output']>;
};

/** order by min() on columns of table "free_rides" */
export type Free_Rides_Min_Order_By = {
  cancel_reason?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  driver_address?: InputMaybe<Order_By>;
  driver_distance?: InputMaybe<Order_By>;
  driver_id?: InputMaybe<Order_By>;
  dropoff_address?: InputMaybe<Order_By>;
  estimated_distance?: InputMaybe<Order_By>;
  estimated_duration?: InputMaybe<Order_By>;
  estimated_fare?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  passenger_count?: InputMaybe<Order_By>;
  pickup_address?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vehicle_type?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "free_rides" */
export type Free_Rides_Mutation_Response = {
  __typename?: 'free_rides_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Free_Rides>;
};

/** input type for inserting object relation for remote table "free_rides" */
export type Free_Rides_Obj_Rel_Insert_Input = {
  data: Free_Rides_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Free_Rides_On_Conflict>;
};

/** on_conflict condition type for table "free_rides" */
export type Free_Rides_On_Conflict = {
  constraint: Free_Rides_Constraint;
  update_columns?: Array<Free_Rides_Update_Column>;
  where?: InputMaybe<Free_Rides_Bool_Exp>;
};

/** Ordering options when selecting data from "free_rides". */
export type Free_Rides_Order_By = {
  cancel_reason?: InputMaybe<Order_By>;
  candidate_driver_ids?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  driver?: InputMaybe<Drivers_Order_By>;
  driver_address?: InputMaybe<Order_By>;
  driver_distance?: InputMaybe<Order_By>;
  driver_id?: InputMaybe<Order_By>;
  driver_location?: InputMaybe<Order_By>;
  dropoff_address?: InputMaybe<Order_By>;
  dropoff_location?: InputMaybe<Order_By>;
  estimated_distance?: InputMaybe<Order_By>;
  estimated_duration?: InputMaybe<Order_By>;
  estimated_fare?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  passenger_count?: InputMaybe<Order_By>;
  pickup_address?: InputMaybe<Order_By>;
  pickup_location?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
  rating?: InputMaybe<Ratings_Order_By>;
  route_geometry?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_profile?: InputMaybe<User_Profiles_Order_By>;
  vehicle_type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: free_rides */
export type Free_Rides_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Free_Rides_Prepend_Input = {
  candidate_driver_ids?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "free_rides" */
export enum Free_Rides_Select_Column {
  /** column name */
  CancelReason = 'cancel_reason',
  /** column name */
  CandidateDriverIds = 'candidate_driver_ids',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DriverAddress = 'driver_address',
  /** column name */
  DriverDistance = 'driver_distance',
  /** column name */
  DriverId = 'driver_id',
  /** column name */
  DriverLocation = 'driver_location',
  /** column name */
  DropoffAddress = 'dropoff_address',
  /** column name */
  DropoffLocation = 'dropoff_location',
  /** column name */
  EstimatedDistance = 'estimated_distance',
  /** column name */
  EstimatedDuration = 'estimated_duration',
  /** column name */
  EstimatedFare = 'estimated_fare',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  PassengerCount = 'passenger_count',
  /** column name */
  PickupAddress = 'pickup_address',
  /** column name */
  PickupLocation = 'pickup_location',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  RouteGeometry = 'route_geometry',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VehicleType = 'vehicle_type'
}

/** select "free_rides_aggregate_bool_exp_bool_and_arguments_columns" columns of table "free_rides" */
export enum Free_Rides_Select_Column_Free_Rides_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "free_rides_aggregate_bool_exp_bool_or_arguments_columns" columns of table "free_rides" */
export enum Free_Rides_Select_Column_Free_Rides_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "free_rides" */
export type Free_Rides_Set_Input = {
  cancel_reason?: InputMaybe<Scalars['String']['input']>;
  candidate_driver_ids?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  driver_address?: InputMaybe<Scalars['String']['input']>;
  driver_distance?: InputMaybe<Scalars['numeric']['input']>;
  driver_id?: InputMaybe<Scalars['uuid']['input']>;
  driver_location?: InputMaybe<Scalars['geography']['input']>;
  dropoff_address?: InputMaybe<Scalars['String']['input']>;
  dropoff_location?: InputMaybe<Scalars['geography']['input']>;
  estimated_distance?: InputMaybe<Scalars['numeric']['input']>;
  estimated_duration?: InputMaybe<Scalars['numeric']['input']>;
  estimated_fare?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  passenger_count?: InputMaybe<Scalars['numeric']['input']>;
  pickup_address?: InputMaybe<Scalars['String']['input']>;
  pickup_location?: InputMaybe<Scalars['geography']['input']>;
  profile_id?: InputMaybe<Scalars['uuid']['input']>;
  route_geometry?: InputMaybe<Scalars['geometry']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  vehicle_type?: InputMaybe<Scalars['vehicle_type_enum']['input']>;
};

/** aggregate stddev on columns */
export type Free_Rides_Stddev_Fields = {
  __typename?: 'free_rides_stddev_fields';
  driver_distance?: Maybe<Scalars['Float']['output']>;
  estimated_distance?: Maybe<Scalars['Float']['output']>;
  estimated_duration?: Maybe<Scalars['Float']['output']>;
  estimated_fare?: Maybe<Scalars['Float']['output']>;
  passenger_count?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "free_rides" */
export type Free_Rides_Stddev_Order_By = {
  driver_distance?: InputMaybe<Order_By>;
  estimated_distance?: InputMaybe<Order_By>;
  estimated_duration?: InputMaybe<Order_By>;
  estimated_fare?: InputMaybe<Order_By>;
  passenger_count?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Free_Rides_Stddev_Pop_Fields = {
  __typename?: 'free_rides_stddev_pop_fields';
  driver_distance?: Maybe<Scalars['Float']['output']>;
  estimated_distance?: Maybe<Scalars['Float']['output']>;
  estimated_duration?: Maybe<Scalars['Float']['output']>;
  estimated_fare?: Maybe<Scalars['Float']['output']>;
  passenger_count?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "free_rides" */
export type Free_Rides_Stddev_Pop_Order_By = {
  driver_distance?: InputMaybe<Order_By>;
  estimated_distance?: InputMaybe<Order_By>;
  estimated_duration?: InputMaybe<Order_By>;
  estimated_fare?: InputMaybe<Order_By>;
  passenger_count?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Free_Rides_Stddev_Samp_Fields = {
  __typename?: 'free_rides_stddev_samp_fields';
  driver_distance?: Maybe<Scalars['Float']['output']>;
  estimated_distance?: Maybe<Scalars['Float']['output']>;
  estimated_duration?: Maybe<Scalars['Float']['output']>;
  estimated_fare?: Maybe<Scalars['Float']['output']>;
  passenger_count?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "free_rides" */
export type Free_Rides_Stddev_Samp_Order_By = {
  driver_distance?: InputMaybe<Order_By>;
  estimated_distance?: InputMaybe<Order_By>;
  estimated_duration?: InputMaybe<Order_By>;
  estimated_fare?: InputMaybe<Order_By>;
  passenger_count?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "free_rides" */
export type Free_Rides_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Free_Rides_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Free_Rides_Stream_Cursor_Value_Input = {
  cancel_reason?: InputMaybe<Scalars['String']['input']>;
  candidate_driver_ids?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  driver_address?: InputMaybe<Scalars['String']['input']>;
  driver_distance?: InputMaybe<Scalars['numeric']['input']>;
  driver_id?: InputMaybe<Scalars['uuid']['input']>;
  driver_location?: InputMaybe<Scalars['geography']['input']>;
  dropoff_address?: InputMaybe<Scalars['String']['input']>;
  dropoff_location?: InputMaybe<Scalars['geography']['input']>;
  estimated_distance?: InputMaybe<Scalars['numeric']['input']>;
  estimated_duration?: InputMaybe<Scalars['numeric']['input']>;
  estimated_fare?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  passenger_count?: InputMaybe<Scalars['numeric']['input']>;
  pickup_address?: InputMaybe<Scalars['String']['input']>;
  pickup_location?: InputMaybe<Scalars['geography']['input']>;
  profile_id?: InputMaybe<Scalars['uuid']['input']>;
  route_geometry?: InputMaybe<Scalars['geometry']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  vehicle_type?: InputMaybe<Scalars['vehicle_type_enum']['input']>;
};

/** aggregate sum on columns */
export type Free_Rides_Sum_Fields = {
  __typename?: 'free_rides_sum_fields';
  driver_distance?: Maybe<Scalars['numeric']['output']>;
  estimated_distance?: Maybe<Scalars['numeric']['output']>;
  estimated_duration?: Maybe<Scalars['numeric']['output']>;
  estimated_fare?: Maybe<Scalars['numeric']['output']>;
  passenger_count?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "free_rides" */
export type Free_Rides_Sum_Order_By = {
  driver_distance?: InputMaybe<Order_By>;
  estimated_distance?: InputMaybe<Order_By>;
  estimated_duration?: InputMaybe<Order_By>;
  estimated_fare?: InputMaybe<Order_By>;
  passenger_count?: InputMaybe<Order_By>;
};

/** update columns of table "free_rides" */
export enum Free_Rides_Update_Column {
  /** column name */
  CancelReason = 'cancel_reason',
  /** column name */
  CandidateDriverIds = 'candidate_driver_ids',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DriverAddress = 'driver_address',
  /** column name */
  DriverDistance = 'driver_distance',
  /** column name */
  DriverId = 'driver_id',
  /** column name */
  DriverLocation = 'driver_location',
  /** column name */
  DropoffAddress = 'dropoff_address',
  /** column name */
  DropoffLocation = 'dropoff_location',
  /** column name */
  EstimatedDistance = 'estimated_distance',
  /** column name */
  EstimatedDuration = 'estimated_duration',
  /** column name */
  EstimatedFare = 'estimated_fare',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  PassengerCount = 'passenger_count',
  /** column name */
  PickupAddress = 'pickup_address',
  /** column name */
  PickupLocation = 'pickup_location',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  RouteGeometry = 'route_geometry',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VehicleType = 'vehicle_type'
}

export type Free_Rides_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Free_Rides_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Free_Rides_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Free_Rides_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Free_Rides_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Free_Rides_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Free_Rides_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Free_Rides_Set_Input>;
  /** filter the rows which have to be updated */
  where: Free_Rides_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Free_Rides_Var_Pop_Fields = {
  __typename?: 'free_rides_var_pop_fields';
  driver_distance?: Maybe<Scalars['Float']['output']>;
  estimated_distance?: Maybe<Scalars['Float']['output']>;
  estimated_duration?: Maybe<Scalars['Float']['output']>;
  estimated_fare?: Maybe<Scalars['Float']['output']>;
  passenger_count?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "free_rides" */
export type Free_Rides_Var_Pop_Order_By = {
  driver_distance?: InputMaybe<Order_By>;
  estimated_distance?: InputMaybe<Order_By>;
  estimated_duration?: InputMaybe<Order_By>;
  estimated_fare?: InputMaybe<Order_By>;
  passenger_count?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Free_Rides_Var_Samp_Fields = {
  __typename?: 'free_rides_var_samp_fields';
  driver_distance?: Maybe<Scalars['Float']['output']>;
  estimated_distance?: Maybe<Scalars['Float']['output']>;
  estimated_duration?: Maybe<Scalars['Float']['output']>;
  estimated_fare?: Maybe<Scalars['Float']['output']>;
  passenger_count?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "free_rides" */
export type Free_Rides_Var_Samp_Order_By = {
  driver_distance?: InputMaybe<Order_By>;
  estimated_distance?: InputMaybe<Order_By>;
  estimated_duration?: InputMaybe<Order_By>;
  estimated_fare?: InputMaybe<Order_By>;
  passenger_count?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Free_Rides_Variance_Fields = {
  __typename?: 'free_rides_variance_fields';
  driver_distance?: Maybe<Scalars['Float']['output']>;
  estimated_distance?: Maybe<Scalars['Float']['output']>;
  estimated_duration?: Maybe<Scalars['Float']['output']>;
  estimated_fare?: Maybe<Scalars['Float']['output']>;
  passenger_count?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "free_rides" */
export type Free_Rides_Variance_Order_By = {
  driver_distance?: InputMaybe<Order_By>;
  estimated_distance?: InputMaybe<Order_By>;
  estimated_duration?: InputMaybe<Order_By>;
  estimated_fare?: InputMaybe<Order_By>;
  passenger_count?: InputMaybe<Order_By>;
};

export type Geography_Cast_Exp = {
  geometry?: InputMaybe<Geometry_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "geography". All fields are combined with logical 'AND'. */
export type Geography_Comparison_Exp = {
  _cast?: InputMaybe<Geography_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geography']['input']>;
  _gt?: InputMaybe<Scalars['geography']['input']>;
  _gte?: InputMaybe<Scalars['geography']['input']>;
  _in?: InputMaybe<Array<Scalars['geography']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['geography']['input']>;
  _lte?: InputMaybe<Scalars['geography']['input']>;
  _neq?: InputMaybe<Scalars['geography']['input']>;
  _nin?: InputMaybe<Array<Scalars['geography']['input']>>;
  /** is the column within a given distance from the given geography value */
  _st_d_within?: InputMaybe<St_D_Within_Geography_Input>;
  /** does the column spatially intersect the given geography value */
  _st_intersects?: InputMaybe<Scalars['geography']['input']>;
};

export type Geometry_Cast_Exp = {
  geography?: InputMaybe<Geography_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "geometry". All fields are combined with logical 'AND'. */
export type Geometry_Comparison_Exp = {
  _cast?: InputMaybe<Geometry_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geometry']['input']>;
  _gt?: InputMaybe<Scalars['geometry']['input']>;
  _gte?: InputMaybe<Scalars['geometry']['input']>;
  _in?: InputMaybe<Array<Scalars['geometry']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['geometry']['input']>;
  _lte?: InputMaybe<Scalars['geometry']['input']>;
  _neq?: InputMaybe<Scalars['geometry']['input']>;
  _nin?: InputMaybe<Array<Scalars['geometry']['input']>>;
  /** is the column within a given 3D distance from the given geometry value */
  _st_3d_d_within?: InputMaybe<St_D_Within_Input>;
  /** does the column spatially intersect the given geometry value in 3D */
  _st_3d_intersects?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column contain the given geometry value */
  _st_contains?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column cross the given geometry value */
  _st_crosses?: InputMaybe<Scalars['geometry']['input']>;
  /** is the column within a given distance from the given geometry value */
  _st_d_within?: InputMaybe<St_D_Within_Input>;
  /** is the column equal to given geometry value (directionality is ignored) */
  _st_equals?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column spatially intersect the given geometry value */
  _st_intersects?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column 'spatially overlap' (intersect but not completely contain) the given geometry value */
  _st_overlaps?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column have atleast one point in common with the given geometry value */
  _st_touches?: InputMaybe<Scalars['geometry']['input']>;
  /** is the column contained in the given geometry value */
  _st_within?: InputMaybe<Scalars['geometry']['input']>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  acceptFreeRide?: Maybe<AcceptFreeRideResponse>;
  acceptOrder?: Maybe<AcceptFreeOrderResponse>;
  createCandidatesAndNotify?: Maybe<CreateCandidatesAndNotifyResponse>;
  /** delete single row from the table: "auth.providers" */
  deleteAuthProvider?: Maybe<AuthProviders>;
  /** delete single row from the table: "auth.provider_requests" */
  deleteAuthProviderRequest?: Maybe<AuthProviderRequests>;
  /** delete data from the table: "auth.provider_requests" */
  deleteAuthProviderRequests?: Maybe<AuthProviderRequests_Mutation_Response>;
  /** delete data from the table: "auth.providers" */
  deleteAuthProviders?: Maybe<AuthProviders_Mutation_Response>;
  /** delete single row from the table: "auth.refresh_tokens" */
  deleteAuthRefreshToken?: Maybe<AuthRefreshTokens>;
  /** delete single row from the table: "auth.refresh_token_types" */
  deleteAuthRefreshTokenType?: Maybe<AuthRefreshTokenTypes>;
  /** delete data from the table: "auth.refresh_token_types" */
  deleteAuthRefreshTokenTypes?: Maybe<AuthRefreshTokenTypes_Mutation_Response>;
  /** delete data from the table: "auth.refresh_tokens" */
  deleteAuthRefreshTokens?: Maybe<AuthRefreshTokens_Mutation_Response>;
  /** delete single row from the table: "auth.roles" */
  deleteAuthRole?: Maybe<AuthRoles>;
  /** delete data from the table: "auth.roles" */
  deleteAuthRoles?: Maybe<AuthRoles_Mutation_Response>;
  /** delete single row from the table: "auth.user_providers" */
  deleteAuthUserProvider?: Maybe<AuthUserProviders>;
  /** delete data from the table: "auth.user_providers" */
  deleteAuthUserProviders?: Maybe<AuthUserProviders_Mutation_Response>;
  /** delete single row from the table: "auth.user_roles" */
  deleteAuthUserRole?: Maybe<AuthUserRoles>;
  /** delete data from the table: "auth.user_roles" */
  deleteAuthUserRoles?: Maybe<AuthUserRoles_Mutation_Response>;
  /** delete single row from the table: "auth.user_security_keys" */
  deleteAuthUserSecurityKey?: Maybe<AuthUserSecurityKeys>;
  /** delete data from the table: "auth.user_security_keys" */
  deleteAuthUserSecurityKeys?: Maybe<AuthUserSecurityKeys_Mutation_Response>;
  /** delete single row from the table: "storage.buckets" */
  deleteBucket?: Maybe<Buckets>;
  /** delete data from the table: "storage.buckets" */
  deleteBuckets?: Maybe<Buckets_Mutation_Response>;
  /** delete single row from the table: "storage.files" */
  deleteFile?: Maybe<Files>;
  /** delete data from the table: "storage.files" */
  deleteFiles?: Maybe<Files_Mutation_Response>;
  /** delete single row from the table: "auth.users" */
  deleteUser?: Maybe<Users>;
  /** delete data from the table: "auth.users" */
  deleteUsers?: Maybe<Users_Mutation_Response>;
  /** delete single row from the table: "storage.virus" */
  deleteVirus?: Maybe<Virus>;
  /** delete data from the table: "storage.virus" */
  deleteViruses?: Maybe<Virus_Mutation_Response>;
  /** delete data from the table: "account_deletion_request" */
  delete_account_deletion_request?: Maybe<Account_Deletion_Request_Mutation_Response>;
  /** delete single row from the table: "account_deletion_request" */
  delete_account_deletion_request_by_pk?: Maybe<Account_Deletion_Request>;
  /** delete data from the table: "app_settings" */
  delete_app_settings?: Maybe<App_Settings_Mutation_Response>;
  /** delete single row from the table: "app_settings" */
  delete_app_settings_by_pk?: Maybe<App_Settings>;
  /** delete data from the table: "app_versions" */
  delete_app_versions?: Maybe<App_Versions_Mutation_Response>;
  /** delete single row from the table: "app_versions" */
  delete_app_versions_by_pk?: Maybe<App_Versions>;
  /** delete data from the table: "assignment" */
  delete_assignment?: Maybe<Assignment_Mutation_Response>;
  /** delete single row from the table: "assignment" */
  delete_assignment_by_pk?: Maybe<Assignment>;
  /** delete data from the table: "basket" */
  delete_basket?: Maybe<Basket_Mutation_Response>;
  /** delete single row from the table: "basket" */
  delete_basket_by_pk?: Maybe<Basket>;
  /** delete data from the table: "basket_dish" */
  delete_basket_dish?: Maybe<Basket_Dish_Mutation_Response>;
  /** delete single row from the table: "basket_dish" */
  delete_basket_dish_by_pk?: Maybe<Basket_Dish>;
  /** delete data from the table: "carrier" */
  delete_carrier?: Maybe<Carrier_Mutation_Response>;
  /** delete single row from the table: "carrier" */
  delete_carrier_by_pk?: Maybe<Carrier>;
  /** delete data from the table: "category" */
  delete_category?: Maybe<Category_Mutation_Response>;
  /** delete single row from the table: "category" */
  delete_category_by_pk?: Maybe<Category>;
  /** delete data from the table: "dish" */
  delete_dish?: Maybe<Dish_Mutation_Response>;
  /** delete single row from the table: "dish" */
  delete_dish_by_pk?: Maybe<Dish>;
  /** delete data from the table: "driver_documents" */
  delete_driver_documents?: Maybe<Driver_Documents_Mutation_Response>;
  /** delete single row from the table: "driver_documents" */
  delete_driver_documents_by_pk?: Maybe<Driver_Documents>;
  /** delete data from the table: "driver_locations_current" */
  delete_driver_locations_current?: Maybe<Driver_Locations_Current_Mutation_Response>;
  /** delete single row from the table: "driver_locations_current" */
  delete_driver_locations_current_by_pk?: Maybe<Driver_Locations_Current>;
  /** delete data from the table: "drivers" */
  delete_drivers?: Maybe<Drivers_Mutation_Response>;
  /** delete single row from the table: "drivers" */
  delete_drivers_by_pk?: Maybe<Drivers>;
  /** delete data from the table: "fare_bands" */
  delete_fare_bands?: Maybe<Fare_Bands_Mutation_Response>;
  /** delete single row from the table: "fare_bands" */
  delete_fare_bands_by_pk?: Maybe<Fare_Bands>;
  /** delete data from the table: "feedback" */
  delete_feedback?: Maybe<Feedback_Mutation_Response>;
  /** delete single row from the table: "feedback" */
  delete_feedback_by_pk?: Maybe<Feedback>;
  /** delete data from the table: "free_rides" */
  delete_free_rides?: Maybe<Free_Rides_Mutation_Response>;
  /** delete single row from the table: "free_rides" */
  delete_free_rides_by_pk?: Maybe<Free_Rides>;
  /** delete data from the table: "order" */
  delete_order?: Maybe<Order_Mutation_Response>;
  /** delete single row from the table: "order" */
  delete_order_by_pk?: Maybe<Order>;
  /** delete data from the table: "payments" */
  delete_payments?: Maybe<Payments_Mutation_Response>;
  /** delete single row from the table: "payments" */
  delete_payments_by_pk?: Maybe<Payments>;
  /** delete data from the table: "ratings" */
  delete_ratings?: Maybe<Ratings_Mutation_Response>;
  /** delete single row from the table: "ratings" */
  delete_ratings_by_pk?: Maybe<Ratings>;
  /** delete data from the table: "restaurant" */
  delete_restaurant?: Maybe<Restaurant_Mutation_Response>;
  /** delete single row from the table: "restaurant" */
  delete_restaurant_by_pk?: Maybe<Restaurant>;
  /** delete data from the table: "ride_events" */
  delete_ride_events?: Maybe<Ride_Events_Mutation_Response>;
  /** delete single row from the table: "ride_events" */
  delete_ride_events_by_pk?: Maybe<Ride_Events>;
  /** delete data from the table: "rides" */
  delete_rides?: Maybe<Rides_Mutation_Response>;
  /** delete single row from the table: "rides" */
  delete_rides_by_pk?: Maybe<Rides>;
  /** delete data from the table: "settlement" */
  delete_settlement?: Maybe<Settlement_Mutation_Response>;
  /** delete single row from the table: "settlement" */
  delete_settlement_by_pk?: Maybe<Settlement>;
  /** delete data from the table: "specialty" */
  delete_specialty?: Maybe<Specialty_Mutation_Response>;
  /** delete single row from the table: "specialty" */
  delete_specialty_by_pk?: Maybe<Specialty>;
  /** delete data from the table: "user_devices" */
  delete_user_devices?: Maybe<User_Devices_Mutation_Response>;
  /** delete single row from the table: "user_devices" */
  delete_user_devices_by_pk?: Maybe<User_Devices>;
  /** delete data from the table: "user_profiles" */
  delete_user_profiles?: Maybe<User_Profiles_Mutation_Response>;
  /** delete single row from the table: "user_profiles" */
  delete_user_profiles_by_pk?: Maybe<User_Profiles>;
  /** delete data from the table: "user_settings" */
  delete_user_settings?: Maybe<User_Settings_Mutation_Response>;
  /** delete single row from the table: "user_settings" */
  delete_user_settings_by_pk?: Maybe<User_Settings>;
  /** delete data from the table: "vehicle_documents" */
  delete_vehicle_documents?: Maybe<Vehicle_Documents_Mutation_Response>;
  /** delete single row from the table: "vehicle_documents" */
  delete_vehicle_documents_by_pk?: Maybe<Vehicle_Documents>;
  /** delete data from the table: "vehicles" */
  delete_vehicles?: Maybe<Vehicles_Mutation_Response>;
  /** delete single row from the table: "vehicles" */
  delete_vehicles_by_pk?: Maybe<Vehicles>;
  /** insert a single row into the table: "auth.providers" */
  insertAuthProvider?: Maybe<AuthProviders>;
  /** insert a single row into the table: "auth.provider_requests" */
  insertAuthProviderRequest?: Maybe<AuthProviderRequests>;
  /** insert data into the table: "auth.provider_requests" */
  insertAuthProviderRequests?: Maybe<AuthProviderRequests_Mutation_Response>;
  /** insert data into the table: "auth.providers" */
  insertAuthProviders?: Maybe<AuthProviders_Mutation_Response>;
  /** insert a single row into the table: "auth.refresh_tokens" */
  insertAuthRefreshToken?: Maybe<AuthRefreshTokens>;
  /** insert a single row into the table: "auth.refresh_token_types" */
  insertAuthRefreshTokenType?: Maybe<AuthRefreshTokenTypes>;
  /** insert data into the table: "auth.refresh_token_types" */
  insertAuthRefreshTokenTypes?: Maybe<AuthRefreshTokenTypes_Mutation_Response>;
  /** insert data into the table: "auth.refresh_tokens" */
  insertAuthRefreshTokens?: Maybe<AuthRefreshTokens_Mutation_Response>;
  /** insert a single row into the table: "auth.roles" */
  insertAuthRole?: Maybe<AuthRoles>;
  /** insert data into the table: "auth.roles" */
  insertAuthRoles?: Maybe<AuthRoles_Mutation_Response>;
  /** insert a single row into the table: "auth.user_providers" */
  insertAuthUserProvider?: Maybe<AuthUserProviders>;
  /** insert data into the table: "auth.user_providers" */
  insertAuthUserProviders?: Maybe<AuthUserProviders_Mutation_Response>;
  /** insert a single row into the table: "auth.user_roles" */
  insertAuthUserRole?: Maybe<AuthUserRoles>;
  /** insert data into the table: "auth.user_roles" */
  insertAuthUserRoles?: Maybe<AuthUserRoles_Mutation_Response>;
  /** insert a single row into the table: "auth.user_security_keys" */
  insertAuthUserSecurityKey?: Maybe<AuthUserSecurityKeys>;
  /** insert data into the table: "auth.user_security_keys" */
  insertAuthUserSecurityKeys?: Maybe<AuthUserSecurityKeys_Mutation_Response>;
  /** insert a single row into the table: "storage.buckets" */
  insertBucket?: Maybe<Buckets>;
  /** insert data into the table: "storage.buckets" */
  insertBuckets?: Maybe<Buckets_Mutation_Response>;
  /** insert a single row into the table: "storage.files" */
  insertFile?: Maybe<Files>;
  /** insert data into the table: "storage.files" */
  insertFiles?: Maybe<Files_Mutation_Response>;
  /** insert a single row into the table: "auth.users" */
  insertUser?: Maybe<Users>;
  /** insert data into the table: "auth.users" */
  insertUsers?: Maybe<Users_Mutation_Response>;
  /** insert a single row into the table: "storage.virus" */
  insertVirus?: Maybe<Virus>;
  /** insert data into the table: "storage.virus" */
  insertViruses?: Maybe<Virus_Mutation_Response>;
  /** insert data into the table: "account_deletion_request" */
  insert_account_deletion_request?: Maybe<Account_Deletion_Request_Mutation_Response>;
  /** insert a single row into the table: "account_deletion_request" */
  insert_account_deletion_request_one?: Maybe<Account_Deletion_Request>;
  /** insert data into the table: "app_settings" */
  insert_app_settings?: Maybe<App_Settings_Mutation_Response>;
  /** insert a single row into the table: "app_settings" */
  insert_app_settings_one?: Maybe<App_Settings>;
  /** insert data into the table: "app_versions" */
  insert_app_versions?: Maybe<App_Versions_Mutation_Response>;
  /** insert a single row into the table: "app_versions" */
  insert_app_versions_one?: Maybe<App_Versions>;
  /** insert data into the table: "assignment" */
  insert_assignment?: Maybe<Assignment_Mutation_Response>;
  /** insert a single row into the table: "assignment" */
  insert_assignment_one?: Maybe<Assignment>;
  /** insert data into the table: "basket" */
  insert_basket?: Maybe<Basket_Mutation_Response>;
  /** insert data into the table: "basket_dish" */
  insert_basket_dish?: Maybe<Basket_Dish_Mutation_Response>;
  /** insert a single row into the table: "basket_dish" */
  insert_basket_dish_one?: Maybe<Basket_Dish>;
  /** insert a single row into the table: "basket" */
  insert_basket_one?: Maybe<Basket>;
  /** insert data into the table: "carrier" */
  insert_carrier?: Maybe<Carrier_Mutation_Response>;
  /** insert a single row into the table: "carrier" */
  insert_carrier_one?: Maybe<Carrier>;
  /** insert data into the table: "category" */
  insert_category?: Maybe<Category_Mutation_Response>;
  /** insert a single row into the table: "category" */
  insert_category_one?: Maybe<Category>;
  /** insert data into the table: "dish" */
  insert_dish?: Maybe<Dish_Mutation_Response>;
  /** insert a single row into the table: "dish" */
  insert_dish_one?: Maybe<Dish>;
  /** insert data into the table: "driver_documents" */
  insert_driver_documents?: Maybe<Driver_Documents_Mutation_Response>;
  /** insert a single row into the table: "driver_documents" */
  insert_driver_documents_one?: Maybe<Driver_Documents>;
  /** insert data into the table: "driver_locations_current" */
  insert_driver_locations_current?: Maybe<Driver_Locations_Current_Mutation_Response>;
  /** insert a single row into the table: "driver_locations_current" */
  insert_driver_locations_current_one?: Maybe<Driver_Locations_Current>;
  /** insert data into the table: "drivers" */
  insert_drivers?: Maybe<Drivers_Mutation_Response>;
  /** insert a single row into the table: "drivers" */
  insert_drivers_one?: Maybe<Drivers>;
  /** insert data into the table: "fare_bands" */
  insert_fare_bands?: Maybe<Fare_Bands_Mutation_Response>;
  /** insert a single row into the table: "fare_bands" */
  insert_fare_bands_one?: Maybe<Fare_Bands>;
  /** insert data into the table: "feedback" */
  insert_feedback?: Maybe<Feedback_Mutation_Response>;
  /** insert a single row into the table: "feedback" */
  insert_feedback_one?: Maybe<Feedback>;
  /** insert data into the table: "free_rides" */
  insert_free_rides?: Maybe<Free_Rides_Mutation_Response>;
  /** insert a single row into the table: "free_rides" */
  insert_free_rides_one?: Maybe<Free_Rides>;
  /** insert data into the table: "order" */
  insert_order?: Maybe<Order_Mutation_Response>;
  /** insert a single row into the table: "order" */
  insert_order_one?: Maybe<Order>;
  /** insert data into the table: "payments" */
  insert_payments?: Maybe<Payments_Mutation_Response>;
  /** insert a single row into the table: "payments" */
  insert_payments_one?: Maybe<Payments>;
  /** insert data into the table: "ratings" */
  insert_ratings?: Maybe<Ratings_Mutation_Response>;
  /** insert a single row into the table: "ratings" */
  insert_ratings_one?: Maybe<Ratings>;
  /** insert data into the table: "restaurant" */
  insert_restaurant?: Maybe<Restaurant_Mutation_Response>;
  /** insert a single row into the table: "restaurant" */
  insert_restaurant_one?: Maybe<Restaurant>;
  /** insert data into the table: "ride_events" */
  insert_ride_events?: Maybe<Ride_Events_Mutation_Response>;
  /** insert a single row into the table: "ride_events" */
  insert_ride_events_one?: Maybe<Ride_Events>;
  /** insert data into the table: "rides" */
  insert_rides?: Maybe<Rides_Mutation_Response>;
  /** insert a single row into the table: "rides" */
  insert_rides_one?: Maybe<Rides>;
  /** insert data into the table: "settlement" */
  insert_settlement?: Maybe<Settlement_Mutation_Response>;
  /** insert a single row into the table: "settlement" */
  insert_settlement_one?: Maybe<Settlement>;
  /** insert data into the table: "specialty" */
  insert_specialty?: Maybe<Specialty_Mutation_Response>;
  /** insert a single row into the table: "specialty" */
  insert_specialty_one?: Maybe<Specialty>;
  /** insert data into the table: "user_devices" */
  insert_user_devices?: Maybe<User_Devices_Mutation_Response>;
  /** insert a single row into the table: "user_devices" */
  insert_user_devices_one?: Maybe<User_Devices>;
  /** insert data into the table: "user_profiles" */
  insert_user_profiles?: Maybe<User_Profiles_Mutation_Response>;
  /** insert a single row into the table: "user_profiles" */
  insert_user_profiles_one?: Maybe<User_Profiles>;
  /** insert data into the table: "user_settings" */
  insert_user_settings?: Maybe<User_Settings_Mutation_Response>;
  /** insert a single row into the table: "user_settings" */
  insert_user_settings_one?: Maybe<User_Settings>;
  /** insert data into the table: "vehicle_documents" */
  insert_vehicle_documents?: Maybe<Vehicle_Documents_Mutation_Response>;
  /** insert a single row into the table: "vehicle_documents" */
  insert_vehicle_documents_one?: Maybe<Vehicle_Documents>;
  /** insert data into the table: "vehicles" */
  insert_vehicles?: Maybe<Vehicles_Mutation_Response>;
  /** insert a single row into the table: "vehicles" */
  insert_vehicles_one?: Maybe<Vehicles>;
  /** update single row of the table: "auth.providers" */
  updateAuthProvider?: Maybe<AuthProviders>;
  /** update single row of the table: "auth.provider_requests" */
  updateAuthProviderRequest?: Maybe<AuthProviderRequests>;
  /** update data of the table: "auth.provider_requests" */
  updateAuthProviderRequests?: Maybe<AuthProviderRequests_Mutation_Response>;
  /** update data of the table: "auth.providers" */
  updateAuthProviders?: Maybe<AuthProviders_Mutation_Response>;
  /** update single row of the table: "auth.refresh_tokens" */
  updateAuthRefreshToken?: Maybe<AuthRefreshTokens>;
  /** update single row of the table: "auth.refresh_token_types" */
  updateAuthRefreshTokenType?: Maybe<AuthRefreshTokenTypes>;
  /** update data of the table: "auth.refresh_token_types" */
  updateAuthRefreshTokenTypes?: Maybe<AuthRefreshTokenTypes_Mutation_Response>;
  /** update data of the table: "auth.refresh_tokens" */
  updateAuthRefreshTokens?: Maybe<AuthRefreshTokens_Mutation_Response>;
  /** update single row of the table: "auth.roles" */
  updateAuthRole?: Maybe<AuthRoles>;
  /** update data of the table: "auth.roles" */
  updateAuthRoles?: Maybe<AuthRoles_Mutation_Response>;
  /** update single row of the table: "auth.user_providers" */
  updateAuthUserProvider?: Maybe<AuthUserProviders>;
  /** update data of the table: "auth.user_providers" */
  updateAuthUserProviders?: Maybe<AuthUserProviders_Mutation_Response>;
  /** update single row of the table: "auth.user_roles" */
  updateAuthUserRole?: Maybe<AuthUserRoles>;
  /** update data of the table: "auth.user_roles" */
  updateAuthUserRoles?: Maybe<AuthUserRoles_Mutation_Response>;
  /** update single row of the table: "auth.user_security_keys" */
  updateAuthUserSecurityKey?: Maybe<AuthUserSecurityKeys>;
  /** update data of the table: "auth.user_security_keys" */
  updateAuthUserSecurityKeys?: Maybe<AuthUserSecurityKeys_Mutation_Response>;
  /** update single row of the table: "storage.buckets" */
  updateBucket?: Maybe<Buckets>;
  /** update data of the table: "storage.buckets" */
  updateBuckets?: Maybe<Buckets_Mutation_Response>;
  /** update single row of the table: "storage.files" */
  updateFile?: Maybe<Files>;
  /** update data of the table: "storage.files" */
  updateFiles?: Maybe<Files_Mutation_Response>;
  /** update single row of the table: "auth.users" */
  updateUser?: Maybe<Users>;
  /** update data of the table: "auth.users" */
  updateUsers?: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "storage.virus" */
  updateVirus?: Maybe<Virus>;
  /** update data of the table: "storage.virus" */
  updateViruses?: Maybe<Virus_Mutation_Response>;
  /** update data of the table: "account_deletion_request" */
  update_account_deletion_request?: Maybe<Account_Deletion_Request_Mutation_Response>;
  /** update single row of the table: "account_deletion_request" */
  update_account_deletion_request_by_pk?: Maybe<Account_Deletion_Request>;
  /** update multiples rows of table: "account_deletion_request" */
  update_account_deletion_request_many?: Maybe<Array<Maybe<Account_Deletion_Request_Mutation_Response>>>;
  /** update data of the table: "app_settings" */
  update_app_settings?: Maybe<App_Settings_Mutation_Response>;
  /** update single row of the table: "app_settings" */
  update_app_settings_by_pk?: Maybe<App_Settings>;
  /** update multiples rows of table: "app_settings" */
  update_app_settings_many?: Maybe<Array<Maybe<App_Settings_Mutation_Response>>>;
  /** update data of the table: "app_versions" */
  update_app_versions?: Maybe<App_Versions_Mutation_Response>;
  /** update single row of the table: "app_versions" */
  update_app_versions_by_pk?: Maybe<App_Versions>;
  /** update multiples rows of table: "app_versions" */
  update_app_versions_many?: Maybe<Array<Maybe<App_Versions_Mutation_Response>>>;
  /** update data of the table: "assignment" */
  update_assignment?: Maybe<Assignment_Mutation_Response>;
  /** update single row of the table: "assignment" */
  update_assignment_by_pk?: Maybe<Assignment>;
  /** update multiples rows of table: "assignment" */
  update_assignment_many?: Maybe<Array<Maybe<Assignment_Mutation_Response>>>;
  /** update multiples rows of table: "auth.provider_requests" */
  update_authProviderRequests_many?: Maybe<Array<Maybe<AuthProviderRequests_Mutation_Response>>>;
  /** update multiples rows of table: "auth.providers" */
  update_authProviders_many?: Maybe<Array<Maybe<AuthProviders_Mutation_Response>>>;
  /** update multiples rows of table: "auth.refresh_token_types" */
  update_authRefreshTokenTypes_many?: Maybe<Array<Maybe<AuthRefreshTokenTypes_Mutation_Response>>>;
  /** update multiples rows of table: "auth.refresh_tokens" */
  update_authRefreshTokens_many?: Maybe<Array<Maybe<AuthRefreshTokens_Mutation_Response>>>;
  /** update multiples rows of table: "auth.roles" */
  update_authRoles_many?: Maybe<Array<Maybe<AuthRoles_Mutation_Response>>>;
  /** update multiples rows of table: "auth.user_providers" */
  update_authUserProviders_many?: Maybe<Array<Maybe<AuthUserProviders_Mutation_Response>>>;
  /** update multiples rows of table: "auth.user_roles" */
  update_authUserRoles_many?: Maybe<Array<Maybe<AuthUserRoles_Mutation_Response>>>;
  /** update multiples rows of table: "auth.user_security_keys" */
  update_authUserSecurityKeys_many?: Maybe<Array<Maybe<AuthUserSecurityKeys_Mutation_Response>>>;
  /** update data of the table: "basket" */
  update_basket?: Maybe<Basket_Mutation_Response>;
  /** update single row of the table: "basket" */
  update_basket_by_pk?: Maybe<Basket>;
  /** update data of the table: "basket_dish" */
  update_basket_dish?: Maybe<Basket_Dish_Mutation_Response>;
  /** update single row of the table: "basket_dish" */
  update_basket_dish_by_pk?: Maybe<Basket_Dish>;
  /** update multiples rows of table: "basket_dish" */
  update_basket_dish_many?: Maybe<Array<Maybe<Basket_Dish_Mutation_Response>>>;
  /** update multiples rows of table: "basket" */
  update_basket_many?: Maybe<Array<Maybe<Basket_Mutation_Response>>>;
  /** update multiples rows of table: "storage.buckets" */
  update_buckets_many?: Maybe<Array<Maybe<Buckets_Mutation_Response>>>;
  /** update data of the table: "carrier" */
  update_carrier?: Maybe<Carrier_Mutation_Response>;
  /** update single row of the table: "carrier" */
  update_carrier_by_pk?: Maybe<Carrier>;
  /** update multiples rows of table: "carrier" */
  update_carrier_many?: Maybe<Array<Maybe<Carrier_Mutation_Response>>>;
  /** update data of the table: "category" */
  update_category?: Maybe<Category_Mutation_Response>;
  /** update single row of the table: "category" */
  update_category_by_pk?: Maybe<Category>;
  /** update multiples rows of table: "category" */
  update_category_many?: Maybe<Array<Maybe<Category_Mutation_Response>>>;
  /** update data of the table: "dish" */
  update_dish?: Maybe<Dish_Mutation_Response>;
  /** update single row of the table: "dish" */
  update_dish_by_pk?: Maybe<Dish>;
  /** update multiples rows of table: "dish" */
  update_dish_many?: Maybe<Array<Maybe<Dish_Mutation_Response>>>;
  /** update data of the table: "driver_documents" */
  update_driver_documents?: Maybe<Driver_Documents_Mutation_Response>;
  /** update single row of the table: "driver_documents" */
  update_driver_documents_by_pk?: Maybe<Driver_Documents>;
  /** update multiples rows of table: "driver_documents" */
  update_driver_documents_many?: Maybe<Array<Maybe<Driver_Documents_Mutation_Response>>>;
  /** update data of the table: "driver_locations_current" */
  update_driver_locations_current?: Maybe<Driver_Locations_Current_Mutation_Response>;
  /** update single row of the table: "driver_locations_current" */
  update_driver_locations_current_by_pk?: Maybe<Driver_Locations_Current>;
  /** update multiples rows of table: "driver_locations_current" */
  update_driver_locations_current_many?: Maybe<Array<Maybe<Driver_Locations_Current_Mutation_Response>>>;
  /** update data of the table: "drivers" */
  update_drivers?: Maybe<Drivers_Mutation_Response>;
  /** update single row of the table: "drivers" */
  update_drivers_by_pk?: Maybe<Drivers>;
  /** update multiples rows of table: "drivers" */
  update_drivers_many?: Maybe<Array<Maybe<Drivers_Mutation_Response>>>;
  /** update data of the table: "fare_bands" */
  update_fare_bands?: Maybe<Fare_Bands_Mutation_Response>;
  /** update single row of the table: "fare_bands" */
  update_fare_bands_by_pk?: Maybe<Fare_Bands>;
  /** update multiples rows of table: "fare_bands" */
  update_fare_bands_many?: Maybe<Array<Maybe<Fare_Bands_Mutation_Response>>>;
  /** update data of the table: "feedback" */
  update_feedback?: Maybe<Feedback_Mutation_Response>;
  /** update single row of the table: "feedback" */
  update_feedback_by_pk?: Maybe<Feedback>;
  /** update multiples rows of table: "feedback" */
  update_feedback_many?: Maybe<Array<Maybe<Feedback_Mutation_Response>>>;
  /** update multiples rows of table: "storage.files" */
  update_files_many?: Maybe<Array<Maybe<Files_Mutation_Response>>>;
  /** update data of the table: "free_rides" */
  update_free_rides?: Maybe<Free_Rides_Mutation_Response>;
  /** update single row of the table: "free_rides" */
  update_free_rides_by_pk?: Maybe<Free_Rides>;
  /** update multiples rows of table: "free_rides" */
  update_free_rides_many?: Maybe<Array<Maybe<Free_Rides_Mutation_Response>>>;
  /** update data of the table: "order" */
  update_order?: Maybe<Order_Mutation_Response>;
  /** update single row of the table: "order" */
  update_order_by_pk?: Maybe<Order>;
  /** update multiples rows of table: "order" */
  update_order_many?: Maybe<Array<Maybe<Order_Mutation_Response>>>;
  /** update data of the table: "payments" */
  update_payments?: Maybe<Payments_Mutation_Response>;
  /** update single row of the table: "payments" */
  update_payments_by_pk?: Maybe<Payments>;
  /** update multiples rows of table: "payments" */
  update_payments_many?: Maybe<Array<Maybe<Payments_Mutation_Response>>>;
  /** update data of the table: "ratings" */
  update_ratings?: Maybe<Ratings_Mutation_Response>;
  /** update single row of the table: "ratings" */
  update_ratings_by_pk?: Maybe<Ratings>;
  /** update multiples rows of table: "ratings" */
  update_ratings_many?: Maybe<Array<Maybe<Ratings_Mutation_Response>>>;
  /** update data of the table: "restaurant" */
  update_restaurant?: Maybe<Restaurant_Mutation_Response>;
  /** update single row of the table: "restaurant" */
  update_restaurant_by_pk?: Maybe<Restaurant>;
  /** update multiples rows of table: "restaurant" */
  update_restaurant_many?: Maybe<Array<Maybe<Restaurant_Mutation_Response>>>;
  /** update data of the table: "ride_events" */
  update_ride_events?: Maybe<Ride_Events_Mutation_Response>;
  /** update single row of the table: "ride_events" */
  update_ride_events_by_pk?: Maybe<Ride_Events>;
  /** update multiples rows of table: "ride_events" */
  update_ride_events_many?: Maybe<Array<Maybe<Ride_Events_Mutation_Response>>>;
  /** update data of the table: "rides" */
  update_rides?: Maybe<Rides_Mutation_Response>;
  /** update single row of the table: "rides" */
  update_rides_by_pk?: Maybe<Rides>;
  /** update multiples rows of table: "rides" */
  update_rides_many?: Maybe<Array<Maybe<Rides_Mutation_Response>>>;
  /** update data of the table: "settlement" */
  update_settlement?: Maybe<Settlement_Mutation_Response>;
  /** update single row of the table: "settlement" */
  update_settlement_by_pk?: Maybe<Settlement>;
  /** update multiples rows of table: "settlement" */
  update_settlement_many?: Maybe<Array<Maybe<Settlement_Mutation_Response>>>;
  /** update data of the table: "specialty" */
  update_specialty?: Maybe<Specialty_Mutation_Response>;
  /** update single row of the table: "specialty" */
  update_specialty_by_pk?: Maybe<Specialty>;
  /** update multiples rows of table: "specialty" */
  update_specialty_many?: Maybe<Array<Maybe<Specialty_Mutation_Response>>>;
  /** update data of the table: "user_devices" */
  update_user_devices?: Maybe<User_Devices_Mutation_Response>;
  /** update single row of the table: "user_devices" */
  update_user_devices_by_pk?: Maybe<User_Devices>;
  /** update multiples rows of table: "user_devices" */
  update_user_devices_many?: Maybe<Array<Maybe<User_Devices_Mutation_Response>>>;
  /** update data of the table: "user_profiles" */
  update_user_profiles?: Maybe<User_Profiles_Mutation_Response>;
  /** update single row of the table: "user_profiles" */
  update_user_profiles_by_pk?: Maybe<User_Profiles>;
  /** update multiples rows of table: "user_profiles" */
  update_user_profiles_many?: Maybe<Array<Maybe<User_Profiles_Mutation_Response>>>;
  /** update data of the table: "user_settings" */
  update_user_settings?: Maybe<User_Settings_Mutation_Response>;
  /** update single row of the table: "user_settings" */
  update_user_settings_by_pk?: Maybe<User_Settings>;
  /** update multiples rows of table: "user_settings" */
  update_user_settings_many?: Maybe<Array<Maybe<User_Settings_Mutation_Response>>>;
  /** update multiples rows of table: "auth.users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_Response>>>;
  /** update data of the table: "vehicle_documents" */
  update_vehicle_documents?: Maybe<Vehicle_Documents_Mutation_Response>;
  /** update single row of the table: "vehicle_documents" */
  update_vehicle_documents_by_pk?: Maybe<Vehicle_Documents>;
  /** update multiples rows of table: "vehicle_documents" */
  update_vehicle_documents_many?: Maybe<Array<Maybe<Vehicle_Documents_Mutation_Response>>>;
  /** update data of the table: "vehicles" */
  update_vehicles?: Maybe<Vehicles_Mutation_Response>;
  /** update single row of the table: "vehicles" */
  update_vehicles_by_pk?: Maybe<Vehicles>;
  /** update multiples rows of table: "vehicles" */
  update_vehicles_many?: Maybe<Array<Maybe<Vehicles_Mutation_Response>>>;
  /** update multiples rows of table: "storage.virus" */
  update_virus_many?: Maybe<Array<Maybe<Virus_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootAcceptFreeRideArgs = {
  driver_id: Scalars['uuid']['input'];
  ride_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootAcceptOrderArgs = {
  orderId: Scalars['uuid']['input'];
  orderState: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootCreateCandidatesAndNotifyArgs = {
  pickup_location: Scalars['geometry']['input'];
  ride_id: Scalars['uuid']['input'];
  vehicle_type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuthProviderArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuthProviderRequestArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuthProviderRequestsArgs = {
  where: AuthProviderRequests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthProvidersArgs = {
  where: AuthProviders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthRefreshTokenArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuthRefreshTokenTypeArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuthRefreshTokenTypesArgs = {
  where: AuthRefreshTokenTypes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthRefreshTokensArgs = {
  where: AuthRefreshTokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthRoleArgs = {
  role: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuthRolesArgs = {
  where: AuthRoles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthUserProviderArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuthUserProvidersArgs = {
  where: AuthUserProviders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthUserRoleArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuthUserRolesArgs = {
  where: AuthUserRoles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthUserSecurityKeyArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuthUserSecurityKeysArgs = {
  where: AuthUserSecurityKeys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteBucketArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteBucketsArgs = {
  where: Buckets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteFileArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteFilesArgs = {
  where: Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteUserArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteUsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteVirusArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteVirusesArgs = {
  where: Virus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Account_Deletion_RequestArgs = {
  where: Account_Deletion_Request_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Account_Deletion_Request_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_App_SettingsArgs = {
  where: App_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_App_Settings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_App_VersionsArgs = {
  where: App_Versions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_App_Versions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_AssignmentArgs = {
  where: Assignment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Assignment_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_BasketArgs = {
  where: Basket_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Basket_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Basket_DishArgs = {
  where: Basket_Dish_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Basket_Dish_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CarrierArgs = {
  where: Carrier_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Carrier_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CategoryArgs = {
  where: Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_DishArgs = {
  where: Dish_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Dish_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Driver_DocumentsArgs = {
  where: Driver_Documents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Driver_Documents_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Driver_Locations_CurrentArgs = {
  where: Driver_Locations_Current_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Driver_Locations_Current_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_DriversArgs = {
  where: Drivers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Drivers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Fare_BandsArgs = {
  where: Fare_Bands_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Fare_Bands_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_FeedbackArgs = {
  where: Feedback_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Feedback_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Free_RidesArgs = {
  where: Free_Rides_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Free_Rides_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_OrderArgs = {
  where: Order_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Order_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PaymentsArgs = {
  where: Payments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Payments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_RatingsArgs = {
  where: Ratings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ratings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_RestaurantArgs = {
  where: Restaurant_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Restaurant_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Ride_EventsArgs = {
  where: Ride_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ride_Events_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_RidesArgs = {
  where: Rides_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Rides_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_SettlementArgs = {
  where: Settlement_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Settlement_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_SpecialtyArgs = {
  where: Specialty_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Specialty_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_DevicesArgs = {
  where: User_Devices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Devices_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_ProfilesArgs = {
  where: User_Profiles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Profiles_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_SettingsArgs = {
  where: User_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Settings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_DocumentsArgs = {
  where: Vehicle_Documents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Documents_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_VehiclesArgs = {
  where: Vehicles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vehicles_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootInsertAuthProviderArgs = {
  object: AuthProviders_Insert_Input;
  on_conflict?: InputMaybe<AuthProviders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthProviderRequestArgs = {
  object: AuthProviderRequests_Insert_Input;
  on_conflict?: InputMaybe<AuthProviderRequests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthProviderRequestsArgs = {
  objects: Array<AuthProviderRequests_Insert_Input>;
  on_conflict?: InputMaybe<AuthProviderRequests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthProvidersArgs = {
  objects: Array<AuthProviders_Insert_Input>;
  on_conflict?: InputMaybe<AuthProviders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthRefreshTokenArgs = {
  object: AuthRefreshTokens_Insert_Input;
  on_conflict?: InputMaybe<AuthRefreshTokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthRefreshTokenTypeArgs = {
  object: AuthRefreshTokenTypes_Insert_Input;
  on_conflict?: InputMaybe<AuthRefreshTokenTypes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthRefreshTokenTypesArgs = {
  objects: Array<AuthRefreshTokenTypes_Insert_Input>;
  on_conflict?: InputMaybe<AuthRefreshTokenTypes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthRefreshTokensArgs = {
  objects: Array<AuthRefreshTokens_Insert_Input>;
  on_conflict?: InputMaybe<AuthRefreshTokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthRoleArgs = {
  object: AuthRoles_Insert_Input;
  on_conflict?: InputMaybe<AuthRoles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthRolesArgs = {
  objects: Array<AuthRoles_Insert_Input>;
  on_conflict?: InputMaybe<AuthRoles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserProviderArgs = {
  object: AuthUserProviders_Insert_Input;
  on_conflict?: InputMaybe<AuthUserProviders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserProvidersArgs = {
  objects: Array<AuthUserProviders_Insert_Input>;
  on_conflict?: InputMaybe<AuthUserProviders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserRoleArgs = {
  object: AuthUserRoles_Insert_Input;
  on_conflict?: InputMaybe<AuthUserRoles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserRolesArgs = {
  objects: Array<AuthUserRoles_Insert_Input>;
  on_conflict?: InputMaybe<AuthUserRoles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserSecurityKeyArgs = {
  object: AuthUserSecurityKeys_Insert_Input;
  on_conflict?: InputMaybe<AuthUserSecurityKeys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserSecurityKeysArgs = {
  objects: Array<AuthUserSecurityKeys_Insert_Input>;
  on_conflict?: InputMaybe<AuthUserSecurityKeys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertBucketArgs = {
  object: Buckets_Insert_Input;
  on_conflict?: InputMaybe<Buckets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertBucketsArgs = {
  objects: Array<Buckets_Insert_Input>;
  on_conflict?: InputMaybe<Buckets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertFileArgs = {
  object: Files_Insert_Input;
  on_conflict?: InputMaybe<Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertFilesArgs = {
  objects: Array<Files_Insert_Input>;
  on_conflict?: InputMaybe<Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertUserArgs = {
  object: Users_Insert_Input;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertUsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertVirusArgs = {
  object: Virus_Insert_Input;
  on_conflict?: InputMaybe<Virus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertVirusesArgs = {
  objects: Array<Virus_Insert_Input>;
  on_conflict?: InputMaybe<Virus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Account_Deletion_RequestArgs = {
  objects: Array<Account_Deletion_Request_Insert_Input>;
  on_conflict?: InputMaybe<Account_Deletion_Request_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Account_Deletion_Request_OneArgs = {
  object: Account_Deletion_Request_Insert_Input;
  on_conflict?: InputMaybe<Account_Deletion_Request_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_App_SettingsArgs = {
  objects: Array<App_Settings_Insert_Input>;
  on_conflict?: InputMaybe<App_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_App_Settings_OneArgs = {
  object: App_Settings_Insert_Input;
  on_conflict?: InputMaybe<App_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_App_VersionsArgs = {
  objects: Array<App_Versions_Insert_Input>;
  on_conflict?: InputMaybe<App_Versions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_App_Versions_OneArgs = {
  object: App_Versions_Insert_Input;
  on_conflict?: InputMaybe<App_Versions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AssignmentArgs = {
  objects: Array<Assignment_Insert_Input>;
  on_conflict?: InputMaybe<Assignment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Assignment_OneArgs = {
  object: Assignment_Insert_Input;
  on_conflict?: InputMaybe<Assignment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BasketArgs = {
  objects: Array<Basket_Insert_Input>;
  on_conflict?: InputMaybe<Basket_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Basket_DishArgs = {
  objects: Array<Basket_Dish_Insert_Input>;
  on_conflict?: InputMaybe<Basket_Dish_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Basket_Dish_OneArgs = {
  object: Basket_Dish_Insert_Input;
  on_conflict?: InputMaybe<Basket_Dish_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Basket_OneArgs = {
  object: Basket_Insert_Input;
  on_conflict?: InputMaybe<Basket_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CarrierArgs = {
  objects: Array<Carrier_Insert_Input>;
  on_conflict?: InputMaybe<Carrier_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Carrier_OneArgs = {
  object: Carrier_Insert_Input;
  on_conflict?: InputMaybe<Carrier_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CategoryArgs = {
  objects: Array<Category_Insert_Input>;
  on_conflict?: InputMaybe<Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Category_OneArgs = {
  object: Category_Insert_Input;
  on_conflict?: InputMaybe<Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DishArgs = {
  objects: Array<Dish_Insert_Input>;
  on_conflict?: InputMaybe<Dish_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dish_OneArgs = {
  object: Dish_Insert_Input;
  on_conflict?: InputMaybe<Dish_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Driver_DocumentsArgs = {
  objects: Array<Driver_Documents_Insert_Input>;
  on_conflict?: InputMaybe<Driver_Documents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Driver_Documents_OneArgs = {
  object: Driver_Documents_Insert_Input;
  on_conflict?: InputMaybe<Driver_Documents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Driver_Locations_CurrentArgs = {
  objects: Array<Driver_Locations_Current_Insert_Input>;
  on_conflict?: InputMaybe<Driver_Locations_Current_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Driver_Locations_Current_OneArgs = {
  object: Driver_Locations_Current_Insert_Input;
  on_conflict?: InputMaybe<Driver_Locations_Current_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DriversArgs = {
  objects: Array<Drivers_Insert_Input>;
  on_conflict?: InputMaybe<Drivers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Drivers_OneArgs = {
  object: Drivers_Insert_Input;
  on_conflict?: InputMaybe<Drivers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fare_BandsArgs = {
  objects: Array<Fare_Bands_Insert_Input>;
  on_conflict?: InputMaybe<Fare_Bands_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fare_Bands_OneArgs = {
  object: Fare_Bands_Insert_Input;
  on_conflict?: InputMaybe<Fare_Bands_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FeedbackArgs = {
  objects: Array<Feedback_Insert_Input>;
  on_conflict?: InputMaybe<Feedback_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feedback_OneArgs = {
  object: Feedback_Insert_Input;
  on_conflict?: InputMaybe<Feedback_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Free_RidesArgs = {
  objects: Array<Free_Rides_Insert_Input>;
  on_conflict?: InputMaybe<Free_Rides_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Free_Rides_OneArgs = {
  object: Free_Rides_Insert_Input;
  on_conflict?: InputMaybe<Free_Rides_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OrderArgs = {
  objects: Array<Order_Insert_Input>;
  on_conflict?: InputMaybe<Order_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_OneArgs = {
  object: Order_Insert_Input;
  on_conflict?: InputMaybe<Order_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PaymentsArgs = {
  objects: Array<Payments_Insert_Input>;
  on_conflict?: InputMaybe<Payments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payments_OneArgs = {
  object: Payments_Insert_Input;
  on_conflict?: InputMaybe<Payments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RatingsArgs = {
  objects: Array<Ratings_Insert_Input>;
  on_conflict?: InputMaybe<Ratings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ratings_OneArgs = {
  object: Ratings_Insert_Input;
  on_conflict?: InputMaybe<Ratings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RestaurantArgs = {
  objects: Array<Restaurant_Insert_Input>;
  on_conflict?: InputMaybe<Restaurant_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Restaurant_OneArgs = {
  object: Restaurant_Insert_Input;
  on_conflict?: InputMaybe<Restaurant_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ride_EventsArgs = {
  objects: Array<Ride_Events_Insert_Input>;
  on_conflict?: InputMaybe<Ride_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ride_Events_OneArgs = {
  object: Ride_Events_Insert_Input;
  on_conflict?: InputMaybe<Ride_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RidesArgs = {
  objects: Array<Rides_Insert_Input>;
  on_conflict?: InputMaybe<Rides_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rides_OneArgs = {
  object: Rides_Insert_Input;
  on_conflict?: InputMaybe<Rides_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SettlementArgs = {
  objects: Array<Settlement_Insert_Input>;
  on_conflict?: InputMaybe<Settlement_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Settlement_OneArgs = {
  object: Settlement_Insert_Input;
  on_conflict?: InputMaybe<Settlement_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SpecialtyArgs = {
  objects: Array<Specialty_Insert_Input>;
  on_conflict?: InputMaybe<Specialty_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Specialty_OneArgs = {
  object: Specialty_Insert_Input;
  on_conflict?: InputMaybe<Specialty_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_DevicesArgs = {
  objects: Array<User_Devices_Insert_Input>;
  on_conflict?: InputMaybe<User_Devices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Devices_OneArgs = {
  object: User_Devices_Insert_Input;
  on_conflict?: InputMaybe<User_Devices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_ProfilesArgs = {
  objects: Array<User_Profiles_Insert_Input>;
  on_conflict?: InputMaybe<User_Profiles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Profiles_OneArgs = {
  object: User_Profiles_Insert_Input;
  on_conflict?: InputMaybe<User_Profiles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_SettingsArgs = {
  objects: Array<User_Settings_Insert_Input>;
  on_conflict?: InputMaybe<User_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Settings_OneArgs = {
  object: User_Settings_Insert_Input;
  on_conflict?: InputMaybe<User_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_DocumentsArgs = {
  objects: Array<Vehicle_Documents_Insert_Input>;
  on_conflict?: InputMaybe<Vehicle_Documents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Documents_OneArgs = {
  object: Vehicle_Documents_Insert_Input;
  on_conflict?: InputMaybe<Vehicle_Documents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_VehiclesArgs = {
  objects: Array<Vehicles_Insert_Input>;
  on_conflict?: InputMaybe<Vehicles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicles_OneArgs = {
  object: Vehicles_Insert_Input;
  on_conflict?: InputMaybe<Vehicles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootUpdateAuthProviderArgs = {
  _set?: InputMaybe<AuthProviders_Set_Input>;
  pk_columns: AuthProviders_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthProviderRequestArgs = {
  _append?: InputMaybe<AuthProviderRequests_Append_Input>;
  _delete_at_path?: InputMaybe<AuthProviderRequests_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<AuthProviderRequests_Delete_Elem_Input>;
  _delete_key?: InputMaybe<AuthProviderRequests_Delete_Key_Input>;
  _prepend?: InputMaybe<AuthProviderRequests_Prepend_Input>;
  _set?: InputMaybe<AuthProviderRequests_Set_Input>;
  pk_columns: AuthProviderRequests_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthProviderRequestsArgs = {
  _append?: InputMaybe<AuthProviderRequests_Append_Input>;
  _delete_at_path?: InputMaybe<AuthProviderRequests_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<AuthProviderRequests_Delete_Elem_Input>;
  _delete_key?: InputMaybe<AuthProviderRequests_Delete_Key_Input>;
  _prepend?: InputMaybe<AuthProviderRequests_Prepend_Input>;
  _set?: InputMaybe<AuthProviderRequests_Set_Input>;
  where: AuthProviderRequests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthProvidersArgs = {
  _set?: InputMaybe<AuthProviders_Set_Input>;
  where: AuthProviders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthRefreshTokenArgs = {
  _append?: InputMaybe<AuthRefreshTokens_Append_Input>;
  _delete_at_path?: InputMaybe<AuthRefreshTokens_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<AuthRefreshTokens_Delete_Elem_Input>;
  _delete_key?: InputMaybe<AuthRefreshTokens_Delete_Key_Input>;
  _prepend?: InputMaybe<AuthRefreshTokens_Prepend_Input>;
  _set?: InputMaybe<AuthRefreshTokens_Set_Input>;
  pk_columns: AuthRefreshTokens_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthRefreshTokenTypeArgs = {
  _set?: InputMaybe<AuthRefreshTokenTypes_Set_Input>;
  pk_columns: AuthRefreshTokenTypes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthRefreshTokenTypesArgs = {
  _set?: InputMaybe<AuthRefreshTokenTypes_Set_Input>;
  where: AuthRefreshTokenTypes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthRefreshTokensArgs = {
  _append?: InputMaybe<AuthRefreshTokens_Append_Input>;
  _delete_at_path?: InputMaybe<AuthRefreshTokens_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<AuthRefreshTokens_Delete_Elem_Input>;
  _delete_key?: InputMaybe<AuthRefreshTokens_Delete_Key_Input>;
  _prepend?: InputMaybe<AuthRefreshTokens_Prepend_Input>;
  _set?: InputMaybe<AuthRefreshTokens_Set_Input>;
  where: AuthRefreshTokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthRoleArgs = {
  _set?: InputMaybe<AuthRoles_Set_Input>;
  pk_columns: AuthRoles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthRolesArgs = {
  _set?: InputMaybe<AuthRoles_Set_Input>;
  where: AuthRoles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserProviderArgs = {
  _set?: InputMaybe<AuthUserProviders_Set_Input>;
  pk_columns: AuthUserProviders_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserProvidersArgs = {
  _set?: InputMaybe<AuthUserProviders_Set_Input>;
  where: AuthUserProviders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserRoleArgs = {
  _set?: InputMaybe<AuthUserRoles_Set_Input>;
  pk_columns: AuthUserRoles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserRolesArgs = {
  _set?: InputMaybe<AuthUserRoles_Set_Input>;
  where: AuthUserRoles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserSecurityKeyArgs = {
  _inc?: InputMaybe<AuthUserSecurityKeys_Inc_Input>;
  _set?: InputMaybe<AuthUserSecurityKeys_Set_Input>;
  pk_columns: AuthUserSecurityKeys_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserSecurityKeysArgs = {
  _inc?: InputMaybe<AuthUserSecurityKeys_Inc_Input>;
  _set?: InputMaybe<AuthUserSecurityKeys_Set_Input>;
  where: AuthUserSecurityKeys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateBucketArgs = {
  _inc?: InputMaybe<Buckets_Inc_Input>;
  _set?: InputMaybe<Buckets_Set_Input>;
  pk_columns: Buckets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateBucketsArgs = {
  _inc?: InputMaybe<Buckets_Inc_Input>;
  _set?: InputMaybe<Buckets_Set_Input>;
  where: Buckets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateFileArgs = {
  _append?: InputMaybe<Files_Append_Input>;
  _delete_at_path?: InputMaybe<Files_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Files_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Files_Delete_Key_Input>;
  _inc?: InputMaybe<Files_Inc_Input>;
  _prepend?: InputMaybe<Files_Prepend_Input>;
  _set?: InputMaybe<Files_Set_Input>;
  pk_columns: Files_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateFilesArgs = {
  _append?: InputMaybe<Files_Append_Input>;
  _delete_at_path?: InputMaybe<Files_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Files_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Files_Delete_Key_Input>;
  _inc?: InputMaybe<Files_Inc_Input>;
  _prepend?: InputMaybe<Files_Prepend_Input>;
  _set?: InputMaybe<Files_Set_Input>;
  where: Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateUserArgs = {
  _append?: InputMaybe<Users_Append_Input>;
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  _prepend?: InputMaybe<Users_Prepend_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateUsersArgs = {
  _append?: InputMaybe<Users_Append_Input>;
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  _prepend?: InputMaybe<Users_Prepend_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateVirusArgs = {
  _append?: InputMaybe<Virus_Append_Input>;
  _delete_at_path?: InputMaybe<Virus_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Virus_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Virus_Delete_Key_Input>;
  _prepend?: InputMaybe<Virus_Prepend_Input>;
  _set?: InputMaybe<Virus_Set_Input>;
  pk_columns: Virus_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateVirusesArgs = {
  _append?: InputMaybe<Virus_Append_Input>;
  _delete_at_path?: InputMaybe<Virus_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Virus_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Virus_Delete_Key_Input>;
  _prepend?: InputMaybe<Virus_Prepend_Input>;
  _set?: InputMaybe<Virus_Set_Input>;
  where: Virus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Account_Deletion_RequestArgs = {
  _set?: InputMaybe<Account_Deletion_Request_Set_Input>;
  where: Account_Deletion_Request_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Account_Deletion_Request_By_PkArgs = {
  _set?: InputMaybe<Account_Deletion_Request_Set_Input>;
  pk_columns: Account_Deletion_Request_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Account_Deletion_Request_ManyArgs = {
  updates: Array<Account_Deletion_Request_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_App_SettingsArgs = {
  _append?: InputMaybe<App_Settings_Append_Input>;
  _delete_at_path?: InputMaybe<App_Settings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<App_Settings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<App_Settings_Delete_Key_Input>;
  _inc?: InputMaybe<App_Settings_Inc_Input>;
  _prepend?: InputMaybe<App_Settings_Prepend_Input>;
  _set?: InputMaybe<App_Settings_Set_Input>;
  where: App_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_App_Settings_By_PkArgs = {
  _append?: InputMaybe<App_Settings_Append_Input>;
  _delete_at_path?: InputMaybe<App_Settings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<App_Settings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<App_Settings_Delete_Key_Input>;
  _inc?: InputMaybe<App_Settings_Inc_Input>;
  _prepend?: InputMaybe<App_Settings_Prepend_Input>;
  _set?: InputMaybe<App_Settings_Set_Input>;
  pk_columns: App_Settings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_App_Settings_ManyArgs = {
  updates: Array<App_Settings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_App_VersionsArgs = {
  _set?: InputMaybe<App_Versions_Set_Input>;
  where: App_Versions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_App_Versions_By_PkArgs = {
  _set?: InputMaybe<App_Versions_Set_Input>;
  pk_columns: App_Versions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_App_Versions_ManyArgs = {
  updates: Array<App_Versions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AssignmentArgs = {
  _set?: InputMaybe<Assignment_Set_Input>;
  where: Assignment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Assignment_By_PkArgs = {
  _set?: InputMaybe<Assignment_Set_Input>;
  pk_columns: Assignment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Assignment_ManyArgs = {
  updates: Array<Assignment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthProviderRequests_ManyArgs = {
  updates: Array<AuthProviderRequests_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthProviders_ManyArgs = {
  updates: Array<AuthProviders_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthRefreshTokenTypes_ManyArgs = {
  updates: Array<AuthRefreshTokenTypes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthRefreshTokens_ManyArgs = {
  updates: Array<AuthRefreshTokens_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthRoles_ManyArgs = {
  updates: Array<AuthRoles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthUserProviders_ManyArgs = {
  updates: Array<AuthUserProviders_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthUserRoles_ManyArgs = {
  updates: Array<AuthUserRoles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthUserSecurityKeys_ManyArgs = {
  updates: Array<AuthUserSecurityKeys_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_BasketArgs = {
  _set?: InputMaybe<Basket_Set_Input>;
  where: Basket_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Basket_By_PkArgs = {
  _set?: InputMaybe<Basket_Set_Input>;
  pk_columns: Basket_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Basket_DishArgs = {
  _inc?: InputMaybe<Basket_Dish_Inc_Input>;
  _set?: InputMaybe<Basket_Dish_Set_Input>;
  where: Basket_Dish_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Basket_Dish_By_PkArgs = {
  _inc?: InputMaybe<Basket_Dish_Inc_Input>;
  _set?: InputMaybe<Basket_Dish_Set_Input>;
  pk_columns: Basket_Dish_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Basket_Dish_ManyArgs = {
  updates: Array<Basket_Dish_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Basket_ManyArgs = {
  updates: Array<Basket_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Buckets_ManyArgs = {
  updates: Array<Buckets_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CarrierArgs = {
  _append?: InputMaybe<Carrier_Append_Input>;
  _delete_at_path?: InputMaybe<Carrier_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Carrier_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Carrier_Delete_Key_Input>;
  _inc?: InputMaybe<Carrier_Inc_Input>;
  _prepend?: InputMaybe<Carrier_Prepend_Input>;
  _set?: InputMaybe<Carrier_Set_Input>;
  where: Carrier_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Carrier_By_PkArgs = {
  _append?: InputMaybe<Carrier_Append_Input>;
  _delete_at_path?: InputMaybe<Carrier_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Carrier_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Carrier_Delete_Key_Input>;
  _inc?: InputMaybe<Carrier_Inc_Input>;
  _prepend?: InputMaybe<Carrier_Prepend_Input>;
  _set?: InputMaybe<Carrier_Set_Input>;
  pk_columns: Carrier_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Carrier_ManyArgs = {
  updates: Array<Carrier_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CategoryArgs = {
  _set?: InputMaybe<Category_Set_Input>;
  where: Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Category_By_PkArgs = {
  _set?: InputMaybe<Category_Set_Input>;
  pk_columns: Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Category_ManyArgs = {
  updates: Array<Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DishArgs = {
  _set?: InputMaybe<Dish_Set_Input>;
  where: Dish_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Dish_By_PkArgs = {
  _set?: InputMaybe<Dish_Set_Input>;
  pk_columns: Dish_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Dish_ManyArgs = {
  updates: Array<Dish_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Driver_DocumentsArgs = {
  _set?: InputMaybe<Driver_Documents_Set_Input>;
  where: Driver_Documents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Driver_Documents_By_PkArgs = {
  _set?: InputMaybe<Driver_Documents_Set_Input>;
  pk_columns: Driver_Documents_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Driver_Documents_ManyArgs = {
  updates: Array<Driver_Documents_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Driver_Locations_CurrentArgs = {
  _inc?: InputMaybe<Driver_Locations_Current_Inc_Input>;
  _set?: InputMaybe<Driver_Locations_Current_Set_Input>;
  where: Driver_Locations_Current_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Driver_Locations_Current_By_PkArgs = {
  _inc?: InputMaybe<Driver_Locations_Current_Inc_Input>;
  _set?: InputMaybe<Driver_Locations_Current_Set_Input>;
  pk_columns: Driver_Locations_Current_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Driver_Locations_Current_ManyArgs = {
  updates: Array<Driver_Locations_Current_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DriversArgs = {
  _append?: InputMaybe<Drivers_Append_Input>;
  _delete_at_path?: InputMaybe<Drivers_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Drivers_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Drivers_Delete_Key_Input>;
  _inc?: InputMaybe<Drivers_Inc_Input>;
  _prepend?: InputMaybe<Drivers_Prepend_Input>;
  _set?: InputMaybe<Drivers_Set_Input>;
  where: Drivers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Drivers_By_PkArgs = {
  _append?: InputMaybe<Drivers_Append_Input>;
  _delete_at_path?: InputMaybe<Drivers_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Drivers_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Drivers_Delete_Key_Input>;
  _inc?: InputMaybe<Drivers_Inc_Input>;
  _prepend?: InputMaybe<Drivers_Prepend_Input>;
  _set?: InputMaybe<Drivers_Set_Input>;
  pk_columns: Drivers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Drivers_ManyArgs = {
  updates: Array<Drivers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Fare_BandsArgs = {
  _inc?: InputMaybe<Fare_Bands_Inc_Input>;
  _set?: InputMaybe<Fare_Bands_Set_Input>;
  where: Fare_Bands_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Fare_Bands_By_PkArgs = {
  _inc?: InputMaybe<Fare_Bands_Inc_Input>;
  _set?: InputMaybe<Fare_Bands_Set_Input>;
  pk_columns: Fare_Bands_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Fare_Bands_ManyArgs = {
  updates: Array<Fare_Bands_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FeedbackArgs = {
  _inc?: InputMaybe<Feedback_Inc_Input>;
  _set?: InputMaybe<Feedback_Set_Input>;
  where: Feedback_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Feedback_By_PkArgs = {
  _inc?: InputMaybe<Feedback_Inc_Input>;
  _set?: InputMaybe<Feedback_Set_Input>;
  pk_columns: Feedback_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Feedback_ManyArgs = {
  updates: Array<Feedback_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Files_ManyArgs = {
  updates: Array<Files_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Free_RidesArgs = {
  _append?: InputMaybe<Free_Rides_Append_Input>;
  _delete_at_path?: InputMaybe<Free_Rides_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Free_Rides_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Free_Rides_Delete_Key_Input>;
  _inc?: InputMaybe<Free_Rides_Inc_Input>;
  _prepend?: InputMaybe<Free_Rides_Prepend_Input>;
  _set?: InputMaybe<Free_Rides_Set_Input>;
  where: Free_Rides_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Free_Rides_By_PkArgs = {
  _append?: InputMaybe<Free_Rides_Append_Input>;
  _delete_at_path?: InputMaybe<Free_Rides_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Free_Rides_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Free_Rides_Delete_Key_Input>;
  _inc?: InputMaybe<Free_Rides_Inc_Input>;
  _prepend?: InputMaybe<Free_Rides_Prepend_Input>;
  _set?: InputMaybe<Free_Rides_Set_Input>;
  pk_columns: Free_Rides_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Free_Rides_ManyArgs = {
  updates: Array<Free_Rides_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OrderArgs = {
  _inc?: InputMaybe<Order_Inc_Input>;
  _set?: InputMaybe<Order_Set_Input>;
  where: Order_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Order_By_PkArgs = {
  _inc?: InputMaybe<Order_Inc_Input>;
  _set?: InputMaybe<Order_Set_Input>;
  pk_columns: Order_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Order_ManyArgs = {
  updates: Array<Order_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PaymentsArgs = {
  _append?: InputMaybe<Payments_Append_Input>;
  _delete_at_path?: InputMaybe<Payments_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Payments_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Payments_Delete_Key_Input>;
  _inc?: InputMaybe<Payments_Inc_Input>;
  _prepend?: InputMaybe<Payments_Prepend_Input>;
  _set?: InputMaybe<Payments_Set_Input>;
  where: Payments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Payments_By_PkArgs = {
  _append?: InputMaybe<Payments_Append_Input>;
  _delete_at_path?: InputMaybe<Payments_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Payments_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Payments_Delete_Key_Input>;
  _inc?: InputMaybe<Payments_Inc_Input>;
  _prepend?: InputMaybe<Payments_Prepend_Input>;
  _set?: InputMaybe<Payments_Set_Input>;
  pk_columns: Payments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Payments_ManyArgs = {
  updates: Array<Payments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RatingsArgs = {
  _inc?: InputMaybe<Ratings_Inc_Input>;
  _set?: InputMaybe<Ratings_Set_Input>;
  where: Ratings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ratings_By_PkArgs = {
  _inc?: InputMaybe<Ratings_Inc_Input>;
  _set?: InputMaybe<Ratings_Set_Input>;
  pk_columns: Ratings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ratings_ManyArgs = {
  updates: Array<Ratings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RestaurantArgs = {
  _append?: InputMaybe<Restaurant_Append_Input>;
  _delete_at_path?: InputMaybe<Restaurant_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Restaurant_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Restaurant_Delete_Key_Input>;
  _inc?: InputMaybe<Restaurant_Inc_Input>;
  _prepend?: InputMaybe<Restaurant_Prepend_Input>;
  _set?: InputMaybe<Restaurant_Set_Input>;
  where: Restaurant_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Restaurant_By_PkArgs = {
  _append?: InputMaybe<Restaurant_Append_Input>;
  _delete_at_path?: InputMaybe<Restaurant_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Restaurant_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Restaurant_Delete_Key_Input>;
  _inc?: InputMaybe<Restaurant_Inc_Input>;
  _prepend?: InputMaybe<Restaurant_Prepend_Input>;
  _set?: InputMaybe<Restaurant_Set_Input>;
  pk_columns: Restaurant_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Restaurant_ManyArgs = {
  updates: Array<Restaurant_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ride_EventsArgs = {
  _append?: InputMaybe<Ride_Events_Append_Input>;
  _delete_at_path?: InputMaybe<Ride_Events_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Ride_Events_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Ride_Events_Delete_Key_Input>;
  _prepend?: InputMaybe<Ride_Events_Prepend_Input>;
  _set?: InputMaybe<Ride_Events_Set_Input>;
  where: Ride_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ride_Events_By_PkArgs = {
  _append?: InputMaybe<Ride_Events_Append_Input>;
  _delete_at_path?: InputMaybe<Ride_Events_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Ride_Events_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Ride_Events_Delete_Key_Input>;
  _prepend?: InputMaybe<Ride_Events_Prepend_Input>;
  _set?: InputMaybe<Ride_Events_Set_Input>;
  pk_columns: Ride_Events_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ride_Events_ManyArgs = {
  updates: Array<Ride_Events_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RidesArgs = {
  _append?: InputMaybe<Rides_Append_Input>;
  _delete_at_path?: InputMaybe<Rides_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Rides_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Rides_Delete_Key_Input>;
  _inc?: InputMaybe<Rides_Inc_Input>;
  _prepend?: InputMaybe<Rides_Prepend_Input>;
  _set?: InputMaybe<Rides_Set_Input>;
  where: Rides_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Rides_By_PkArgs = {
  _append?: InputMaybe<Rides_Append_Input>;
  _delete_at_path?: InputMaybe<Rides_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Rides_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Rides_Delete_Key_Input>;
  _inc?: InputMaybe<Rides_Inc_Input>;
  _prepend?: InputMaybe<Rides_Prepend_Input>;
  _set?: InputMaybe<Rides_Set_Input>;
  pk_columns: Rides_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Rides_ManyArgs = {
  updates: Array<Rides_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SettlementArgs = {
  _inc?: InputMaybe<Settlement_Inc_Input>;
  _set?: InputMaybe<Settlement_Set_Input>;
  where: Settlement_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Settlement_By_PkArgs = {
  _inc?: InputMaybe<Settlement_Inc_Input>;
  _set?: InputMaybe<Settlement_Set_Input>;
  pk_columns: Settlement_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Settlement_ManyArgs = {
  updates: Array<Settlement_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SpecialtyArgs = {
  _set?: InputMaybe<Specialty_Set_Input>;
  where: Specialty_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Specialty_By_PkArgs = {
  _set?: InputMaybe<Specialty_Set_Input>;
  pk_columns: Specialty_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Specialty_ManyArgs = {
  updates: Array<Specialty_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_DevicesArgs = {
  _set?: InputMaybe<User_Devices_Set_Input>;
  where: User_Devices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Devices_By_PkArgs = {
  _set?: InputMaybe<User_Devices_Set_Input>;
  pk_columns: User_Devices_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Devices_ManyArgs = {
  updates: Array<User_Devices_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_ProfilesArgs = {
  _append?: InputMaybe<User_Profiles_Append_Input>;
  _delete_at_path?: InputMaybe<User_Profiles_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Profiles_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Profiles_Delete_Key_Input>;
  _prepend?: InputMaybe<User_Profiles_Prepend_Input>;
  _set?: InputMaybe<User_Profiles_Set_Input>;
  where: User_Profiles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Profiles_By_PkArgs = {
  _append?: InputMaybe<User_Profiles_Append_Input>;
  _delete_at_path?: InputMaybe<User_Profiles_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Profiles_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Profiles_Delete_Key_Input>;
  _prepend?: InputMaybe<User_Profiles_Prepend_Input>;
  _set?: InputMaybe<User_Profiles_Set_Input>;
  pk_columns: User_Profiles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Profiles_ManyArgs = {
  updates: Array<User_Profiles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_SettingsArgs = {
  _append?: InputMaybe<User_Settings_Append_Input>;
  _delete_at_path?: InputMaybe<User_Settings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Settings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Settings_Delete_Key_Input>;
  _prepend?: InputMaybe<User_Settings_Prepend_Input>;
  _set?: InputMaybe<User_Settings_Set_Input>;
  where: User_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Settings_By_PkArgs = {
  _append?: InputMaybe<User_Settings_Append_Input>;
  _delete_at_path?: InputMaybe<User_Settings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Settings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Settings_Delete_Key_Input>;
  _prepend?: InputMaybe<User_Settings_Prepend_Input>;
  _set?: InputMaybe<User_Settings_Set_Input>;
  pk_columns: User_Settings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Settings_ManyArgs = {
  updates: Array<User_Settings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgs = {
  updates: Array<Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_DocumentsArgs = {
  _set?: InputMaybe<Vehicle_Documents_Set_Input>;
  where: Vehicle_Documents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Documents_By_PkArgs = {
  _set?: InputMaybe<Vehicle_Documents_Set_Input>;
  pk_columns: Vehicle_Documents_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Documents_ManyArgs = {
  updates: Array<Vehicle_Documents_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_VehiclesArgs = {
  _set?: InputMaybe<Vehicles_Set_Input>;
  where: Vehicles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicles_By_PkArgs = {
  _set?: InputMaybe<Vehicles_Set_Input>;
  pk_columns: Vehicles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicles_ManyArgs = {
  updates: Array<Vehicles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Virus_ManyArgs = {
  updates: Array<Virus_Updates>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** columns and relationships of "order" */
export type Order = {
  __typename?: 'order';
  address?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  assignment?: Maybe<Assignment>;
  /** An object relationship */
  basket: Basket;
  basketId: Scalars['uuid']['output'];
  cancelReason?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  deliveredBy: Scalars['String']['output'];
  deliveryCharge?: Maybe<Scalars['numeric']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  dropoffLocation?: Maybe<Scalars['geography']['output']>;
  id: Scalars['uuid']['output'];
  note?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['numeric']['output']>;
  receiverName?: Maybe<Scalars['String']['output']>;
  settlementId?: Maybe<Scalars['uuid']['output']>;
  status: Scalars['String']['output'];
  subTotal?: Maybe<Scalars['numeric']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "order" */
export type Order_Aggregate = {
  __typename?: 'order_aggregate';
  aggregate?: Maybe<Order_Aggregate_Fields>;
  nodes: Array<Order>;
};

export type Order_Aggregate_Bool_Exp = {
  count?: InputMaybe<Order_Aggregate_Bool_Exp_Count>;
};

export type Order_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Order_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Order_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "order" */
export type Order_Aggregate_Fields = {
  __typename?: 'order_aggregate_fields';
  avg?: Maybe<Order_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Order_Max_Fields>;
  min?: Maybe<Order_Min_Fields>;
  stddev?: Maybe<Order_Stddev_Fields>;
  stddev_pop?: Maybe<Order_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Order_Stddev_Samp_Fields>;
  sum?: Maybe<Order_Sum_Fields>;
  var_pop?: Maybe<Order_Var_Pop_Fields>;
  var_samp?: Maybe<Order_Var_Samp_Fields>;
  variance?: Maybe<Order_Variance_Fields>;
};


/** aggregate fields of "order" */
export type Order_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Order_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "order" */
export type Order_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Max_Order_By>;
  min?: InputMaybe<Order_Min_Order_By>;
  stddev?: InputMaybe<Order_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "order" */
export type Order_Arr_Rel_Insert_Input = {
  data: Array<Order_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Order_On_Conflict>;
};

/** aggregate avg on columns */
export type Order_Avg_Fields = {
  __typename?: 'order_avg_fields';
  deliveryCharge?: Maybe<Scalars['Float']['output']>;
  phoneNumber?: Maybe<Scalars['Float']['output']>;
  subTotal?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "order" */
export type Order_Avg_Order_By = {
  deliveryCharge?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  subTotal?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order". All fields are combined with a logical 'AND'. */
export type Order_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Bool_Exp>>;
  _not?: InputMaybe<Order_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  assignment?: InputMaybe<Assignment_Bool_Exp>;
  basket?: InputMaybe<Basket_Bool_Exp>;
  basketId?: InputMaybe<Uuid_Comparison_Exp>;
  cancelReason?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deliveredBy?: InputMaybe<String_Comparison_Exp>;
  deliveryCharge?: InputMaybe<Numeric_Comparison_Exp>;
  direction?: InputMaybe<String_Comparison_Exp>;
  dropoffLocation?: InputMaybe<Geography_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  phoneNumber?: InputMaybe<Numeric_Comparison_Exp>;
  receiverName?: InputMaybe<String_Comparison_Exp>;
  settlementId?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  subTotal?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** unique or primary key constraints on table "order" */
export enum Order_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrderPkey = 'order_pkey'
}

/** input type for incrementing numeric columns in table "order" */
export type Order_Inc_Input = {
  deliveryCharge?: InputMaybe<Scalars['numeric']['input']>;
  phoneNumber?: InputMaybe<Scalars['numeric']['input']>;
  subTotal?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "order" */
export type Order_Insert_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  assignment?: InputMaybe<Assignment_Obj_Rel_Insert_Input>;
  basket?: InputMaybe<Basket_Obj_Rel_Insert_Input>;
  basketId?: InputMaybe<Scalars['uuid']['input']>;
  cancelReason?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deliveredBy?: InputMaybe<Scalars['String']['input']>;
  deliveryCharge?: InputMaybe<Scalars['numeric']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  dropoffLocation?: InputMaybe<Scalars['geography']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['numeric']['input']>;
  receiverName?: InputMaybe<Scalars['String']['input']>;
  settlementId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subTotal?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Order_Max_Fields = {
  __typename?: 'order_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  basketId?: Maybe<Scalars['uuid']['output']>;
  cancelReason?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deliveredBy?: Maybe<Scalars['String']['output']>;
  deliveryCharge?: Maybe<Scalars['numeric']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['numeric']['output']>;
  receiverName?: Maybe<Scalars['String']['output']>;
  settlementId?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subTotal?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "order" */
export type Order_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  basketId?: InputMaybe<Order_By>;
  cancelReason?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deliveredBy?: InputMaybe<Order_By>;
  deliveryCharge?: InputMaybe<Order_By>;
  direction?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  receiverName?: InputMaybe<Order_By>;
  settlementId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subTotal?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Order_Min_Fields = {
  __typename?: 'order_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  basketId?: Maybe<Scalars['uuid']['output']>;
  cancelReason?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deliveredBy?: Maybe<Scalars['String']['output']>;
  deliveryCharge?: Maybe<Scalars['numeric']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['numeric']['output']>;
  receiverName?: Maybe<Scalars['String']['output']>;
  settlementId?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subTotal?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "order" */
export type Order_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  basketId?: InputMaybe<Order_By>;
  cancelReason?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deliveredBy?: InputMaybe<Order_By>;
  deliveryCharge?: InputMaybe<Order_By>;
  direction?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  receiverName?: InputMaybe<Order_By>;
  settlementId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subTotal?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "order" */
export type Order_Mutation_Response = {
  __typename?: 'order_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Order>;
};

/** input type for inserting object relation for remote table "order" */
export type Order_Obj_Rel_Insert_Input = {
  data: Order_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Order_On_Conflict>;
};

/** on_conflict condition type for table "order" */
export type Order_On_Conflict = {
  constraint: Order_Constraint;
  update_columns?: Array<Order_Update_Column>;
  where?: InputMaybe<Order_Bool_Exp>;
};

/** Ordering options when selecting data from "order". */
export type Order_Order_By = {
  address?: InputMaybe<Order_By>;
  assignment?: InputMaybe<Assignment_Order_By>;
  basket?: InputMaybe<Basket_Order_By>;
  basketId?: InputMaybe<Order_By>;
  cancelReason?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deliveredBy?: InputMaybe<Order_By>;
  deliveryCharge?: InputMaybe<Order_By>;
  direction?: InputMaybe<Order_By>;
  dropoffLocation?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  receiverName?: InputMaybe<Order_By>;
  settlementId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subTotal?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: order */
export type Order_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "order" */
export enum Order_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  BasketId = 'basketId',
  /** column name */
  CancelReason = 'cancelReason',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeliveredBy = 'deliveredBy',
  /** column name */
  DeliveryCharge = 'deliveryCharge',
  /** column name */
  Direction = 'direction',
  /** column name */
  DropoffLocation = 'dropoffLocation',
  /** column name */
  Id = 'id',
  /** column name */
  Note = 'note',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  ReceiverName = 'receiverName',
  /** column name */
  SettlementId = 'settlementId',
  /** column name */
  Status = 'status',
  /** column name */
  SubTotal = 'subTotal',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "order" */
export type Order_Set_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  basketId?: InputMaybe<Scalars['uuid']['input']>;
  cancelReason?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deliveredBy?: InputMaybe<Scalars['String']['input']>;
  deliveryCharge?: InputMaybe<Scalars['numeric']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  dropoffLocation?: InputMaybe<Scalars['geography']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['numeric']['input']>;
  receiverName?: InputMaybe<Scalars['String']['input']>;
  settlementId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subTotal?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Order_Stddev_Fields = {
  __typename?: 'order_stddev_fields';
  deliveryCharge?: Maybe<Scalars['Float']['output']>;
  phoneNumber?: Maybe<Scalars['Float']['output']>;
  subTotal?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "order" */
export type Order_Stddev_Order_By = {
  deliveryCharge?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  subTotal?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Order_Stddev_Pop_Fields = {
  __typename?: 'order_stddev_pop_fields';
  deliveryCharge?: Maybe<Scalars['Float']['output']>;
  phoneNumber?: Maybe<Scalars['Float']['output']>;
  subTotal?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "order" */
export type Order_Stddev_Pop_Order_By = {
  deliveryCharge?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  subTotal?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Order_Stddev_Samp_Fields = {
  __typename?: 'order_stddev_samp_fields';
  deliveryCharge?: Maybe<Scalars['Float']['output']>;
  phoneNumber?: Maybe<Scalars['Float']['output']>;
  subTotal?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "order" */
export type Order_Stddev_Samp_Order_By = {
  deliveryCharge?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  subTotal?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "order" */
export type Order_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  basketId?: InputMaybe<Scalars['uuid']['input']>;
  cancelReason?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deliveredBy?: InputMaybe<Scalars['String']['input']>;
  deliveryCharge?: InputMaybe<Scalars['numeric']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  dropoffLocation?: InputMaybe<Scalars['geography']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['numeric']['input']>;
  receiverName?: InputMaybe<Scalars['String']['input']>;
  settlementId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subTotal?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Order_Sum_Fields = {
  __typename?: 'order_sum_fields';
  deliveryCharge?: Maybe<Scalars['numeric']['output']>;
  phoneNumber?: Maybe<Scalars['numeric']['output']>;
  subTotal?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "order" */
export type Order_Sum_Order_By = {
  deliveryCharge?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  subTotal?: InputMaybe<Order_By>;
};

/** update columns of table "order" */
export enum Order_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  BasketId = 'basketId',
  /** column name */
  CancelReason = 'cancelReason',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeliveredBy = 'deliveredBy',
  /** column name */
  DeliveryCharge = 'deliveryCharge',
  /** column name */
  Direction = 'direction',
  /** column name */
  DropoffLocation = 'dropoffLocation',
  /** column name */
  Id = 'id',
  /** column name */
  Note = 'note',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  ReceiverName = 'receiverName',
  /** column name */
  SettlementId = 'settlementId',
  /** column name */
  Status = 'status',
  /** column name */
  SubTotal = 'subTotal',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Order_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Order_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Order_Set_Input>;
  /** filter the rows which have to be updated */
  where: Order_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Order_Var_Pop_Fields = {
  __typename?: 'order_var_pop_fields';
  deliveryCharge?: Maybe<Scalars['Float']['output']>;
  phoneNumber?: Maybe<Scalars['Float']['output']>;
  subTotal?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "order" */
export type Order_Var_Pop_Order_By = {
  deliveryCharge?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  subTotal?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Order_Var_Samp_Fields = {
  __typename?: 'order_var_samp_fields';
  deliveryCharge?: Maybe<Scalars['Float']['output']>;
  phoneNumber?: Maybe<Scalars['Float']['output']>;
  subTotal?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "order" */
export type Order_Var_Samp_Order_By = {
  deliveryCharge?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  subTotal?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Order_Variance_Fields = {
  __typename?: 'order_variance_fields';
  deliveryCharge?: Maybe<Scalars['Float']['output']>;
  phoneNumber?: Maybe<Scalars['Float']['output']>;
  subTotal?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "order" */
export type Order_Variance_Order_By = {
  deliveryCharge?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  subTotal?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "payment_status_enum". All fields are combined with logical 'AND'. */
export type Payment_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['payment_status_enum']['input']>;
  _gt?: InputMaybe<Scalars['payment_status_enum']['input']>;
  _gte?: InputMaybe<Scalars['payment_status_enum']['input']>;
  _in?: InputMaybe<Array<Scalars['payment_status_enum']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['payment_status_enum']['input']>;
  _lte?: InputMaybe<Scalars['payment_status_enum']['input']>;
  _neq?: InputMaybe<Scalars['payment_status_enum']['input']>;
  _nin?: InputMaybe<Array<Scalars['payment_status_enum']['input']>>;
};

/** columns and relationships of "payments" */
export type Payments = {
  __typename?: 'payments';
  amount?: Maybe<Scalars['numeric']['output']>;
  created_at: Scalars['timestamptz']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  payment_details?: Maybe<Scalars['jsonb']['output']>;
  processed_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  ride: Rides;
  ride_id: Scalars['uuid']['output'];
  status?: Maybe<Scalars['payment_status_enum']['output']>;
  transaction_id?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};


/** columns and relationships of "payments" */
export type PaymentsPayment_DetailsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "payments" */
export type Payments_Aggregate = {
  __typename?: 'payments_aggregate';
  aggregate?: Maybe<Payments_Aggregate_Fields>;
  nodes: Array<Payments>;
};

export type Payments_Aggregate_Bool_Exp = {
  count?: InputMaybe<Payments_Aggregate_Bool_Exp_Count>;
};

export type Payments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Payments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Payments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "payments" */
export type Payments_Aggregate_Fields = {
  __typename?: 'payments_aggregate_fields';
  avg?: Maybe<Payments_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Payments_Max_Fields>;
  min?: Maybe<Payments_Min_Fields>;
  stddev?: Maybe<Payments_Stddev_Fields>;
  stddev_pop?: Maybe<Payments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Payments_Stddev_Samp_Fields>;
  sum?: Maybe<Payments_Sum_Fields>;
  var_pop?: Maybe<Payments_Var_Pop_Fields>;
  var_samp?: Maybe<Payments_Var_Samp_Fields>;
  variance?: Maybe<Payments_Variance_Fields>;
};


/** aggregate fields of "payments" */
export type Payments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Payments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "payments" */
export type Payments_Aggregate_Order_By = {
  avg?: InputMaybe<Payments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Payments_Max_Order_By>;
  min?: InputMaybe<Payments_Min_Order_By>;
  stddev?: InputMaybe<Payments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Payments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Payments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Payments_Sum_Order_By>;
  var_pop?: InputMaybe<Payments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Payments_Var_Samp_Order_By>;
  variance?: InputMaybe<Payments_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Payments_Append_Input = {
  payment_details?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "payments" */
export type Payments_Arr_Rel_Insert_Input = {
  data: Array<Payments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Payments_On_Conflict>;
};

/** aggregate avg on columns */
export type Payments_Avg_Fields = {
  __typename?: 'payments_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "payments" */
export type Payments_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "payments". All fields are combined with a logical 'AND'. */
export type Payments_Bool_Exp = {
  _and?: InputMaybe<Array<Payments_Bool_Exp>>;
  _not?: InputMaybe<Payments_Bool_Exp>;
  _or?: InputMaybe<Array<Payments_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  payment_details?: InputMaybe<Jsonb_Comparison_Exp>;
  processed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  ride?: InputMaybe<Rides_Bool_Exp>;
  ride_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Payment_Status_Enum_Comparison_Exp>;
  transaction_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "payments" */
export enum Payments_Constraint {
  /** unique or primary key constraint on columns "id" */
  PaymentsPkey = 'payments_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Payments_Delete_At_Path_Input = {
  payment_details?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Payments_Delete_Elem_Input = {
  payment_details?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Payments_Delete_Key_Input = {
  payment_details?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "payments" */
export type Payments_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "payments" */
export type Payments_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  payment_details?: InputMaybe<Scalars['jsonb']['input']>;
  processed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  ride?: InputMaybe<Rides_Obj_Rel_Insert_Input>;
  ride_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['payment_status_enum']['input']>;
  transaction_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Payments_Max_Fields = {
  __typename?: 'payments_max_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  processed_at?: Maybe<Scalars['timestamptz']['output']>;
  ride_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['payment_status_enum']['output']>;
  transaction_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "payments" */
export type Payments_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  processed_at?: InputMaybe<Order_By>;
  ride_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Payments_Min_Fields = {
  __typename?: 'payments_min_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  processed_at?: Maybe<Scalars['timestamptz']['output']>;
  ride_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['payment_status_enum']['output']>;
  transaction_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "payments" */
export type Payments_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  processed_at?: InputMaybe<Order_By>;
  ride_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "payments" */
export type Payments_Mutation_Response = {
  __typename?: 'payments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Payments>;
};

/** on_conflict condition type for table "payments" */
export type Payments_On_Conflict = {
  constraint: Payments_Constraint;
  update_columns?: Array<Payments_Update_Column>;
  where?: InputMaybe<Payments_Bool_Exp>;
};

/** Ordering options when selecting data from "payments". */
export type Payments_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_details?: InputMaybe<Order_By>;
  processed_at?: InputMaybe<Order_By>;
  ride?: InputMaybe<Rides_Order_By>;
  ride_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: payments */
export type Payments_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Payments_Prepend_Input = {
  payment_details?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "payments" */
export enum Payments_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentDetails = 'payment_details',
  /** column name */
  ProcessedAt = 'processed_at',
  /** column name */
  RideId = 'ride_id',
  /** column name */
  Status = 'status',
  /** column name */
  TransactionId = 'transaction_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "payments" */
export type Payments_Set_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  payment_details?: InputMaybe<Scalars['jsonb']['input']>;
  processed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  ride_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['payment_status_enum']['input']>;
  transaction_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Payments_Stddev_Fields = {
  __typename?: 'payments_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "payments" */
export type Payments_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Payments_Stddev_Pop_Fields = {
  __typename?: 'payments_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "payments" */
export type Payments_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Payments_Stddev_Samp_Fields = {
  __typename?: 'payments_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "payments" */
export type Payments_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "payments" */
export type Payments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Payments_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  payment_details?: InputMaybe<Scalars['jsonb']['input']>;
  processed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  ride_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['payment_status_enum']['input']>;
  transaction_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Payments_Sum_Fields = {
  __typename?: 'payments_sum_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "payments" */
export type Payments_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** update columns of table "payments" */
export enum Payments_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentDetails = 'payment_details',
  /** column name */
  ProcessedAt = 'processed_at',
  /** column name */
  RideId = 'ride_id',
  /** column name */
  Status = 'status',
  /** column name */
  TransactionId = 'transaction_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Payments_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Payments_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Payments_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Payments_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Payments_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Payments_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Payments_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Payments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Payments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Payments_Var_Pop_Fields = {
  __typename?: 'payments_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "payments" */
export type Payments_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Payments_Var_Samp_Fields = {
  __typename?: 'payments_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "payments" */
export type Payments_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Payments_Variance_Fields = {
  __typename?: 'payments_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "payments" */
export type Payments_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "account_deletion_request" */
  account_deletion_request: Array<Account_Deletion_Request>;
  /** fetch aggregated fields from the table: "account_deletion_request" */
  account_deletion_request_aggregate: Account_Deletion_Request_Aggregate;
  /** fetch data from the table: "account_deletion_request" using primary key columns */
  account_deletion_request_by_pk?: Maybe<Account_Deletion_Request>;
  /** fetch data from the table: "app_settings" */
  app_settings: Array<App_Settings>;
  /** fetch aggregated fields from the table: "app_settings" */
  app_settings_aggregate: App_Settings_Aggregate;
  /** fetch data from the table: "app_settings" using primary key columns */
  app_settings_by_pk?: Maybe<App_Settings>;
  /** fetch data from the table: "app_versions" */
  app_versions: Array<App_Versions>;
  /** fetch aggregated fields from the table: "app_versions" */
  app_versions_aggregate: App_Versions_Aggregate;
  /** fetch data from the table: "app_versions" using primary key columns */
  app_versions_by_pk?: Maybe<App_Versions>;
  /** fetch data from the table: "assignment" */
  assignment: Array<Assignment>;
  /** fetch aggregated fields from the table: "assignment" */
  assignment_aggregate: Assignment_Aggregate;
  /** fetch data from the table: "assignment" using primary key columns */
  assignment_by_pk?: Maybe<Assignment>;
  /** fetch data from the table: "auth.providers" using primary key columns */
  authProvider?: Maybe<AuthProviders>;
  /** fetch data from the table: "auth.provider_requests" using primary key columns */
  authProviderRequest?: Maybe<AuthProviderRequests>;
  /** fetch data from the table: "auth.provider_requests" */
  authProviderRequests: Array<AuthProviderRequests>;
  /** fetch aggregated fields from the table: "auth.provider_requests" */
  authProviderRequestsAggregate: AuthProviderRequests_Aggregate;
  /** fetch data from the table: "auth.providers" */
  authProviders: Array<AuthProviders>;
  /** fetch aggregated fields from the table: "auth.providers" */
  authProvidersAggregate: AuthProviders_Aggregate;
  /** fetch data from the table: "auth.refresh_tokens" using primary key columns */
  authRefreshToken?: Maybe<AuthRefreshTokens>;
  /** fetch data from the table: "auth.refresh_token_types" using primary key columns */
  authRefreshTokenType?: Maybe<AuthRefreshTokenTypes>;
  /** fetch data from the table: "auth.refresh_token_types" */
  authRefreshTokenTypes: Array<AuthRefreshTokenTypes>;
  /** fetch aggregated fields from the table: "auth.refresh_token_types" */
  authRefreshTokenTypesAggregate: AuthRefreshTokenTypes_Aggregate;
  /** fetch data from the table: "auth.refresh_tokens" */
  authRefreshTokens: Array<AuthRefreshTokens>;
  /** fetch aggregated fields from the table: "auth.refresh_tokens" */
  authRefreshTokensAggregate: AuthRefreshTokens_Aggregate;
  /** fetch data from the table: "auth.roles" using primary key columns */
  authRole?: Maybe<AuthRoles>;
  /** fetch data from the table: "auth.roles" */
  authRoles: Array<AuthRoles>;
  /** fetch aggregated fields from the table: "auth.roles" */
  authRolesAggregate: AuthRoles_Aggregate;
  /** fetch data from the table: "auth.user_providers" using primary key columns */
  authUserProvider?: Maybe<AuthUserProviders>;
  /** fetch data from the table: "auth.user_providers" */
  authUserProviders: Array<AuthUserProviders>;
  /** fetch aggregated fields from the table: "auth.user_providers" */
  authUserProvidersAggregate: AuthUserProviders_Aggregate;
  /** fetch data from the table: "auth.user_roles" using primary key columns */
  authUserRole?: Maybe<AuthUserRoles>;
  /** fetch data from the table: "auth.user_roles" */
  authUserRoles: Array<AuthUserRoles>;
  /** fetch aggregated fields from the table: "auth.user_roles" */
  authUserRolesAggregate: AuthUserRoles_Aggregate;
  /** fetch data from the table: "auth.user_security_keys" using primary key columns */
  authUserSecurityKey?: Maybe<AuthUserSecurityKeys>;
  /** fetch data from the table: "auth.user_security_keys" */
  authUserSecurityKeys: Array<AuthUserSecurityKeys>;
  /** fetch aggregated fields from the table: "auth.user_security_keys" */
  authUserSecurityKeysAggregate: AuthUserSecurityKeys_Aggregate;
  /** fetch data from the table: "basket" */
  basket: Array<Basket>;
  /** fetch aggregated fields from the table: "basket" */
  basket_aggregate: Basket_Aggregate;
  /** fetch data from the table: "basket" using primary key columns */
  basket_by_pk?: Maybe<Basket>;
  /** fetch data from the table: "basket_dish" */
  basket_dish: Array<Basket_Dish>;
  /** fetch aggregated fields from the table: "basket_dish" */
  basket_dish_aggregate: Basket_Dish_Aggregate;
  /** fetch data from the table: "basket_dish" using primary key columns */
  basket_dish_by_pk?: Maybe<Basket_Dish>;
  /** fetch data from the table: "storage.buckets" using primary key columns */
  bucket?: Maybe<Buckets>;
  /** fetch data from the table: "storage.buckets" */
  buckets: Array<Buckets>;
  /** fetch aggregated fields from the table: "storage.buckets" */
  bucketsAggregate: Buckets_Aggregate;
  /** fetch data from the table: "carrier" */
  carrier: Array<Carrier>;
  /** fetch aggregated fields from the table: "carrier" */
  carrier_aggregate: Carrier_Aggregate;
  /** fetch data from the table: "carrier" using primary key columns */
  carrier_by_pk?: Maybe<Carrier>;
  /** fetch data from the table: "category" */
  category: Array<Category>;
  /** fetch aggregated fields from the table: "category" */
  category_aggregate: Category_Aggregate;
  /** fetch data from the table: "category" using primary key columns */
  category_by_pk?: Maybe<Category>;
  /** fetch data from the table: "dish" */
  dish: Array<Dish>;
  /** fetch aggregated fields from the table: "dish" */
  dish_aggregate: Dish_Aggregate;
  /** fetch data from the table: "dish" using primary key columns */
  dish_by_pk?: Maybe<Dish>;
  /** An array relationship */
  driver_documents: Array<Driver_Documents>;
  /** An aggregate relationship */
  driver_documents_aggregate: Driver_Documents_Aggregate;
  /** fetch data from the table: "driver_documents" using primary key columns */
  driver_documents_by_pk?: Maybe<Driver_Documents>;
  /** fetch data from the table: "driver_locations_current" */
  driver_locations_current: Array<Driver_Locations_Current>;
  /** fetch aggregated fields from the table: "driver_locations_current" */
  driver_locations_current_aggregate: Driver_Locations_Current_Aggregate;
  /** fetch data from the table: "driver_locations_current" using primary key columns */
  driver_locations_current_by_pk?: Maybe<Driver_Locations_Current>;
  /** An array relationship */
  drivers: Array<Drivers>;
  /** An aggregate relationship */
  drivers_aggregate: Drivers_Aggregate;
  /** fetch data from the table: "drivers" using primary key columns */
  drivers_by_pk?: Maybe<Drivers>;
  /** fetch data from the table: "fare_bands" */
  fare_bands: Array<Fare_Bands>;
  /** fetch aggregated fields from the table: "fare_bands" */
  fare_bands_aggregate: Fare_Bands_Aggregate;
  /** fetch data from the table: "fare_bands" using primary key columns */
  fare_bands_by_pk?: Maybe<Fare_Bands>;
  /** fetch data from the table: "feedback" */
  feedback: Array<Feedback>;
  /** fetch aggregated fields from the table: "feedback" */
  feedback_aggregate: Feedback_Aggregate;
  /** fetch data from the table: "feedback" using primary key columns */
  feedback_by_pk?: Maybe<Feedback>;
  /** fetch data from the table: "storage.files" using primary key columns */
  file?: Maybe<Files>;
  /** An array relationship */
  files: Array<Files>;
  /** fetch aggregated fields from the table: "storage.files" */
  filesAggregate: Files_Aggregate;
  /** An array relationship */
  free_rides: Array<Free_Rides>;
  /** An aggregate relationship */
  free_rides_aggregate: Free_Rides_Aggregate;
  /** fetch data from the table: "free_rides" using primary key columns */
  free_rides_by_pk?: Maybe<Free_Rides>;
  /** fetch data from the table: "order" */
  order: Array<Order>;
  /** fetch aggregated fields from the table: "order" */
  order_aggregate: Order_Aggregate;
  /** fetch data from the table: "order" using primary key columns */
  order_by_pk?: Maybe<Order>;
  /** An array relationship */
  payments: Array<Payments>;
  /** An aggregate relationship */
  payments_aggregate: Payments_Aggregate;
  /** fetch data from the table: "payments" using primary key columns */
  payments_by_pk?: Maybe<Payments>;
  /** An array relationship */
  ratings: Array<Ratings>;
  /** An aggregate relationship */
  ratings_aggregate: Ratings_Aggregate;
  /** fetch data from the table: "ratings" using primary key columns */
  ratings_by_pk?: Maybe<Ratings>;
  /** fetch data from the table: "restaurant" */
  restaurant: Array<Restaurant>;
  /** fetch aggregated fields from the table: "restaurant" */
  restaurant_aggregate: Restaurant_Aggregate;
  /** fetch data from the table: "restaurant" using primary key columns */
  restaurant_by_pk?: Maybe<Restaurant>;
  /** An array relationship */
  ride_events: Array<Ride_Events>;
  /** An aggregate relationship */
  ride_events_aggregate: Ride_Events_Aggregate;
  /** fetch data from the table: "ride_events" using primary key columns */
  ride_events_by_pk?: Maybe<Ride_Events>;
  /** An array relationship */
  rides: Array<Rides>;
  /** An aggregate relationship */
  rides_aggregate: Rides_Aggregate;
  /** fetch data from the table: "rides" using primary key columns */
  rides_by_pk?: Maybe<Rides>;
  /** fetch data from the table: "settlement" */
  settlement: Array<Settlement>;
  /** fetch aggregated fields from the table: "settlement" */
  settlement_aggregate: Settlement_Aggregate;
  /** fetch data from the table: "settlement" using primary key columns */
  settlement_by_pk?: Maybe<Settlement>;
  /** fetch data from the table: "specialty" */
  specialty: Array<Specialty>;
  /** fetch aggregated fields from the table: "specialty" */
  specialty_aggregate: Specialty_Aggregate;
  /** fetch data from the table: "specialty" using primary key columns */
  specialty_by_pk?: Maybe<Specialty>;
  /** fetch data from the table: "auth.users" using primary key columns */
  user?: Maybe<Users>;
  /** fetch data from the table: "user_devices" */
  user_devices: Array<User_Devices>;
  /** fetch aggregated fields from the table: "user_devices" */
  user_devices_aggregate: User_Devices_Aggregate;
  /** fetch data from the table: "user_devices" using primary key columns */
  user_devices_by_pk?: Maybe<User_Devices>;
  /** fetch data from the table: "user_profiles" */
  user_profiles: Array<User_Profiles>;
  /** fetch aggregated fields from the table: "user_profiles" */
  user_profiles_aggregate: User_Profiles_Aggregate;
  /** fetch data from the table: "user_profiles" using primary key columns */
  user_profiles_by_pk?: Maybe<User_Profiles>;
  /** fetch data from the table: "user_settings" */
  user_settings: Array<User_Settings>;
  /** fetch aggregated fields from the table: "user_settings" */
  user_settings_aggregate: User_Settings_Aggregate;
  /** fetch data from the table: "user_settings" using primary key columns */
  user_settings_by_pk?: Maybe<User_Settings>;
  /** fetch data from the table: "auth.users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "auth.users" */
  usersAggregate: Users_Aggregate;
  /** An array relationship */
  vehicle_documents: Array<Vehicle_Documents>;
  /** An aggregate relationship */
  vehicle_documents_aggregate: Vehicle_Documents_Aggregate;
  /** fetch data from the table: "vehicle_documents" using primary key columns */
  vehicle_documents_by_pk?: Maybe<Vehicle_Documents>;
  /** An array relationship */
  vehicles: Array<Vehicles>;
  /** An aggregate relationship */
  vehicles_aggregate: Vehicles_Aggregate;
  /** fetch data from the table: "vehicles" using primary key columns */
  vehicles_by_pk?: Maybe<Vehicles>;
  /** fetch data from the table: "storage.virus" using primary key columns */
  virus?: Maybe<Virus>;
  /** fetch data from the table: "storage.virus" */
  viruses: Array<Virus>;
  /** fetch aggregated fields from the table: "storage.virus" */
  virusesAggregate: Virus_Aggregate;
};


export type Query_RootAccount_Deletion_RequestArgs = {
  distinct_on?: InputMaybe<Array<Account_Deletion_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Deletion_Request_Order_By>>;
  where?: InputMaybe<Account_Deletion_Request_Bool_Exp>;
};


export type Query_RootAccount_Deletion_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Deletion_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Deletion_Request_Order_By>>;
  where?: InputMaybe<Account_Deletion_Request_Bool_Exp>;
};


export type Query_RootAccount_Deletion_Request_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootApp_SettingsArgs = {
  distinct_on?: InputMaybe<Array<App_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Settings_Order_By>>;
  where?: InputMaybe<App_Settings_Bool_Exp>;
};


export type Query_RootApp_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Settings_Order_By>>;
  where?: InputMaybe<App_Settings_Bool_Exp>;
};


export type Query_RootApp_Settings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootApp_VersionsArgs = {
  distinct_on?: InputMaybe<Array<App_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Versions_Order_By>>;
  where?: InputMaybe<App_Versions_Bool_Exp>;
};


export type Query_RootApp_Versions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Versions_Order_By>>;
  where?: InputMaybe<App_Versions_Bool_Exp>;
};


export type Query_RootApp_Versions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAssignmentArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assignment_Order_By>>;
  where?: InputMaybe<Assignment_Bool_Exp>;
};


export type Query_RootAssignment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assignment_Order_By>>;
  where?: InputMaybe<Assignment_Bool_Exp>;
};


export type Query_RootAssignment_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAuthProviderArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootAuthProviderRequestArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAuthProviderRequestsArgs = {
  distinct_on?: InputMaybe<Array<AuthProviderRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthProviderRequests_Order_By>>;
  where?: InputMaybe<AuthProviderRequests_Bool_Exp>;
};


export type Query_RootAuthProviderRequestsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthProviderRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthProviderRequests_Order_By>>;
  where?: InputMaybe<AuthProviderRequests_Bool_Exp>;
};


export type Query_RootAuthProvidersArgs = {
  distinct_on?: InputMaybe<Array<AuthProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthProviders_Order_By>>;
  where?: InputMaybe<AuthProviders_Bool_Exp>;
};


export type Query_RootAuthProvidersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthProviders_Order_By>>;
  where?: InputMaybe<AuthProviders_Bool_Exp>;
};


export type Query_RootAuthRefreshTokenArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAuthRefreshTokenTypeArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootAuthRefreshTokenTypesArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokenTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokenTypes_Order_By>>;
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>;
};


export type Query_RootAuthRefreshTokenTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokenTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokenTypes_Order_By>>;
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>;
};


export type Query_RootAuthRefreshTokensArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};


export type Query_RootAuthRefreshTokensAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};


export type Query_RootAuthRoleArgs = {
  role: Scalars['String']['input'];
};


export type Query_RootAuthRolesArgs = {
  distinct_on?: InputMaybe<Array<AuthRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRoles_Order_By>>;
  where?: InputMaybe<AuthRoles_Bool_Exp>;
};


export type Query_RootAuthRolesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRoles_Order_By>>;
  where?: InputMaybe<AuthRoles_Bool_Exp>;
};


export type Query_RootAuthUserProviderArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAuthUserProvidersArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};


export type Query_RootAuthUserProvidersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};


export type Query_RootAuthUserRoleArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAuthUserRolesArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


export type Query_RootAuthUserRolesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


export type Query_RootAuthUserSecurityKeyArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAuthUserSecurityKeysArgs = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
};


export type Query_RootAuthUserSecurityKeysAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
};


export type Query_RootBasketArgs = {
  distinct_on?: InputMaybe<Array<Basket_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Basket_Order_By>>;
  where?: InputMaybe<Basket_Bool_Exp>;
};


export type Query_RootBasket_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Basket_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Basket_Order_By>>;
  where?: InputMaybe<Basket_Bool_Exp>;
};


export type Query_RootBasket_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootBasket_DishArgs = {
  distinct_on?: InputMaybe<Array<Basket_Dish_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Basket_Dish_Order_By>>;
  where?: InputMaybe<Basket_Dish_Bool_Exp>;
};


export type Query_RootBasket_Dish_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Basket_Dish_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Basket_Dish_Order_By>>;
  where?: InputMaybe<Basket_Dish_Bool_Exp>;
};


export type Query_RootBasket_Dish_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootBucketArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootBucketsArgs = {
  distinct_on?: InputMaybe<Array<Buckets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buckets_Order_By>>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};


export type Query_RootBucketsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Buckets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buckets_Order_By>>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};


export type Query_RootCarrierArgs = {
  distinct_on?: InputMaybe<Array<Carrier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Carrier_Order_By>>;
  where?: InputMaybe<Carrier_Bool_Exp>;
};


export type Query_RootCarrier_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Carrier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Carrier_Order_By>>;
  where?: InputMaybe<Carrier_Bool_Exp>;
};


export type Query_RootCarrier_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCategoryArgs = {
  distinct_on?: InputMaybe<Array<Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Category_Order_By>>;
  where?: InputMaybe<Category_Bool_Exp>;
};


export type Query_RootCategory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Category_Order_By>>;
  where?: InputMaybe<Category_Bool_Exp>;
};


export type Query_RootCategory_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDishArgs = {
  distinct_on?: InputMaybe<Array<Dish_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dish_Order_By>>;
  where?: InputMaybe<Dish_Bool_Exp>;
};


export type Query_RootDish_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dish_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dish_Order_By>>;
  where?: InputMaybe<Dish_Bool_Exp>;
};


export type Query_RootDish_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDriver_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Driver_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Documents_Order_By>>;
  where?: InputMaybe<Driver_Documents_Bool_Exp>;
};


export type Query_RootDriver_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Driver_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Documents_Order_By>>;
  where?: InputMaybe<Driver_Documents_Bool_Exp>;
};


export type Query_RootDriver_Documents_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDriver_Locations_CurrentArgs = {
  distinct_on?: InputMaybe<Array<Driver_Locations_Current_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Locations_Current_Order_By>>;
  where?: InputMaybe<Driver_Locations_Current_Bool_Exp>;
};


export type Query_RootDriver_Locations_Current_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Driver_Locations_Current_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Locations_Current_Order_By>>;
  where?: InputMaybe<Driver_Locations_Current_Bool_Exp>;
};


export type Query_RootDriver_Locations_Current_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDriversArgs = {
  distinct_on?: InputMaybe<Array<Drivers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Drivers_Order_By>>;
  where?: InputMaybe<Drivers_Bool_Exp>;
};


export type Query_RootDrivers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Drivers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Drivers_Order_By>>;
  where?: InputMaybe<Drivers_Bool_Exp>;
};


export type Query_RootDrivers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFare_BandsArgs = {
  distinct_on?: InputMaybe<Array<Fare_Bands_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fare_Bands_Order_By>>;
  where?: InputMaybe<Fare_Bands_Bool_Exp>;
};


export type Query_RootFare_Bands_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fare_Bands_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fare_Bands_Order_By>>;
  where?: InputMaybe<Fare_Bands_Bool_Exp>;
};


export type Query_RootFare_Bands_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFeedbackArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Feedback_Order_By>>;
  where?: InputMaybe<Feedback_Bool_Exp>;
};


export type Query_RootFeedback_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Feedback_Order_By>>;
  where?: InputMaybe<Feedback_Bool_Exp>;
};


export type Query_RootFeedback_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFileArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Query_RootFilesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Query_RootFree_RidesArgs = {
  distinct_on?: InputMaybe<Array<Free_Rides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Free_Rides_Order_By>>;
  where?: InputMaybe<Free_Rides_Bool_Exp>;
};


export type Query_RootFree_Rides_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Free_Rides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Free_Rides_Order_By>>;
  where?: InputMaybe<Free_Rides_Bool_Exp>;
};


export type Query_RootFree_Rides_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrderArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


export type Query_RootOrder_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


export type Query_RootOrder_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPaymentsArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


export type Query_RootPayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


export type Query_RootPayments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRatingsArgs = {
  distinct_on?: InputMaybe<Array<Ratings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ratings_Order_By>>;
  where?: InputMaybe<Ratings_Bool_Exp>;
};


export type Query_RootRatings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ratings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ratings_Order_By>>;
  where?: InputMaybe<Ratings_Bool_Exp>;
};


export type Query_RootRatings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRestaurantArgs = {
  distinct_on?: InputMaybe<Array<Restaurant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Restaurant_Order_By>>;
  where?: InputMaybe<Restaurant_Bool_Exp>;
};


export type Query_RootRestaurant_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Restaurant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Restaurant_Order_By>>;
  where?: InputMaybe<Restaurant_Bool_Exp>;
};


export type Query_RootRestaurant_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRide_EventsArgs = {
  distinct_on?: InputMaybe<Array<Ride_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ride_Events_Order_By>>;
  where?: InputMaybe<Ride_Events_Bool_Exp>;
};


export type Query_RootRide_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ride_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ride_Events_Order_By>>;
  where?: InputMaybe<Ride_Events_Bool_Exp>;
};


export type Query_RootRide_Events_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRidesArgs = {
  distinct_on?: InputMaybe<Array<Rides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rides_Order_By>>;
  where?: InputMaybe<Rides_Bool_Exp>;
};


export type Query_RootRides_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rides_Order_By>>;
  where?: InputMaybe<Rides_Bool_Exp>;
};


export type Query_RootRides_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSettlementArgs = {
  distinct_on?: InputMaybe<Array<Settlement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Settlement_Order_By>>;
  where?: InputMaybe<Settlement_Bool_Exp>;
};


export type Query_RootSettlement_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Settlement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Settlement_Order_By>>;
  where?: InputMaybe<Settlement_Bool_Exp>;
};


export type Query_RootSettlement_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSpecialtyArgs = {
  distinct_on?: InputMaybe<Array<Specialty_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Specialty_Order_By>>;
  where?: InputMaybe<Specialty_Bool_Exp>;
};


export type Query_RootSpecialty_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Specialty_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Specialty_Order_By>>;
  where?: InputMaybe<Specialty_Bool_Exp>;
};


export type Query_RootSpecialty_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUserArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUser_DevicesArgs = {
  distinct_on?: InputMaybe<Array<User_Devices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Devices_Order_By>>;
  where?: InputMaybe<User_Devices_Bool_Exp>;
};


export type Query_RootUser_Devices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Devices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Devices_Order_By>>;
  where?: InputMaybe<User_Devices_Bool_Exp>;
};


export type Query_RootUser_Devices_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUser_ProfilesArgs = {
  distinct_on?: InputMaybe<Array<User_Profiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Profiles_Order_By>>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
};


export type Query_RootUser_Profiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Profiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Profiles_Order_By>>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
};


export type Query_RootUser_Profiles_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUser_SettingsArgs = {
  distinct_on?: InputMaybe<Array<User_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Settings_Order_By>>;
  where?: InputMaybe<User_Settings_Bool_Exp>;
};


export type Query_RootUser_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Settings_Order_By>>;
  where?: InputMaybe<User_Settings_Bool_Exp>;
};


export type Query_RootUser_Settings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsersAggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootVehicle_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Documents_Order_By>>;
  where?: InputMaybe<Vehicle_Documents_Bool_Exp>;
};


export type Query_RootVehicle_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Documents_Order_By>>;
  where?: InputMaybe<Vehicle_Documents_Bool_Exp>;
};


export type Query_RootVehicle_Documents_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootVehiclesArgs = {
  distinct_on?: InputMaybe<Array<Vehicles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicles_Order_By>>;
  where?: InputMaybe<Vehicles_Bool_Exp>;
};


export type Query_RootVehicles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicles_Order_By>>;
  where?: InputMaybe<Vehicles_Bool_Exp>;
};


export type Query_RootVehicles_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootVirusArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootVirusesArgs = {
  distinct_on?: InputMaybe<Array<Virus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Virus_Order_By>>;
  where?: InputMaybe<Virus_Bool_Exp>;
};


export type Query_RootVirusesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Virus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Virus_Order_By>>;
  where?: InputMaybe<Virus_Bool_Exp>;
};

/** columns and relationships of "ratings" */
export type Ratings = {
  __typename?: 'ratings';
  comment?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  driver?: Maybe<Drivers>;
  /** An object relationship */
  free_ride?: Maybe<Free_Rides>;
  free_ride_id?: Maybe<Scalars['uuid']['output']>;
  from_user_id?: Maybe<Scalars['uuid']['output']>;
  from_user_profile_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  rating?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  ride?: Maybe<Rides>;
  ride_id?: Maybe<Scalars['uuid']['output']>;
  to_driver_id?: Maybe<Scalars['uuid']['output']>;
  to_user_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user_profile?: Maybe<User_Profiles>;
};

/** aggregated selection of "ratings" */
export type Ratings_Aggregate = {
  __typename?: 'ratings_aggregate';
  aggregate?: Maybe<Ratings_Aggregate_Fields>;
  nodes: Array<Ratings>;
};

export type Ratings_Aggregate_Bool_Exp = {
  count?: InputMaybe<Ratings_Aggregate_Bool_Exp_Count>;
};

export type Ratings_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ratings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ratings_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ratings" */
export type Ratings_Aggregate_Fields = {
  __typename?: 'ratings_aggregate_fields';
  avg?: Maybe<Ratings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Ratings_Max_Fields>;
  min?: Maybe<Ratings_Min_Fields>;
  stddev?: Maybe<Ratings_Stddev_Fields>;
  stddev_pop?: Maybe<Ratings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ratings_Stddev_Samp_Fields>;
  sum?: Maybe<Ratings_Sum_Fields>;
  var_pop?: Maybe<Ratings_Var_Pop_Fields>;
  var_samp?: Maybe<Ratings_Var_Samp_Fields>;
  variance?: Maybe<Ratings_Variance_Fields>;
};


/** aggregate fields of "ratings" */
export type Ratings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ratings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "ratings" */
export type Ratings_Aggregate_Order_By = {
  avg?: InputMaybe<Ratings_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ratings_Max_Order_By>;
  min?: InputMaybe<Ratings_Min_Order_By>;
  stddev?: InputMaybe<Ratings_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ratings_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ratings_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ratings_Sum_Order_By>;
  var_pop?: InputMaybe<Ratings_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ratings_Var_Samp_Order_By>;
  variance?: InputMaybe<Ratings_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "ratings" */
export type Ratings_Arr_Rel_Insert_Input = {
  data: Array<Ratings_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ratings_On_Conflict>;
};

/** aggregate avg on columns */
export type Ratings_Avg_Fields = {
  __typename?: 'ratings_avg_fields';
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "ratings" */
export type Ratings_Avg_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ratings". All fields are combined with a logical 'AND'. */
export type Ratings_Bool_Exp = {
  _and?: InputMaybe<Array<Ratings_Bool_Exp>>;
  _not?: InputMaybe<Ratings_Bool_Exp>;
  _or?: InputMaybe<Array<Ratings_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  driver?: InputMaybe<Drivers_Bool_Exp>;
  free_ride?: InputMaybe<Free_Rides_Bool_Exp>;
  free_ride_id?: InputMaybe<Uuid_Comparison_Exp>;
  from_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  from_user_profile_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  rating?: InputMaybe<Int_Comparison_Exp>;
  ride?: InputMaybe<Rides_Bool_Exp>;
  ride_id?: InputMaybe<Uuid_Comparison_Exp>;
  to_driver_id?: InputMaybe<Uuid_Comparison_Exp>;
  to_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_profile?: InputMaybe<User_Profiles_Bool_Exp>;
};

/** unique or primary key constraints on table "ratings" */
export enum Ratings_Constraint {
  /** unique or primary key constraint on columns "id" */
  RatingsPkey = 'ratings_pkey'
}

/** input type for incrementing numeric columns in table "ratings" */
export type Ratings_Inc_Input = {
  rating?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "ratings" */
export type Ratings_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  driver?: InputMaybe<Drivers_Obj_Rel_Insert_Input>;
  free_ride?: InputMaybe<Free_Rides_Obj_Rel_Insert_Input>;
  free_ride_id?: InputMaybe<Scalars['uuid']['input']>;
  from_user_id?: InputMaybe<Scalars['uuid']['input']>;
  from_user_profile_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  ride?: InputMaybe<Rides_Obj_Rel_Insert_Input>;
  ride_id?: InputMaybe<Scalars['uuid']['input']>;
  to_driver_id?: InputMaybe<Scalars['uuid']['input']>;
  to_user_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_profile?: InputMaybe<User_Profiles_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Ratings_Max_Fields = {
  __typename?: 'ratings_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  free_ride_id?: Maybe<Scalars['uuid']['output']>;
  from_user_id?: Maybe<Scalars['uuid']['output']>;
  from_user_profile_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ride_id?: Maybe<Scalars['uuid']['output']>;
  to_driver_id?: Maybe<Scalars['uuid']['output']>;
  to_user_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "ratings" */
export type Ratings_Max_Order_By = {
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  free_ride_id?: InputMaybe<Order_By>;
  from_user_id?: InputMaybe<Order_By>;
  from_user_profile_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  ride_id?: InputMaybe<Order_By>;
  to_driver_id?: InputMaybe<Order_By>;
  to_user_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ratings_Min_Fields = {
  __typename?: 'ratings_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  free_ride_id?: Maybe<Scalars['uuid']['output']>;
  from_user_id?: Maybe<Scalars['uuid']['output']>;
  from_user_profile_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ride_id?: Maybe<Scalars['uuid']['output']>;
  to_driver_id?: Maybe<Scalars['uuid']['output']>;
  to_user_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "ratings" */
export type Ratings_Min_Order_By = {
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  free_ride_id?: InputMaybe<Order_By>;
  from_user_id?: InputMaybe<Order_By>;
  from_user_profile_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  ride_id?: InputMaybe<Order_By>;
  to_driver_id?: InputMaybe<Order_By>;
  to_user_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ratings" */
export type Ratings_Mutation_Response = {
  __typename?: 'ratings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ratings>;
};

/** input type for inserting object relation for remote table "ratings" */
export type Ratings_Obj_Rel_Insert_Input = {
  data: Ratings_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ratings_On_Conflict>;
};

/** on_conflict condition type for table "ratings" */
export type Ratings_On_Conflict = {
  constraint: Ratings_Constraint;
  update_columns?: Array<Ratings_Update_Column>;
  where?: InputMaybe<Ratings_Bool_Exp>;
};

/** Ordering options when selecting data from "ratings". */
export type Ratings_Order_By = {
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  driver?: InputMaybe<Drivers_Order_By>;
  free_ride?: InputMaybe<Free_Rides_Order_By>;
  free_ride_id?: InputMaybe<Order_By>;
  from_user_id?: InputMaybe<Order_By>;
  from_user_profile_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  ride?: InputMaybe<Rides_Order_By>;
  ride_id?: InputMaybe<Order_By>;
  to_driver_id?: InputMaybe<Order_By>;
  to_user_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_profile?: InputMaybe<User_Profiles_Order_By>;
};

/** primary key columns input for table: ratings */
export type Ratings_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "ratings" */
export enum Ratings_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FreeRideId = 'free_ride_id',
  /** column name */
  FromUserId = 'from_user_id',
  /** column name */
  FromUserProfileId = 'from_user_profile_id',
  /** column name */
  Id = 'id',
  /** column name */
  Rating = 'rating',
  /** column name */
  RideId = 'ride_id',
  /** column name */
  ToDriverId = 'to_driver_id',
  /** column name */
  ToUserId = 'to_user_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "ratings" */
export type Ratings_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  free_ride_id?: InputMaybe<Scalars['uuid']['input']>;
  from_user_id?: InputMaybe<Scalars['uuid']['input']>;
  from_user_profile_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  ride_id?: InputMaybe<Scalars['uuid']['input']>;
  to_driver_id?: InputMaybe<Scalars['uuid']['input']>;
  to_user_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Ratings_Stddev_Fields = {
  __typename?: 'ratings_stddev_fields';
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "ratings" */
export type Ratings_Stddev_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Ratings_Stddev_Pop_Fields = {
  __typename?: 'ratings_stddev_pop_fields';
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "ratings" */
export type Ratings_Stddev_Pop_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Ratings_Stddev_Samp_Fields = {
  __typename?: 'ratings_stddev_samp_fields';
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "ratings" */
export type Ratings_Stddev_Samp_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ratings" */
export type Ratings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ratings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ratings_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  free_ride_id?: InputMaybe<Scalars['uuid']['input']>;
  from_user_id?: InputMaybe<Scalars['uuid']['input']>;
  from_user_profile_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  ride_id?: InputMaybe<Scalars['uuid']['input']>;
  to_driver_id?: InputMaybe<Scalars['uuid']['input']>;
  to_user_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Ratings_Sum_Fields = {
  __typename?: 'ratings_sum_fields';
  rating?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "ratings" */
export type Ratings_Sum_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** update columns of table "ratings" */
export enum Ratings_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FreeRideId = 'free_ride_id',
  /** column name */
  FromUserId = 'from_user_id',
  /** column name */
  FromUserProfileId = 'from_user_profile_id',
  /** column name */
  Id = 'id',
  /** column name */
  Rating = 'rating',
  /** column name */
  RideId = 'ride_id',
  /** column name */
  ToDriverId = 'to_driver_id',
  /** column name */
  ToUserId = 'to_user_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Ratings_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ratings_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ratings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ratings_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Ratings_Var_Pop_Fields = {
  __typename?: 'ratings_var_pop_fields';
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "ratings" */
export type Ratings_Var_Pop_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Ratings_Var_Samp_Fields = {
  __typename?: 'ratings_var_samp_fields';
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "ratings" */
export type Ratings_Var_Samp_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Ratings_Variance_Fields = {
  __typename?: 'ratings_variance_fields';
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "ratings" */
export type Ratings_Variance_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** columns and relationships of "restaurant" */
export type Restaurant = {
  __typename?: 'restaurant';
  address?: Maybe<Scalars['String']['output']>;
  admin_commission?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  baskets: Array<Basket>;
  /** An aggregate relationship */
  baskets_aggregate: Basket_Aggregate;
  /** An array relationship */
  carriers: Array<Carrier>;
  /** An aggregate relationship */
  carriers_aggregate: Carrier_Aggregate;
  closing_hour?: Maybe<Scalars['time']['output']>;
  cover?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  delivery_charge?: Maybe<Scalars['Int']['output']>;
  delivery_commission?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  dishes: Array<Dish>;
  /** An aggregate relationship */
  dishes_aggregate: Dish_Aggregate;
  email?: Maybe<Scalars['String']['output']>;
  free_distance?: Maybe<Scalars['Int']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  image?: Maybe<Scalars['uuid']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Scalars['geography']['output']>;
  max_distance?: Maybe<Scalars['numeric']['output']>;
  min_order_amount?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  opening_hour?: Maybe<Scalars['time']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  revenue?: Maybe<Scalars['Int']['output']>;
  short_description?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  specialty?: Maybe<Specialty>;
  specialtyId?: Maybe<Scalars['uuid']['output']>;
  threshold_amount?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  userId?: Maybe<Scalars['uuid']['output']>;
  weekly_off_days?: Maybe<Scalars['jsonb']['output']>;
};


/** columns and relationships of "restaurant" */
export type RestaurantBasketsArgs = {
  distinct_on?: InputMaybe<Array<Basket_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Basket_Order_By>>;
  where?: InputMaybe<Basket_Bool_Exp>;
};


/** columns and relationships of "restaurant" */
export type RestaurantBaskets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Basket_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Basket_Order_By>>;
  where?: InputMaybe<Basket_Bool_Exp>;
};


/** columns and relationships of "restaurant" */
export type RestaurantCarriersArgs = {
  distinct_on?: InputMaybe<Array<Carrier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Carrier_Order_By>>;
  where?: InputMaybe<Carrier_Bool_Exp>;
};


/** columns and relationships of "restaurant" */
export type RestaurantCarriers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Carrier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Carrier_Order_By>>;
  where?: InputMaybe<Carrier_Bool_Exp>;
};


/** columns and relationships of "restaurant" */
export type RestaurantDishesArgs = {
  distinct_on?: InputMaybe<Array<Dish_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dish_Order_By>>;
  where?: InputMaybe<Dish_Bool_Exp>;
};


/** columns and relationships of "restaurant" */
export type RestaurantDishes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dish_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dish_Order_By>>;
  where?: InputMaybe<Dish_Bool_Exp>;
};


/** columns and relationships of "restaurant" */
export type RestaurantWeekly_Off_DaysArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "restaurant" */
export type Restaurant_Aggregate = {
  __typename?: 'restaurant_aggregate';
  aggregate?: Maybe<Restaurant_Aggregate_Fields>;
  nodes: Array<Restaurant>;
};

export type Restaurant_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Restaurant_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Restaurant_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Restaurant_Aggregate_Bool_Exp_Count>;
};

export type Restaurant_Aggregate_Bool_Exp_Bool_And = {
  arguments: Restaurant_Select_Column_Restaurant_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Restaurant_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Restaurant_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Restaurant_Select_Column_Restaurant_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Restaurant_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Restaurant_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Restaurant_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Restaurant_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "restaurant" */
export type Restaurant_Aggregate_Fields = {
  __typename?: 'restaurant_aggregate_fields';
  avg?: Maybe<Restaurant_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Restaurant_Max_Fields>;
  min?: Maybe<Restaurant_Min_Fields>;
  stddev?: Maybe<Restaurant_Stddev_Fields>;
  stddev_pop?: Maybe<Restaurant_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Restaurant_Stddev_Samp_Fields>;
  sum?: Maybe<Restaurant_Sum_Fields>;
  var_pop?: Maybe<Restaurant_Var_Pop_Fields>;
  var_samp?: Maybe<Restaurant_Var_Samp_Fields>;
  variance?: Maybe<Restaurant_Variance_Fields>;
};


/** aggregate fields of "restaurant" */
export type Restaurant_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Restaurant_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "restaurant" */
export type Restaurant_Aggregate_Order_By = {
  avg?: InputMaybe<Restaurant_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Restaurant_Max_Order_By>;
  min?: InputMaybe<Restaurant_Min_Order_By>;
  stddev?: InputMaybe<Restaurant_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Restaurant_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Restaurant_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Restaurant_Sum_Order_By>;
  var_pop?: InputMaybe<Restaurant_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Restaurant_Var_Samp_Order_By>;
  variance?: InputMaybe<Restaurant_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Restaurant_Append_Input = {
  weekly_off_days?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "restaurant" */
export type Restaurant_Arr_Rel_Insert_Input = {
  data: Array<Restaurant_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Restaurant_On_Conflict>;
};

/** aggregate avg on columns */
export type Restaurant_Avg_Fields = {
  __typename?: 'restaurant_avg_fields';
  admin_commission?: Maybe<Scalars['Float']['output']>;
  delivery_charge?: Maybe<Scalars['Float']['output']>;
  delivery_commission?: Maybe<Scalars['Float']['output']>;
  free_distance?: Maybe<Scalars['Float']['output']>;
  max_distance?: Maybe<Scalars['Float']['output']>;
  min_order_amount?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
  threshold_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "restaurant" */
export type Restaurant_Avg_Order_By = {
  admin_commission?: InputMaybe<Order_By>;
  delivery_charge?: InputMaybe<Order_By>;
  delivery_commission?: InputMaybe<Order_By>;
  free_distance?: InputMaybe<Order_By>;
  max_distance?: InputMaybe<Order_By>;
  min_order_amount?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  revenue?: InputMaybe<Order_By>;
  threshold_amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "restaurant". All fields are combined with a logical 'AND'. */
export type Restaurant_Bool_Exp = {
  _and?: InputMaybe<Array<Restaurant_Bool_Exp>>;
  _not?: InputMaybe<Restaurant_Bool_Exp>;
  _or?: InputMaybe<Array<Restaurant_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  admin_commission?: InputMaybe<Int_Comparison_Exp>;
  baskets?: InputMaybe<Basket_Bool_Exp>;
  baskets_aggregate?: InputMaybe<Basket_Aggregate_Bool_Exp>;
  carriers?: InputMaybe<Carrier_Bool_Exp>;
  carriers_aggregate?: InputMaybe<Carrier_Aggregate_Bool_Exp>;
  closing_hour?: InputMaybe<Time_Comparison_Exp>;
  cover?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  delivery_charge?: InputMaybe<Int_Comparison_Exp>;
  delivery_commission?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dishes?: InputMaybe<Dish_Bool_Exp>;
  dishes_aggregate?: InputMaybe<Dish_Aggregate_Bool_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  free_distance?: InputMaybe<Int_Comparison_Exp>;
  genre?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image?: InputMaybe<Uuid_Comparison_Exp>;
  isActive?: InputMaybe<Boolean_Comparison_Exp>;
  location?: InputMaybe<Geography_Comparison_Exp>;
  max_distance?: InputMaybe<Numeric_Comparison_Exp>;
  min_order_amount?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  opening_hour?: InputMaybe<Time_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  rating?: InputMaybe<Int_Comparison_Exp>;
  revenue?: InputMaybe<Int_Comparison_Exp>;
  short_description?: InputMaybe<String_Comparison_Exp>;
  specialty?: InputMaybe<Specialty_Bool_Exp>;
  specialtyId?: InputMaybe<Uuid_Comparison_Exp>;
  threshold_amount?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
  weekly_off_days?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "restaurant" */
export enum Restaurant_Constraint {
  /** unique or primary key constraint on columns "id" */
  RestaurantPkey = 'restaurant_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Restaurant_Delete_At_Path_Input = {
  weekly_off_days?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Restaurant_Delete_Elem_Input = {
  weekly_off_days?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Restaurant_Delete_Key_Input = {
  weekly_off_days?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "restaurant" */
export type Restaurant_Inc_Input = {
  admin_commission?: InputMaybe<Scalars['Int']['input']>;
  delivery_charge?: InputMaybe<Scalars['Int']['input']>;
  delivery_commission?: InputMaybe<Scalars['Int']['input']>;
  free_distance?: InputMaybe<Scalars['Int']['input']>;
  max_distance?: InputMaybe<Scalars['numeric']['input']>;
  min_order_amount?: InputMaybe<Scalars['Int']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  revenue?: InputMaybe<Scalars['Int']['input']>;
  threshold_amount?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "restaurant" */
export type Restaurant_Insert_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  admin_commission?: InputMaybe<Scalars['Int']['input']>;
  baskets?: InputMaybe<Basket_Arr_Rel_Insert_Input>;
  carriers?: InputMaybe<Carrier_Arr_Rel_Insert_Input>;
  closing_hour?: InputMaybe<Scalars['time']['input']>;
  cover?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  delivery_charge?: InputMaybe<Scalars['Int']['input']>;
  delivery_commission?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dishes?: InputMaybe<Dish_Arr_Rel_Insert_Input>;
  email?: InputMaybe<Scalars['String']['input']>;
  free_distance?: InputMaybe<Scalars['Int']['input']>;
  genre?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Scalars['uuid']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['geography']['input']>;
  max_distance?: InputMaybe<Scalars['numeric']['input']>;
  min_order_amount?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  opening_hour?: InputMaybe<Scalars['time']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  revenue?: InputMaybe<Scalars['Int']['input']>;
  short_description?: InputMaybe<Scalars['String']['input']>;
  specialty?: InputMaybe<Specialty_Obj_Rel_Insert_Input>;
  specialtyId?: InputMaybe<Scalars['uuid']['input']>;
  threshold_amount?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  weekly_off_days?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type Restaurant_Max_Fields = {
  __typename?: 'restaurant_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  admin_commission?: Maybe<Scalars['Int']['output']>;
  cover?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  delivery_charge?: Maybe<Scalars['Int']['output']>;
  delivery_commission?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  free_distance?: Maybe<Scalars['Int']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image?: Maybe<Scalars['uuid']['output']>;
  max_distance?: Maybe<Scalars['numeric']['output']>;
  min_order_amount?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  revenue?: Maybe<Scalars['Int']['output']>;
  short_description?: Maybe<Scalars['String']['output']>;
  specialtyId?: Maybe<Scalars['uuid']['output']>;
  threshold_amount?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "restaurant" */
export type Restaurant_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  admin_commission?: InputMaybe<Order_By>;
  cover?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  delivery_charge?: InputMaybe<Order_By>;
  delivery_commission?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  free_distance?: InputMaybe<Order_By>;
  genre?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  max_distance?: InputMaybe<Order_By>;
  min_order_amount?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  revenue?: InputMaybe<Order_By>;
  short_description?: InputMaybe<Order_By>;
  specialtyId?: InputMaybe<Order_By>;
  threshold_amount?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Restaurant_Min_Fields = {
  __typename?: 'restaurant_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  admin_commission?: Maybe<Scalars['Int']['output']>;
  cover?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  delivery_charge?: Maybe<Scalars['Int']['output']>;
  delivery_commission?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  free_distance?: Maybe<Scalars['Int']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image?: Maybe<Scalars['uuid']['output']>;
  max_distance?: Maybe<Scalars['numeric']['output']>;
  min_order_amount?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  revenue?: Maybe<Scalars['Int']['output']>;
  short_description?: Maybe<Scalars['String']['output']>;
  specialtyId?: Maybe<Scalars['uuid']['output']>;
  threshold_amount?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "restaurant" */
export type Restaurant_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  admin_commission?: InputMaybe<Order_By>;
  cover?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  delivery_charge?: InputMaybe<Order_By>;
  delivery_commission?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  free_distance?: InputMaybe<Order_By>;
  genre?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  max_distance?: InputMaybe<Order_By>;
  min_order_amount?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  revenue?: InputMaybe<Order_By>;
  short_description?: InputMaybe<Order_By>;
  specialtyId?: InputMaybe<Order_By>;
  threshold_amount?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "restaurant" */
export type Restaurant_Mutation_Response = {
  __typename?: 'restaurant_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Restaurant>;
};

/** input type for inserting object relation for remote table "restaurant" */
export type Restaurant_Obj_Rel_Insert_Input = {
  data: Restaurant_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Restaurant_On_Conflict>;
};

/** on_conflict condition type for table "restaurant" */
export type Restaurant_On_Conflict = {
  constraint: Restaurant_Constraint;
  update_columns?: Array<Restaurant_Update_Column>;
  where?: InputMaybe<Restaurant_Bool_Exp>;
};

/** Ordering options when selecting data from "restaurant". */
export type Restaurant_Order_By = {
  address?: InputMaybe<Order_By>;
  admin_commission?: InputMaybe<Order_By>;
  baskets_aggregate?: InputMaybe<Basket_Aggregate_Order_By>;
  carriers_aggregate?: InputMaybe<Carrier_Aggregate_Order_By>;
  closing_hour?: InputMaybe<Order_By>;
  cover?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  delivery_charge?: InputMaybe<Order_By>;
  delivery_commission?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dishes_aggregate?: InputMaybe<Dish_Aggregate_Order_By>;
  email?: InputMaybe<Order_By>;
  free_distance?: InputMaybe<Order_By>;
  genre?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  isActive?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  max_distance?: InputMaybe<Order_By>;
  min_order_amount?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  opening_hour?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  revenue?: InputMaybe<Order_By>;
  short_description?: InputMaybe<Order_By>;
  specialty?: InputMaybe<Specialty_Order_By>;
  specialtyId?: InputMaybe<Order_By>;
  threshold_amount?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  weekly_off_days?: InputMaybe<Order_By>;
};

/** primary key columns input for table: restaurant */
export type Restaurant_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Restaurant_Prepend_Input = {
  weekly_off_days?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "restaurant" */
export enum Restaurant_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AdminCommission = 'admin_commission',
  /** column name */
  ClosingHour = 'closing_hour',
  /** column name */
  Cover = 'cover',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeliveryCharge = 'delivery_charge',
  /** column name */
  DeliveryCommission = 'delivery_commission',
  /** column name */
  Description = 'description',
  /** column name */
  Email = 'email',
  /** column name */
  FreeDistance = 'free_distance',
  /** column name */
  Genre = 'genre',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  Location = 'location',
  /** column name */
  MaxDistance = 'max_distance',
  /** column name */
  MinOrderAmount = 'min_order_amount',
  /** column name */
  Name = 'name',
  /** column name */
  OpeningHour = 'opening_hour',
  /** column name */
  Phone = 'phone',
  /** column name */
  Rating = 'rating',
  /** column name */
  Revenue = 'revenue',
  /** column name */
  ShortDescription = 'short_description',
  /** column name */
  SpecialtyId = 'specialtyId',
  /** column name */
  ThresholdAmount = 'threshold_amount',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'userId',
  /** column name */
  WeeklyOffDays = 'weekly_off_days'
}

/** select "restaurant_aggregate_bool_exp_bool_and_arguments_columns" columns of table "restaurant" */
export enum Restaurant_Select_Column_Restaurant_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'isActive'
}

/** select "restaurant_aggregate_bool_exp_bool_or_arguments_columns" columns of table "restaurant" */
export enum Restaurant_Select_Column_Restaurant_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'isActive'
}

/** input type for updating data in table "restaurant" */
export type Restaurant_Set_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  admin_commission?: InputMaybe<Scalars['Int']['input']>;
  closing_hour?: InputMaybe<Scalars['time']['input']>;
  cover?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  delivery_charge?: InputMaybe<Scalars['Int']['input']>;
  delivery_commission?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  free_distance?: InputMaybe<Scalars['Int']['input']>;
  genre?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Scalars['uuid']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['geography']['input']>;
  max_distance?: InputMaybe<Scalars['numeric']['input']>;
  min_order_amount?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  opening_hour?: InputMaybe<Scalars['time']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  revenue?: InputMaybe<Scalars['Int']['input']>;
  short_description?: InputMaybe<Scalars['String']['input']>;
  specialtyId?: InputMaybe<Scalars['uuid']['input']>;
  threshold_amount?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  weekly_off_days?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate stddev on columns */
export type Restaurant_Stddev_Fields = {
  __typename?: 'restaurant_stddev_fields';
  admin_commission?: Maybe<Scalars['Float']['output']>;
  delivery_charge?: Maybe<Scalars['Float']['output']>;
  delivery_commission?: Maybe<Scalars['Float']['output']>;
  free_distance?: Maybe<Scalars['Float']['output']>;
  max_distance?: Maybe<Scalars['Float']['output']>;
  min_order_amount?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
  threshold_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "restaurant" */
export type Restaurant_Stddev_Order_By = {
  admin_commission?: InputMaybe<Order_By>;
  delivery_charge?: InputMaybe<Order_By>;
  delivery_commission?: InputMaybe<Order_By>;
  free_distance?: InputMaybe<Order_By>;
  max_distance?: InputMaybe<Order_By>;
  min_order_amount?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  revenue?: InputMaybe<Order_By>;
  threshold_amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Restaurant_Stddev_Pop_Fields = {
  __typename?: 'restaurant_stddev_pop_fields';
  admin_commission?: Maybe<Scalars['Float']['output']>;
  delivery_charge?: Maybe<Scalars['Float']['output']>;
  delivery_commission?: Maybe<Scalars['Float']['output']>;
  free_distance?: Maybe<Scalars['Float']['output']>;
  max_distance?: Maybe<Scalars['Float']['output']>;
  min_order_amount?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
  threshold_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "restaurant" */
export type Restaurant_Stddev_Pop_Order_By = {
  admin_commission?: InputMaybe<Order_By>;
  delivery_charge?: InputMaybe<Order_By>;
  delivery_commission?: InputMaybe<Order_By>;
  free_distance?: InputMaybe<Order_By>;
  max_distance?: InputMaybe<Order_By>;
  min_order_amount?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  revenue?: InputMaybe<Order_By>;
  threshold_amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Restaurant_Stddev_Samp_Fields = {
  __typename?: 'restaurant_stddev_samp_fields';
  admin_commission?: Maybe<Scalars['Float']['output']>;
  delivery_charge?: Maybe<Scalars['Float']['output']>;
  delivery_commission?: Maybe<Scalars['Float']['output']>;
  free_distance?: Maybe<Scalars['Float']['output']>;
  max_distance?: Maybe<Scalars['Float']['output']>;
  min_order_amount?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
  threshold_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "restaurant" */
export type Restaurant_Stddev_Samp_Order_By = {
  admin_commission?: InputMaybe<Order_By>;
  delivery_charge?: InputMaybe<Order_By>;
  delivery_commission?: InputMaybe<Order_By>;
  free_distance?: InputMaybe<Order_By>;
  max_distance?: InputMaybe<Order_By>;
  min_order_amount?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  revenue?: InputMaybe<Order_By>;
  threshold_amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "restaurant" */
export type Restaurant_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Restaurant_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Restaurant_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  admin_commission?: InputMaybe<Scalars['Int']['input']>;
  closing_hour?: InputMaybe<Scalars['time']['input']>;
  cover?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  delivery_charge?: InputMaybe<Scalars['Int']['input']>;
  delivery_commission?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  free_distance?: InputMaybe<Scalars['Int']['input']>;
  genre?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Scalars['uuid']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['geography']['input']>;
  max_distance?: InputMaybe<Scalars['numeric']['input']>;
  min_order_amount?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  opening_hour?: InputMaybe<Scalars['time']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  revenue?: InputMaybe<Scalars['Int']['input']>;
  short_description?: InputMaybe<Scalars['String']['input']>;
  specialtyId?: InputMaybe<Scalars['uuid']['input']>;
  threshold_amount?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  weekly_off_days?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate sum on columns */
export type Restaurant_Sum_Fields = {
  __typename?: 'restaurant_sum_fields';
  admin_commission?: Maybe<Scalars['Int']['output']>;
  delivery_charge?: Maybe<Scalars['Int']['output']>;
  delivery_commission?: Maybe<Scalars['Int']['output']>;
  free_distance?: Maybe<Scalars['Int']['output']>;
  max_distance?: Maybe<Scalars['numeric']['output']>;
  min_order_amount?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  revenue?: Maybe<Scalars['Int']['output']>;
  threshold_amount?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "restaurant" */
export type Restaurant_Sum_Order_By = {
  admin_commission?: InputMaybe<Order_By>;
  delivery_charge?: InputMaybe<Order_By>;
  delivery_commission?: InputMaybe<Order_By>;
  free_distance?: InputMaybe<Order_By>;
  max_distance?: InputMaybe<Order_By>;
  min_order_amount?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  revenue?: InputMaybe<Order_By>;
  threshold_amount?: InputMaybe<Order_By>;
};

/** update columns of table "restaurant" */
export enum Restaurant_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AdminCommission = 'admin_commission',
  /** column name */
  ClosingHour = 'closing_hour',
  /** column name */
  Cover = 'cover',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeliveryCharge = 'delivery_charge',
  /** column name */
  DeliveryCommission = 'delivery_commission',
  /** column name */
  Description = 'description',
  /** column name */
  Email = 'email',
  /** column name */
  FreeDistance = 'free_distance',
  /** column name */
  Genre = 'genre',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  Location = 'location',
  /** column name */
  MaxDistance = 'max_distance',
  /** column name */
  MinOrderAmount = 'min_order_amount',
  /** column name */
  Name = 'name',
  /** column name */
  OpeningHour = 'opening_hour',
  /** column name */
  Phone = 'phone',
  /** column name */
  Rating = 'rating',
  /** column name */
  Revenue = 'revenue',
  /** column name */
  ShortDescription = 'short_description',
  /** column name */
  SpecialtyId = 'specialtyId',
  /** column name */
  ThresholdAmount = 'threshold_amount',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'userId',
  /** column name */
  WeeklyOffDays = 'weekly_off_days'
}

export type Restaurant_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Restaurant_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Restaurant_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Restaurant_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Restaurant_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Restaurant_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Restaurant_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Restaurant_Set_Input>;
  /** filter the rows which have to be updated */
  where: Restaurant_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Restaurant_Var_Pop_Fields = {
  __typename?: 'restaurant_var_pop_fields';
  admin_commission?: Maybe<Scalars['Float']['output']>;
  delivery_charge?: Maybe<Scalars['Float']['output']>;
  delivery_commission?: Maybe<Scalars['Float']['output']>;
  free_distance?: Maybe<Scalars['Float']['output']>;
  max_distance?: Maybe<Scalars['Float']['output']>;
  min_order_amount?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
  threshold_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "restaurant" */
export type Restaurant_Var_Pop_Order_By = {
  admin_commission?: InputMaybe<Order_By>;
  delivery_charge?: InputMaybe<Order_By>;
  delivery_commission?: InputMaybe<Order_By>;
  free_distance?: InputMaybe<Order_By>;
  max_distance?: InputMaybe<Order_By>;
  min_order_amount?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  revenue?: InputMaybe<Order_By>;
  threshold_amount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Restaurant_Var_Samp_Fields = {
  __typename?: 'restaurant_var_samp_fields';
  admin_commission?: Maybe<Scalars['Float']['output']>;
  delivery_charge?: Maybe<Scalars['Float']['output']>;
  delivery_commission?: Maybe<Scalars['Float']['output']>;
  free_distance?: Maybe<Scalars['Float']['output']>;
  max_distance?: Maybe<Scalars['Float']['output']>;
  min_order_amount?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
  threshold_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "restaurant" */
export type Restaurant_Var_Samp_Order_By = {
  admin_commission?: InputMaybe<Order_By>;
  delivery_charge?: InputMaybe<Order_By>;
  delivery_commission?: InputMaybe<Order_By>;
  free_distance?: InputMaybe<Order_By>;
  max_distance?: InputMaybe<Order_By>;
  min_order_amount?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  revenue?: InputMaybe<Order_By>;
  threshold_amount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Restaurant_Variance_Fields = {
  __typename?: 'restaurant_variance_fields';
  admin_commission?: Maybe<Scalars['Float']['output']>;
  delivery_charge?: Maybe<Scalars['Float']['output']>;
  delivery_commission?: Maybe<Scalars['Float']['output']>;
  free_distance?: Maybe<Scalars['Float']['output']>;
  max_distance?: Maybe<Scalars['Float']['output']>;
  min_order_amount?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
  threshold_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "restaurant" */
export type Restaurant_Variance_Order_By = {
  admin_commission?: InputMaybe<Order_By>;
  delivery_charge?: InputMaybe<Order_By>;
  delivery_commission?: InputMaybe<Order_By>;
  free_distance?: InputMaybe<Order_By>;
  max_distance?: InputMaybe<Order_By>;
  min_order_amount?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  revenue?: InputMaybe<Order_By>;
  threshold_amount?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "ride_event_type_enum". All fields are combined with logical 'AND'. */
export type Ride_Event_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['ride_event_type_enum']['input']>;
  _gt?: InputMaybe<Scalars['ride_event_type_enum']['input']>;
  _gte?: InputMaybe<Scalars['ride_event_type_enum']['input']>;
  _in?: InputMaybe<Array<Scalars['ride_event_type_enum']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['ride_event_type_enum']['input']>;
  _lte?: InputMaybe<Scalars['ride_event_type_enum']['input']>;
  _neq?: InputMaybe<Scalars['ride_event_type_enum']['input']>;
  _nin?: InputMaybe<Array<Scalars['ride_event_type_enum']['input']>>;
};

/** columns and relationships of "ride_events" */
export type Ride_Events = {
  __typename?: 'ride_events';
  created_at: Scalars['timestamptz']['output'];
  event_data?: Maybe<Scalars['jsonb']['output']>;
  event_type: Scalars['ride_event_type_enum']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  ride: Rides;
  ride_id: Scalars['uuid']['output'];
};


/** columns and relationships of "ride_events" */
export type Ride_EventsEvent_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "ride_events" */
export type Ride_Events_Aggregate = {
  __typename?: 'ride_events_aggregate';
  aggregate?: Maybe<Ride_Events_Aggregate_Fields>;
  nodes: Array<Ride_Events>;
};

export type Ride_Events_Aggregate_Bool_Exp = {
  count?: InputMaybe<Ride_Events_Aggregate_Bool_Exp_Count>;
};

export type Ride_Events_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ride_Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ride_Events_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ride_events" */
export type Ride_Events_Aggregate_Fields = {
  __typename?: 'ride_events_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Ride_Events_Max_Fields>;
  min?: Maybe<Ride_Events_Min_Fields>;
};


/** aggregate fields of "ride_events" */
export type Ride_Events_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ride_Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "ride_events" */
export type Ride_Events_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ride_Events_Max_Order_By>;
  min?: InputMaybe<Ride_Events_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Ride_Events_Append_Input = {
  event_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "ride_events" */
export type Ride_Events_Arr_Rel_Insert_Input = {
  data: Array<Ride_Events_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ride_Events_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ride_events". All fields are combined with a logical 'AND'. */
export type Ride_Events_Bool_Exp = {
  _and?: InputMaybe<Array<Ride_Events_Bool_Exp>>;
  _not?: InputMaybe<Ride_Events_Bool_Exp>;
  _or?: InputMaybe<Array<Ride_Events_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_data?: InputMaybe<Jsonb_Comparison_Exp>;
  event_type?: InputMaybe<Ride_Event_Type_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ride?: InputMaybe<Rides_Bool_Exp>;
  ride_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "ride_events" */
export enum Ride_Events_Constraint {
  /** unique or primary key constraint on columns "id" */
  RideEventsPkey = 'ride_events_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Ride_Events_Delete_At_Path_Input = {
  event_data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Ride_Events_Delete_Elem_Input = {
  event_data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Ride_Events_Delete_Key_Input = {
  event_data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "ride_events" */
export type Ride_Events_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_data?: InputMaybe<Scalars['jsonb']['input']>;
  event_type?: InputMaybe<Scalars['ride_event_type_enum']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ride?: InputMaybe<Rides_Obj_Rel_Insert_Input>;
  ride_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Ride_Events_Max_Fields = {
  __typename?: 'ride_events_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['ride_event_type_enum']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ride_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "ride_events" */
export type Ride_Events_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ride_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ride_Events_Min_Fields = {
  __typename?: 'ride_events_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['ride_event_type_enum']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ride_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "ride_events" */
export type Ride_Events_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ride_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ride_events" */
export type Ride_Events_Mutation_Response = {
  __typename?: 'ride_events_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ride_Events>;
};

/** on_conflict condition type for table "ride_events" */
export type Ride_Events_On_Conflict = {
  constraint: Ride_Events_Constraint;
  update_columns?: Array<Ride_Events_Update_Column>;
  where?: InputMaybe<Ride_Events_Bool_Exp>;
};

/** Ordering options when selecting data from "ride_events". */
export type Ride_Events_Order_By = {
  created_at?: InputMaybe<Order_By>;
  event_data?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ride?: InputMaybe<Rides_Order_By>;
  ride_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ride_events */
export type Ride_Events_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Ride_Events_Prepend_Input = {
  event_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "ride_events" */
export enum Ride_Events_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EventData = 'event_data',
  /** column name */
  EventType = 'event_type',
  /** column name */
  Id = 'id',
  /** column name */
  RideId = 'ride_id'
}

/** input type for updating data in table "ride_events" */
export type Ride_Events_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_data?: InputMaybe<Scalars['jsonb']['input']>;
  event_type?: InputMaybe<Scalars['ride_event_type_enum']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ride_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "ride_events" */
export type Ride_Events_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ride_Events_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ride_Events_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_data?: InputMaybe<Scalars['jsonb']['input']>;
  event_type?: InputMaybe<Scalars['ride_event_type_enum']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ride_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "ride_events" */
export enum Ride_Events_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EventData = 'event_data',
  /** column name */
  EventType = 'event_type',
  /** column name */
  Id = 'id',
  /** column name */
  RideId = 'ride_id'
}

export type Ride_Events_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Ride_Events_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Ride_Events_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Ride_Events_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Ride_Events_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Ride_Events_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ride_Events_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ride_Events_Bool_Exp;
};

/** Boolean expression to compare columns of type "ride_status_enum". All fields are combined with logical 'AND'. */
export type Ride_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['ride_status_enum']['input']>;
  _gt?: InputMaybe<Scalars['ride_status_enum']['input']>;
  _gte?: InputMaybe<Scalars['ride_status_enum']['input']>;
  _in?: InputMaybe<Array<Scalars['ride_status_enum']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['ride_status_enum']['input']>;
  _lte?: InputMaybe<Scalars['ride_status_enum']['input']>;
  _neq?: InputMaybe<Scalars['ride_status_enum']['input']>;
  _nin?: InputMaybe<Array<Scalars['ride_status_enum']['input']>>;
};

/** columns and relationships of "rides" */
export type Rides = {
  __typename?: 'rides';
  actual_fare?: Maybe<Scalars['numeric']['output']>;
  cancel_reason?: Maybe<Scalars['String']['output']>;
  cancelled_at?: Maybe<Scalars['timestamptz']['output']>;
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  driver?: Maybe<Drivers>;
  driver_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  drivers: Array<Drivers>;
  /** An aggregate relationship */
  drivers_aggregate: Drivers_Aggregate;
  dropoff_address?: Maybe<Scalars['String']['output']>;
  dropoff_location: Scalars['geography']['output'];
  estimated_distance?: Maybe<Scalars['numeric']['output']>;
  estimated_duration?: Maybe<Scalars['numeric']['output']>;
  estimated_fare?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  payments: Array<Payments>;
  /** An aggregate relationship */
  payments_aggregate: Payments_Aggregate;
  pickup_address?: Maybe<Scalars['String']['output']>;
  pickup_location: Scalars['geography']['output'];
  /** An array relationship */
  ratings: Array<Ratings>;
  /** An aggregate relationship */
  ratings_aggregate: Ratings_Aggregate;
  /** An array relationship */
  ride_events: Array<Ride_Events>;
  /** An aggregate relationship */
  ride_events_aggregate: Ride_Events_Aggregate;
  route_info?: Maybe<Scalars['jsonb']['output']>;
  scheduled_for?: Maybe<Scalars['timestamptz']['output']>;
  started_at?: Maybe<Scalars['timestamptz']['output']>;
  status?: Maybe<Scalars['ride_status_enum']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
  /** An object relationship */
  vehicle?: Maybe<Vehicles>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "rides" */
export type RidesDriversArgs = {
  distinct_on?: InputMaybe<Array<Drivers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Drivers_Order_By>>;
  where?: InputMaybe<Drivers_Bool_Exp>;
};


/** columns and relationships of "rides" */
export type RidesDrivers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Drivers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Drivers_Order_By>>;
  where?: InputMaybe<Drivers_Bool_Exp>;
};


/** columns and relationships of "rides" */
export type RidesPaymentsArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


/** columns and relationships of "rides" */
export type RidesPayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


/** columns and relationships of "rides" */
export type RidesRatingsArgs = {
  distinct_on?: InputMaybe<Array<Ratings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ratings_Order_By>>;
  where?: InputMaybe<Ratings_Bool_Exp>;
};


/** columns and relationships of "rides" */
export type RidesRatings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ratings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ratings_Order_By>>;
  where?: InputMaybe<Ratings_Bool_Exp>;
};


/** columns and relationships of "rides" */
export type RidesRide_EventsArgs = {
  distinct_on?: InputMaybe<Array<Ride_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ride_Events_Order_By>>;
  where?: InputMaybe<Ride_Events_Bool_Exp>;
};


/** columns and relationships of "rides" */
export type RidesRide_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ride_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ride_Events_Order_By>>;
  where?: InputMaybe<Ride_Events_Bool_Exp>;
};


/** columns and relationships of "rides" */
export type RidesRoute_InfoArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "rides" */
export type Rides_Aggregate = {
  __typename?: 'rides_aggregate';
  aggregate?: Maybe<Rides_Aggregate_Fields>;
  nodes: Array<Rides>;
};

export type Rides_Aggregate_Bool_Exp = {
  count?: InputMaybe<Rides_Aggregate_Bool_Exp_Count>;
};

export type Rides_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Rides_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Rides_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "rides" */
export type Rides_Aggregate_Fields = {
  __typename?: 'rides_aggregate_fields';
  avg?: Maybe<Rides_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Rides_Max_Fields>;
  min?: Maybe<Rides_Min_Fields>;
  stddev?: Maybe<Rides_Stddev_Fields>;
  stddev_pop?: Maybe<Rides_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Rides_Stddev_Samp_Fields>;
  sum?: Maybe<Rides_Sum_Fields>;
  var_pop?: Maybe<Rides_Var_Pop_Fields>;
  var_samp?: Maybe<Rides_Var_Samp_Fields>;
  variance?: Maybe<Rides_Variance_Fields>;
};


/** aggregate fields of "rides" */
export type Rides_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Rides_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "rides" */
export type Rides_Aggregate_Order_By = {
  avg?: InputMaybe<Rides_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Rides_Max_Order_By>;
  min?: InputMaybe<Rides_Min_Order_By>;
  stddev?: InputMaybe<Rides_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Rides_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Rides_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Rides_Sum_Order_By>;
  var_pop?: InputMaybe<Rides_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Rides_Var_Samp_Order_By>;
  variance?: InputMaybe<Rides_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Rides_Append_Input = {
  route_info?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "rides" */
export type Rides_Arr_Rel_Insert_Input = {
  data: Array<Rides_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Rides_On_Conflict>;
};

/** aggregate avg on columns */
export type Rides_Avg_Fields = {
  __typename?: 'rides_avg_fields';
  actual_fare?: Maybe<Scalars['Float']['output']>;
  estimated_distance?: Maybe<Scalars['Float']['output']>;
  estimated_duration?: Maybe<Scalars['Float']['output']>;
  estimated_fare?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "rides" */
export type Rides_Avg_Order_By = {
  actual_fare?: InputMaybe<Order_By>;
  estimated_distance?: InputMaybe<Order_By>;
  estimated_duration?: InputMaybe<Order_By>;
  estimated_fare?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "rides". All fields are combined with a logical 'AND'. */
export type Rides_Bool_Exp = {
  _and?: InputMaybe<Array<Rides_Bool_Exp>>;
  _not?: InputMaybe<Rides_Bool_Exp>;
  _or?: InputMaybe<Array<Rides_Bool_Exp>>;
  actual_fare?: InputMaybe<Numeric_Comparison_Exp>;
  cancel_reason?: InputMaybe<String_Comparison_Exp>;
  cancelled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  driver?: InputMaybe<Drivers_Bool_Exp>;
  driver_id?: InputMaybe<Uuid_Comparison_Exp>;
  drivers?: InputMaybe<Drivers_Bool_Exp>;
  drivers_aggregate?: InputMaybe<Drivers_Aggregate_Bool_Exp>;
  dropoff_address?: InputMaybe<String_Comparison_Exp>;
  dropoff_location?: InputMaybe<Geography_Comparison_Exp>;
  estimated_distance?: InputMaybe<Numeric_Comparison_Exp>;
  estimated_duration?: InputMaybe<Numeric_Comparison_Exp>;
  estimated_fare?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  payments?: InputMaybe<Payments_Bool_Exp>;
  payments_aggregate?: InputMaybe<Payments_Aggregate_Bool_Exp>;
  pickup_address?: InputMaybe<String_Comparison_Exp>;
  pickup_location?: InputMaybe<Geography_Comparison_Exp>;
  ratings?: InputMaybe<Ratings_Bool_Exp>;
  ratings_aggregate?: InputMaybe<Ratings_Aggregate_Bool_Exp>;
  ride_events?: InputMaybe<Ride_Events_Bool_Exp>;
  ride_events_aggregate?: InputMaybe<Ride_Events_Aggregate_Bool_Exp>;
  route_info?: InputMaybe<Jsonb_Comparison_Exp>;
  scheduled_for?: InputMaybe<Timestamptz_Comparison_Exp>;
  started_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<Ride_Status_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  vehicle?: InputMaybe<Vehicles_Bool_Exp>;
  vehicle_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "rides" */
export enum Rides_Constraint {
  /** unique or primary key constraint on columns "id" */
  RidesPkey = 'rides_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Rides_Delete_At_Path_Input = {
  route_info?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Rides_Delete_Elem_Input = {
  route_info?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Rides_Delete_Key_Input = {
  route_info?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "rides" */
export type Rides_Inc_Input = {
  actual_fare?: InputMaybe<Scalars['numeric']['input']>;
  estimated_distance?: InputMaybe<Scalars['numeric']['input']>;
  estimated_duration?: InputMaybe<Scalars['numeric']['input']>;
  estimated_fare?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "rides" */
export type Rides_Insert_Input = {
  actual_fare?: InputMaybe<Scalars['numeric']['input']>;
  cancel_reason?: InputMaybe<Scalars['String']['input']>;
  cancelled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  driver?: InputMaybe<Drivers_Obj_Rel_Insert_Input>;
  driver_id?: InputMaybe<Scalars['uuid']['input']>;
  drivers?: InputMaybe<Drivers_Arr_Rel_Insert_Input>;
  dropoff_address?: InputMaybe<Scalars['String']['input']>;
  dropoff_location?: InputMaybe<Scalars['geography']['input']>;
  estimated_distance?: InputMaybe<Scalars['numeric']['input']>;
  estimated_duration?: InputMaybe<Scalars['numeric']['input']>;
  estimated_fare?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  payments?: InputMaybe<Payments_Arr_Rel_Insert_Input>;
  pickup_address?: InputMaybe<Scalars['String']['input']>;
  pickup_location?: InputMaybe<Scalars['geography']['input']>;
  ratings?: InputMaybe<Ratings_Arr_Rel_Insert_Input>;
  ride_events?: InputMaybe<Ride_Events_Arr_Rel_Insert_Input>;
  route_info?: InputMaybe<Scalars['jsonb']['input']>;
  scheduled_for?: InputMaybe<Scalars['timestamptz']['input']>;
  started_at?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['ride_status_enum']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  vehicle?: InputMaybe<Vehicles_Obj_Rel_Insert_Input>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Rides_Max_Fields = {
  __typename?: 'rides_max_fields';
  actual_fare?: Maybe<Scalars['numeric']['output']>;
  cancel_reason?: Maybe<Scalars['String']['output']>;
  cancelled_at?: Maybe<Scalars['timestamptz']['output']>;
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  driver_id?: Maybe<Scalars['uuid']['output']>;
  dropoff_address?: Maybe<Scalars['String']['output']>;
  estimated_distance?: Maybe<Scalars['numeric']['output']>;
  estimated_duration?: Maybe<Scalars['numeric']['output']>;
  estimated_fare?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  pickup_address?: Maybe<Scalars['String']['output']>;
  scheduled_for?: Maybe<Scalars['timestamptz']['output']>;
  started_at?: Maybe<Scalars['timestamptz']['output']>;
  status?: Maybe<Scalars['ride_status_enum']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "rides" */
export type Rides_Max_Order_By = {
  actual_fare?: InputMaybe<Order_By>;
  cancel_reason?: InputMaybe<Order_By>;
  cancelled_at?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  driver_id?: InputMaybe<Order_By>;
  dropoff_address?: InputMaybe<Order_By>;
  estimated_distance?: InputMaybe<Order_By>;
  estimated_duration?: InputMaybe<Order_By>;
  estimated_fare?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pickup_address?: InputMaybe<Order_By>;
  scheduled_for?: InputMaybe<Order_By>;
  started_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Rides_Min_Fields = {
  __typename?: 'rides_min_fields';
  actual_fare?: Maybe<Scalars['numeric']['output']>;
  cancel_reason?: Maybe<Scalars['String']['output']>;
  cancelled_at?: Maybe<Scalars['timestamptz']['output']>;
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  driver_id?: Maybe<Scalars['uuid']['output']>;
  dropoff_address?: Maybe<Scalars['String']['output']>;
  estimated_distance?: Maybe<Scalars['numeric']['output']>;
  estimated_duration?: Maybe<Scalars['numeric']['output']>;
  estimated_fare?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  pickup_address?: Maybe<Scalars['String']['output']>;
  scheduled_for?: Maybe<Scalars['timestamptz']['output']>;
  started_at?: Maybe<Scalars['timestamptz']['output']>;
  status?: Maybe<Scalars['ride_status_enum']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "rides" */
export type Rides_Min_Order_By = {
  actual_fare?: InputMaybe<Order_By>;
  cancel_reason?: InputMaybe<Order_By>;
  cancelled_at?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  driver_id?: InputMaybe<Order_By>;
  dropoff_address?: InputMaybe<Order_By>;
  estimated_distance?: InputMaybe<Order_By>;
  estimated_duration?: InputMaybe<Order_By>;
  estimated_fare?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pickup_address?: InputMaybe<Order_By>;
  scheduled_for?: InputMaybe<Order_By>;
  started_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "rides" */
export type Rides_Mutation_Response = {
  __typename?: 'rides_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Rides>;
};

/** input type for inserting object relation for remote table "rides" */
export type Rides_Obj_Rel_Insert_Input = {
  data: Rides_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Rides_On_Conflict>;
};

/** on_conflict condition type for table "rides" */
export type Rides_On_Conflict = {
  constraint: Rides_Constraint;
  update_columns?: Array<Rides_Update_Column>;
  where?: InputMaybe<Rides_Bool_Exp>;
};

/** Ordering options when selecting data from "rides". */
export type Rides_Order_By = {
  actual_fare?: InputMaybe<Order_By>;
  cancel_reason?: InputMaybe<Order_By>;
  cancelled_at?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  driver?: InputMaybe<Drivers_Order_By>;
  driver_id?: InputMaybe<Order_By>;
  drivers_aggregate?: InputMaybe<Drivers_Aggregate_Order_By>;
  dropoff_address?: InputMaybe<Order_By>;
  dropoff_location?: InputMaybe<Order_By>;
  estimated_distance?: InputMaybe<Order_By>;
  estimated_duration?: InputMaybe<Order_By>;
  estimated_fare?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payments_aggregate?: InputMaybe<Payments_Aggregate_Order_By>;
  pickup_address?: InputMaybe<Order_By>;
  pickup_location?: InputMaybe<Order_By>;
  ratings_aggregate?: InputMaybe<Ratings_Aggregate_Order_By>;
  ride_events_aggregate?: InputMaybe<Ride_Events_Aggregate_Order_By>;
  route_info?: InputMaybe<Order_By>;
  scheduled_for?: InputMaybe<Order_By>;
  started_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  vehicle?: InputMaybe<Vehicles_Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: rides */
export type Rides_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Rides_Prepend_Input = {
  route_info?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "rides" */
export enum Rides_Select_Column {
  /** column name */
  ActualFare = 'actual_fare',
  /** column name */
  CancelReason = 'cancel_reason',
  /** column name */
  CancelledAt = 'cancelled_at',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DriverId = 'driver_id',
  /** column name */
  DropoffAddress = 'dropoff_address',
  /** column name */
  DropoffLocation = 'dropoff_location',
  /** column name */
  EstimatedDistance = 'estimated_distance',
  /** column name */
  EstimatedDuration = 'estimated_duration',
  /** column name */
  EstimatedFare = 'estimated_fare',
  /** column name */
  Id = 'id',
  /** column name */
  PickupAddress = 'pickup_address',
  /** column name */
  PickupLocation = 'pickup_location',
  /** column name */
  RouteInfo = 'route_info',
  /** column name */
  ScheduledFor = 'scheduled_for',
  /** column name */
  StartedAt = 'started_at',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VehicleId = 'vehicle_id'
}

/** input type for updating data in table "rides" */
export type Rides_Set_Input = {
  actual_fare?: InputMaybe<Scalars['numeric']['input']>;
  cancel_reason?: InputMaybe<Scalars['String']['input']>;
  cancelled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  driver_id?: InputMaybe<Scalars['uuid']['input']>;
  dropoff_address?: InputMaybe<Scalars['String']['input']>;
  dropoff_location?: InputMaybe<Scalars['geography']['input']>;
  estimated_distance?: InputMaybe<Scalars['numeric']['input']>;
  estimated_duration?: InputMaybe<Scalars['numeric']['input']>;
  estimated_fare?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  pickup_address?: InputMaybe<Scalars['String']['input']>;
  pickup_location?: InputMaybe<Scalars['geography']['input']>;
  route_info?: InputMaybe<Scalars['jsonb']['input']>;
  scheduled_for?: InputMaybe<Scalars['timestamptz']['input']>;
  started_at?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['ride_status_enum']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Rides_Stddev_Fields = {
  __typename?: 'rides_stddev_fields';
  actual_fare?: Maybe<Scalars['Float']['output']>;
  estimated_distance?: Maybe<Scalars['Float']['output']>;
  estimated_duration?: Maybe<Scalars['Float']['output']>;
  estimated_fare?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "rides" */
export type Rides_Stddev_Order_By = {
  actual_fare?: InputMaybe<Order_By>;
  estimated_distance?: InputMaybe<Order_By>;
  estimated_duration?: InputMaybe<Order_By>;
  estimated_fare?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Rides_Stddev_Pop_Fields = {
  __typename?: 'rides_stddev_pop_fields';
  actual_fare?: Maybe<Scalars['Float']['output']>;
  estimated_distance?: Maybe<Scalars['Float']['output']>;
  estimated_duration?: Maybe<Scalars['Float']['output']>;
  estimated_fare?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "rides" */
export type Rides_Stddev_Pop_Order_By = {
  actual_fare?: InputMaybe<Order_By>;
  estimated_distance?: InputMaybe<Order_By>;
  estimated_duration?: InputMaybe<Order_By>;
  estimated_fare?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Rides_Stddev_Samp_Fields = {
  __typename?: 'rides_stddev_samp_fields';
  actual_fare?: Maybe<Scalars['Float']['output']>;
  estimated_distance?: Maybe<Scalars['Float']['output']>;
  estimated_duration?: Maybe<Scalars['Float']['output']>;
  estimated_fare?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "rides" */
export type Rides_Stddev_Samp_Order_By = {
  actual_fare?: InputMaybe<Order_By>;
  estimated_distance?: InputMaybe<Order_By>;
  estimated_duration?: InputMaybe<Order_By>;
  estimated_fare?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "rides" */
export type Rides_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rides_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rides_Stream_Cursor_Value_Input = {
  actual_fare?: InputMaybe<Scalars['numeric']['input']>;
  cancel_reason?: InputMaybe<Scalars['String']['input']>;
  cancelled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  driver_id?: InputMaybe<Scalars['uuid']['input']>;
  dropoff_address?: InputMaybe<Scalars['String']['input']>;
  dropoff_location?: InputMaybe<Scalars['geography']['input']>;
  estimated_distance?: InputMaybe<Scalars['numeric']['input']>;
  estimated_duration?: InputMaybe<Scalars['numeric']['input']>;
  estimated_fare?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  pickup_address?: InputMaybe<Scalars['String']['input']>;
  pickup_location?: InputMaybe<Scalars['geography']['input']>;
  route_info?: InputMaybe<Scalars['jsonb']['input']>;
  scheduled_for?: InputMaybe<Scalars['timestamptz']['input']>;
  started_at?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['ride_status_enum']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Rides_Sum_Fields = {
  __typename?: 'rides_sum_fields';
  actual_fare?: Maybe<Scalars['numeric']['output']>;
  estimated_distance?: Maybe<Scalars['numeric']['output']>;
  estimated_duration?: Maybe<Scalars['numeric']['output']>;
  estimated_fare?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "rides" */
export type Rides_Sum_Order_By = {
  actual_fare?: InputMaybe<Order_By>;
  estimated_distance?: InputMaybe<Order_By>;
  estimated_duration?: InputMaybe<Order_By>;
  estimated_fare?: InputMaybe<Order_By>;
};

/** update columns of table "rides" */
export enum Rides_Update_Column {
  /** column name */
  ActualFare = 'actual_fare',
  /** column name */
  CancelReason = 'cancel_reason',
  /** column name */
  CancelledAt = 'cancelled_at',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DriverId = 'driver_id',
  /** column name */
  DropoffAddress = 'dropoff_address',
  /** column name */
  DropoffLocation = 'dropoff_location',
  /** column name */
  EstimatedDistance = 'estimated_distance',
  /** column name */
  EstimatedDuration = 'estimated_duration',
  /** column name */
  EstimatedFare = 'estimated_fare',
  /** column name */
  Id = 'id',
  /** column name */
  PickupAddress = 'pickup_address',
  /** column name */
  PickupLocation = 'pickup_location',
  /** column name */
  RouteInfo = 'route_info',
  /** column name */
  ScheduledFor = 'scheduled_for',
  /** column name */
  StartedAt = 'started_at',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VehicleId = 'vehicle_id'
}

export type Rides_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Rides_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Rides_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Rides_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Rides_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Rides_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Rides_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Rides_Set_Input>;
  /** filter the rows which have to be updated */
  where: Rides_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Rides_Var_Pop_Fields = {
  __typename?: 'rides_var_pop_fields';
  actual_fare?: Maybe<Scalars['Float']['output']>;
  estimated_distance?: Maybe<Scalars['Float']['output']>;
  estimated_duration?: Maybe<Scalars['Float']['output']>;
  estimated_fare?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "rides" */
export type Rides_Var_Pop_Order_By = {
  actual_fare?: InputMaybe<Order_By>;
  estimated_distance?: InputMaybe<Order_By>;
  estimated_duration?: InputMaybe<Order_By>;
  estimated_fare?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Rides_Var_Samp_Fields = {
  __typename?: 'rides_var_samp_fields';
  actual_fare?: Maybe<Scalars['Float']['output']>;
  estimated_distance?: Maybe<Scalars['Float']['output']>;
  estimated_duration?: Maybe<Scalars['Float']['output']>;
  estimated_fare?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "rides" */
export type Rides_Var_Samp_Order_By = {
  actual_fare?: InputMaybe<Order_By>;
  estimated_distance?: InputMaybe<Order_By>;
  estimated_duration?: InputMaybe<Order_By>;
  estimated_fare?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Rides_Variance_Fields = {
  __typename?: 'rides_variance_fields';
  actual_fare?: Maybe<Scalars['Float']['output']>;
  estimated_distance?: Maybe<Scalars['Float']['output']>;
  estimated_duration?: Maybe<Scalars['Float']['output']>;
  estimated_fare?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "rides" */
export type Rides_Variance_Order_By = {
  actual_fare?: InputMaybe<Order_By>;
  estimated_distance?: InputMaybe<Order_By>;
  estimated_duration?: InputMaybe<Order_By>;
  estimated_fare?: InputMaybe<Order_By>;
};

/** columns and relationships of "settlement" */
export type Settlement = {
  __typename?: 'settlement';
  created_at: Scalars['timestamp']['output'];
  dishAmount: Scalars['numeric']['output'];
  id: Scalars['uuid']['output'];
  /** An array relationship */
  orders: Array<Order>;
  /** An aggregate relationship */
  orders_aggregate: Order_Aggregate;
  /** An object relationship */
  restaurant?: Maybe<Restaurant>;
  restaurantId?: Maybe<Scalars['uuid']['output']>;
  totalAdminEarning?: Maybe<Scalars['numeric']['output']>;
  totalDeliveryCharge: Scalars['numeric']['output'];
  totalRestaurantEarning?: Maybe<Scalars['numeric']['output']>;
  updated_at: Scalars['timestamp']['output'];
};


/** columns and relationships of "settlement" */
export type SettlementOrdersArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


/** columns and relationships of "settlement" */
export type SettlementOrders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};

/** aggregated selection of "settlement" */
export type Settlement_Aggregate = {
  __typename?: 'settlement_aggregate';
  aggregate?: Maybe<Settlement_Aggregate_Fields>;
  nodes: Array<Settlement>;
};

/** aggregate fields of "settlement" */
export type Settlement_Aggregate_Fields = {
  __typename?: 'settlement_aggregate_fields';
  avg?: Maybe<Settlement_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Settlement_Max_Fields>;
  min?: Maybe<Settlement_Min_Fields>;
  stddev?: Maybe<Settlement_Stddev_Fields>;
  stddev_pop?: Maybe<Settlement_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Settlement_Stddev_Samp_Fields>;
  sum?: Maybe<Settlement_Sum_Fields>;
  var_pop?: Maybe<Settlement_Var_Pop_Fields>;
  var_samp?: Maybe<Settlement_Var_Samp_Fields>;
  variance?: Maybe<Settlement_Variance_Fields>;
};


/** aggregate fields of "settlement" */
export type Settlement_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Settlement_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Settlement_Avg_Fields = {
  __typename?: 'settlement_avg_fields';
  dishAmount?: Maybe<Scalars['Float']['output']>;
  totalAdminEarning?: Maybe<Scalars['Float']['output']>;
  totalDeliveryCharge?: Maybe<Scalars['Float']['output']>;
  totalRestaurantEarning?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "settlement". All fields are combined with a logical 'AND'. */
export type Settlement_Bool_Exp = {
  _and?: InputMaybe<Array<Settlement_Bool_Exp>>;
  _not?: InputMaybe<Settlement_Bool_Exp>;
  _or?: InputMaybe<Array<Settlement_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  dishAmount?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  orders?: InputMaybe<Order_Bool_Exp>;
  orders_aggregate?: InputMaybe<Order_Aggregate_Bool_Exp>;
  restaurant?: InputMaybe<Restaurant_Bool_Exp>;
  restaurantId?: InputMaybe<Uuid_Comparison_Exp>;
  totalAdminEarning?: InputMaybe<Numeric_Comparison_Exp>;
  totalDeliveryCharge?: InputMaybe<Numeric_Comparison_Exp>;
  totalRestaurantEarning?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "settlement" */
export enum Settlement_Constraint {
  /** unique or primary key constraint on columns "id" */
  SettlementPkey = 'settlement_pkey'
}

/** input type for incrementing numeric columns in table "settlement" */
export type Settlement_Inc_Input = {
  dishAmount?: InputMaybe<Scalars['numeric']['input']>;
  totalAdminEarning?: InputMaybe<Scalars['numeric']['input']>;
  totalDeliveryCharge?: InputMaybe<Scalars['numeric']['input']>;
  totalRestaurantEarning?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "settlement" */
export type Settlement_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  dishAmount?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  orders?: InputMaybe<Order_Arr_Rel_Insert_Input>;
  restaurant?: InputMaybe<Restaurant_Obj_Rel_Insert_Input>;
  restaurantId?: InputMaybe<Scalars['uuid']['input']>;
  totalAdminEarning?: InputMaybe<Scalars['numeric']['input']>;
  totalDeliveryCharge?: InputMaybe<Scalars['numeric']['input']>;
  totalRestaurantEarning?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Settlement_Max_Fields = {
  __typename?: 'settlement_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  dishAmount?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  restaurantId?: Maybe<Scalars['uuid']['output']>;
  totalAdminEarning?: Maybe<Scalars['numeric']['output']>;
  totalDeliveryCharge?: Maybe<Scalars['numeric']['output']>;
  totalRestaurantEarning?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Settlement_Min_Fields = {
  __typename?: 'settlement_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  dishAmount?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  restaurantId?: Maybe<Scalars['uuid']['output']>;
  totalAdminEarning?: Maybe<Scalars['numeric']['output']>;
  totalDeliveryCharge?: Maybe<Scalars['numeric']['output']>;
  totalRestaurantEarning?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "settlement" */
export type Settlement_Mutation_Response = {
  __typename?: 'settlement_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Settlement>;
};

/** on_conflict condition type for table "settlement" */
export type Settlement_On_Conflict = {
  constraint: Settlement_Constraint;
  update_columns?: Array<Settlement_Update_Column>;
  where?: InputMaybe<Settlement_Bool_Exp>;
};

/** Ordering options when selecting data from "settlement". */
export type Settlement_Order_By = {
  created_at?: InputMaybe<Order_By>;
  dishAmount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orders_aggregate?: InputMaybe<Order_Aggregate_Order_By>;
  restaurant?: InputMaybe<Restaurant_Order_By>;
  restaurantId?: InputMaybe<Order_By>;
  totalAdminEarning?: InputMaybe<Order_By>;
  totalDeliveryCharge?: InputMaybe<Order_By>;
  totalRestaurantEarning?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: settlement */
export type Settlement_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "settlement" */
export enum Settlement_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DishAmount = 'dishAmount',
  /** column name */
  Id = 'id',
  /** column name */
  RestaurantId = 'restaurantId',
  /** column name */
  TotalAdminEarning = 'totalAdminEarning',
  /** column name */
  TotalDeliveryCharge = 'totalDeliveryCharge',
  /** column name */
  TotalRestaurantEarning = 'totalRestaurantEarning',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "settlement" */
export type Settlement_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  dishAmount?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  restaurantId?: InputMaybe<Scalars['uuid']['input']>;
  totalAdminEarning?: InputMaybe<Scalars['numeric']['input']>;
  totalDeliveryCharge?: InputMaybe<Scalars['numeric']['input']>;
  totalRestaurantEarning?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Settlement_Stddev_Fields = {
  __typename?: 'settlement_stddev_fields';
  dishAmount?: Maybe<Scalars['Float']['output']>;
  totalAdminEarning?: Maybe<Scalars['Float']['output']>;
  totalDeliveryCharge?: Maybe<Scalars['Float']['output']>;
  totalRestaurantEarning?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Settlement_Stddev_Pop_Fields = {
  __typename?: 'settlement_stddev_pop_fields';
  dishAmount?: Maybe<Scalars['Float']['output']>;
  totalAdminEarning?: Maybe<Scalars['Float']['output']>;
  totalDeliveryCharge?: Maybe<Scalars['Float']['output']>;
  totalRestaurantEarning?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Settlement_Stddev_Samp_Fields = {
  __typename?: 'settlement_stddev_samp_fields';
  dishAmount?: Maybe<Scalars['Float']['output']>;
  totalAdminEarning?: Maybe<Scalars['Float']['output']>;
  totalDeliveryCharge?: Maybe<Scalars['Float']['output']>;
  totalRestaurantEarning?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "settlement" */
export type Settlement_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Settlement_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Settlement_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  dishAmount?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  restaurantId?: InputMaybe<Scalars['uuid']['input']>;
  totalAdminEarning?: InputMaybe<Scalars['numeric']['input']>;
  totalDeliveryCharge?: InputMaybe<Scalars['numeric']['input']>;
  totalRestaurantEarning?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Settlement_Sum_Fields = {
  __typename?: 'settlement_sum_fields';
  dishAmount?: Maybe<Scalars['numeric']['output']>;
  totalAdminEarning?: Maybe<Scalars['numeric']['output']>;
  totalDeliveryCharge?: Maybe<Scalars['numeric']['output']>;
  totalRestaurantEarning?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "settlement" */
export enum Settlement_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DishAmount = 'dishAmount',
  /** column name */
  Id = 'id',
  /** column name */
  RestaurantId = 'restaurantId',
  /** column name */
  TotalAdminEarning = 'totalAdminEarning',
  /** column name */
  TotalDeliveryCharge = 'totalDeliveryCharge',
  /** column name */
  TotalRestaurantEarning = 'totalRestaurantEarning',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Settlement_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Settlement_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Settlement_Set_Input>;
  /** filter the rows which have to be updated */
  where: Settlement_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Settlement_Var_Pop_Fields = {
  __typename?: 'settlement_var_pop_fields';
  dishAmount?: Maybe<Scalars['Float']['output']>;
  totalAdminEarning?: Maybe<Scalars['Float']['output']>;
  totalDeliveryCharge?: Maybe<Scalars['Float']['output']>;
  totalRestaurantEarning?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Settlement_Var_Samp_Fields = {
  __typename?: 'settlement_var_samp_fields';
  dishAmount?: Maybe<Scalars['Float']['output']>;
  totalAdminEarning?: Maybe<Scalars['Float']['output']>;
  totalDeliveryCharge?: Maybe<Scalars['Float']['output']>;
  totalRestaurantEarning?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Settlement_Variance_Fields = {
  __typename?: 'settlement_variance_fields';
  dishAmount?: Maybe<Scalars['Float']['output']>;
  totalAdminEarning?: Maybe<Scalars['Float']['output']>;
  totalDeliveryCharge?: Maybe<Scalars['Float']['output']>;
  totalRestaurantEarning?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "specialty" */
export type Specialty = {
  __typename?: 'specialty';
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  restaurants: Array<Restaurant>;
  /** An aggregate relationship */
  restaurants_aggregate: Restaurant_Aggregate;
};


/** columns and relationships of "specialty" */
export type SpecialtyRestaurantsArgs = {
  distinct_on?: InputMaybe<Array<Restaurant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Restaurant_Order_By>>;
  where?: InputMaybe<Restaurant_Bool_Exp>;
};


/** columns and relationships of "specialty" */
export type SpecialtyRestaurants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Restaurant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Restaurant_Order_By>>;
  where?: InputMaybe<Restaurant_Bool_Exp>;
};

/** aggregated selection of "specialty" */
export type Specialty_Aggregate = {
  __typename?: 'specialty_aggregate';
  aggregate?: Maybe<Specialty_Aggregate_Fields>;
  nodes: Array<Specialty>;
};

/** aggregate fields of "specialty" */
export type Specialty_Aggregate_Fields = {
  __typename?: 'specialty_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Specialty_Max_Fields>;
  min?: Maybe<Specialty_Min_Fields>;
};


/** aggregate fields of "specialty" */
export type Specialty_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Specialty_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "specialty". All fields are combined with a logical 'AND'. */
export type Specialty_Bool_Exp = {
  _and?: InputMaybe<Array<Specialty_Bool_Exp>>;
  _not?: InputMaybe<Specialty_Bool_Exp>;
  _or?: InputMaybe<Array<Specialty_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  restaurants?: InputMaybe<Restaurant_Bool_Exp>;
  restaurants_aggregate?: InputMaybe<Restaurant_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "specialty" */
export enum Specialty_Constraint {
  /** unique or primary key constraint on columns "id" */
  SpecialtyPkey = 'specialty_pkey'
}

/** input type for inserting data into table "specialty" */
export type Specialty_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  restaurants?: InputMaybe<Restaurant_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Specialty_Max_Fields = {
  __typename?: 'specialty_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Specialty_Min_Fields = {
  __typename?: 'specialty_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "specialty" */
export type Specialty_Mutation_Response = {
  __typename?: 'specialty_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Specialty>;
};

/** input type for inserting object relation for remote table "specialty" */
export type Specialty_Obj_Rel_Insert_Input = {
  data: Specialty_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Specialty_On_Conflict>;
};

/** on_conflict condition type for table "specialty" */
export type Specialty_On_Conflict = {
  constraint: Specialty_Constraint;
  update_columns?: Array<Specialty_Update_Column>;
  where?: InputMaybe<Specialty_Bool_Exp>;
};

/** Ordering options when selecting data from "specialty". */
export type Specialty_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  restaurants_aggregate?: InputMaybe<Restaurant_Aggregate_Order_By>;
};

/** primary key columns input for table: specialty */
export type Specialty_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "specialty" */
export enum Specialty_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "specialty" */
export type Specialty_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "specialty" */
export type Specialty_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Specialty_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Specialty_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "specialty" */
export enum Specialty_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Specialty_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Specialty_Set_Input>;
  /** filter the rows which have to be updated */
  where: Specialty_Bool_Exp;
};

export type St_D_Within_Geography_Input = {
  distance: Scalars['Float']['input'];
  from: Scalars['geography']['input'];
  use_spheroid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type St_D_Within_Input = {
  distance: Scalars['Float']['input'];
  from: Scalars['geometry']['input'];
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "account_deletion_request" */
  account_deletion_request: Array<Account_Deletion_Request>;
  /** fetch aggregated fields from the table: "account_deletion_request" */
  account_deletion_request_aggregate: Account_Deletion_Request_Aggregate;
  /** fetch data from the table: "account_deletion_request" using primary key columns */
  account_deletion_request_by_pk?: Maybe<Account_Deletion_Request>;
  /** fetch data from the table in a streaming manner: "account_deletion_request" */
  account_deletion_request_stream: Array<Account_Deletion_Request>;
  /** fetch data from the table: "app_settings" */
  app_settings: Array<App_Settings>;
  /** fetch aggregated fields from the table: "app_settings" */
  app_settings_aggregate: App_Settings_Aggregate;
  /** fetch data from the table: "app_settings" using primary key columns */
  app_settings_by_pk?: Maybe<App_Settings>;
  /** fetch data from the table in a streaming manner: "app_settings" */
  app_settings_stream: Array<App_Settings>;
  /** fetch data from the table: "app_versions" */
  app_versions: Array<App_Versions>;
  /** fetch aggregated fields from the table: "app_versions" */
  app_versions_aggregate: App_Versions_Aggregate;
  /** fetch data from the table: "app_versions" using primary key columns */
  app_versions_by_pk?: Maybe<App_Versions>;
  /** fetch data from the table in a streaming manner: "app_versions" */
  app_versions_stream: Array<App_Versions>;
  /** fetch data from the table: "assignment" */
  assignment: Array<Assignment>;
  /** fetch aggregated fields from the table: "assignment" */
  assignment_aggregate: Assignment_Aggregate;
  /** fetch data from the table: "assignment" using primary key columns */
  assignment_by_pk?: Maybe<Assignment>;
  /** fetch data from the table in a streaming manner: "assignment" */
  assignment_stream: Array<Assignment>;
  /** fetch data from the table: "auth.providers" using primary key columns */
  authProvider?: Maybe<AuthProviders>;
  /** fetch data from the table: "auth.provider_requests" using primary key columns */
  authProviderRequest?: Maybe<AuthProviderRequests>;
  /** fetch data from the table: "auth.provider_requests" */
  authProviderRequests: Array<AuthProviderRequests>;
  /** fetch aggregated fields from the table: "auth.provider_requests" */
  authProviderRequestsAggregate: AuthProviderRequests_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.provider_requests" */
  authProviderRequests_stream: Array<AuthProviderRequests>;
  /** fetch data from the table: "auth.providers" */
  authProviders: Array<AuthProviders>;
  /** fetch aggregated fields from the table: "auth.providers" */
  authProvidersAggregate: AuthProviders_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.providers" */
  authProviders_stream: Array<AuthProviders>;
  /** fetch data from the table: "auth.refresh_tokens" using primary key columns */
  authRefreshToken?: Maybe<AuthRefreshTokens>;
  /** fetch data from the table: "auth.refresh_token_types" using primary key columns */
  authRefreshTokenType?: Maybe<AuthRefreshTokenTypes>;
  /** fetch data from the table: "auth.refresh_token_types" */
  authRefreshTokenTypes: Array<AuthRefreshTokenTypes>;
  /** fetch aggregated fields from the table: "auth.refresh_token_types" */
  authRefreshTokenTypesAggregate: AuthRefreshTokenTypes_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.refresh_token_types" */
  authRefreshTokenTypes_stream: Array<AuthRefreshTokenTypes>;
  /** fetch data from the table: "auth.refresh_tokens" */
  authRefreshTokens: Array<AuthRefreshTokens>;
  /** fetch aggregated fields from the table: "auth.refresh_tokens" */
  authRefreshTokensAggregate: AuthRefreshTokens_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.refresh_tokens" */
  authRefreshTokens_stream: Array<AuthRefreshTokens>;
  /** fetch data from the table: "auth.roles" using primary key columns */
  authRole?: Maybe<AuthRoles>;
  /** fetch data from the table: "auth.roles" */
  authRoles: Array<AuthRoles>;
  /** fetch aggregated fields from the table: "auth.roles" */
  authRolesAggregate: AuthRoles_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.roles" */
  authRoles_stream: Array<AuthRoles>;
  /** fetch data from the table: "auth.user_providers" using primary key columns */
  authUserProvider?: Maybe<AuthUserProviders>;
  /** fetch data from the table: "auth.user_providers" */
  authUserProviders: Array<AuthUserProviders>;
  /** fetch aggregated fields from the table: "auth.user_providers" */
  authUserProvidersAggregate: AuthUserProviders_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.user_providers" */
  authUserProviders_stream: Array<AuthUserProviders>;
  /** fetch data from the table: "auth.user_roles" using primary key columns */
  authUserRole?: Maybe<AuthUserRoles>;
  /** fetch data from the table: "auth.user_roles" */
  authUserRoles: Array<AuthUserRoles>;
  /** fetch aggregated fields from the table: "auth.user_roles" */
  authUserRolesAggregate: AuthUserRoles_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.user_roles" */
  authUserRoles_stream: Array<AuthUserRoles>;
  /** fetch data from the table: "auth.user_security_keys" using primary key columns */
  authUserSecurityKey?: Maybe<AuthUserSecurityKeys>;
  /** fetch data from the table: "auth.user_security_keys" */
  authUserSecurityKeys: Array<AuthUserSecurityKeys>;
  /** fetch aggregated fields from the table: "auth.user_security_keys" */
  authUserSecurityKeysAggregate: AuthUserSecurityKeys_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.user_security_keys" */
  authUserSecurityKeys_stream: Array<AuthUserSecurityKeys>;
  /** fetch data from the table: "basket" */
  basket: Array<Basket>;
  /** fetch aggregated fields from the table: "basket" */
  basket_aggregate: Basket_Aggregate;
  /** fetch data from the table: "basket" using primary key columns */
  basket_by_pk?: Maybe<Basket>;
  /** fetch data from the table: "basket_dish" */
  basket_dish: Array<Basket_Dish>;
  /** fetch aggregated fields from the table: "basket_dish" */
  basket_dish_aggregate: Basket_Dish_Aggregate;
  /** fetch data from the table: "basket_dish" using primary key columns */
  basket_dish_by_pk?: Maybe<Basket_Dish>;
  /** fetch data from the table in a streaming manner: "basket_dish" */
  basket_dish_stream: Array<Basket_Dish>;
  /** fetch data from the table in a streaming manner: "basket" */
  basket_stream: Array<Basket>;
  /** fetch data from the table: "storage.buckets" using primary key columns */
  bucket?: Maybe<Buckets>;
  /** fetch data from the table: "storage.buckets" */
  buckets: Array<Buckets>;
  /** fetch aggregated fields from the table: "storage.buckets" */
  bucketsAggregate: Buckets_Aggregate;
  /** fetch data from the table in a streaming manner: "storage.buckets" */
  buckets_stream: Array<Buckets>;
  /** fetch data from the table: "carrier" */
  carrier: Array<Carrier>;
  /** fetch aggregated fields from the table: "carrier" */
  carrier_aggregate: Carrier_Aggregate;
  /** fetch data from the table: "carrier" using primary key columns */
  carrier_by_pk?: Maybe<Carrier>;
  /** fetch data from the table in a streaming manner: "carrier" */
  carrier_stream: Array<Carrier>;
  /** fetch data from the table: "category" */
  category: Array<Category>;
  /** fetch aggregated fields from the table: "category" */
  category_aggregate: Category_Aggregate;
  /** fetch data from the table: "category" using primary key columns */
  category_by_pk?: Maybe<Category>;
  /** fetch data from the table in a streaming manner: "category" */
  category_stream: Array<Category>;
  /** fetch data from the table: "dish" */
  dish: Array<Dish>;
  /** fetch aggregated fields from the table: "dish" */
  dish_aggregate: Dish_Aggregate;
  /** fetch data from the table: "dish" using primary key columns */
  dish_by_pk?: Maybe<Dish>;
  /** fetch data from the table in a streaming manner: "dish" */
  dish_stream: Array<Dish>;
  /** An array relationship */
  driver_documents: Array<Driver_Documents>;
  /** An aggregate relationship */
  driver_documents_aggregate: Driver_Documents_Aggregate;
  /** fetch data from the table: "driver_documents" using primary key columns */
  driver_documents_by_pk?: Maybe<Driver_Documents>;
  /** fetch data from the table in a streaming manner: "driver_documents" */
  driver_documents_stream: Array<Driver_Documents>;
  /** fetch data from the table: "driver_locations_current" */
  driver_locations_current: Array<Driver_Locations_Current>;
  /** fetch aggregated fields from the table: "driver_locations_current" */
  driver_locations_current_aggregate: Driver_Locations_Current_Aggregate;
  /** fetch data from the table: "driver_locations_current" using primary key columns */
  driver_locations_current_by_pk?: Maybe<Driver_Locations_Current>;
  /** fetch data from the table in a streaming manner: "driver_locations_current" */
  driver_locations_current_stream: Array<Driver_Locations_Current>;
  /** An array relationship */
  drivers: Array<Drivers>;
  /** An aggregate relationship */
  drivers_aggregate: Drivers_Aggregate;
  /** fetch data from the table: "drivers" using primary key columns */
  drivers_by_pk?: Maybe<Drivers>;
  /** fetch data from the table in a streaming manner: "drivers" */
  drivers_stream: Array<Drivers>;
  /** fetch data from the table: "fare_bands" */
  fare_bands: Array<Fare_Bands>;
  /** fetch aggregated fields from the table: "fare_bands" */
  fare_bands_aggregate: Fare_Bands_Aggregate;
  /** fetch data from the table: "fare_bands" using primary key columns */
  fare_bands_by_pk?: Maybe<Fare_Bands>;
  /** fetch data from the table in a streaming manner: "fare_bands" */
  fare_bands_stream: Array<Fare_Bands>;
  /** fetch data from the table: "feedback" */
  feedback: Array<Feedback>;
  /** fetch aggregated fields from the table: "feedback" */
  feedback_aggregate: Feedback_Aggregate;
  /** fetch data from the table: "feedback" using primary key columns */
  feedback_by_pk?: Maybe<Feedback>;
  /** fetch data from the table in a streaming manner: "feedback" */
  feedback_stream: Array<Feedback>;
  /** fetch data from the table: "storage.files" using primary key columns */
  file?: Maybe<Files>;
  /** An array relationship */
  files: Array<Files>;
  /** fetch aggregated fields from the table: "storage.files" */
  filesAggregate: Files_Aggregate;
  /** fetch data from the table in a streaming manner: "storage.files" */
  files_stream: Array<Files>;
  /** An array relationship */
  free_rides: Array<Free_Rides>;
  /** An aggregate relationship */
  free_rides_aggregate: Free_Rides_Aggregate;
  /** fetch data from the table: "free_rides" using primary key columns */
  free_rides_by_pk?: Maybe<Free_Rides>;
  /** fetch data from the table in a streaming manner: "free_rides" */
  free_rides_stream: Array<Free_Rides>;
  /** fetch data from the table: "order" */
  order: Array<Order>;
  /** fetch aggregated fields from the table: "order" */
  order_aggregate: Order_Aggregate;
  /** fetch data from the table: "order" using primary key columns */
  order_by_pk?: Maybe<Order>;
  /** fetch data from the table in a streaming manner: "order" */
  order_stream: Array<Order>;
  /** An array relationship */
  payments: Array<Payments>;
  /** An aggregate relationship */
  payments_aggregate: Payments_Aggregate;
  /** fetch data from the table: "payments" using primary key columns */
  payments_by_pk?: Maybe<Payments>;
  /** fetch data from the table in a streaming manner: "payments" */
  payments_stream: Array<Payments>;
  /** An array relationship */
  ratings: Array<Ratings>;
  /** An aggregate relationship */
  ratings_aggregate: Ratings_Aggregate;
  /** fetch data from the table: "ratings" using primary key columns */
  ratings_by_pk?: Maybe<Ratings>;
  /** fetch data from the table in a streaming manner: "ratings" */
  ratings_stream: Array<Ratings>;
  /** fetch data from the table: "restaurant" */
  restaurant: Array<Restaurant>;
  /** fetch aggregated fields from the table: "restaurant" */
  restaurant_aggregate: Restaurant_Aggregate;
  /** fetch data from the table: "restaurant" using primary key columns */
  restaurant_by_pk?: Maybe<Restaurant>;
  /** fetch data from the table in a streaming manner: "restaurant" */
  restaurant_stream: Array<Restaurant>;
  /** An array relationship */
  ride_events: Array<Ride_Events>;
  /** An aggregate relationship */
  ride_events_aggregate: Ride_Events_Aggregate;
  /** fetch data from the table: "ride_events" using primary key columns */
  ride_events_by_pk?: Maybe<Ride_Events>;
  /** fetch data from the table in a streaming manner: "ride_events" */
  ride_events_stream: Array<Ride_Events>;
  /** An array relationship */
  rides: Array<Rides>;
  /** An aggregate relationship */
  rides_aggregate: Rides_Aggregate;
  /** fetch data from the table: "rides" using primary key columns */
  rides_by_pk?: Maybe<Rides>;
  /** fetch data from the table in a streaming manner: "rides" */
  rides_stream: Array<Rides>;
  /** fetch data from the table: "settlement" */
  settlement: Array<Settlement>;
  /** fetch aggregated fields from the table: "settlement" */
  settlement_aggregate: Settlement_Aggregate;
  /** fetch data from the table: "settlement" using primary key columns */
  settlement_by_pk?: Maybe<Settlement>;
  /** fetch data from the table in a streaming manner: "settlement" */
  settlement_stream: Array<Settlement>;
  /** fetch data from the table: "specialty" */
  specialty: Array<Specialty>;
  /** fetch aggregated fields from the table: "specialty" */
  specialty_aggregate: Specialty_Aggregate;
  /** fetch data from the table: "specialty" using primary key columns */
  specialty_by_pk?: Maybe<Specialty>;
  /** fetch data from the table in a streaming manner: "specialty" */
  specialty_stream: Array<Specialty>;
  /** fetch data from the table: "auth.users" using primary key columns */
  user?: Maybe<Users>;
  /** fetch data from the table: "user_devices" */
  user_devices: Array<User_Devices>;
  /** fetch aggregated fields from the table: "user_devices" */
  user_devices_aggregate: User_Devices_Aggregate;
  /** fetch data from the table: "user_devices" using primary key columns */
  user_devices_by_pk?: Maybe<User_Devices>;
  /** fetch data from the table in a streaming manner: "user_devices" */
  user_devices_stream: Array<User_Devices>;
  /** fetch data from the table: "user_profiles" */
  user_profiles: Array<User_Profiles>;
  /** fetch aggregated fields from the table: "user_profiles" */
  user_profiles_aggregate: User_Profiles_Aggregate;
  /** fetch data from the table: "user_profiles" using primary key columns */
  user_profiles_by_pk?: Maybe<User_Profiles>;
  /** fetch data from the table in a streaming manner: "user_profiles" */
  user_profiles_stream: Array<User_Profiles>;
  /** fetch data from the table: "user_settings" */
  user_settings: Array<User_Settings>;
  /** fetch aggregated fields from the table: "user_settings" */
  user_settings_aggregate: User_Settings_Aggregate;
  /** fetch data from the table: "user_settings" using primary key columns */
  user_settings_by_pk?: Maybe<User_Settings>;
  /** fetch data from the table in a streaming manner: "user_settings" */
  user_settings_stream: Array<User_Settings>;
  /** fetch data from the table: "auth.users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "auth.users" */
  usersAggregate: Users_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.users" */
  users_stream: Array<Users>;
  /** An array relationship */
  vehicle_documents: Array<Vehicle_Documents>;
  /** An aggregate relationship */
  vehicle_documents_aggregate: Vehicle_Documents_Aggregate;
  /** fetch data from the table: "vehicle_documents" using primary key columns */
  vehicle_documents_by_pk?: Maybe<Vehicle_Documents>;
  /** fetch data from the table in a streaming manner: "vehicle_documents" */
  vehicle_documents_stream: Array<Vehicle_Documents>;
  /** An array relationship */
  vehicles: Array<Vehicles>;
  /** An aggregate relationship */
  vehicles_aggregate: Vehicles_Aggregate;
  /** fetch data from the table: "vehicles" using primary key columns */
  vehicles_by_pk?: Maybe<Vehicles>;
  /** fetch data from the table in a streaming manner: "vehicles" */
  vehicles_stream: Array<Vehicles>;
  /** fetch data from the table: "storage.virus" using primary key columns */
  virus?: Maybe<Virus>;
  /** fetch data from the table in a streaming manner: "storage.virus" */
  virus_stream: Array<Virus>;
  /** fetch data from the table: "storage.virus" */
  viruses: Array<Virus>;
  /** fetch aggregated fields from the table: "storage.virus" */
  virusesAggregate: Virus_Aggregate;
};


export type Subscription_RootAccount_Deletion_RequestArgs = {
  distinct_on?: InputMaybe<Array<Account_Deletion_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Deletion_Request_Order_By>>;
  where?: InputMaybe<Account_Deletion_Request_Bool_Exp>;
};


export type Subscription_RootAccount_Deletion_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Deletion_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Deletion_Request_Order_By>>;
  where?: InputMaybe<Account_Deletion_Request_Bool_Exp>;
};


export type Subscription_RootAccount_Deletion_Request_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAccount_Deletion_Request_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Account_Deletion_Request_Stream_Cursor_Input>>;
  where?: InputMaybe<Account_Deletion_Request_Bool_Exp>;
};


export type Subscription_RootApp_SettingsArgs = {
  distinct_on?: InputMaybe<Array<App_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Settings_Order_By>>;
  where?: InputMaybe<App_Settings_Bool_Exp>;
};


export type Subscription_RootApp_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Settings_Order_By>>;
  where?: InputMaybe<App_Settings_Bool_Exp>;
};


export type Subscription_RootApp_Settings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootApp_Settings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<App_Settings_Stream_Cursor_Input>>;
  where?: InputMaybe<App_Settings_Bool_Exp>;
};


export type Subscription_RootApp_VersionsArgs = {
  distinct_on?: InputMaybe<Array<App_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Versions_Order_By>>;
  where?: InputMaybe<App_Versions_Bool_Exp>;
};


export type Subscription_RootApp_Versions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<App_Versions_Order_By>>;
  where?: InputMaybe<App_Versions_Bool_Exp>;
};


export type Subscription_RootApp_Versions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootApp_Versions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<App_Versions_Stream_Cursor_Input>>;
  where?: InputMaybe<App_Versions_Bool_Exp>;
};


export type Subscription_RootAssignmentArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assignment_Order_By>>;
  where?: InputMaybe<Assignment_Bool_Exp>;
};


export type Subscription_RootAssignment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assignment_Order_By>>;
  where?: InputMaybe<Assignment_Bool_Exp>;
};


export type Subscription_RootAssignment_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAssignment_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Assignment_Stream_Cursor_Input>>;
  where?: InputMaybe<Assignment_Bool_Exp>;
};


export type Subscription_RootAuthProviderArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootAuthProviderRequestArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAuthProviderRequestsArgs = {
  distinct_on?: InputMaybe<Array<AuthProviderRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthProviderRequests_Order_By>>;
  where?: InputMaybe<AuthProviderRequests_Bool_Exp>;
};


export type Subscription_RootAuthProviderRequestsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthProviderRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthProviderRequests_Order_By>>;
  where?: InputMaybe<AuthProviderRequests_Bool_Exp>;
};


export type Subscription_RootAuthProviderRequests_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthProviderRequests_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthProviderRequests_Bool_Exp>;
};


export type Subscription_RootAuthProvidersArgs = {
  distinct_on?: InputMaybe<Array<AuthProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthProviders_Order_By>>;
  where?: InputMaybe<AuthProviders_Bool_Exp>;
};


export type Subscription_RootAuthProvidersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthProviders_Order_By>>;
  where?: InputMaybe<AuthProviders_Bool_Exp>;
};


export type Subscription_RootAuthProviders_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthProviders_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthProviders_Bool_Exp>;
};


export type Subscription_RootAuthRefreshTokenArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAuthRefreshTokenTypeArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootAuthRefreshTokenTypesArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokenTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokenTypes_Order_By>>;
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>;
};


export type Subscription_RootAuthRefreshTokenTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokenTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokenTypes_Order_By>>;
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>;
};


export type Subscription_RootAuthRefreshTokenTypes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthRefreshTokenTypes_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>;
};


export type Subscription_RootAuthRefreshTokensArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};


export type Subscription_RootAuthRefreshTokensAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};


export type Subscription_RootAuthRefreshTokens_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthRefreshTokens_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};


export type Subscription_RootAuthRoleArgs = {
  role: Scalars['String']['input'];
};


export type Subscription_RootAuthRolesArgs = {
  distinct_on?: InputMaybe<Array<AuthRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRoles_Order_By>>;
  where?: InputMaybe<AuthRoles_Bool_Exp>;
};


export type Subscription_RootAuthRolesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRoles_Order_By>>;
  where?: InputMaybe<AuthRoles_Bool_Exp>;
};


export type Subscription_RootAuthRoles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthRoles_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthRoles_Bool_Exp>;
};


export type Subscription_RootAuthUserProviderArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAuthUserProvidersArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};


export type Subscription_RootAuthUserProvidersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};


export type Subscription_RootAuthUserProviders_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthUserProviders_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};


export type Subscription_RootAuthUserRoleArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAuthUserRolesArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


export type Subscription_RootAuthUserRolesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


export type Subscription_RootAuthUserRoles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthUserRoles_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


export type Subscription_RootAuthUserSecurityKeyArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAuthUserSecurityKeysArgs = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
};


export type Subscription_RootAuthUserSecurityKeysAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
};


export type Subscription_RootAuthUserSecurityKeys_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthUserSecurityKeys_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
};


export type Subscription_RootBasketArgs = {
  distinct_on?: InputMaybe<Array<Basket_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Basket_Order_By>>;
  where?: InputMaybe<Basket_Bool_Exp>;
};


export type Subscription_RootBasket_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Basket_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Basket_Order_By>>;
  where?: InputMaybe<Basket_Bool_Exp>;
};


export type Subscription_RootBasket_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBasket_DishArgs = {
  distinct_on?: InputMaybe<Array<Basket_Dish_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Basket_Dish_Order_By>>;
  where?: InputMaybe<Basket_Dish_Bool_Exp>;
};


export type Subscription_RootBasket_Dish_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Basket_Dish_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Basket_Dish_Order_By>>;
  where?: InputMaybe<Basket_Dish_Bool_Exp>;
};


export type Subscription_RootBasket_Dish_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBasket_Dish_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Basket_Dish_Stream_Cursor_Input>>;
  where?: InputMaybe<Basket_Dish_Bool_Exp>;
};


export type Subscription_RootBasket_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Basket_Stream_Cursor_Input>>;
  where?: InputMaybe<Basket_Bool_Exp>;
};


export type Subscription_RootBucketArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootBucketsArgs = {
  distinct_on?: InputMaybe<Array<Buckets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buckets_Order_By>>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};


export type Subscription_RootBucketsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Buckets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buckets_Order_By>>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};


export type Subscription_RootBuckets_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Buckets_Stream_Cursor_Input>>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};


export type Subscription_RootCarrierArgs = {
  distinct_on?: InputMaybe<Array<Carrier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Carrier_Order_By>>;
  where?: InputMaybe<Carrier_Bool_Exp>;
};


export type Subscription_RootCarrier_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Carrier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Carrier_Order_By>>;
  where?: InputMaybe<Carrier_Bool_Exp>;
};


export type Subscription_RootCarrier_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCarrier_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Carrier_Stream_Cursor_Input>>;
  where?: InputMaybe<Carrier_Bool_Exp>;
};


export type Subscription_RootCategoryArgs = {
  distinct_on?: InputMaybe<Array<Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Category_Order_By>>;
  where?: InputMaybe<Category_Bool_Exp>;
};


export type Subscription_RootCategory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Category_Order_By>>;
  where?: InputMaybe<Category_Bool_Exp>;
};


export type Subscription_RootCategory_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCategory_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Category_Bool_Exp>;
};


export type Subscription_RootDishArgs = {
  distinct_on?: InputMaybe<Array<Dish_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dish_Order_By>>;
  where?: InputMaybe<Dish_Bool_Exp>;
};


export type Subscription_RootDish_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dish_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dish_Order_By>>;
  where?: InputMaybe<Dish_Bool_Exp>;
};


export type Subscription_RootDish_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDish_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Dish_Stream_Cursor_Input>>;
  where?: InputMaybe<Dish_Bool_Exp>;
};


export type Subscription_RootDriver_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Driver_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Documents_Order_By>>;
  where?: InputMaybe<Driver_Documents_Bool_Exp>;
};


export type Subscription_RootDriver_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Driver_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Documents_Order_By>>;
  where?: InputMaybe<Driver_Documents_Bool_Exp>;
};


export type Subscription_RootDriver_Documents_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDriver_Documents_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Driver_Documents_Stream_Cursor_Input>>;
  where?: InputMaybe<Driver_Documents_Bool_Exp>;
};


export type Subscription_RootDriver_Locations_CurrentArgs = {
  distinct_on?: InputMaybe<Array<Driver_Locations_Current_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Locations_Current_Order_By>>;
  where?: InputMaybe<Driver_Locations_Current_Bool_Exp>;
};


export type Subscription_RootDriver_Locations_Current_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Driver_Locations_Current_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Locations_Current_Order_By>>;
  where?: InputMaybe<Driver_Locations_Current_Bool_Exp>;
};


export type Subscription_RootDriver_Locations_Current_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDriver_Locations_Current_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Driver_Locations_Current_Stream_Cursor_Input>>;
  where?: InputMaybe<Driver_Locations_Current_Bool_Exp>;
};


export type Subscription_RootDriversArgs = {
  distinct_on?: InputMaybe<Array<Drivers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Drivers_Order_By>>;
  where?: InputMaybe<Drivers_Bool_Exp>;
};


export type Subscription_RootDrivers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Drivers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Drivers_Order_By>>;
  where?: InputMaybe<Drivers_Bool_Exp>;
};


export type Subscription_RootDrivers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDrivers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Drivers_Stream_Cursor_Input>>;
  where?: InputMaybe<Drivers_Bool_Exp>;
};


export type Subscription_RootFare_BandsArgs = {
  distinct_on?: InputMaybe<Array<Fare_Bands_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fare_Bands_Order_By>>;
  where?: InputMaybe<Fare_Bands_Bool_Exp>;
};


export type Subscription_RootFare_Bands_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fare_Bands_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fare_Bands_Order_By>>;
  where?: InputMaybe<Fare_Bands_Bool_Exp>;
};


export type Subscription_RootFare_Bands_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFare_Bands_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Fare_Bands_Stream_Cursor_Input>>;
  where?: InputMaybe<Fare_Bands_Bool_Exp>;
};


export type Subscription_RootFeedbackArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Feedback_Order_By>>;
  where?: InputMaybe<Feedback_Bool_Exp>;
};


export type Subscription_RootFeedback_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Feedback_Order_By>>;
  where?: InputMaybe<Feedback_Bool_Exp>;
};


export type Subscription_RootFeedback_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFeedback_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Feedback_Stream_Cursor_Input>>;
  where?: InputMaybe<Feedback_Bool_Exp>;
};


export type Subscription_RootFileArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootFilesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootFiles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Files_Stream_Cursor_Input>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootFree_RidesArgs = {
  distinct_on?: InputMaybe<Array<Free_Rides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Free_Rides_Order_By>>;
  where?: InputMaybe<Free_Rides_Bool_Exp>;
};


export type Subscription_RootFree_Rides_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Free_Rides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Free_Rides_Order_By>>;
  where?: InputMaybe<Free_Rides_Bool_Exp>;
};


export type Subscription_RootFree_Rides_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFree_Rides_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Free_Rides_Stream_Cursor_Input>>;
  where?: InputMaybe<Free_Rides_Bool_Exp>;
};


export type Subscription_RootOrderArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


export type Subscription_RootOrder_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


export type Subscription_RootOrder_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrder_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Order_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


export type Subscription_RootPaymentsArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


export type Subscription_RootPayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


export type Subscription_RootPayments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPayments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Payments_Stream_Cursor_Input>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


export type Subscription_RootRatingsArgs = {
  distinct_on?: InputMaybe<Array<Ratings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ratings_Order_By>>;
  where?: InputMaybe<Ratings_Bool_Exp>;
};


export type Subscription_RootRatings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ratings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ratings_Order_By>>;
  where?: InputMaybe<Ratings_Bool_Exp>;
};


export type Subscription_RootRatings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRatings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ratings_Stream_Cursor_Input>>;
  where?: InputMaybe<Ratings_Bool_Exp>;
};


export type Subscription_RootRestaurantArgs = {
  distinct_on?: InputMaybe<Array<Restaurant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Restaurant_Order_By>>;
  where?: InputMaybe<Restaurant_Bool_Exp>;
};


export type Subscription_RootRestaurant_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Restaurant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Restaurant_Order_By>>;
  where?: InputMaybe<Restaurant_Bool_Exp>;
};


export type Subscription_RootRestaurant_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRestaurant_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Restaurant_Stream_Cursor_Input>>;
  where?: InputMaybe<Restaurant_Bool_Exp>;
};


export type Subscription_RootRide_EventsArgs = {
  distinct_on?: InputMaybe<Array<Ride_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ride_Events_Order_By>>;
  where?: InputMaybe<Ride_Events_Bool_Exp>;
};


export type Subscription_RootRide_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ride_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ride_Events_Order_By>>;
  where?: InputMaybe<Ride_Events_Bool_Exp>;
};


export type Subscription_RootRide_Events_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRide_Events_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ride_Events_Stream_Cursor_Input>>;
  where?: InputMaybe<Ride_Events_Bool_Exp>;
};


export type Subscription_RootRidesArgs = {
  distinct_on?: InputMaybe<Array<Rides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rides_Order_By>>;
  where?: InputMaybe<Rides_Bool_Exp>;
};


export type Subscription_RootRides_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rides_Order_By>>;
  where?: InputMaybe<Rides_Bool_Exp>;
};


export type Subscription_RootRides_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRides_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rides_Stream_Cursor_Input>>;
  where?: InputMaybe<Rides_Bool_Exp>;
};


export type Subscription_RootSettlementArgs = {
  distinct_on?: InputMaybe<Array<Settlement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Settlement_Order_By>>;
  where?: InputMaybe<Settlement_Bool_Exp>;
};


export type Subscription_RootSettlement_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Settlement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Settlement_Order_By>>;
  where?: InputMaybe<Settlement_Bool_Exp>;
};


export type Subscription_RootSettlement_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSettlement_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Settlement_Stream_Cursor_Input>>;
  where?: InputMaybe<Settlement_Bool_Exp>;
};


export type Subscription_RootSpecialtyArgs = {
  distinct_on?: InputMaybe<Array<Specialty_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Specialty_Order_By>>;
  where?: InputMaybe<Specialty_Bool_Exp>;
};


export type Subscription_RootSpecialty_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Specialty_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Specialty_Order_By>>;
  where?: InputMaybe<Specialty_Bool_Exp>;
};


export type Subscription_RootSpecialty_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSpecialty_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Specialty_Stream_Cursor_Input>>;
  where?: InputMaybe<Specialty_Bool_Exp>;
};


export type Subscription_RootUserArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_DevicesArgs = {
  distinct_on?: InputMaybe<Array<User_Devices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Devices_Order_By>>;
  where?: InputMaybe<User_Devices_Bool_Exp>;
};


export type Subscription_RootUser_Devices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Devices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Devices_Order_By>>;
  where?: InputMaybe<User_Devices_Bool_Exp>;
};


export type Subscription_RootUser_Devices_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_Devices_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Devices_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Devices_Bool_Exp>;
};


export type Subscription_RootUser_ProfilesArgs = {
  distinct_on?: InputMaybe<Array<User_Profiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Profiles_Order_By>>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
};


export type Subscription_RootUser_Profiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Profiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Profiles_Order_By>>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
};


export type Subscription_RootUser_Profiles_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_Profiles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Profiles_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
};


export type Subscription_RootUser_SettingsArgs = {
  distinct_on?: InputMaybe<Array<User_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Settings_Order_By>>;
  where?: InputMaybe<User_Settings_Bool_Exp>;
};


export type Subscription_RootUser_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Settings_Order_By>>;
  where?: InputMaybe<User_Settings_Bool_Exp>;
};


export type Subscription_RootUser_Settings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_Settings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Settings_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Settings_Bool_Exp>;
};


export type Subscription_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsersAggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootVehicle_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Documents_Order_By>>;
  where?: InputMaybe<Vehicle_Documents_Bool_Exp>;
};


export type Subscription_RootVehicle_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Documents_Order_By>>;
  where?: InputMaybe<Vehicle_Documents_Bool_Exp>;
};


export type Subscription_RootVehicle_Documents_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootVehicle_Documents_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vehicle_Documents_Stream_Cursor_Input>>;
  where?: InputMaybe<Vehicle_Documents_Bool_Exp>;
};


export type Subscription_RootVehiclesArgs = {
  distinct_on?: InputMaybe<Array<Vehicles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicles_Order_By>>;
  where?: InputMaybe<Vehicles_Bool_Exp>;
};


export type Subscription_RootVehicles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicles_Order_By>>;
  where?: InputMaybe<Vehicles_Bool_Exp>;
};


export type Subscription_RootVehicles_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootVehicles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vehicles_Stream_Cursor_Input>>;
  where?: InputMaybe<Vehicles_Bool_Exp>;
};


export type Subscription_RootVirusArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootVirus_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Virus_Stream_Cursor_Input>>;
  where?: InputMaybe<Virus_Bool_Exp>;
};


export type Subscription_RootVirusesArgs = {
  distinct_on?: InputMaybe<Array<Virus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Virus_Order_By>>;
  where?: InputMaybe<Virus_Bool_Exp>;
};


export type Subscription_RootVirusesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Virus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Virus_Order_By>>;
  where?: InputMaybe<Virus_Bool_Exp>;
};

/** Boolean expression to compare columns of type "time". All fields are combined with logical 'AND'. */
export type Time_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['time']['input']>;
  _gt?: InputMaybe<Scalars['time']['input']>;
  _gte?: InputMaybe<Scalars['time']['input']>;
  _in?: InputMaybe<Array<Scalars['time']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['time']['input']>;
  _lte?: InputMaybe<Scalars['time']['input']>;
  _neq?: InputMaybe<Scalars['time']['input']>;
  _nin?: InputMaybe<Array<Scalars['time']['input']>>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** columns and relationships of "user_devices" */
export type User_Devices = {
  __typename?: 'user_devices';
  created_at: Scalars['timestamptz']['output'];
  device_token: Scalars['String']['output'];
  device_type: Scalars['String']['output'];
  /** An array relationship */
  driver_locations_currents: Array<Driver_Locations_Current>;
  /** An aggregate relationship */
  driver_locations_currents_aggregate: Driver_Locations_Current_Aggregate;
  fcm_token: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_active: Scalars['timestamptz']['output'];
  push_token: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};


/** columns and relationships of "user_devices" */
export type User_DevicesDriver_Locations_CurrentsArgs = {
  distinct_on?: InputMaybe<Array<Driver_Locations_Current_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Locations_Current_Order_By>>;
  where?: InputMaybe<Driver_Locations_Current_Bool_Exp>;
};


/** columns and relationships of "user_devices" */
export type User_DevicesDriver_Locations_Currents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Driver_Locations_Current_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Locations_Current_Order_By>>;
  where?: InputMaybe<Driver_Locations_Current_Bool_Exp>;
};

/** aggregated selection of "user_devices" */
export type User_Devices_Aggregate = {
  __typename?: 'user_devices_aggregate';
  aggregate?: Maybe<User_Devices_Aggregate_Fields>;
  nodes: Array<User_Devices>;
};

/** aggregate fields of "user_devices" */
export type User_Devices_Aggregate_Fields = {
  __typename?: 'user_devices_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Devices_Max_Fields>;
  min?: Maybe<User_Devices_Min_Fields>;
};


/** aggregate fields of "user_devices" */
export type User_Devices_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Devices_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "user_devices". All fields are combined with a logical 'AND'. */
export type User_Devices_Bool_Exp = {
  _and?: InputMaybe<Array<User_Devices_Bool_Exp>>;
  _not?: InputMaybe<User_Devices_Bool_Exp>;
  _or?: InputMaybe<Array<User_Devices_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  device_token?: InputMaybe<String_Comparison_Exp>;
  device_type?: InputMaybe<String_Comparison_Exp>;
  driver_locations_currents?: InputMaybe<Driver_Locations_Current_Bool_Exp>;
  driver_locations_currents_aggregate?: InputMaybe<Driver_Locations_Current_Aggregate_Bool_Exp>;
  fcm_token?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_active?: InputMaybe<Timestamptz_Comparison_Exp>;
  push_token?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_devices" */
export enum User_Devices_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserDevicesPkey = 'user_devices_pkey'
}

/** input type for inserting data into table "user_devices" */
export type User_Devices_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  device_token?: InputMaybe<Scalars['String']['input']>;
  device_type?: InputMaybe<Scalars['String']['input']>;
  driver_locations_currents?: InputMaybe<Driver_Locations_Current_Arr_Rel_Insert_Input>;
  fcm_token?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_active?: InputMaybe<Scalars['timestamptz']['input']>;
  push_token?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type User_Devices_Max_Fields = {
  __typename?: 'user_devices_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  device_token?: Maybe<Scalars['String']['output']>;
  device_type?: Maybe<Scalars['String']['output']>;
  fcm_token?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_active?: Maybe<Scalars['timestamptz']['output']>;
  push_token?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type User_Devices_Min_Fields = {
  __typename?: 'user_devices_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  device_token?: Maybe<Scalars['String']['output']>;
  device_type?: Maybe<Scalars['String']['output']>;
  fcm_token?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_active?: Maybe<Scalars['timestamptz']['output']>;
  push_token?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "user_devices" */
export type User_Devices_Mutation_Response = {
  __typename?: 'user_devices_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Devices>;
};

/** input type for inserting object relation for remote table "user_devices" */
export type User_Devices_Obj_Rel_Insert_Input = {
  data: User_Devices_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Devices_On_Conflict>;
};

/** on_conflict condition type for table "user_devices" */
export type User_Devices_On_Conflict = {
  constraint: User_Devices_Constraint;
  update_columns?: Array<User_Devices_Update_Column>;
  where?: InputMaybe<User_Devices_Bool_Exp>;
};

/** Ordering options when selecting data from "user_devices". */
export type User_Devices_Order_By = {
  created_at?: InputMaybe<Order_By>;
  device_token?: InputMaybe<Order_By>;
  device_type?: InputMaybe<Order_By>;
  driver_locations_currents_aggregate?: InputMaybe<Driver_Locations_Current_Aggregate_Order_By>;
  fcm_token?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_active?: InputMaybe<Order_By>;
  push_token?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_devices */
export type User_Devices_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_devices" */
export enum User_Devices_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeviceToken = 'device_token',
  /** column name */
  DeviceType = 'device_type',
  /** column name */
  FcmToken = 'fcm_token',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastActive = 'last_active',
  /** column name */
  PushToken = 'push_token',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_devices" */
export type User_Devices_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  device_token?: InputMaybe<Scalars['String']['input']>;
  device_type?: InputMaybe<Scalars['String']['input']>;
  fcm_token?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_active?: InputMaybe<Scalars['timestamptz']['input']>;
  push_token?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "user_devices" */
export type User_Devices_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Devices_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Devices_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  device_token?: InputMaybe<Scalars['String']['input']>;
  device_type?: InputMaybe<Scalars['String']['input']>;
  fcm_token?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_active?: InputMaybe<Scalars['timestamptz']['input']>;
  push_token?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "user_devices" */
export enum User_Devices_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeviceToken = 'device_token',
  /** column name */
  DeviceType = 'device_type',
  /** column name */
  FcmToken = 'fcm_token',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastActive = 'last_active',
  /** column name */
  PushToken = 'push_token',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type User_Devices_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Devices_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Devices_Bool_Exp;
};

/** columns and relationships of "user_profiles" */
export type User_Profiles = {
  __typename?: 'user_profiles';
  avatar_url?: Maybe<Scalars['String']['output']>;
  blood_donation_consent: Scalars['Boolean']['output'];
  blood_group: Scalars['blood_group_enum']['output'];
  created_at: Scalars['timestamptz']['output'];
  dob?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  free_rides: Array<Free_Rides>;
  /** An aggregate relationship */
  free_rides_aggregate: Free_Rides_Aggregate;
  full_name?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  last_location?: Maybe<Scalars['geography']['output']>;
  last_seen_at?: Maybe<Scalars['timestamp']['output']>;
  location?: Maybe<Scalars['geography']['output']>;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  notification_token?: Maybe<Scalars['String']['output']>;
  notification_token_food?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};


/** columns and relationships of "user_profiles" */
export type User_ProfilesFree_RidesArgs = {
  distinct_on?: InputMaybe<Array<Free_Rides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Free_Rides_Order_By>>;
  where?: InputMaybe<Free_Rides_Bool_Exp>;
};


/** columns and relationships of "user_profiles" */
export type User_ProfilesFree_Rides_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Free_Rides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Free_Rides_Order_By>>;
  where?: InputMaybe<Free_Rides_Bool_Exp>;
};


/** columns and relationships of "user_profiles" */
export type User_ProfilesMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "user_profiles" */
export type User_Profiles_Aggregate = {
  __typename?: 'user_profiles_aggregate';
  aggregate?: Maybe<User_Profiles_Aggregate_Fields>;
  nodes: Array<User_Profiles>;
};

/** aggregate fields of "user_profiles" */
export type User_Profiles_Aggregate_Fields = {
  __typename?: 'user_profiles_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Profiles_Max_Fields>;
  min?: Maybe<User_Profiles_Min_Fields>;
};


/** aggregate fields of "user_profiles" */
export type User_Profiles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Profiles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type User_Profiles_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "user_profiles". All fields are combined with a logical 'AND'. */
export type User_Profiles_Bool_Exp = {
  _and?: InputMaybe<Array<User_Profiles_Bool_Exp>>;
  _not?: InputMaybe<User_Profiles_Bool_Exp>;
  _or?: InputMaybe<Array<User_Profiles_Bool_Exp>>;
  avatar_url?: InputMaybe<String_Comparison_Exp>;
  blood_donation_consent?: InputMaybe<Boolean_Comparison_Exp>;
  blood_group?: InputMaybe<Blood_Group_Enum_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  dob?: InputMaybe<String_Comparison_Exp>;
  free_rides?: InputMaybe<Free_Rides_Bool_Exp>;
  free_rides_aggregate?: InputMaybe<Free_Rides_Aggregate_Bool_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_location?: InputMaybe<Geography_Comparison_Exp>;
  last_seen_at?: InputMaybe<Timestamp_Comparison_Exp>;
  location?: InputMaybe<Geography_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  notification_token?: InputMaybe<String_Comparison_Exp>;
  notification_token_food?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_profiles" */
export enum User_Profiles_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserProfilesPkey = 'user_profiles_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type User_Profiles_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type User_Profiles_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type User_Profiles_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "user_profiles" */
export type User_Profiles_Insert_Input = {
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  blood_donation_consent?: InputMaybe<Scalars['Boolean']['input']>;
  blood_group?: InputMaybe<Scalars['blood_group_enum']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  free_rides?: InputMaybe<Free_Rides_Arr_Rel_Insert_Input>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_location?: InputMaybe<Scalars['geography']['input']>;
  last_seen_at?: InputMaybe<Scalars['timestamp']['input']>;
  location?: InputMaybe<Scalars['geography']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  notification_token?: InputMaybe<Scalars['String']['input']>;
  notification_token_food?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type User_Profiles_Max_Fields = {
  __typename?: 'user_profiles_max_fields';
  avatar_url?: Maybe<Scalars['String']['output']>;
  blood_group?: Maybe<Scalars['blood_group_enum']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  dob?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_seen_at?: Maybe<Scalars['timestamp']['output']>;
  notification_token?: Maybe<Scalars['String']['output']>;
  notification_token_food?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type User_Profiles_Min_Fields = {
  __typename?: 'user_profiles_min_fields';
  avatar_url?: Maybe<Scalars['String']['output']>;
  blood_group?: Maybe<Scalars['blood_group_enum']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  dob?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_seen_at?: Maybe<Scalars['timestamp']['output']>;
  notification_token?: Maybe<Scalars['String']['output']>;
  notification_token_food?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "user_profiles" */
export type User_Profiles_Mutation_Response = {
  __typename?: 'user_profiles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Profiles>;
};

/** input type for inserting object relation for remote table "user_profiles" */
export type User_Profiles_Obj_Rel_Insert_Input = {
  data: User_Profiles_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Profiles_On_Conflict>;
};

/** on_conflict condition type for table "user_profiles" */
export type User_Profiles_On_Conflict = {
  constraint: User_Profiles_Constraint;
  update_columns?: Array<User_Profiles_Update_Column>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
};

/** Ordering options when selecting data from "user_profiles". */
export type User_Profiles_Order_By = {
  avatar_url?: InputMaybe<Order_By>;
  blood_donation_consent?: InputMaybe<Order_By>;
  blood_group?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dob?: InputMaybe<Order_By>;
  free_rides_aggregate?: InputMaybe<Free_Rides_Aggregate_Order_By>;
  full_name?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_location?: InputMaybe<Order_By>;
  last_seen_at?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  notification_token?: InputMaybe<Order_By>;
  notification_token_food?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_profiles */
export type User_Profiles_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type User_Profiles_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "user_profiles" */
export enum User_Profiles_Select_Column {
  /** column name */
  AvatarUrl = 'avatar_url',
  /** column name */
  BloodDonationConsent = 'blood_donation_consent',
  /** column name */
  BloodGroup = 'blood_group',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Dob = 'dob',
  /** column name */
  FullName = 'full_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastLocation = 'last_location',
  /** column name */
  LastSeenAt = 'last_seen_at',
  /** column name */
  Location = 'location',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NotificationToken = 'notification_token',
  /** column name */
  NotificationTokenFood = 'notification_token_food',
  /** column name */
  Phone = 'phone',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_profiles" */
export type User_Profiles_Set_Input = {
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  blood_donation_consent?: InputMaybe<Scalars['Boolean']['input']>;
  blood_group?: InputMaybe<Scalars['blood_group_enum']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_location?: InputMaybe<Scalars['geography']['input']>;
  last_seen_at?: InputMaybe<Scalars['timestamp']['input']>;
  location?: InputMaybe<Scalars['geography']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  notification_token?: InputMaybe<Scalars['String']['input']>;
  notification_token_food?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "user_profiles" */
export type User_Profiles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Profiles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Profiles_Stream_Cursor_Value_Input = {
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  blood_donation_consent?: InputMaybe<Scalars['Boolean']['input']>;
  blood_group?: InputMaybe<Scalars['blood_group_enum']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_location?: InputMaybe<Scalars['geography']['input']>;
  last_seen_at?: InputMaybe<Scalars['timestamp']['input']>;
  location?: InputMaybe<Scalars['geography']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  notification_token?: InputMaybe<Scalars['String']['input']>;
  notification_token_food?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "user_profiles" */
export enum User_Profiles_Update_Column {
  /** column name */
  AvatarUrl = 'avatar_url',
  /** column name */
  BloodDonationConsent = 'blood_donation_consent',
  /** column name */
  BloodGroup = 'blood_group',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Dob = 'dob',
  /** column name */
  FullName = 'full_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastLocation = 'last_location',
  /** column name */
  LastSeenAt = 'last_seen_at',
  /** column name */
  Location = 'location',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NotificationToken = 'notification_token',
  /** column name */
  NotificationTokenFood = 'notification_token_food',
  /** column name */
  Phone = 'phone',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type User_Profiles_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<User_Profiles_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<User_Profiles_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<User_Profiles_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<User_Profiles_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<User_Profiles_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Profiles_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Profiles_Bool_Exp;
};

/** columns and relationships of "user_settings" */
export type User_Settings = {
  __typename?: 'user_settings';
  app_settings: Scalars['jsonb']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  language: Scalars['String']['output'];
  notification_preference: Scalars['jsonb']['output'];
  timezone: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};


/** columns and relationships of "user_settings" */
export type User_SettingsApp_SettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "user_settings" */
export type User_SettingsNotification_PreferenceArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "user_settings" */
export type User_Settings_Aggregate = {
  __typename?: 'user_settings_aggregate';
  aggregate?: Maybe<User_Settings_Aggregate_Fields>;
  nodes: Array<User_Settings>;
};

/** aggregate fields of "user_settings" */
export type User_Settings_Aggregate_Fields = {
  __typename?: 'user_settings_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Settings_Max_Fields>;
  min?: Maybe<User_Settings_Min_Fields>;
};


/** aggregate fields of "user_settings" */
export type User_Settings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Settings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type User_Settings_Append_Input = {
  app_settings?: InputMaybe<Scalars['jsonb']['input']>;
  notification_preference?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "user_settings". All fields are combined with a logical 'AND'. */
export type User_Settings_Bool_Exp = {
  _and?: InputMaybe<Array<User_Settings_Bool_Exp>>;
  _not?: InputMaybe<User_Settings_Bool_Exp>;
  _or?: InputMaybe<Array<User_Settings_Bool_Exp>>;
  app_settings?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  language?: InputMaybe<String_Comparison_Exp>;
  notification_preference?: InputMaybe<Jsonb_Comparison_Exp>;
  timezone?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_settings" */
export enum User_Settings_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserSettingsPkey = 'user_settings_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type User_Settings_Delete_At_Path_Input = {
  app_settings?: InputMaybe<Array<Scalars['String']['input']>>;
  notification_preference?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type User_Settings_Delete_Elem_Input = {
  app_settings?: InputMaybe<Scalars['Int']['input']>;
  notification_preference?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type User_Settings_Delete_Key_Input = {
  app_settings?: InputMaybe<Scalars['String']['input']>;
  notification_preference?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "user_settings" */
export type User_Settings_Insert_Input = {
  app_settings?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  notification_preference?: InputMaybe<Scalars['jsonb']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type User_Settings_Max_Fields = {
  __typename?: 'user_settings_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type User_Settings_Min_Fields = {
  __typename?: 'user_settings_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "user_settings" */
export type User_Settings_Mutation_Response = {
  __typename?: 'user_settings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Settings>;
};

/** on_conflict condition type for table "user_settings" */
export type User_Settings_On_Conflict = {
  constraint: User_Settings_Constraint;
  update_columns?: Array<User_Settings_Update_Column>;
  where?: InputMaybe<User_Settings_Bool_Exp>;
};

/** Ordering options when selecting data from "user_settings". */
export type User_Settings_Order_By = {
  app_settings?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  notification_preference?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_settings */
export type User_Settings_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type User_Settings_Prepend_Input = {
  app_settings?: InputMaybe<Scalars['jsonb']['input']>;
  notification_preference?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "user_settings" */
export enum User_Settings_Select_Column {
  /** column name */
  AppSettings = 'app_settings',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Language = 'language',
  /** column name */
  NotificationPreference = 'notification_preference',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_settings" */
export type User_Settings_Set_Input = {
  app_settings?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  notification_preference?: InputMaybe<Scalars['jsonb']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "user_settings" */
export type User_Settings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Settings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Settings_Stream_Cursor_Value_Input = {
  app_settings?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  notification_preference?: InputMaybe<Scalars['jsonb']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "user_settings" */
export enum User_Settings_Update_Column {
  /** column name */
  AppSettings = 'app_settings',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Language = 'language',
  /** column name */
  NotificationPreference = 'notification_preference',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type User_Settings_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<User_Settings_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<User_Settings_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<User_Settings_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<User_Settings_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<User_Settings_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Settings_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Settings_Bool_Exp;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type Users = {
  __typename?: 'users';
  activeMfaType?: Maybe<Scalars['String']['output']>;
  avatarUrl: Scalars['String']['output'];
  /** An object relationship */
  carrier?: Maybe<Carrier>;
  createdAt: Scalars['timestamptz']['output'];
  currentChallenge?: Maybe<Scalars['String']['output']>;
  defaultRole: Scalars['String']['output'];
  /** An object relationship */
  defaultRoleByRole: AuthRoles;
  disabled: Scalars['Boolean']['output'];
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['citext']['output']>;
  emailVerified: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  lastSeen?: Maybe<Scalars['timestamptz']['output']>;
  locale: Scalars['String']['output'];
  metadata?: Maybe<Scalars['jsonb']['output']>;
  newEmail?: Maybe<Scalars['citext']['output']>;
  otpHash?: Maybe<Scalars['String']['output']>;
  otpHashExpiresAt: Scalars['timestamptz']['output'];
  otpMethodLastUsed?: Maybe<Scalars['String']['output']>;
  passwordHash?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberVerified: Scalars['Boolean']['output'];
  /** An array relationship */
  refreshTokens: Array<AuthRefreshTokens>;
  /** An aggregate relationship */
  refreshTokens_aggregate: AuthRefreshTokens_Aggregate;
  /** An object relationship */
  restaurant?: Maybe<Restaurant>;
  /** An array relationship */
  roles: Array<AuthUserRoles>;
  /** An aggregate relationship */
  roles_aggregate: AuthUserRoles_Aggregate;
  /** An array relationship */
  securityKeys: Array<AuthUserSecurityKeys>;
  /** An aggregate relationship */
  securityKeys_aggregate: AuthUserSecurityKeys_Aggregate;
  ticket?: Maybe<Scalars['String']['output']>;
  ticketExpiresAt: Scalars['timestamptz']['output'];
  totpSecret?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  userProviders: Array<AuthUserProviders>;
  /** An aggregate relationship */
  userProviders_aggregate: AuthUserProviders_Aggregate;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersRefreshTokensArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersRefreshTokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersRolesArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersSecurityKeysArgs = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersSecurityKeys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersUserProvidersArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersUserProviders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};

/** aggregated selection of "auth.users" */
export type Users_Aggregate = {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

export type Users_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Users_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Users_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Users_Aggregate_Bool_Exp_Count>;
};

export type Users_Aggregate_Bool_Exp_Bool_And = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.users" */
export type Users_Aggregate_Fields = {
  __typename?: 'users_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
};


/** aggregate fields of "auth.users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "auth.users" */
export type Users_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Users_Max_Order_By>;
  min?: InputMaybe<Users_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Users_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "auth.users" */
export type Users_Arr_Rel_Insert_Input = {
  data: Array<Users_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  activeMfaType?: InputMaybe<String_Comparison_Exp>;
  avatarUrl?: InputMaybe<String_Comparison_Exp>;
  carrier?: InputMaybe<Carrier_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  currentChallenge?: InputMaybe<String_Comparison_Exp>;
  defaultRole?: InputMaybe<String_Comparison_Exp>;
  defaultRoleByRole?: InputMaybe<AuthRoles_Bool_Exp>;
  disabled?: InputMaybe<Boolean_Comparison_Exp>;
  displayName?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<Citext_Comparison_Exp>;
  emailVerified?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isAnonymous?: InputMaybe<Boolean_Comparison_Exp>;
  lastSeen?: InputMaybe<Timestamptz_Comparison_Exp>;
  locale?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  newEmail?: InputMaybe<Citext_Comparison_Exp>;
  otpHash?: InputMaybe<String_Comparison_Exp>;
  otpHashExpiresAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  otpMethodLastUsed?: InputMaybe<String_Comparison_Exp>;
  passwordHash?: InputMaybe<String_Comparison_Exp>;
  phoneNumber?: InputMaybe<String_Comparison_Exp>;
  phoneNumberVerified?: InputMaybe<Boolean_Comparison_Exp>;
  refreshTokens?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
  refreshTokens_aggregate?: InputMaybe<AuthRefreshTokens_Aggregate_Bool_Exp>;
  restaurant?: InputMaybe<Restaurant_Bool_Exp>;
  roles?: InputMaybe<AuthUserRoles_Bool_Exp>;
  roles_aggregate?: InputMaybe<AuthUserRoles_Aggregate_Bool_Exp>;
  securityKeys?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
  securityKeys_aggregate?: InputMaybe<AuthUserSecurityKeys_Aggregate_Bool_Exp>;
  ticket?: InputMaybe<String_Comparison_Exp>;
  ticketExpiresAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  totpSecret?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userProviders?: InputMaybe<AuthUserProviders_Bool_Exp>;
  userProviders_aggregate?: InputMaybe<AuthUserProviders_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "auth.users" */
export enum Users_Constraint {
  /** unique or primary key constraint on columns "email" */
  UsersEmailKey = 'users_email_key',
  /** unique or primary key constraint on columns "phone_number" */
  UsersPhoneNumberKey = 'users_phone_number_key',
  /** unique or primary key constraint on columns "id" */
  UsersPkey = 'users_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Users_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Users_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Users_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "auth.users" */
export type Users_Insert_Input = {
  activeMfaType?: InputMaybe<Scalars['String']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  carrier?: InputMaybe<Carrier_Obj_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  currentChallenge?: InputMaybe<Scalars['String']['input']>;
  defaultRole?: InputMaybe<Scalars['String']['input']>;
  defaultRoleByRole?: InputMaybe<AuthRoles_Obj_Rel_Insert_Input>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['citext']['input']>;
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  lastSeen?: InputMaybe<Scalars['timestamptz']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  newEmail?: InputMaybe<Scalars['citext']['input']>;
  otpHash?: InputMaybe<Scalars['String']['input']>;
  otpHashExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  otpMethodLastUsed?: InputMaybe<Scalars['String']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberVerified?: InputMaybe<Scalars['Boolean']['input']>;
  refreshTokens?: InputMaybe<AuthRefreshTokens_Arr_Rel_Insert_Input>;
  restaurant?: InputMaybe<Restaurant_Obj_Rel_Insert_Input>;
  roles?: InputMaybe<AuthUserRoles_Arr_Rel_Insert_Input>;
  securityKeys?: InputMaybe<AuthUserSecurityKeys_Arr_Rel_Insert_Input>;
  ticket?: InputMaybe<Scalars['String']['input']>;
  ticketExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  totpSecret?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userProviders?: InputMaybe<AuthUserProviders_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'users_max_fields';
  activeMfaType?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  currentChallenge?: Maybe<Scalars['String']['output']>;
  defaultRole?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['citext']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastSeen?: Maybe<Scalars['timestamptz']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  newEmail?: Maybe<Scalars['citext']['output']>;
  otpHash?: Maybe<Scalars['String']['output']>;
  otpHashExpiresAt?: Maybe<Scalars['timestamptz']['output']>;
  otpMethodLastUsed?: Maybe<Scalars['String']['output']>;
  passwordHash?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  ticket?: Maybe<Scalars['String']['output']>;
  ticketExpiresAt?: Maybe<Scalars['timestamptz']['output']>;
  totpSecret?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "auth.users" */
export type Users_Max_Order_By = {
  activeMfaType?: InputMaybe<Order_By>;
  avatarUrl?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currentChallenge?: InputMaybe<Order_By>;
  defaultRole?: InputMaybe<Order_By>;
  displayName?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastSeen?: InputMaybe<Order_By>;
  locale?: InputMaybe<Order_By>;
  newEmail?: InputMaybe<Order_By>;
  otpHash?: InputMaybe<Order_By>;
  otpHashExpiresAt?: InputMaybe<Order_By>;
  otpMethodLastUsed?: InputMaybe<Order_By>;
  passwordHash?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  ticket?: InputMaybe<Order_By>;
  ticketExpiresAt?: InputMaybe<Order_By>;
  totpSecret?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'users_min_fields';
  activeMfaType?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  currentChallenge?: Maybe<Scalars['String']['output']>;
  defaultRole?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['citext']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastSeen?: Maybe<Scalars['timestamptz']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  newEmail?: Maybe<Scalars['citext']['output']>;
  otpHash?: Maybe<Scalars['String']['output']>;
  otpHashExpiresAt?: Maybe<Scalars['timestamptz']['output']>;
  otpMethodLastUsed?: Maybe<Scalars['String']['output']>;
  passwordHash?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  ticket?: Maybe<Scalars['String']['output']>;
  ticketExpiresAt?: Maybe<Scalars['timestamptz']['output']>;
  totpSecret?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "auth.users" */
export type Users_Min_Order_By = {
  activeMfaType?: InputMaybe<Order_By>;
  avatarUrl?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currentChallenge?: InputMaybe<Order_By>;
  defaultRole?: InputMaybe<Order_By>;
  displayName?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastSeen?: InputMaybe<Order_By>;
  locale?: InputMaybe<Order_By>;
  newEmail?: InputMaybe<Order_By>;
  otpHash?: InputMaybe<Order_By>;
  otpHashExpiresAt?: InputMaybe<Order_By>;
  otpMethodLastUsed?: InputMaybe<Order_By>;
  passwordHash?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  ticket?: InputMaybe<Order_By>;
  ticketExpiresAt?: InputMaybe<Order_By>;
  totpSecret?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.users" */
export type Users_Mutation_Response = {
  __typename?: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "auth.users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** on_conflict condition type for table "auth.users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns?: Array<Users_Update_Column>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.users". */
export type Users_Order_By = {
  activeMfaType?: InputMaybe<Order_By>;
  avatarUrl?: InputMaybe<Order_By>;
  carrier?: InputMaybe<Carrier_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currentChallenge?: InputMaybe<Order_By>;
  defaultRole?: InputMaybe<Order_By>;
  defaultRoleByRole?: InputMaybe<AuthRoles_Order_By>;
  disabled?: InputMaybe<Order_By>;
  displayName?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  emailVerified?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isAnonymous?: InputMaybe<Order_By>;
  lastSeen?: InputMaybe<Order_By>;
  locale?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  newEmail?: InputMaybe<Order_By>;
  otpHash?: InputMaybe<Order_By>;
  otpHashExpiresAt?: InputMaybe<Order_By>;
  otpMethodLastUsed?: InputMaybe<Order_By>;
  passwordHash?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  phoneNumberVerified?: InputMaybe<Order_By>;
  refreshTokens_aggregate?: InputMaybe<AuthRefreshTokens_Aggregate_Order_By>;
  restaurant?: InputMaybe<Restaurant_Order_By>;
  roles_aggregate?: InputMaybe<AuthUserRoles_Aggregate_Order_By>;
  securityKeys_aggregate?: InputMaybe<AuthUserSecurityKeys_Aggregate_Order_By>;
  ticket?: InputMaybe<Order_By>;
  ticketExpiresAt?: InputMaybe<Order_By>;
  totpSecret?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userProviders_aggregate?: InputMaybe<AuthUserProviders_Aggregate_Order_By>;
};

/** primary key columns input for table: auth.users */
export type Users_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Users_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "auth.users" */
export enum Users_Select_Column {
  /** column name */
  ActiveMfaType = 'activeMfaType',
  /** column name */
  AvatarUrl = 'avatarUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CurrentChallenge = 'currentChallenge',
  /** column name */
  DefaultRole = 'defaultRole',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  Email = 'email',
  /** column name */
  EmailVerified = 'emailVerified',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnonymous = 'isAnonymous',
  /** column name */
  LastSeen = 'lastSeen',
  /** column name */
  Locale = 'locale',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NewEmail = 'newEmail',
  /** column name */
  OtpHash = 'otpHash',
  /** column name */
  OtpHashExpiresAt = 'otpHashExpiresAt',
  /** column name */
  OtpMethodLastUsed = 'otpMethodLastUsed',
  /** column name */
  PasswordHash = 'passwordHash',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  PhoneNumberVerified = 'phoneNumberVerified',
  /** column name */
  Ticket = 'ticket',
  /** column name */
  TicketExpiresAt = 'ticketExpiresAt',
  /** column name */
  TotpSecret = 'totpSecret',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "users_aggregate_bool_exp_bool_and_arguments_columns" columns of table "auth.users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Disabled = 'disabled',
  /** column name */
  EmailVerified = 'emailVerified',
  /** column name */
  IsAnonymous = 'isAnonymous',
  /** column name */
  PhoneNumberVerified = 'phoneNumberVerified'
}

/** select "users_aggregate_bool_exp_bool_or_arguments_columns" columns of table "auth.users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Disabled = 'disabled',
  /** column name */
  EmailVerified = 'emailVerified',
  /** column name */
  IsAnonymous = 'isAnonymous',
  /** column name */
  PhoneNumberVerified = 'phoneNumberVerified'
}

/** input type for updating data in table "auth.users" */
export type Users_Set_Input = {
  activeMfaType?: InputMaybe<Scalars['String']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  currentChallenge?: InputMaybe<Scalars['String']['input']>;
  defaultRole?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['citext']['input']>;
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  lastSeen?: InputMaybe<Scalars['timestamptz']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  newEmail?: InputMaybe<Scalars['citext']['input']>;
  otpHash?: InputMaybe<Scalars['String']['input']>;
  otpHashExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  otpMethodLastUsed?: InputMaybe<Scalars['String']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberVerified?: InputMaybe<Scalars['Boolean']['input']>;
  ticket?: InputMaybe<Scalars['String']['input']>;
  ticketExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  totpSecret?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  activeMfaType?: InputMaybe<Scalars['String']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  currentChallenge?: InputMaybe<Scalars['String']['input']>;
  defaultRole?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['citext']['input']>;
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  lastSeen?: InputMaybe<Scalars['timestamptz']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  newEmail?: InputMaybe<Scalars['citext']['input']>;
  otpHash?: InputMaybe<Scalars['String']['input']>;
  otpHashExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  otpMethodLastUsed?: InputMaybe<Scalars['String']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberVerified?: InputMaybe<Scalars['Boolean']['input']>;
  ticket?: InputMaybe<Scalars['String']['input']>;
  ticketExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  totpSecret?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "auth.users" */
export enum Users_Update_Column {
  /** column name */
  ActiveMfaType = 'activeMfaType',
  /** column name */
  AvatarUrl = 'avatarUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CurrentChallenge = 'currentChallenge',
  /** column name */
  DefaultRole = 'defaultRole',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  Email = 'email',
  /** column name */
  EmailVerified = 'emailVerified',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnonymous = 'isAnonymous',
  /** column name */
  LastSeen = 'lastSeen',
  /** column name */
  Locale = 'locale',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NewEmail = 'newEmail',
  /** column name */
  OtpHash = 'otpHash',
  /** column name */
  OtpHashExpiresAt = 'otpHashExpiresAt',
  /** column name */
  OtpMethodLastUsed = 'otpMethodLastUsed',
  /** column name */
  PasswordHash = 'passwordHash',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  PhoneNumberVerified = 'phoneNumberVerified',
  /** column name */
  Ticket = 'ticket',
  /** column name */
  TicketExpiresAt = 'ticketExpiresAt',
  /** column name */
  TotpSecret = 'totpSecret',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Users_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Users_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Users_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_Bool_Exp;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/** columns and relationships of "vehicle_documents" */
export type Vehicle_Documents = {
  __typename?: 'vehicle_documents';
  created_at: Scalars['timestamptz']['output'];
  document_type?: Maybe<Scalars['document_type_enum']['output']>;
  document_url?: Maybe<Scalars['String']['output']>;
  expiry_date?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  status?: Maybe<Scalars['document_status_enum']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  vehicle: Vehicles;
  vehicle_id: Scalars['uuid']['output'];
};

/** aggregated selection of "vehicle_documents" */
export type Vehicle_Documents_Aggregate = {
  __typename?: 'vehicle_documents_aggregate';
  aggregate?: Maybe<Vehicle_Documents_Aggregate_Fields>;
  nodes: Array<Vehicle_Documents>;
};

export type Vehicle_Documents_Aggregate_Bool_Exp = {
  count?: InputMaybe<Vehicle_Documents_Aggregate_Bool_Exp_Count>;
};

export type Vehicle_Documents_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Vehicle_Documents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vehicle_Documents_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vehicle_documents" */
export type Vehicle_Documents_Aggregate_Fields = {
  __typename?: 'vehicle_documents_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Vehicle_Documents_Max_Fields>;
  min?: Maybe<Vehicle_Documents_Min_Fields>;
};


/** aggregate fields of "vehicle_documents" */
export type Vehicle_Documents_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vehicle_Documents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "vehicle_documents" */
export type Vehicle_Documents_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vehicle_Documents_Max_Order_By>;
  min?: InputMaybe<Vehicle_Documents_Min_Order_By>;
};

/** input type for inserting array relation for remote table "vehicle_documents" */
export type Vehicle_Documents_Arr_Rel_Insert_Input = {
  data: Array<Vehicle_Documents_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Vehicle_Documents_On_Conflict>;
};

/** Boolean expression to filter rows from the table "vehicle_documents". All fields are combined with a logical 'AND'. */
export type Vehicle_Documents_Bool_Exp = {
  _and?: InputMaybe<Array<Vehicle_Documents_Bool_Exp>>;
  _not?: InputMaybe<Vehicle_Documents_Bool_Exp>;
  _or?: InputMaybe<Array<Vehicle_Documents_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  document_type?: InputMaybe<Document_Type_Enum_Comparison_Exp>;
  document_url?: InputMaybe<String_Comparison_Exp>;
  expiry_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Document_Status_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  vehicle?: InputMaybe<Vehicles_Bool_Exp>;
  vehicle_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "vehicle_documents" */
export enum Vehicle_Documents_Constraint {
  /** unique or primary key constraint on columns "id" */
  VehicleDocumentsPkey = 'vehicle_documents_pkey'
}

/** input type for inserting data into table "vehicle_documents" */
export type Vehicle_Documents_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  document_type?: InputMaybe<Scalars['document_type_enum']['input']>;
  document_url?: InputMaybe<Scalars['String']['input']>;
  expiry_date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['document_status_enum']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  vehicle?: InputMaybe<Vehicles_Obj_Rel_Insert_Input>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Vehicle_Documents_Max_Fields = {
  __typename?: 'vehicle_documents_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  document_type?: Maybe<Scalars['document_type_enum']['output']>;
  document_url?: Maybe<Scalars['String']['output']>;
  expiry_date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['document_status_enum']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "vehicle_documents" */
export type Vehicle_Documents_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  document_url?: InputMaybe<Order_By>;
  expiry_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Vehicle_Documents_Min_Fields = {
  __typename?: 'vehicle_documents_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  document_type?: Maybe<Scalars['document_type_enum']['output']>;
  document_url?: Maybe<Scalars['String']['output']>;
  expiry_date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['document_status_enum']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "vehicle_documents" */
export type Vehicle_Documents_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  document_url?: InputMaybe<Order_By>;
  expiry_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "vehicle_documents" */
export type Vehicle_Documents_Mutation_Response = {
  __typename?: 'vehicle_documents_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Vehicle_Documents>;
};

/** on_conflict condition type for table "vehicle_documents" */
export type Vehicle_Documents_On_Conflict = {
  constraint: Vehicle_Documents_Constraint;
  update_columns?: Array<Vehicle_Documents_Update_Column>;
  where?: InputMaybe<Vehicle_Documents_Bool_Exp>;
};

/** Ordering options when selecting data from "vehicle_documents". */
export type Vehicle_Documents_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  document_url?: InputMaybe<Order_By>;
  expiry_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vehicle?: InputMaybe<Vehicles_Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vehicle_documents */
export type Vehicle_Documents_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "vehicle_documents" */
export enum Vehicle_Documents_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentType = 'document_type',
  /** column name */
  DocumentUrl = 'document_url',
  /** column name */
  ExpiryDate = 'expiry_date',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VehicleId = 'vehicle_id'
}

/** input type for updating data in table "vehicle_documents" */
export type Vehicle_Documents_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  document_type?: InputMaybe<Scalars['document_type_enum']['input']>;
  document_url?: InputMaybe<Scalars['String']['input']>;
  expiry_date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['document_status_enum']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "vehicle_documents" */
export type Vehicle_Documents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vehicle_Documents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vehicle_Documents_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  document_type?: InputMaybe<Scalars['document_type_enum']['input']>;
  document_url?: InputMaybe<Scalars['String']['input']>;
  expiry_date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['document_status_enum']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "vehicle_documents" */
export enum Vehicle_Documents_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentType = 'document_type',
  /** column name */
  DocumentUrl = 'document_url',
  /** column name */
  ExpiryDate = 'expiry_date',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VehicleId = 'vehicle_id'
}

export type Vehicle_Documents_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Vehicle_Documents_Set_Input>;
  /** filter the rows which have to be updated */
  where: Vehicle_Documents_Bool_Exp;
};

/** Boolean expression to compare columns of type "vehicle_type_enum". All fields are combined with logical 'AND'. */
export type Vehicle_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['vehicle_type_enum']['input']>;
  _gt?: InputMaybe<Scalars['vehicle_type_enum']['input']>;
  _gte?: InputMaybe<Scalars['vehicle_type_enum']['input']>;
  _in?: InputMaybe<Array<Scalars['vehicle_type_enum']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['vehicle_type_enum']['input']>;
  _lte?: InputMaybe<Scalars['vehicle_type_enum']['input']>;
  _neq?: InputMaybe<Scalars['vehicle_type_enum']['input']>;
  _nin?: InputMaybe<Array<Scalars['vehicle_type_enum']['input']>>;
};

/** columns and relationships of "vehicles" */
export type Vehicles = {
  __typename?: 'vehicles';
  color?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  driver: Drivers;
  driver_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  insurance?: Maybe<Scalars['uuid']['output']>;
  insurance_expiry?: Maybe<Scalars['date']['output']>;
  is_active: Scalars['Boolean']['output'];
  license_plate?: Maybe<Scalars['String']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  registration?: Maybe<Scalars['uuid']['output']>;
  registration_expiry?: Maybe<Scalars['date']['output']>;
  registration_fourth?: Maybe<Scalars['uuid']['output']>;
  registration_second?: Maybe<Scalars['uuid']['output']>;
  registration_third?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  rides: Array<Rides>;
  /** An aggregate relationship */
  rides_aggregate: Rides_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
  vehicle_back?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  vehicle_documents: Array<Vehicle_Documents>;
  /** An aggregate relationship */
  vehicle_documents_aggregate: Vehicle_Documents_Aggregate;
  vehicle_front?: Maybe<Scalars['uuid']['output']>;
  vehicle_type?: Maybe<Scalars['vehicle_type_enum']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "vehicles" */
export type VehiclesRidesArgs = {
  distinct_on?: InputMaybe<Array<Rides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rides_Order_By>>;
  where?: InputMaybe<Rides_Bool_Exp>;
};


/** columns and relationships of "vehicles" */
export type VehiclesRides_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rides_Order_By>>;
  where?: InputMaybe<Rides_Bool_Exp>;
};


/** columns and relationships of "vehicles" */
export type VehiclesVehicle_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Documents_Order_By>>;
  where?: InputMaybe<Vehicle_Documents_Bool_Exp>;
};


/** columns and relationships of "vehicles" */
export type VehiclesVehicle_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Documents_Order_By>>;
  where?: InputMaybe<Vehicle_Documents_Bool_Exp>;
};

/** aggregated selection of "vehicles" */
export type Vehicles_Aggregate = {
  __typename?: 'vehicles_aggregate';
  aggregate?: Maybe<Vehicles_Aggregate_Fields>;
  nodes: Array<Vehicles>;
};

export type Vehicles_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Vehicles_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Vehicles_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Vehicles_Aggregate_Bool_Exp_Count>;
};

export type Vehicles_Aggregate_Bool_Exp_Bool_And = {
  arguments: Vehicles_Select_Column_Vehicles_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vehicles_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Vehicles_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Vehicles_Select_Column_Vehicles_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vehicles_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Vehicles_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Vehicles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vehicles_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vehicles" */
export type Vehicles_Aggregate_Fields = {
  __typename?: 'vehicles_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Vehicles_Max_Fields>;
  min?: Maybe<Vehicles_Min_Fields>;
};


/** aggregate fields of "vehicles" */
export type Vehicles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vehicles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "vehicles" */
export type Vehicles_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vehicles_Max_Order_By>;
  min?: InputMaybe<Vehicles_Min_Order_By>;
};

/** input type for inserting array relation for remote table "vehicles" */
export type Vehicles_Arr_Rel_Insert_Input = {
  data: Array<Vehicles_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Vehicles_On_Conflict>;
};

/** Boolean expression to filter rows from the table "vehicles". All fields are combined with a logical 'AND'. */
export type Vehicles_Bool_Exp = {
  _and?: InputMaybe<Array<Vehicles_Bool_Exp>>;
  _not?: InputMaybe<Vehicles_Bool_Exp>;
  _or?: InputMaybe<Array<Vehicles_Bool_Exp>>;
  color?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  driver?: InputMaybe<Drivers_Bool_Exp>;
  driver_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  insurance?: InputMaybe<Uuid_Comparison_Exp>;
  insurance_expiry?: InputMaybe<Date_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  license_plate?: InputMaybe<String_Comparison_Exp>;
  make?: InputMaybe<String_Comparison_Exp>;
  model?: InputMaybe<String_Comparison_Exp>;
  registration?: InputMaybe<Uuid_Comparison_Exp>;
  registration_expiry?: InputMaybe<Date_Comparison_Exp>;
  registration_fourth?: InputMaybe<Uuid_Comparison_Exp>;
  registration_second?: InputMaybe<Uuid_Comparison_Exp>;
  registration_third?: InputMaybe<Uuid_Comparison_Exp>;
  rides?: InputMaybe<Rides_Bool_Exp>;
  rides_aggregate?: InputMaybe<Rides_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  vehicle_back?: InputMaybe<Uuid_Comparison_Exp>;
  vehicle_documents?: InputMaybe<Vehicle_Documents_Bool_Exp>;
  vehicle_documents_aggregate?: InputMaybe<Vehicle_Documents_Aggregate_Bool_Exp>;
  vehicle_front?: InputMaybe<Uuid_Comparison_Exp>;
  vehicle_type?: InputMaybe<Vehicle_Type_Enum_Comparison_Exp>;
  year?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "vehicles" */
export enum Vehicles_Constraint {
  /** unique or primary key constraint on columns "id" */
  VehiclesPkey = 'vehicles_pkey'
}

/** input type for inserting data into table "vehicles" */
export type Vehicles_Insert_Input = {
  color?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  driver?: InputMaybe<Drivers_Obj_Rel_Insert_Input>;
  driver_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  insurance?: InputMaybe<Scalars['uuid']['input']>;
  insurance_expiry?: InputMaybe<Scalars['date']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  license_plate?: InputMaybe<Scalars['String']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  registration?: InputMaybe<Scalars['uuid']['input']>;
  registration_expiry?: InputMaybe<Scalars['date']['input']>;
  registration_fourth?: InputMaybe<Scalars['uuid']['input']>;
  registration_second?: InputMaybe<Scalars['uuid']['input']>;
  registration_third?: InputMaybe<Scalars['uuid']['input']>;
  rides?: InputMaybe<Rides_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  vehicle_back?: InputMaybe<Scalars['uuid']['input']>;
  vehicle_documents?: InputMaybe<Vehicle_Documents_Arr_Rel_Insert_Input>;
  vehicle_front?: InputMaybe<Scalars['uuid']['input']>;
  vehicle_type?: InputMaybe<Scalars['vehicle_type_enum']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Vehicles_Max_Fields = {
  __typename?: 'vehicles_max_fields';
  color?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  driver_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  insurance?: Maybe<Scalars['uuid']['output']>;
  insurance_expiry?: Maybe<Scalars['date']['output']>;
  license_plate?: Maybe<Scalars['String']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  registration?: Maybe<Scalars['uuid']['output']>;
  registration_expiry?: Maybe<Scalars['date']['output']>;
  registration_fourth?: Maybe<Scalars['uuid']['output']>;
  registration_second?: Maybe<Scalars['uuid']['output']>;
  registration_third?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  vehicle_back?: Maybe<Scalars['uuid']['output']>;
  vehicle_front?: Maybe<Scalars['uuid']['output']>;
  vehicle_type?: Maybe<Scalars['vehicle_type_enum']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "vehicles" */
export type Vehicles_Max_Order_By = {
  color?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  driver_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insurance?: InputMaybe<Order_By>;
  insurance_expiry?: InputMaybe<Order_By>;
  license_plate?: InputMaybe<Order_By>;
  make?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  registration?: InputMaybe<Order_By>;
  registration_expiry?: InputMaybe<Order_By>;
  registration_fourth?: InputMaybe<Order_By>;
  registration_second?: InputMaybe<Order_By>;
  registration_third?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vehicle_back?: InputMaybe<Order_By>;
  vehicle_front?: InputMaybe<Order_By>;
  vehicle_type?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Vehicles_Min_Fields = {
  __typename?: 'vehicles_min_fields';
  color?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  driver_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  insurance?: Maybe<Scalars['uuid']['output']>;
  insurance_expiry?: Maybe<Scalars['date']['output']>;
  license_plate?: Maybe<Scalars['String']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  registration?: Maybe<Scalars['uuid']['output']>;
  registration_expiry?: Maybe<Scalars['date']['output']>;
  registration_fourth?: Maybe<Scalars['uuid']['output']>;
  registration_second?: Maybe<Scalars['uuid']['output']>;
  registration_third?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  vehicle_back?: Maybe<Scalars['uuid']['output']>;
  vehicle_front?: Maybe<Scalars['uuid']['output']>;
  vehicle_type?: Maybe<Scalars['vehicle_type_enum']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "vehicles" */
export type Vehicles_Min_Order_By = {
  color?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  driver_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insurance?: InputMaybe<Order_By>;
  insurance_expiry?: InputMaybe<Order_By>;
  license_plate?: InputMaybe<Order_By>;
  make?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  registration?: InputMaybe<Order_By>;
  registration_expiry?: InputMaybe<Order_By>;
  registration_fourth?: InputMaybe<Order_By>;
  registration_second?: InputMaybe<Order_By>;
  registration_third?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vehicle_back?: InputMaybe<Order_By>;
  vehicle_front?: InputMaybe<Order_By>;
  vehicle_type?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "vehicles" */
export type Vehicles_Mutation_Response = {
  __typename?: 'vehicles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Vehicles>;
};

/** input type for inserting object relation for remote table "vehicles" */
export type Vehicles_Obj_Rel_Insert_Input = {
  data: Vehicles_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Vehicles_On_Conflict>;
};

/** on_conflict condition type for table "vehicles" */
export type Vehicles_On_Conflict = {
  constraint: Vehicles_Constraint;
  update_columns?: Array<Vehicles_Update_Column>;
  where?: InputMaybe<Vehicles_Bool_Exp>;
};

/** Ordering options when selecting data from "vehicles". */
export type Vehicles_Order_By = {
  color?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  driver?: InputMaybe<Drivers_Order_By>;
  driver_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insurance?: InputMaybe<Order_By>;
  insurance_expiry?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  license_plate?: InputMaybe<Order_By>;
  make?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  registration?: InputMaybe<Order_By>;
  registration_expiry?: InputMaybe<Order_By>;
  registration_fourth?: InputMaybe<Order_By>;
  registration_second?: InputMaybe<Order_By>;
  registration_third?: InputMaybe<Order_By>;
  rides_aggregate?: InputMaybe<Rides_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vehicle_back?: InputMaybe<Order_By>;
  vehicle_documents_aggregate?: InputMaybe<Vehicle_Documents_Aggregate_Order_By>;
  vehicle_front?: InputMaybe<Order_By>;
  vehicle_type?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vehicles */
export type Vehicles_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "vehicles" */
export enum Vehicles_Select_Column {
  /** column name */
  Color = 'color',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DriverId = 'driver_id',
  /** column name */
  Id = 'id',
  /** column name */
  Insurance = 'insurance',
  /** column name */
  InsuranceExpiry = 'insurance_expiry',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LicensePlate = 'license_plate',
  /** column name */
  Make = 'make',
  /** column name */
  Model = 'model',
  /** column name */
  Registration = 'registration',
  /** column name */
  RegistrationExpiry = 'registration_expiry',
  /** column name */
  RegistrationFourth = 'registration_fourth',
  /** column name */
  RegistrationSecond = 'registration_second',
  /** column name */
  RegistrationThird = 'registration_third',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VehicleBack = 'vehicle_back',
  /** column name */
  VehicleFront = 'vehicle_front',
  /** column name */
  VehicleType = 'vehicle_type',
  /** column name */
  Year = 'year'
}

/** select "vehicles_aggregate_bool_exp_bool_and_arguments_columns" columns of table "vehicles" */
export enum Vehicles_Select_Column_Vehicles_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "vehicles_aggregate_bool_exp_bool_or_arguments_columns" columns of table "vehicles" */
export enum Vehicles_Select_Column_Vehicles_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "vehicles" */
export type Vehicles_Set_Input = {
  color?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  driver_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  insurance?: InputMaybe<Scalars['uuid']['input']>;
  insurance_expiry?: InputMaybe<Scalars['date']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  license_plate?: InputMaybe<Scalars['String']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  registration?: InputMaybe<Scalars['uuid']['input']>;
  registration_expiry?: InputMaybe<Scalars['date']['input']>;
  registration_fourth?: InputMaybe<Scalars['uuid']['input']>;
  registration_second?: InputMaybe<Scalars['uuid']['input']>;
  registration_third?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  vehicle_back?: InputMaybe<Scalars['uuid']['input']>;
  vehicle_front?: InputMaybe<Scalars['uuid']['input']>;
  vehicle_type?: InputMaybe<Scalars['vehicle_type_enum']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "vehicles" */
export type Vehicles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vehicles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vehicles_Stream_Cursor_Value_Input = {
  color?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  driver_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  insurance?: InputMaybe<Scalars['uuid']['input']>;
  insurance_expiry?: InputMaybe<Scalars['date']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  license_plate?: InputMaybe<Scalars['String']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  registration?: InputMaybe<Scalars['uuid']['input']>;
  registration_expiry?: InputMaybe<Scalars['date']['input']>;
  registration_fourth?: InputMaybe<Scalars['uuid']['input']>;
  registration_second?: InputMaybe<Scalars['uuid']['input']>;
  registration_third?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  vehicle_back?: InputMaybe<Scalars['uuid']['input']>;
  vehicle_front?: InputMaybe<Scalars['uuid']['input']>;
  vehicle_type?: InputMaybe<Scalars['vehicle_type_enum']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "vehicles" */
export enum Vehicles_Update_Column {
  /** column name */
  Color = 'color',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DriverId = 'driver_id',
  /** column name */
  Id = 'id',
  /** column name */
  Insurance = 'insurance',
  /** column name */
  InsuranceExpiry = 'insurance_expiry',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LicensePlate = 'license_plate',
  /** column name */
  Make = 'make',
  /** column name */
  Model = 'model',
  /** column name */
  Registration = 'registration',
  /** column name */
  RegistrationExpiry = 'registration_expiry',
  /** column name */
  RegistrationFourth = 'registration_fourth',
  /** column name */
  RegistrationSecond = 'registration_second',
  /** column name */
  RegistrationThird = 'registration_third',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VehicleBack = 'vehicle_back',
  /** column name */
  VehicleFront = 'vehicle_front',
  /** column name */
  VehicleType = 'vehicle_type',
  /** column name */
  Year = 'year'
}

export type Vehicles_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Vehicles_Set_Input>;
  /** filter the rows which have to be updated */
  where: Vehicles_Bool_Exp;
};

/** columns and relationships of "storage.virus" */
export type Virus = {
  __typename?: 'virus';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  file: Files;
  fileId: Scalars['uuid']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  userSession: Scalars['jsonb']['output'];
  virus: Scalars['String']['output'];
};


/** columns and relationships of "storage.virus" */
export type VirusUserSessionArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "storage.virus" */
export type Virus_Aggregate = {
  __typename?: 'virus_aggregate';
  aggregate?: Maybe<Virus_Aggregate_Fields>;
  nodes: Array<Virus>;
};

/** aggregate fields of "storage.virus" */
export type Virus_Aggregate_Fields = {
  __typename?: 'virus_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Virus_Max_Fields>;
  min?: Maybe<Virus_Min_Fields>;
};


/** aggregate fields of "storage.virus" */
export type Virus_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Virus_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Virus_Append_Input = {
  userSession?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "storage.virus". All fields are combined with a logical 'AND'. */
export type Virus_Bool_Exp = {
  _and?: InputMaybe<Array<Virus_Bool_Exp>>;
  _not?: InputMaybe<Virus_Bool_Exp>;
  _or?: InputMaybe<Array<Virus_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  fileId?: InputMaybe<Uuid_Comparison_Exp>;
  filename?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userSession?: InputMaybe<Jsonb_Comparison_Exp>;
  virus?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "storage.virus" */
export enum Virus_Constraint {
  /** unique or primary key constraint on columns "id" */
  VirusPkey = 'virus_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Virus_Delete_At_Path_Input = {
  userSession?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Virus_Delete_Elem_Input = {
  userSession?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Virus_Delete_Key_Input = {
  userSession?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "storage.virus" */
export type Virus_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userSession?: InputMaybe<Scalars['jsonb']['input']>;
  virus?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Virus_Max_Fields = {
  __typename?: 'virus_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  fileId?: Maybe<Scalars['uuid']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  virus?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Virus_Min_Fields = {
  __typename?: 'virus_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  fileId?: Maybe<Scalars['uuid']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  virus?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "storage.virus" */
export type Virus_Mutation_Response = {
  __typename?: 'virus_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Virus>;
};

/** on_conflict condition type for table "storage.virus" */
export type Virus_On_Conflict = {
  constraint: Virus_Constraint;
  update_columns?: Array<Virus_Update_Column>;
  where?: InputMaybe<Virus_Bool_Exp>;
};

/** Ordering options when selecting data from "storage.virus". */
export type Virus_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  fileId?: InputMaybe<Order_By>;
  filename?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userSession?: InputMaybe<Order_By>;
  virus?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storage.virus */
export type Virus_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Virus_Prepend_Input = {
  userSession?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "storage.virus" */
export enum Virus_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FileId = 'fileId',
  /** column name */
  Filename = 'filename',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserSession = 'userSession',
  /** column name */
  Virus = 'virus'
}

/** input type for updating data in table "storage.virus" */
export type Virus_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userSession?: InputMaybe<Scalars['jsonb']['input']>;
  virus?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "virus" */
export type Virus_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Virus_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Virus_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userSession?: InputMaybe<Scalars['jsonb']['input']>;
  virus?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "storage.virus" */
export enum Virus_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FileId = 'fileId',
  /** column name */
  Filename = 'filename',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserSession = 'userSession',
  /** column name */
  Virus = 'virus'
}

export type Virus_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Virus_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Virus_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Virus_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Virus_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Virus_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Virus_Set_Input>;
  /** filter the rows which have to be updated */
  where: Virus_Bool_Exp;
};

export type GetCarriersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCarriersQuery = { __typename?: 'query_root', carrier: Array<{ __typename?: 'carrier', id: any, location?: any | null, heading?: number | null, name: string, phone?: string | null, status: string, isOnline: boolean, image?: string | null, address?: string | null, verification_status?: any | null, user?: { __typename?: 'users', email?: any | null } | null }> };

export type GetAdminCarriersQueryVariables = Exact<{
  radius: Scalars['Float']['input'];
  from: Scalars['geography']['input'];
}>;


export type GetAdminCarriersQuery = { __typename?: 'query_root', carrier: Array<{ __typename?: 'carrier', id: any, location?: any | null, heading?: number | null, name: string, phone?: string | null, status: string, isOnline: boolean, image?: string | null, address?: string | null, verification_status?: any | null }> };

export type BrodcastOrderMutationVariables = Exact<{
  orderId: Scalars['uuid']['input'];
}>;


export type BrodcastOrderMutation = { __typename?: 'mutation_root', insert_assignment_one?: { __typename?: 'assignment', id: any } | null };

export type AssignOrderMutationVariables = Exact<{
  orderId: Scalars['uuid']['input'];
  carrierId: Scalars['uuid']['input'];
  status: Scalars['String']['input'];
}>;


export type AssignOrderMutation = { __typename?: 'mutation_root', insert_assignment_one?: { __typename?: 'assignment', id: any } | null };

export type UpdateAssignmentByPkMutationVariables = Exact<{
  pk_columns: Assignment_Pk_Columns_Input;
  _set: Assignment_Set_Input;
}>;


export type UpdateAssignmentByPkMutation = { __typename?: 'mutation_root', update_assignment_by_pk?: { __typename?: 'assignment', id: any } | null };

export type UpdateAssignmentByOrderIdMutationVariables = Exact<{
  orderId: Scalars['uuid']['input'];
  carrierId: Scalars['uuid']['input'];
}>;


export type UpdateAssignmentByOrderIdMutation = { __typename?: 'mutation_root', update_assignment?: { __typename?: 'assignment_mutation_response', returning: Array<{ __typename?: 'assignment', id: any }> } | null };

export type GetCarrierQueryVariables = Exact<{
  carrierId: Scalars['uuid']['input'];
}>;


export type GetCarrierQuery = { __typename?: 'query_root', carrier_by_pk?: { __typename?: 'carrier', id: any, location?: any | null, heading?: number | null, name: string, phone?: string | null, status: string, isOnline: boolean, image?: string | null, address?: string | null, verification_status?: any | null, restaurantId?: any | null, restaurant?: { __typename?: 'restaurant', id: any, name: string } | null, user?: { __typename?: 'users', email?: any | null } | null } | null };

export type GetCarrierByIdSubscriptionVariables = Exact<{
  carrierId: Scalars['uuid']['input'];
}>;


export type GetCarrierByIdSubscription = { __typename?: 'subscription_root', carrier_by_pk?: { __typename?: 'carrier', id: any, location?: any | null, heading?: number | null, name: string, phone?: string | null, status: string, isOnline: boolean, image?: string | null, address?: string | null, verification_status?: any | null, user?: { __typename?: 'users', email?: any | null } | null } | null };

export type SearchCarrierQueryVariables = Exact<{
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchCarrierQuery = { __typename?: 'query_root', carrier: Array<{ __typename?: 'carrier', id: any, location?: any | null, heading?: number | null, name: string, phone?: string | null, status: string, isOnline: boolean, image?: string | null, address?: string | null, verification_status?: any | null, user?: { __typename?: 'users', email?: any | null } | null }> };

export type UpdateCarrierByPkMutationVariables = Exact<{
  pk_columns: Carrier_Pk_Columns_Input;
  _set: Carrier_Set_Input;
}>;


export type UpdateCarrierByPkMutation = { __typename?: 'mutation_root', update_carrier_by_pk?: { __typename?: 'carrier', id: any } | null };

export type InsertCarrierOneMutationVariables = Exact<{
  insert_carrier_inputs: Carrier_Insert_Input;
}>;


export type InsertCarrierOneMutation = { __typename?: 'mutation_root', insert_carrier_one?: { __typename?: 'carrier', id: any } | null };

export type GetAllCategoriesQueryVariables = Exact<{
  order_by?: InputMaybe<Array<Category_Order_By> | Category_Order_By>;
}>;


export type GetAllCategoriesQuery = { __typename?: 'query_root', category: Array<{ __typename?: 'category', id: any, name: string }> };

export type InsertCategoryOneMutationVariables = Exact<{
  object: Category_Insert_Input;
}>;


export type InsertCategoryOneMutation = { __typename?: 'mutation_root', insert_category_one?: { __typename?: 'category', name: string } | null };

export type UpdateCategoryByPkMutationVariables = Exact<{
  pk_columns: Category_Pk_Columns_Input;
  _set: Category_Set_Input;
}>;


export type UpdateCategoryByPkMutation = { __typename?: 'mutation_root', update_category_by_pk?: { __typename?: 'category', name: string } | null };

export type DeleteCategoryByPkMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteCategoryByPkMutation = { __typename?: 'mutation_root', delete_category_by_pk?: { __typename?: 'category', name: string } | null };

export type GetRestaurantCategoryDishesQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  category_order_by?: InputMaybe<Array<Category_Order_By> | Category_Order_By>;
  dish_order_by?: InputMaybe<Array<Dish_Order_By> | Dish_Order_By>;
}>;


export type GetRestaurantCategoryDishesQuery = { __typename?: 'query_root', category: Array<{ __typename?: 'category', name: string, id: any, dishes_aggregate: { __typename?: 'dish_aggregate', aggregate?: { __typename?: 'dish_aggregate_fields', count: number } | null }, dishes: Array<{ __typename?: 'dish', name: string, id: any, image?: any | null, price: string, isActive?: boolean | null, type?: string | null, category?: { __typename?: 'category', id: any, name: string } | null, restaurant: { __typename?: 'restaurant', name: string, id: any } }> }> };

export type GetAllCategoryDishesQueryVariables = Exact<{
  category_order_by?: InputMaybe<Array<Category_Order_By> | Category_Order_By>;
  dish_order_by?: InputMaybe<Array<Dish_Order_By> | Dish_Order_By>;
}>;


export type GetAllCategoryDishesQuery = { __typename?: 'query_root', category: Array<{ __typename?: 'category', name: string, id: any, image?: any | null, dishes_aggregate: { __typename?: 'dish_aggregate', aggregate?: { __typename?: 'dish_aggregate_fields', count: number } | null }, dishes: Array<{ __typename?: 'dish', id: any, name: string, image?: any | null, price: string, isActive?: boolean | null, type?: string | null, restaurantId: any, category?: { __typename?: 'category', id: any, name: string } | null, restaurant: { __typename?: 'restaurant', name: string, id: any } }> }> };

export type UpdateDishByPkMutationVariables = Exact<{
  pk_columns: Dish_Pk_Columns_Input;
  _set: Dish_Set_Input;
}>;


export type UpdateDishByPkMutation = { __typename?: 'mutation_root', update_dish_by_pk?: { __typename?: 'dish', id: any } | null };

export type DeleteDishByPkMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteDishByPkMutation = { __typename?: 'mutation_root', delete_dish_by_pk?: { __typename?: 'dish', id: any } | null };

export type InsertDishOneMutationVariables = Exact<{
  object: Dish_Insert_Input;
}>;


export type InsertDishOneMutation = { __typename?: 'mutation_root', insert_dish_one?: { __typename?: 'dish', id: any } | null };

export type GetOwnDishesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOwnDishesQuery = { __typename?: 'query_root', dish: Array<{ __typename?: 'dish', name: string, price: string, id: any, image?: any | null, category?: { __typename?: 'category', name: string } | null }> };

export type GetAllDriversQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAllDriversQuery = { __typename?: 'query_root', drivers: Array<{ __typename?: 'drivers', id: any, is_active: boolean, is_busy: boolean, local_unit?: string | null, name?: string | null, phone_number?: string | null, ward_no?: string | null, gender?: string | null, verification_status?: any | null, created_at: any, driver_locations_current?: { __typename?: 'driver_locations_current', location?: any | null, updated_at?: any | null } | null, vehicle?: { __typename?: 'vehicles', id: any, vehicle_type?: any | null } | null, completedRides: { __typename?: 'free_rides_aggregate', aggregate?: { __typename?: 'free_rides_aggregate_fields', count: number } | null }, totalRides: { __typename?: 'free_rides_aggregate', aggregate?: { __typename?: 'free_rides_aggregate_fields', count: number } | null } }>, drivers_aggregate: { __typename?: 'drivers_aggregate', aggregate?: { __typename?: 'drivers_aggregate_fields', count: number } | null } };

export type GetDriverByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetDriverByIdQuery = { __typename?: 'query_root', drivers_by_pk?: { __typename?: 'drivers', id: any, is_active: boolean, is_busy: boolean, license_number?: string | null, local_unit?: string | null, license?: any | null, name?: string | null, notification_token?: string | null, phone_number?: string | null, profile?: any | null, province?: string | null, selfie?: any | null, street_address?: string | null, updated_at: any, ward_no?: string | null, gender?: string | null, dob?: string | null, district?: string | null, verification_status?: any | null, rejection_reason?: string | null, created_at: any, blood_group?: any | null, blood_donation_consent: boolean, driver_locations_current?: { __typename?: 'driver_locations_current', location?: any | null, updated_at?: any | null } | null, ratings_aggregate: { __typename?: 'ratings_aggregate', aggregate?: { __typename?: 'ratings_aggregate_fields', avg?: { __typename?: 'ratings_avg_fields', rating?: number | null } | null } | null }, free_rides_aggregate: { __typename?: 'free_rides_aggregate', aggregate?: { __typename?: 'free_rides_aggregate_fields', count: number } | null }, totalRides: { __typename?: 'free_rides_aggregate', aggregate?: { __typename?: 'free_rides_aggregate_fields', count: number } | null }, vehicle?: { __typename?: 'vehicles', id: any, color?: string | null, make?: string | null, model?: string | null, license_plate?: string | null, registration?: any | null, registration_second?: any | null, vehicle_type?: any | null, vehicle_front?: any | null, insurance?: any | null } | null, user: { __typename?: 'users', email?: any | null } } | null };

export type GetFilteredDriversQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  verification_status?: InputMaybe<Array<Scalars['document_status_enum']['input']> | Scalars['document_status_enum']['input']>;
}>;


export type GetFilteredDriversQuery = { __typename?: 'query_root', drivers: Array<{ __typename?: 'drivers', id: any, is_active: boolean, is_busy: boolean, name?: string | null, phone_number?: string | null, province?: string | null, local_unit?: string | null, street_address?: string | null, updated_at: any, ward_no?: string | null, gender?: string | null, dob?: string | null, verification_status?: any | null, created_at: any, driver_locations_current?: { __typename?: 'driver_locations_current', updated_at?: any | null } | null, ratings_aggregate: { __typename?: 'ratings_aggregate', aggregate?: { __typename?: 'ratings_aggregate_fields', avg?: { __typename?: 'ratings_avg_fields', rating?: number | null } | null } | null }, free_rides_aggregate: { __typename?: 'free_rides_aggregate', aggregate?: { __typename?: 'free_rides_aggregate_fields', count: number } | null }, vehicle?: { __typename?: 'vehicles', id: any, vehicle_type?: any | null, make?: string | null, model?: string | null, license_plate?: string | null } | null, user: { __typename?: 'users', email?: any | null } }> };

export type GetDriversCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDriversCountQuery = { __typename?: 'query_root', total: { __typename?: 'drivers_aggregate', aggregate?: { __typename?: 'drivers_aggregate_fields', count: number } | null }, verified: { __typename?: 'drivers_aggregate', aggregate?: { __typename?: 'drivers_aggregate_fields', count: number } | null }, pending: { __typename?: 'drivers_aggregate', aggregate?: { __typename?: 'drivers_aggregate_fields', count: number } | null }, reviewing: { __typename?: 'drivers_aggregate', aggregate?: { __typename?: 'drivers_aggregate_fields', count: number } | null }, rejected: { __typename?: 'drivers_aggregate', aggregate?: { __typename?: 'drivers_aggregate_fields', count: number } | null }, conditional: { __typename?: 'drivers_aggregate', aggregate?: { __typename?: 'drivers_aggregate_fields', count: number } | null }, processing: { __typename?: 'drivers_aggregate', aggregate?: { __typename?: 'drivers_aggregate_fields', count: number } | null }, scooter: { __typename?: 'drivers_aggregate', aggregate?: { __typename?: 'drivers_aggregate_fields', count: number } | null }, motorcycle: { __typename?: 'drivers_aggregate', aggregate?: { __typename?: 'drivers_aggregate_fields', count: number } | null }, car: { __typename?: 'drivers_aggregate', aggregate?: { __typename?: 'drivers_aggregate_fields', count: number } | null }, toto: { __typename?: 'drivers_aggregate', aggregate?: { __typename?: 'drivers_aggregate_fields', count: number } | null }, auto: { __typename?: 'drivers_aggregate', aggregate?: { __typename?: 'drivers_aggregate_fields', count: number } | null }, no_vehicle: { __typename?: 'drivers_aggregate', aggregate?: { __typename?: 'drivers_aggregate_fields', count: number } | null } };

export type SearchDriverQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
}>;


export type SearchDriverQuery = { __typename?: 'query_root', drivers: Array<{ __typename?: 'drivers', id: any, name?: string | null, phone_number?: string | null, local_unit?: string | null }> };

export type UpdateDriverByPkMutationVariables = Exact<{
  pk_columns: Drivers_Pk_Columns_Input;
  _set: Drivers_Set_Input;
}>;


export type UpdateDriverByPkMutation = { __typename?: 'mutation_root', update_drivers_by_pk?: { __typename?: 'drivers', id: any } | null };

export type GetOrderbyPkQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetOrderbyPkQuery = { __typename?: 'query_root', order_by_pk?: { __typename?: 'order', id: any, dropoffLocation?: any | null, deliveryCharge?: any | null, cancelReason?: string | null, note?: string | null, phoneNumber?: any | null, receiverName?: string | null, direction?: string | null, status: string, subTotal?: any | null, deliveredBy: string, updated_at: any, created_at: any, address?: string | null, basket: { __typename?: 'basket', id: any, restaurant: { __typename?: 'restaurant', name: string, phone?: string | null, id: any, location?: any | null, carriers: Array<{ __typename?: 'carrier', id: any, name: string, phone?: string | null, image?: string | null }> }, basket_dishes: Array<{ __typename?: 'basket_dish', quantity: number, id: any, dish: { __typename?: 'dish', id: any, image?: any | null, name: string, price: string } }> }, assignment?: { __typename?: 'assignment', id: any, status: string, carrier?: { __typename?: 'carrier', name: string, id: any, location?: any | null, phone?: string | null, status: string } | null } | null } | null };

export type GetPendingOrdersSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GetPendingOrdersSubscription = { __typename?: 'subscription_root', order: Array<{ __typename?: 'order', id: any, note?: string | null, phoneNumber?: any | null, receiverName?: string | null, status: string, subTotal?: any | null, deliveredBy: string, dropoffLocation?: any | null, deliveryCharge?: any | null, cancelReason?: string | null, address?: string | null, direction?: string | null, created_at: any, updated_at: any, basket: { __typename?: 'basket', id: any, restaurant: { __typename?: 'restaurant', id: any, name: string, phone?: string | null, admin_commission?: number | null }, basket_dishes: Array<{ __typename?: 'basket_dish', id: any, quantity: number, dish: { __typename?: 'dish', name: string, price: string, id: any } }> }, assignment?: { __typename?: 'assignment', carrier?: { __typename?: 'carrier', name: string, id: any, phone?: string | null, status: string } | null } | null }> };

export type UpdateOrderStatusMutationVariables = Exact<{
  pk_columns: Order_Pk_Columns_Input;
  _set: Order_Set_Input;
}>;


export type UpdateOrderStatusMutation = { __typename?: 'mutation_root', update_order_by_pk?: { __typename?: 'order', id: any, basket: { __typename?: 'basket', id: any, receiver?: { __typename?: 'user_profiles', notification_token_food?: string | null } | null } } | null };

export type GetIncludedOrdersQueryVariables = Exact<{
  includedStates?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  order_by?: InputMaybe<Array<Order_Order_By> | Order_Order_By>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  restaurantId: Scalars['uuid']['input'];
}>;


export type GetIncludedOrdersQuery = { __typename?: 'query_root', order: Array<{ __typename?: 'order', id: any, note?: string | null, phoneNumber?: any | null, receiverName?: string | null, status: string, subTotal?: any | null, deliveredBy: string, dropoffLocation?: any | null, deliveryCharge?: any | null, cancelReason?: string | null, created_at: any, updated_at: any, basket: { __typename?: 'basket', id: any, restaurant: { __typename?: 'restaurant', id: any, name: string, phone?: string | null }, basket_dishes: Array<{ __typename?: 'basket_dish', id: any, quantity: number, dish: { __typename?: 'dish', name: string, price: string, id: any } }> }, assignment?: { __typename?: 'assignment', carrier?: { __typename?: 'carrier', name: string, id: any, phone?: string | null, status: string } | null } | null }> };

export type GetAllUnSettledOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllUnSettledOrdersQuery = { __typename?: 'query_root', orders: Array<{ __typename?: 'order', id: any, subTotal?: any | null, deliveryCharge?: any | null, deliveredBy: string, created_at: any, updated_at: any, basket: { __typename?: 'basket', id: any, restaurant: { __typename?: 'restaurant', id: any, name: string, phone?: string | null, admin_commission?: number | null } } }> };

export type GetSettledOrdersQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['timestamp']['input']>;
  endDate?: InputMaybe<Scalars['timestamp']['input']>;
}>;


export type GetSettledOrdersQuery = { __typename?: 'query_root', settlements: Array<{ __typename?: 'settlement', id: any, restaurantId?: any | null, dishAmount: any, totalDeliveryCharge: any, totalRestaurantEarning?: any | null, totalAdminEarning?: any | null, created_at: any, restaurant?: { __typename?: 'restaurant', id: any, name: string } | null, orders: Array<{ __typename?: 'order', id: any }>, orders_aggregate: { __typename?: 'order_aggregate', aggregate?: { __typename?: 'order_aggregate_fields', count: number } | null } }> };

export type GetRestaurantUnSettledOrdersQueryVariables = Exact<{
  restaurantId: Scalars['uuid']['input'];
}>;


export type GetRestaurantUnSettledOrdersQuery = { __typename?: 'query_root', orders: Array<{ __typename?: 'order', id: any, subTotal?: any | null, deliveryCharge?: any | null, deliveredBy: string, created_at: any, updated_at: any, basket: { __typename?: 'basket', id: any, restaurant: { __typename?: 'restaurant', id: any, name: string, image?: any | null, phone?: string | null, email?: string | null, admin_commission?: number | null }, basket_dishes: Array<{ __typename?: 'basket_dish', id: any, quantity: number, dish: { __typename?: 'dish', name: string, price: string, id: any } }> } }> };

export type GetRestaurantSettledOrdersQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['timestamp']['input']>;
  endDate?: InputMaybe<Scalars['timestamp']['input']>;
  restaurantId: Scalars['uuid']['input'];
}>;


export type GetRestaurantSettledOrdersQuery = { __typename?: 'query_root', settlements: Array<{ __typename?: 'settlement', id: any, restaurantId?: any | null, dishAmount: any, totalDeliveryCharge: any, totalRestaurantEarning?: any | null, totalAdminEarning?: any | null, created_at: any, restaurant?: { __typename?: 'restaurant', id: any, name: string } | null, orders: Array<{ __typename?: 'order', id: any }>, orders_aggregate: { __typename?: 'order_aggregate', aggregate?: { __typename?: 'order_aggregate_fields', count: number } | null } }> };

export type GetSettledOrdersByIdQueryVariables = Exact<{
  settlementId: Scalars['uuid']['input'];
}>;


export type GetSettledOrdersByIdQuery = { __typename?: 'query_root', orders: Array<{ __typename?: 'order', id: any, subTotal?: any | null, deliveryCharge?: any | null, deliveredBy: string, created_at: any, updated_at: any, basket: { __typename?: 'basket', id: any, restaurant: { __typename?: 'restaurant', id: any, name: string, image?: any | null, phone?: string | null, email?: string | null, admin_commission?: number | null }, basket_dishes: Array<{ __typename?: 'basket_dish', id: any, quantity: number, dish: { __typename?: 'dish', name: string, price: string, id: any } }> } }> };

export type InsertSettlementMutationVariables = Exact<{
  restaurantId: Scalars['uuid']['input'];
  dishAmount: Scalars['numeric']['input'];
  totalDeliveryCharge: Scalars['numeric']['input'];
  totalRestaurantEarning: Scalars['numeric']['input'];
  totalAdminEarning: Scalars['numeric']['input'];
}>;


export type InsertSettlementMutation = { __typename?: 'mutation_root', insert_settlement?: { __typename?: 'settlement_mutation_response', returning: Array<{ __typename?: 'settlement', id: any }> } | null };

export type UpdateOrdersWithSettlementMutationVariables = Exact<{
  settlementId: Scalars['uuid']['input'];
  orders: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type UpdateOrdersWithSettlementMutation = { __typename?: 'mutation_root', update_order?: { __typename?: 'order_mutation_response', affected_rows: number } | null };

export type GetTotalOrderSalesQueryVariables = Exact<{
  dateFrom: Scalars['timestamptz']['input'];
  dateTo: Scalars['timestamptz']['input'];
}>;


export type GetTotalOrderSalesQuery = { __typename?: 'query_root', order_aggregate: { __typename?: 'order_aggregate', aggregate?: { __typename?: 'order_aggregate_fields', count: number, sum?: { __typename?: 'order_sum_fields', deliveryCharge?: any | null, subTotal?: any | null } | null } | null } };

export type UpdateOrderByPkMutationVariables = Exact<{
  pk_columns: Order_Pk_Columns_Input;
  _set: Order_Set_Input;
}>;


export type UpdateOrderByPkMutation = { __typename?: 'mutation_root', update_order_by_pk?: { __typename?: 'order', id: any } | null };

export type GetCarrierActiveOrdersQueryVariables = Exact<{
  carrierId: Scalars['uuid']['input'];
}>;


export type GetCarrierActiveOrdersQuery = { __typename?: 'query_root', order: Array<{ __typename?: 'order', id: any, note?: string | null, phoneNumber?: any | null, receiverName?: string | null, status: string, subTotal?: any | null, deliveredBy: string, dropoffLocation?: any | null, deliveryCharge?: any | null, cancelReason?: string | null, created_at: any, updated_at: any, basket: { __typename?: 'basket', id: any, restaurant: { __typename?: 'restaurant', id: any, name: string, phone?: string | null }, basket_dishes: Array<{ __typename?: 'basket_dish', id: any, quantity: number, dish: { __typename?: 'dish', name: string, price: string, id: any } }> }, assignment?: { __typename?: 'assignment', carrier?: { __typename?: 'carrier', name: string, id: any, phone?: string | null, status: string } | null } | null }> };

export type GetCarrierDeliveredOrdersQueryVariables = Exact<{
  carrierId: Scalars['uuid']['input'];
  startDate?: InputMaybe<Scalars['timestamptz']['input']>;
  endDate?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type GetCarrierDeliveredOrdersQuery = { __typename?: 'query_root', order: Array<{ __typename?: 'order', id: any, note?: string | null, phoneNumber?: any | null, receiverName?: string | null, status: string, subTotal?: any | null, deliveredBy: string, dropoffLocation?: any | null, deliveryCharge?: any | null, cancelReason?: string | null, created_at: any, updated_at: any, basket: { __typename?: 'basket', id: any, restaurant: { __typename?: 'restaurant', id: any, name: string, phone?: string | null }, basket_dishes: Array<{ __typename?: 'basket_dish', id: any, quantity: number, dish: { __typename?: 'dish', name: string, price: string, id: any } }> }, assignment?: { __typename?: 'assignment', carrier?: { __typename?: 'carrier', name: string, id: any, phone?: string | null, status: string } | null } | null }> };

export type GetActiveOrdersSubscriptionVariables = Exact<{
  includedStates?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  order_by?: InputMaybe<Array<Order_Order_By> | Order_Order_By>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetActiveOrdersSubscription = { __typename?: 'subscription_root', order: Array<{ __typename?: 'order', id: any, note?: string | null, phoneNumber?: any | null, receiverName?: string | null, status: string, subTotal?: any | null, deliveredBy: string, dropoffLocation?: any | null, deliveryCharge?: any | null, cancelReason?: string | null, address?: string | null, direction?: string | null, created_at: any, updated_at: any, basket: { __typename?: 'basket', id: any, restaurant: { __typename?: 'restaurant', id: any, name: string, phone?: string | null }, basket_dishes: Array<{ __typename?: 'basket_dish', id: any, quantity: number, dish: { __typename?: 'dish', name: string, price: string, id: any } }> }, assignment?: { __typename?: 'assignment', carrier?: { __typename?: 'carrier', name: string, id: any, phone?: string | null, status: string } | null } | null }> };

export type GetAllProfilesQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Profiles_Order_By> | User_Profiles_Order_By>;
}>;


export type GetAllProfilesQuery = { __typename?: 'query_root', user_profiles: Array<{ __typename?: 'user_profiles', id: any, full_name?: string | null, phone?: string | null, gender?: string | null, location?: any | null, updated_at: any, created_at: any, completedRides: { __typename?: 'free_rides_aggregate', aggregate?: { __typename?: 'free_rides_aggregate_fields', count: number } | null }, totalRides: { __typename?: 'free_rides_aggregate', aggregate?: { __typename?: 'free_rides_aggregate_fields', count: number } | null } }>, user_profiles_aggregate: { __typename?: 'user_profiles_aggregate', aggregate?: { __typename?: 'user_profiles_aggregate_fields', count: number } | null } };

export type GetProfileByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetProfileByIdQuery = { __typename?: 'query_root', user_profiles_by_pk?: { __typename?: 'user_profiles', id: any, full_name?: string | null, phone?: string | null, gender?: string | null, created_at: any, updated_at: any, location?: any | null, blood_group: any, blood_donation_consent: boolean, user: { __typename?: 'users', email?: any | null } } | null };

export type UpdateProfileMutationVariables = Exact<{
  pk_columns: User_Profiles_Pk_Columns_Input;
  _set: User_Profiles_Set_Input;
}>;


export type UpdateProfileMutation = { __typename?: 'mutation_root', update_user_profiles_by_pk?: { __typename?: 'user_profiles', id: any } | null };

export type GetMyRestaurantQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetMyRestaurantQuery = { __typename?: 'query_root', restaurant: Array<{ __typename?: 'restaurant', id: any, name: string, location?: any | null }> };

export type GetRestaurantByPkQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetRestaurantByPkQuery = { __typename?: 'query_root', restaurant_by_pk?: { __typename?: 'restaurant', id: any, cover?: any | null, address?: string | null, created_at: any, admin_commission?: number | null, delivery_charge?: number | null, delivery_commission?: number | null, description?: string | null, email?: string | null, free_distance?: number | null, genre?: string | null, image?: any | null, location?: any | null, max_distance?: any | null, name: string, phone?: string | null, rating?: number | null, revenue?: number | null, short_description?: string | null, specialtyId?: any | null, isActive?: boolean | null, type?: string | null, threshold_amount?: number | null, min_order_amount?: number | null, opening_hour?: any | null, closing_hour?: any | null, weekly_off_days?: any | null, specialty?: { __typename?: 'specialty', id: any, name: string } | null } | null };

export type GetRestaurantByUserIdQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type GetRestaurantByUserIdQuery = { __typename?: 'query_root', restaurant: Array<{ __typename?: 'restaurant', id: any, cover?: any | null, address?: string | null, created_at: any, admin_commission?: number | null, delivery_charge?: number | null, delivery_commission?: number | null, description?: string | null, email?: string | null, free_distance?: number | null, genre?: string | null, image?: any | null, location?: any | null, max_distance?: any | null, name: string, phone?: string | null, rating?: number | null, revenue?: number | null, short_description?: string | null, specialtyId?: any | null, isActive?: boolean | null, type?: string | null, threshold_amount?: number | null, min_order_amount?: number | null, opening_hour?: any | null, closing_hour?: any | null, weekly_off_days?: any | null, specialty?: { __typename?: 'specialty', id: any, name: string } | null, carriers: Array<{ __typename?: 'carrier', id: any, name: string, image?: string | null, isOnline: boolean, verification_status?: any | null }> }> };

export type GetAllRestaurantsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllRestaurantsQuery = { __typename?: 'query_root', restaurant: Array<{ __typename?: 'restaurant', id: any, email?: string | null, revenue?: number | null, rating?: number | null, admin_commission?: number | null, short_description?: string | null, isActive?: boolean | null, threshold_amount?: number | null, updated_at: any, phone?: string | null, name: string, max_distance?: any | null, location?: any | null, genre?: string | null, free_distance?: number | null, description?: string | null, delivery_commission?: number | null, delivery_charge?: number | null, address?: string | null, created_at: any, userId?: any | null, cover?: any | null, image?: any | null, specialtyId?: any | null, type?: string | null, min_order_amount?: number | null, opening_hour?: any | null, closing_hour?: any | null, weekly_off_days?: any | null, specialty?: { __typename?: 'specialty', id: any, name: string } | null }> };

export type SearchResturantQueryVariables = Exact<{
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchResturantQuery = { __typename?: 'query_root', restaurant: Array<{ __typename?: 'restaurant', id: any, email?: string | null, revenue?: number | null, rating?: number | null, admin_commission?: number | null, short_description?: string | null, isActive?: boolean | null, threshold_amount?: number | null, updated_at: any, phone?: string | null, name: string, max_distance?: any | null, location?: any | null, genre?: string | null, free_distance?: number | null, description?: string | null, delivery_commission?: number | null, delivery_charge?: number | null, address?: string | null, created_at: any, userId?: any | null, type?: string | null, min_order_amount?: number | null, opening_hour?: any | null, closing_hour?: any | null, weekly_off_days?: any | null }> };

export type InsertRestaurantOneMutationVariables = Exact<{
  insert_restaurant_inputs: Restaurant_Insert_Input;
}>;


export type InsertRestaurantOneMutation = { __typename?: 'mutation_root', insert_restaurant_one?: { __typename?: 'restaurant', id: any } | null };

export type UpdateRestaurantMutationVariables = Exact<{
  pk_columns: Restaurant_Pk_Columns_Input;
  _set: Restaurant_Set_Input;
}>;


export type UpdateRestaurantMutation = { __typename?: 'mutation_root', update_restaurant_by_pk?: { __typename?: 'restaurant', id: any } | null };

export type UpdateRestaurantValidityAndStateMutationVariables = Exact<{
  pk_columns: Restaurant_Pk_Columns_Input;
  _set: Restaurant_Set_Input;
}>;


export type UpdateRestaurantValidityAndStateMutation = { __typename?: 'mutation_root', update_restaurant_by_pk?: { __typename?: 'restaurant', id: any } | null };

export type GetResturantByEmailQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type GetResturantByEmailQuery = { __typename?: 'query_root', restaurant: Array<{ __typename?: 'restaurant', id: any }> };

export type GetAllRidesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['timestamptz']['input']>;
  endDate?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type GetAllRidesQuery = { __typename?: 'query_root', free_rides: Array<{ __typename?: 'free_rides', id: any, status?: string | null, is_active: boolean, pickup_address?: string | null, pickup_location?: any | null, dropoff_address?: string | null, dropoff_location?: any | null, created_at: any, updated_at: any, cancel_reason?: string | null, driver?: { __typename?: 'drivers', id: any, name?: string | null, phone_number?: string | null, local_unit?: string | null, street_address?: string | null, vehicle?: { __typename?: 'vehicles', id: any, vehicle_type?: any | null, model?: string | null, make?: string | null } | null } | null, user_profile?: { __typename?: 'user_profiles', id: any, full_name?: string | null, phone?: string | null } | null }> };

export type GetRidesByStatusQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['timestamptz']['input']>;
  endDate?: InputMaybe<Scalars['timestamptz']['input']>;
  status: Scalars['String']['input'];
}>;


export type GetRidesByStatusQuery = { __typename?: 'query_root', free_rides: Array<{ __typename?: 'free_rides', id: any, status?: string | null, is_active: boolean, pickup_address?: string | null, pickup_location?: any | null, dropoff_address?: string | null, dropoff_location?: any | null, created_at: any, updated_at: any, cancel_reason?: string | null, driver?: { __typename?: 'drivers', id: any, name?: string | null, phone_number?: string | null, local_unit?: string | null, street_address?: string | null, vehicle?: { __typename?: 'vehicles', id: any, vehicle_type?: any | null, model?: string | null, make?: string | null } | null } | null, user_profile?: { __typename?: 'user_profiles', id: any, full_name?: string | null, phone?: string | null } | null }> };

export type GetRideByDriverIdQueryVariables = Exact<{
  driverId: Scalars['uuid']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetRideByDriverIdQuery = { __typename?: 'query_root', free_rides: Array<{ __typename?: 'free_rides', status?: string | null, id: any, is_active: boolean, pickup_address?: string | null, pickup_location?: any | null, dropoff_address?: string | null, dropoff_location?: any | null, created_at: any, updated_at: any, cancel_reason?: string | null, driver?: { __typename?: 'drivers', id: any, name?: string | null, phone_number?: string | null, local_unit?: string | null, street_address?: string | null, vehicle?: { __typename?: 'vehicles', id: any, vehicle_type?: any | null, model?: string | null, make?: string | null } | null } | null, user_profile?: { __typename?: 'user_profiles', id: any, full_name?: string | null, phone?: string | null } | null }> };

export type GetRideByUserProfileIdQueryVariables = Exact<{
  profileId: Scalars['uuid']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetRideByUserProfileIdQuery = { __typename?: 'query_root', free_rides: Array<{ __typename?: 'free_rides', cancel_reason?: string | null, created_at: any, driver_id?: any | null, dropoff_address?: string | null, dropoff_location?: any | null, id: any, is_active: boolean, pickup_address?: string | null, pickup_location?: any | null, profile_id?: any | null, status?: string | null, updated_at: any, driver?: { __typename?: 'drivers', id: any, name?: string | null, phone_number?: string | null, local_unit?: string | null, street_address?: string | null, vehicle?: { __typename?: 'vehicles', id: any, vehicle_type?: any | null, model?: string | null, make?: string | null } | null } | null, user_profile?: { __typename?: 'user_profiles', id: any, full_name?: string | null, phone?: string | null } | null }>, completed_rides_count: { __typename?: 'free_rides_aggregate', aggregate?: { __typename?: 'free_rides_aggregate_fields', count: number } | null }, cancelled_rides_count: { __typename?: 'free_rides_aggregate', aggregate?: { __typename?: 'free_rides_aggregate_fields', count: number } | null }, total_rides_count: { __typename?: 'free_rides_aggregate', aggregate?: { __typename?: 'free_rides_aggregate_fields', count: number } | null } };

export type GetRidesCountQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['timestamptz']['input']>;
  endDate?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type GetRidesCountQuery = { __typename?: 'query_root', completed_rides_count: { __typename?: 'free_rides_aggregate', aggregate?: { __typename?: 'free_rides_aggregate_fields', count: number } | null }, cancelled_rides_count: { __typename?: 'free_rides_aggregate', aggregate?: { __typename?: 'free_rides_aggregate_fields', count: number } | null }, total_rides_count: { __typename?: 'free_rides_aggregate', aggregate?: { __typename?: 'free_rides_aggregate_fields', count: number } | null } };

export type GetAllSpecialitiesQueryVariables = Exact<{
  order_by?: InputMaybe<Array<Specialty_Order_By> | Specialty_Order_By>;
}>;


export type GetAllSpecialitiesQuery = { __typename?: 'query_root', specialty: Array<{ __typename?: 'specialty', id: any, name: string, restaurants_aggregate: { __typename?: 'restaurant_aggregate', aggregate?: { __typename?: 'restaurant_aggregate_fields', count: number } | null } }> };

export type InsertSpecialtyOneMutationVariables = Exact<{
  object: Specialty_Insert_Input;
}>;


export type InsertSpecialtyOneMutation = { __typename?: 'mutation_root', insert_specialty_one?: { __typename?: 'specialty', id: any } | null };

export type UpdateSpecilityByPkMutationVariables = Exact<{
  pk_columns: Specialty_Pk_Columns_Input;
  _set: Specialty_Set_Input;
}>;


export type UpdateSpecilityByPkMutation = { __typename?: 'mutation_root', update_specialty_by_pk?: { __typename?: 'specialty', id: any } | null };

export type DeleteSpecialtyByPkMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteSpecialtyByPkMutation = { __typename?: 'mutation_root', delete_specialty_by_pk?: { __typename?: 'specialty', id: any } | null };

export type SubscribeToActiveRideRequestsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SubscribeToActiveRideRequestsSubscription = { __typename?: 'subscription_root', free_rides: Array<{ __typename?: 'free_rides', id: any, created_at: any, pickup_address?: string | null, user_profile?: { __typename?: 'user_profiles', full_name?: string | null } | null }> };

export type GetUserQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetUserQuery = { __typename?: 'query_root', user?: { __typename?: 'users', id: any, email?: any | null, displayName: string, defaultRole: string, metadata?: any | null } | null };

export type GetUserByEmailQueryVariables = Exact<{
  email: Scalars['citext']['input'];
}>;


export type GetUserByEmailQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, email?: any | null }> };

export type SearchUserByEmailQueryVariables = Exact<{
  searchTerm?: InputMaybe<Scalars['citext']['input']>;
}>;


export type SearchUserByEmailQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, email?: any | null }> };

export type SearchSellerByEmailQueryVariables = Exact<{
  searchTerm?: InputMaybe<Scalars['citext']['input']>;
}>;


export type SearchSellerByEmailQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, email?: any | null }> };

export type SearchSellersWithoutRestaurantQueryVariables = Exact<{
  searchTerm?: InputMaybe<Scalars['citext']['input']>;
}>;


export type SearchSellersWithoutRestaurantQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, email?: any | null }> };

export type SearchUserWithoutCarrierQueryVariables = Exact<{
  searchTerm?: InputMaybe<Scalars['citext']['input']>;
}>;


export type SearchUserWithoutCarrierQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, email?: any | null }> };

export type UpdateVehiclesByPkMutationVariables = Exact<{
  pk_columns: Vehicles_Pk_Columns_Input;
  _set: Vehicles_Set_Input;
}>;


export type UpdateVehiclesByPkMutation = { __typename?: 'mutation_root', update_vehicles_by_pk?: { __typename?: 'vehicles', id: any } | null };


export const GetCarriersDocument = gql`
    query getCarriers {
  carrier {
    id
    location
    heading
    name
    phone
    status
    isOnline
    image
    address
    verification_status
    user {
      email
    }
  }
}
    `;

/**
 * __useGetCarriersQuery__
 *
 * To run a query within a React component, call `useGetCarriersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarriersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarriersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCarriersQuery(baseOptions?: Apollo.QueryHookOptions<GetCarriersQuery, GetCarriersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCarriersQuery, GetCarriersQueryVariables>(GetCarriersDocument, options);
      }
export function useGetCarriersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCarriersQuery, GetCarriersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCarriersQuery, GetCarriersQueryVariables>(GetCarriersDocument, options);
        }
export function useGetCarriersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCarriersQuery, GetCarriersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCarriersQuery, GetCarriersQueryVariables>(GetCarriersDocument, options);
        }
export type GetCarriersQueryHookResult = ReturnType<typeof useGetCarriersQuery>;
export type GetCarriersLazyQueryHookResult = ReturnType<typeof useGetCarriersLazyQuery>;
export type GetCarriersSuspenseQueryHookResult = ReturnType<typeof useGetCarriersSuspenseQuery>;
export type GetCarriersQueryResult = Apollo.QueryResult<GetCarriersQuery, GetCarriersQueryVariables>;
export function refetchGetCarriersQuery(variables?: GetCarriersQueryVariables) {
      return { query: GetCarriersDocument, variables: variables }
    }
export const GetAdminCarriersDocument = gql`
    query getAdminCarriers($radius: Float!, $from: geography!) {
  carrier(
    where: {restaurantId: {_is_null: true}, location: {_st_d_within: {distance: $radius, from: $from}}}
  ) {
    id
    location
    heading
    name
    phone
    status
    isOnline
    image
    address
    verification_status
  }
}
    `;

/**
 * __useGetAdminCarriersQuery__
 *
 * To run a query within a React component, call `useGetAdminCarriersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminCarriersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminCarriersQuery({
 *   variables: {
 *      radius: // value for 'radius'
 *      from: // value for 'from'
 *   },
 * });
 */
export function useGetAdminCarriersQuery(baseOptions: Apollo.QueryHookOptions<GetAdminCarriersQuery, GetAdminCarriersQueryVariables> & ({ variables: GetAdminCarriersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminCarriersQuery, GetAdminCarriersQueryVariables>(GetAdminCarriersDocument, options);
      }
export function useGetAdminCarriersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminCarriersQuery, GetAdminCarriersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminCarriersQuery, GetAdminCarriersQueryVariables>(GetAdminCarriersDocument, options);
        }
export function useGetAdminCarriersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdminCarriersQuery, GetAdminCarriersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdminCarriersQuery, GetAdminCarriersQueryVariables>(GetAdminCarriersDocument, options);
        }
export type GetAdminCarriersQueryHookResult = ReturnType<typeof useGetAdminCarriersQuery>;
export type GetAdminCarriersLazyQueryHookResult = ReturnType<typeof useGetAdminCarriersLazyQuery>;
export type GetAdminCarriersSuspenseQueryHookResult = ReturnType<typeof useGetAdminCarriersSuspenseQuery>;
export type GetAdminCarriersQueryResult = Apollo.QueryResult<GetAdminCarriersQuery, GetAdminCarriersQueryVariables>;
export function refetchGetAdminCarriersQuery(variables: GetAdminCarriersQueryVariables) {
      return { query: GetAdminCarriersDocument, variables: variables }
    }
export const BrodcastOrderDocument = gql`
    mutation brodcastOrder($orderId: uuid!) {
  insert_assignment_one(object: {orderId: $orderId}) {
    id
  }
}
    `;
export type BrodcastOrderMutationFn = Apollo.MutationFunction<BrodcastOrderMutation, BrodcastOrderMutationVariables>;

/**
 * __useBrodcastOrderMutation__
 *
 * To run a mutation, you first call `useBrodcastOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrodcastOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brodcastOrderMutation, { data, loading, error }] = useBrodcastOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useBrodcastOrderMutation(baseOptions?: Apollo.MutationHookOptions<BrodcastOrderMutation, BrodcastOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrodcastOrderMutation, BrodcastOrderMutationVariables>(BrodcastOrderDocument, options);
      }
export type BrodcastOrderMutationHookResult = ReturnType<typeof useBrodcastOrderMutation>;
export type BrodcastOrderMutationResult = Apollo.MutationResult<BrodcastOrderMutation>;
export type BrodcastOrderMutationOptions = Apollo.BaseMutationOptions<BrodcastOrderMutation, BrodcastOrderMutationVariables>;
export const AssignOrderDocument = gql`
    mutation assignOrder($orderId: uuid!, $carrierId: uuid!, $status: String!) {
  insert_assignment_one(
    object: {orderId: $orderId, carrierId: $carrierId, status: $status}
  ) {
    id
  }
}
    `;
export type AssignOrderMutationFn = Apollo.MutationFunction<AssignOrderMutation, AssignOrderMutationVariables>;

/**
 * __useAssignOrderMutation__
 *
 * To run a mutation, you first call `useAssignOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignOrderMutation, { data, loading, error }] = useAssignOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      carrierId: // value for 'carrierId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useAssignOrderMutation(baseOptions?: Apollo.MutationHookOptions<AssignOrderMutation, AssignOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignOrderMutation, AssignOrderMutationVariables>(AssignOrderDocument, options);
      }
export type AssignOrderMutationHookResult = ReturnType<typeof useAssignOrderMutation>;
export type AssignOrderMutationResult = Apollo.MutationResult<AssignOrderMutation>;
export type AssignOrderMutationOptions = Apollo.BaseMutationOptions<AssignOrderMutation, AssignOrderMutationVariables>;
export const UpdateAssignmentByPkDocument = gql`
    mutation updateAssignmentByPk($pk_columns: assignment_pk_columns_input!, $_set: assignment_set_input!) {
  update_assignment_by_pk(pk_columns: $pk_columns, _set: $_set) {
    id
  }
}
    `;
export type UpdateAssignmentByPkMutationFn = Apollo.MutationFunction<UpdateAssignmentByPkMutation, UpdateAssignmentByPkMutationVariables>;

/**
 * __useUpdateAssignmentByPkMutation__
 *
 * To run a mutation, you first call `useUpdateAssignmentByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssignmentByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssignmentByPkMutation, { data, loading, error }] = useUpdateAssignmentByPkMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdateAssignmentByPkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAssignmentByPkMutation, UpdateAssignmentByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAssignmentByPkMutation, UpdateAssignmentByPkMutationVariables>(UpdateAssignmentByPkDocument, options);
      }
export type UpdateAssignmentByPkMutationHookResult = ReturnType<typeof useUpdateAssignmentByPkMutation>;
export type UpdateAssignmentByPkMutationResult = Apollo.MutationResult<UpdateAssignmentByPkMutation>;
export type UpdateAssignmentByPkMutationOptions = Apollo.BaseMutationOptions<UpdateAssignmentByPkMutation, UpdateAssignmentByPkMutationVariables>;
export const UpdateAssignmentByOrderIdDocument = gql`
    mutation updateAssignmentByOrderId($orderId: uuid!, $carrierId: uuid!) {
  update_assignment(
    where: {orderId: {_eq: $orderId}}
    _set: {carrierId: $carrierId, status: "ACCEPTED"}
  ) {
    returning {
      id
    }
  }
}
    `;
export type UpdateAssignmentByOrderIdMutationFn = Apollo.MutationFunction<UpdateAssignmentByOrderIdMutation, UpdateAssignmentByOrderIdMutationVariables>;

/**
 * __useUpdateAssignmentByOrderIdMutation__
 *
 * To run a mutation, you first call `useUpdateAssignmentByOrderIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssignmentByOrderIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssignmentByOrderIdMutation, { data, loading, error }] = useUpdateAssignmentByOrderIdMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      carrierId: // value for 'carrierId'
 *   },
 * });
 */
export function useUpdateAssignmentByOrderIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAssignmentByOrderIdMutation, UpdateAssignmentByOrderIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAssignmentByOrderIdMutation, UpdateAssignmentByOrderIdMutationVariables>(UpdateAssignmentByOrderIdDocument, options);
      }
export type UpdateAssignmentByOrderIdMutationHookResult = ReturnType<typeof useUpdateAssignmentByOrderIdMutation>;
export type UpdateAssignmentByOrderIdMutationResult = Apollo.MutationResult<UpdateAssignmentByOrderIdMutation>;
export type UpdateAssignmentByOrderIdMutationOptions = Apollo.BaseMutationOptions<UpdateAssignmentByOrderIdMutation, UpdateAssignmentByOrderIdMutationVariables>;
export const GetCarrierDocument = gql`
    query getCarrier($carrierId: uuid!) {
  carrier_by_pk(id: $carrierId) {
    id
    location
    heading
    name
    phone
    status
    isOnline
    image
    address
    verification_status
    restaurantId
    restaurant {
      id
      name
    }
    user {
      email
    }
  }
}
    `;

/**
 * __useGetCarrierQuery__
 *
 * To run a query within a React component, call `useGetCarrierQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarrierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarrierQuery({
 *   variables: {
 *      carrierId: // value for 'carrierId'
 *   },
 * });
 */
export function useGetCarrierQuery(baseOptions: Apollo.QueryHookOptions<GetCarrierQuery, GetCarrierQueryVariables> & ({ variables: GetCarrierQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCarrierQuery, GetCarrierQueryVariables>(GetCarrierDocument, options);
      }
export function useGetCarrierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCarrierQuery, GetCarrierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCarrierQuery, GetCarrierQueryVariables>(GetCarrierDocument, options);
        }
export function useGetCarrierSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCarrierQuery, GetCarrierQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCarrierQuery, GetCarrierQueryVariables>(GetCarrierDocument, options);
        }
export type GetCarrierQueryHookResult = ReturnType<typeof useGetCarrierQuery>;
export type GetCarrierLazyQueryHookResult = ReturnType<typeof useGetCarrierLazyQuery>;
export type GetCarrierSuspenseQueryHookResult = ReturnType<typeof useGetCarrierSuspenseQuery>;
export type GetCarrierQueryResult = Apollo.QueryResult<GetCarrierQuery, GetCarrierQueryVariables>;
export function refetchGetCarrierQuery(variables: GetCarrierQueryVariables) {
      return { query: GetCarrierDocument, variables: variables }
    }
export const GetCarrierByIdDocument = gql`
    subscription getCarrierById($carrierId: uuid!) {
  carrier_by_pk(id: $carrierId) {
    id
    location
    heading
    name
    phone
    status
    isOnline
    image
    address
    verification_status
    user {
      email
    }
  }
}
    `;

/**
 * __useGetCarrierByIdSubscription__
 *
 * To run a query within a React component, call `useGetCarrierByIdSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetCarrierByIdSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarrierByIdSubscription({
 *   variables: {
 *      carrierId: // value for 'carrierId'
 *   },
 * });
 */
export function useGetCarrierByIdSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetCarrierByIdSubscription, GetCarrierByIdSubscriptionVariables> & ({ variables: GetCarrierByIdSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetCarrierByIdSubscription, GetCarrierByIdSubscriptionVariables>(GetCarrierByIdDocument, options);
      }
export type GetCarrierByIdSubscriptionHookResult = ReturnType<typeof useGetCarrierByIdSubscription>;
export type GetCarrierByIdSubscriptionResult = Apollo.SubscriptionResult<GetCarrierByIdSubscription>;
export const SearchCarrierDocument = gql`
    query searchCarrier($searchTerm: String) {
  carrier(where: {name: {_iregex: $searchTerm}}) {
    id
    location
    heading
    name
    phone
    status
    isOnline
    image
    address
    verification_status
    user {
      email
    }
  }
}
    `;

/**
 * __useSearchCarrierQuery__
 *
 * To run a query within a React component, call `useSearchCarrierQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCarrierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCarrierQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useSearchCarrierQuery(baseOptions?: Apollo.QueryHookOptions<SearchCarrierQuery, SearchCarrierQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCarrierQuery, SearchCarrierQueryVariables>(SearchCarrierDocument, options);
      }
export function useSearchCarrierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCarrierQuery, SearchCarrierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCarrierQuery, SearchCarrierQueryVariables>(SearchCarrierDocument, options);
        }
export function useSearchCarrierSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchCarrierQuery, SearchCarrierQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchCarrierQuery, SearchCarrierQueryVariables>(SearchCarrierDocument, options);
        }
export type SearchCarrierQueryHookResult = ReturnType<typeof useSearchCarrierQuery>;
export type SearchCarrierLazyQueryHookResult = ReturnType<typeof useSearchCarrierLazyQuery>;
export type SearchCarrierSuspenseQueryHookResult = ReturnType<typeof useSearchCarrierSuspenseQuery>;
export type SearchCarrierQueryResult = Apollo.QueryResult<SearchCarrierQuery, SearchCarrierQueryVariables>;
export function refetchSearchCarrierQuery(variables?: SearchCarrierQueryVariables) {
      return { query: SearchCarrierDocument, variables: variables }
    }
export const UpdateCarrierByPkDocument = gql`
    mutation updateCarrierByPk($pk_columns: carrier_pk_columns_input!, $_set: carrier_set_input!) {
  update_carrier_by_pk(pk_columns: $pk_columns, _set: $_set) {
    id
  }
}
    `;
export type UpdateCarrierByPkMutationFn = Apollo.MutationFunction<UpdateCarrierByPkMutation, UpdateCarrierByPkMutationVariables>;

/**
 * __useUpdateCarrierByPkMutation__
 *
 * To run a mutation, you first call `useUpdateCarrierByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCarrierByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCarrierByPkMutation, { data, loading, error }] = useUpdateCarrierByPkMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdateCarrierByPkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCarrierByPkMutation, UpdateCarrierByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCarrierByPkMutation, UpdateCarrierByPkMutationVariables>(UpdateCarrierByPkDocument, options);
      }
export type UpdateCarrierByPkMutationHookResult = ReturnType<typeof useUpdateCarrierByPkMutation>;
export type UpdateCarrierByPkMutationResult = Apollo.MutationResult<UpdateCarrierByPkMutation>;
export type UpdateCarrierByPkMutationOptions = Apollo.BaseMutationOptions<UpdateCarrierByPkMutation, UpdateCarrierByPkMutationVariables>;
export const InsertCarrierOneDocument = gql`
    mutation insertCarrierOne($insert_carrier_inputs: carrier_insert_input!) {
  insert_carrier_one(object: $insert_carrier_inputs) {
    id
  }
}
    `;
export type InsertCarrierOneMutationFn = Apollo.MutationFunction<InsertCarrierOneMutation, InsertCarrierOneMutationVariables>;

/**
 * __useInsertCarrierOneMutation__
 *
 * To run a mutation, you first call `useInsertCarrierOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertCarrierOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertCarrierOneMutation, { data, loading, error }] = useInsertCarrierOneMutation({
 *   variables: {
 *      insert_carrier_inputs: // value for 'insert_carrier_inputs'
 *   },
 * });
 */
export function useInsertCarrierOneMutation(baseOptions?: Apollo.MutationHookOptions<InsertCarrierOneMutation, InsertCarrierOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertCarrierOneMutation, InsertCarrierOneMutationVariables>(InsertCarrierOneDocument, options);
      }
export type InsertCarrierOneMutationHookResult = ReturnType<typeof useInsertCarrierOneMutation>;
export type InsertCarrierOneMutationResult = Apollo.MutationResult<InsertCarrierOneMutation>;
export type InsertCarrierOneMutationOptions = Apollo.BaseMutationOptions<InsertCarrierOneMutation, InsertCarrierOneMutationVariables>;
export const GetAllCategoriesDocument = gql`
    query getAllCategories($order_by: [category_order_by!]) {
  category(order_by: $order_by) {
    id
    name
  }
}
    `;

/**
 * __useGetAllCategoriesQuery__
 *
 * To run a query within a React component, call `useGetAllCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCategoriesQuery({
 *   variables: {
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useGetAllCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCategoriesQuery, GetAllCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCategoriesQuery, GetAllCategoriesQueryVariables>(GetAllCategoriesDocument, options);
      }
export function useGetAllCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCategoriesQuery, GetAllCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCategoriesQuery, GetAllCategoriesQueryVariables>(GetAllCategoriesDocument, options);
        }
export function useGetAllCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllCategoriesQuery, GetAllCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllCategoriesQuery, GetAllCategoriesQueryVariables>(GetAllCategoriesDocument, options);
        }
export type GetAllCategoriesQueryHookResult = ReturnType<typeof useGetAllCategoriesQuery>;
export type GetAllCategoriesLazyQueryHookResult = ReturnType<typeof useGetAllCategoriesLazyQuery>;
export type GetAllCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetAllCategoriesSuspenseQuery>;
export type GetAllCategoriesQueryResult = Apollo.QueryResult<GetAllCategoriesQuery, GetAllCategoriesQueryVariables>;
export function refetchGetAllCategoriesQuery(variables?: GetAllCategoriesQueryVariables) {
      return { query: GetAllCategoriesDocument, variables: variables }
    }
export const InsertCategoryOneDocument = gql`
    mutation insertCategoryOne($object: category_insert_input!) {
  insert_category_one(object: $object) {
    name
  }
}
    `;
export type InsertCategoryOneMutationFn = Apollo.MutationFunction<InsertCategoryOneMutation, InsertCategoryOneMutationVariables>;

/**
 * __useInsertCategoryOneMutation__
 *
 * To run a mutation, you first call `useInsertCategoryOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertCategoryOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertCategoryOneMutation, { data, loading, error }] = useInsertCategoryOneMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertCategoryOneMutation(baseOptions?: Apollo.MutationHookOptions<InsertCategoryOneMutation, InsertCategoryOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertCategoryOneMutation, InsertCategoryOneMutationVariables>(InsertCategoryOneDocument, options);
      }
export type InsertCategoryOneMutationHookResult = ReturnType<typeof useInsertCategoryOneMutation>;
export type InsertCategoryOneMutationResult = Apollo.MutationResult<InsertCategoryOneMutation>;
export type InsertCategoryOneMutationOptions = Apollo.BaseMutationOptions<InsertCategoryOneMutation, InsertCategoryOneMutationVariables>;
export const UpdateCategoryByPkDocument = gql`
    mutation updateCategoryByPk($pk_columns: category_pk_columns_input!, $_set: category_set_input!) {
  update_category_by_pk(pk_columns: $pk_columns, _set: $_set) {
    name
  }
}
    `;
export type UpdateCategoryByPkMutationFn = Apollo.MutationFunction<UpdateCategoryByPkMutation, UpdateCategoryByPkMutationVariables>;

/**
 * __useUpdateCategoryByPkMutation__
 *
 * To run a mutation, you first call `useUpdateCategoryByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCategoryByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCategoryByPkMutation, { data, loading, error }] = useUpdateCategoryByPkMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdateCategoryByPkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCategoryByPkMutation, UpdateCategoryByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCategoryByPkMutation, UpdateCategoryByPkMutationVariables>(UpdateCategoryByPkDocument, options);
      }
export type UpdateCategoryByPkMutationHookResult = ReturnType<typeof useUpdateCategoryByPkMutation>;
export type UpdateCategoryByPkMutationResult = Apollo.MutationResult<UpdateCategoryByPkMutation>;
export type UpdateCategoryByPkMutationOptions = Apollo.BaseMutationOptions<UpdateCategoryByPkMutation, UpdateCategoryByPkMutationVariables>;
export const DeleteCategoryByPkDocument = gql`
    mutation deleteCategoryByPk($id: uuid!) {
  delete_category_by_pk(id: $id) {
    name
  }
}
    `;
export type DeleteCategoryByPkMutationFn = Apollo.MutationFunction<DeleteCategoryByPkMutation, DeleteCategoryByPkMutationVariables>;

/**
 * __useDeleteCategoryByPkMutation__
 *
 * To run a mutation, you first call `useDeleteCategoryByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCategoryByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCategoryByPkMutation, { data, loading, error }] = useDeleteCategoryByPkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCategoryByPkMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCategoryByPkMutation, DeleteCategoryByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCategoryByPkMutation, DeleteCategoryByPkMutationVariables>(DeleteCategoryByPkDocument, options);
      }
export type DeleteCategoryByPkMutationHookResult = ReturnType<typeof useDeleteCategoryByPkMutation>;
export type DeleteCategoryByPkMutationResult = Apollo.MutationResult<DeleteCategoryByPkMutation>;
export type DeleteCategoryByPkMutationOptions = Apollo.BaseMutationOptions<DeleteCategoryByPkMutation, DeleteCategoryByPkMutationVariables>;
export const GetRestaurantCategoryDishesDocument = gql`
    query getRestaurantCategoryDishes($id: uuid!, $category_order_by: [category_order_by!], $dish_order_by: [dish_order_by!]) {
  category(
    order_by: $category_order_by
    where: {dishes: {restaurantId: {_eq: $id}}}
  ) {
    name
    id
    dishes_aggregate {
      aggregate {
        count
      }
    }
    dishes(order_by: $dish_order_by, where: {restaurantId: {_eq: $id}}) {
      name
      id
      image
      price
      isActive
      type
      category {
        id
        name
      }
      restaurant {
        name
        id
      }
    }
  }
}
    `;

/**
 * __useGetRestaurantCategoryDishesQuery__
 *
 * To run a query within a React component, call `useGetRestaurantCategoryDishesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantCategoryDishesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantCategoryDishesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      category_order_by: // value for 'category_order_by'
 *      dish_order_by: // value for 'dish_order_by'
 *   },
 * });
 */
export function useGetRestaurantCategoryDishesQuery(baseOptions: Apollo.QueryHookOptions<GetRestaurantCategoryDishesQuery, GetRestaurantCategoryDishesQueryVariables> & ({ variables: GetRestaurantCategoryDishesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRestaurantCategoryDishesQuery, GetRestaurantCategoryDishesQueryVariables>(GetRestaurantCategoryDishesDocument, options);
      }
export function useGetRestaurantCategoryDishesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRestaurantCategoryDishesQuery, GetRestaurantCategoryDishesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRestaurantCategoryDishesQuery, GetRestaurantCategoryDishesQueryVariables>(GetRestaurantCategoryDishesDocument, options);
        }
export function useGetRestaurantCategoryDishesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRestaurantCategoryDishesQuery, GetRestaurantCategoryDishesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRestaurantCategoryDishesQuery, GetRestaurantCategoryDishesQueryVariables>(GetRestaurantCategoryDishesDocument, options);
        }
export type GetRestaurantCategoryDishesQueryHookResult = ReturnType<typeof useGetRestaurantCategoryDishesQuery>;
export type GetRestaurantCategoryDishesLazyQueryHookResult = ReturnType<typeof useGetRestaurantCategoryDishesLazyQuery>;
export type GetRestaurantCategoryDishesSuspenseQueryHookResult = ReturnType<typeof useGetRestaurantCategoryDishesSuspenseQuery>;
export type GetRestaurantCategoryDishesQueryResult = Apollo.QueryResult<GetRestaurantCategoryDishesQuery, GetRestaurantCategoryDishesQueryVariables>;
export function refetchGetRestaurantCategoryDishesQuery(variables: GetRestaurantCategoryDishesQueryVariables) {
      return { query: GetRestaurantCategoryDishesDocument, variables: variables }
    }
export const GetAllCategoryDishesDocument = gql`
    query getAllCategoryDishes($category_order_by: [category_order_by!], $dish_order_by: [dish_order_by!]) {
  category(order_by: $category_order_by) {
    name
    id
    image
    dishes_aggregate {
      aggregate {
        count
      }
    }
    dishes(order_by: $dish_order_by) {
      id
      name
      image
      price
      isActive
      type
      category {
        id
        name
      }
      restaurant {
        name
        id
      }
      restaurantId
    }
  }
}
    `;

/**
 * __useGetAllCategoryDishesQuery__
 *
 * To run a query within a React component, call `useGetAllCategoryDishesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCategoryDishesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCategoryDishesQuery({
 *   variables: {
 *      category_order_by: // value for 'category_order_by'
 *      dish_order_by: // value for 'dish_order_by'
 *   },
 * });
 */
export function useGetAllCategoryDishesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCategoryDishesQuery, GetAllCategoryDishesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCategoryDishesQuery, GetAllCategoryDishesQueryVariables>(GetAllCategoryDishesDocument, options);
      }
export function useGetAllCategoryDishesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCategoryDishesQuery, GetAllCategoryDishesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCategoryDishesQuery, GetAllCategoryDishesQueryVariables>(GetAllCategoryDishesDocument, options);
        }
export function useGetAllCategoryDishesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllCategoryDishesQuery, GetAllCategoryDishesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllCategoryDishesQuery, GetAllCategoryDishesQueryVariables>(GetAllCategoryDishesDocument, options);
        }
export type GetAllCategoryDishesQueryHookResult = ReturnType<typeof useGetAllCategoryDishesQuery>;
export type GetAllCategoryDishesLazyQueryHookResult = ReturnType<typeof useGetAllCategoryDishesLazyQuery>;
export type GetAllCategoryDishesSuspenseQueryHookResult = ReturnType<typeof useGetAllCategoryDishesSuspenseQuery>;
export type GetAllCategoryDishesQueryResult = Apollo.QueryResult<GetAllCategoryDishesQuery, GetAllCategoryDishesQueryVariables>;
export function refetchGetAllCategoryDishesQuery(variables?: GetAllCategoryDishesQueryVariables) {
      return { query: GetAllCategoryDishesDocument, variables: variables }
    }
export const UpdateDishByPkDocument = gql`
    mutation updateDishByPk($pk_columns: dish_pk_columns_input!, $_set: dish_set_input!) {
  update_dish_by_pk(pk_columns: $pk_columns, _set: $_set) {
    id
  }
}
    `;
export type UpdateDishByPkMutationFn = Apollo.MutationFunction<UpdateDishByPkMutation, UpdateDishByPkMutationVariables>;

/**
 * __useUpdateDishByPkMutation__
 *
 * To run a mutation, you first call `useUpdateDishByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDishByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDishByPkMutation, { data, loading, error }] = useUpdateDishByPkMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdateDishByPkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDishByPkMutation, UpdateDishByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDishByPkMutation, UpdateDishByPkMutationVariables>(UpdateDishByPkDocument, options);
      }
export type UpdateDishByPkMutationHookResult = ReturnType<typeof useUpdateDishByPkMutation>;
export type UpdateDishByPkMutationResult = Apollo.MutationResult<UpdateDishByPkMutation>;
export type UpdateDishByPkMutationOptions = Apollo.BaseMutationOptions<UpdateDishByPkMutation, UpdateDishByPkMutationVariables>;
export const DeleteDishByPkDocument = gql`
    mutation deleteDishByPk($id: uuid!) {
  delete_dish_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteDishByPkMutationFn = Apollo.MutationFunction<DeleteDishByPkMutation, DeleteDishByPkMutationVariables>;

/**
 * __useDeleteDishByPkMutation__
 *
 * To run a mutation, you first call `useDeleteDishByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDishByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDishByPkMutation, { data, loading, error }] = useDeleteDishByPkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDishByPkMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDishByPkMutation, DeleteDishByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDishByPkMutation, DeleteDishByPkMutationVariables>(DeleteDishByPkDocument, options);
      }
export type DeleteDishByPkMutationHookResult = ReturnType<typeof useDeleteDishByPkMutation>;
export type DeleteDishByPkMutationResult = Apollo.MutationResult<DeleteDishByPkMutation>;
export type DeleteDishByPkMutationOptions = Apollo.BaseMutationOptions<DeleteDishByPkMutation, DeleteDishByPkMutationVariables>;
export const InsertDishOneDocument = gql`
    mutation insertDishOne($object: dish_insert_input!) {
  insert_dish_one(object: $object) {
    id
  }
}
    `;
export type InsertDishOneMutationFn = Apollo.MutationFunction<InsertDishOneMutation, InsertDishOneMutationVariables>;

/**
 * __useInsertDishOneMutation__
 *
 * To run a mutation, you first call `useInsertDishOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertDishOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertDishOneMutation, { data, loading, error }] = useInsertDishOneMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertDishOneMutation(baseOptions?: Apollo.MutationHookOptions<InsertDishOneMutation, InsertDishOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertDishOneMutation, InsertDishOneMutationVariables>(InsertDishOneDocument, options);
      }
export type InsertDishOneMutationHookResult = ReturnType<typeof useInsertDishOneMutation>;
export type InsertDishOneMutationResult = Apollo.MutationResult<InsertDishOneMutation>;
export type InsertDishOneMutationOptions = Apollo.BaseMutationOptions<InsertDishOneMutation, InsertDishOneMutationVariables>;
export const GetOwnDishesDocument = gql`
    query getOwnDishes {
  dish {
    name
    price
    id
    category {
      name
    }
    image
  }
}
    `;

/**
 * __useGetOwnDishesQuery__
 *
 * To run a query within a React component, call `useGetOwnDishesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnDishesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOwnDishesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOwnDishesQuery(baseOptions?: Apollo.QueryHookOptions<GetOwnDishesQuery, GetOwnDishesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOwnDishesQuery, GetOwnDishesQueryVariables>(GetOwnDishesDocument, options);
      }
export function useGetOwnDishesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOwnDishesQuery, GetOwnDishesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOwnDishesQuery, GetOwnDishesQueryVariables>(GetOwnDishesDocument, options);
        }
export function useGetOwnDishesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOwnDishesQuery, GetOwnDishesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOwnDishesQuery, GetOwnDishesQueryVariables>(GetOwnDishesDocument, options);
        }
export type GetOwnDishesQueryHookResult = ReturnType<typeof useGetOwnDishesQuery>;
export type GetOwnDishesLazyQueryHookResult = ReturnType<typeof useGetOwnDishesLazyQuery>;
export type GetOwnDishesSuspenseQueryHookResult = ReturnType<typeof useGetOwnDishesSuspenseQuery>;
export type GetOwnDishesQueryResult = Apollo.QueryResult<GetOwnDishesQuery, GetOwnDishesQueryVariables>;
export function refetchGetOwnDishesQuery(variables?: GetOwnDishesQueryVariables) {
      return { query: GetOwnDishesDocument, variables: variables }
    }
export const GetAllDriversDocument = gql`
    query GetAllDrivers($offset: Int = 0, $limit: Int = 10) {
  drivers(
    offset: $offset
    limit: $limit
    order_by: {driver_locations_current: {updated_at: desc}}
    where: {verification_status: {_in: ["verified", "conditional"]}}
  ) {
    id
    is_active
    is_busy
    local_unit
    name
    phone_number
    ward_no
    gender
    verification_status
    created_at
    driver_locations_current {
      location
      updated_at
    }
    vehicle {
      id
      vehicle_type
    }
    created_at
    completedRides: free_rides_aggregate(where: {status: {_eq: "completed"}}) {
      aggregate {
        count
      }
    }
    totalRides: free_rides_aggregate {
      aggregate {
        count
      }
    }
  }
  drivers_aggregate {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetAllDriversQuery__
 *
 * To run a query within a React component, call `useGetAllDriversQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllDriversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllDriversQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAllDriversQuery(baseOptions?: Apollo.QueryHookOptions<GetAllDriversQuery, GetAllDriversQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllDriversQuery, GetAllDriversQueryVariables>(GetAllDriversDocument, options);
      }
export function useGetAllDriversLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllDriversQuery, GetAllDriversQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllDriversQuery, GetAllDriversQueryVariables>(GetAllDriversDocument, options);
        }
export function useGetAllDriversSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllDriversQuery, GetAllDriversQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllDriversQuery, GetAllDriversQueryVariables>(GetAllDriversDocument, options);
        }
export type GetAllDriversQueryHookResult = ReturnType<typeof useGetAllDriversQuery>;
export type GetAllDriversLazyQueryHookResult = ReturnType<typeof useGetAllDriversLazyQuery>;
export type GetAllDriversSuspenseQueryHookResult = ReturnType<typeof useGetAllDriversSuspenseQuery>;
export type GetAllDriversQueryResult = Apollo.QueryResult<GetAllDriversQuery, GetAllDriversQueryVariables>;
export function refetchGetAllDriversQuery(variables?: GetAllDriversQueryVariables) {
      return { query: GetAllDriversDocument, variables: variables }
    }
export const GetDriverByIdDocument = gql`
    query GetDriverById($id: uuid!) {
  drivers_by_pk(id: $id) {
    id
    is_active
    is_busy
    license_number
    local_unit
    license
    name
    notification_token
    phone_number
    profile
    province
    selfie
    street_address
    updated_at
    ward_no
    gender
    dob
    district
    verification_status
    rejection_reason
    created_at
    blood_group
    blood_donation_consent
    driver_locations_current {
      location
      updated_at
    }
    ratings_aggregate {
      aggregate {
        avg {
          rating
        }
      }
    }
    free_rides_aggregate(where: {status: {_eq: "completed"}}) {
      aggregate {
        count
      }
    }
    totalRides: free_rides_aggregate {
      aggregate {
        count
      }
    }
    vehicle {
      id
      color
      make
      model
      license_plate
      registration
      registration_second
      vehicle_type
      vehicle_front
      insurance
    }
    user {
      email
    }
    created_at
  }
}
    `;

/**
 * __useGetDriverByIdQuery__
 *
 * To run a query within a React component, call `useGetDriverByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriverByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriverByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDriverByIdQuery(baseOptions: Apollo.QueryHookOptions<GetDriverByIdQuery, GetDriverByIdQueryVariables> & ({ variables: GetDriverByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriverByIdQuery, GetDriverByIdQueryVariables>(GetDriverByIdDocument, options);
      }
export function useGetDriverByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriverByIdQuery, GetDriverByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriverByIdQuery, GetDriverByIdQueryVariables>(GetDriverByIdDocument, options);
        }
export function useGetDriverByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDriverByIdQuery, GetDriverByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDriverByIdQuery, GetDriverByIdQueryVariables>(GetDriverByIdDocument, options);
        }
export type GetDriverByIdQueryHookResult = ReturnType<typeof useGetDriverByIdQuery>;
export type GetDriverByIdLazyQueryHookResult = ReturnType<typeof useGetDriverByIdLazyQuery>;
export type GetDriverByIdSuspenseQueryHookResult = ReturnType<typeof useGetDriverByIdSuspenseQuery>;
export type GetDriverByIdQueryResult = Apollo.QueryResult<GetDriverByIdQuery, GetDriverByIdQueryVariables>;
export function refetchGetDriverByIdQuery(variables: GetDriverByIdQueryVariables) {
      return { query: GetDriverByIdDocument, variables: variables }
    }
export const GetFilteredDriversDocument = gql`
    query GetFilteredDrivers($offset: Int = 0, $limit: Int = 10, $verification_status: [document_status_enum!]) {
  drivers(
    order_by: {created_at: desc}
    limit: $limit
    offset: $offset
    where: {verification_status: {_in: $verification_status}}
  ) {
    id
    is_active
    is_busy
    name
    phone_number
    province
    local_unit
    street_address
    updated_at
    ward_no
    gender
    dob
    verification_status
    created_at
    driver_locations_current {
      updated_at
    }
    ratings_aggregate {
      aggregate {
        avg {
          rating
        }
      }
    }
    free_rides_aggregate {
      aggregate {
        count
      }
    }
    vehicle {
      id
      vehicle_type
      make
      model
      license_plate
    }
    user {
      email
    }
    created_at
  }
}
    `;

/**
 * __useGetFilteredDriversQuery__
 *
 * To run a query within a React component, call `useGetFilteredDriversQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilteredDriversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilteredDriversQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      verification_status: // value for 'verification_status'
 *   },
 * });
 */
export function useGetFilteredDriversQuery(baseOptions?: Apollo.QueryHookOptions<GetFilteredDriversQuery, GetFilteredDriversQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilteredDriversQuery, GetFilteredDriversQueryVariables>(GetFilteredDriversDocument, options);
      }
export function useGetFilteredDriversLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilteredDriversQuery, GetFilteredDriversQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilteredDriversQuery, GetFilteredDriversQueryVariables>(GetFilteredDriversDocument, options);
        }
export function useGetFilteredDriversSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFilteredDriversQuery, GetFilteredDriversQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFilteredDriversQuery, GetFilteredDriversQueryVariables>(GetFilteredDriversDocument, options);
        }
export type GetFilteredDriversQueryHookResult = ReturnType<typeof useGetFilteredDriversQuery>;
export type GetFilteredDriversLazyQueryHookResult = ReturnType<typeof useGetFilteredDriversLazyQuery>;
export type GetFilteredDriversSuspenseQueryHookResult = ReturnType<typeof useGetFilteredDriversSuspenseQuery>;
export type GetFilteredDriversQueryResult = Apollo.QueryResult<GetFilteredDriversQuery, GetFilteredDriversQueryVariables>;
export function refetchGetFilteredDriversQuery(variables?: GetFilteredDriversQueryVariables) {
      return { query: GetFilteredDriversDocument, variables: variables }
    }
export const GetDriversCountDocument = gql`
    query GetDriversCount {
  total: drivers_aggregate {
    aggregate {
      count
    }
  }
  verified: drivers_aggregate(where: {verification_status: {_eq: "verified"}}) {
    aggregate {
      count
    }
  }
  pending: drivers_aggregate(where: {verification_status: {_eq: "pending"}}) {
    aggregate {
      count
    }
  }
  reviewing: drivers_aggregate(where: {verification_status: {_eq: "reviewing"}}) {
    aggregate {
      count
    }
  }
  rejected: drivers_aggregate(where: {verification_status: {_eq: "rejected"}}) {
    aggregate {
      count
    }
  }
  conditional: drivers_aggregate(
    where: {verification_status: {_eq: "conditional"}}
  ) {
    aggregate {
      count
    }
  }
  processing: drivers_aggregate(where: {verification_status: {_eq: "processing"}}) {
    aggregate {
      count
    }
  }
  scooter: drivers_aggregate(where: {vehicle: {vehicle_type: {_eq: "scooter"}}}) {
    aggregate {
      count
    }
  }
  motorcycle: drivers_aggregate(
    where: {vehicle: {vehicle_type: {_eq: "motorcycle"}}}
  ) {
    aggregate {
      count
    }
  }
  car: drivers_aggregate(where: {vehicle: {vehicle_type: {_eq: "car"}}}) {
    aggregate {
      count
    }
  }
  toto: drivers_aggregate(where: {vehicle: {vehicle_type: {_eq: "toto"}}}) {
    aggregate {
      count
    }
  }
  auto: drivers_aggregate(where: {vehicle: {vehicle_type: {_eq: "auto"}}}) {
    aggregate {
      count
    }
  }
  no_vehicle: drivers_aggregate(
    where: {_not: {vehicles: {id: {_is_null: false}}}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetDriversCountQuery__
 *
 * To run a query within a React component, call `useGetDriversCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriversCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriversCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDriversCountQuery(baseOptions?: Apollo.QueryHookOptions<GetDriversCountQuery, GetDriversCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriversCountQuery, GetDriversCountQueryVariables>(GetDriversCountDocument, options);
      }
export function useGetDriversCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriversCountQuery, GetDriversCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriversCountQuery, GetDriversCountQueryVariables>(GetDriversCountDocument, options);
        }
export function useGetDriversCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDriversCountQuery, GetDriversCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDriversCountQuery, GetDriversCountQueryVariables>(GetDriversCountDocument, options);
        }
export type GetDriversCountQueryHookResult = ReturnType<typeof useGetDriversCountQuery>;
export type GetDriversCountLazyQueryHookResult = ReturnType<typeof useGetDriversCountLazyQuery>;
export type GetDriversCountSuspenseQueryHookResult = ReturnType<typeof useGetDriversCountSuspenseQuery>;
export type GetDriversCountQueryResult = Apollo.QueryResult<GetDriversCountQuery, GetDriversCountQueryVariables>;
export function refetchGetDriversCountQuery(variables?: GetDriversCountQueryVariables) {
      return { query: GetDriversCountDocument, variables: variables }
    }
export const SearchDriverDocument = gql`
    query SearchDriver($searchTerm: String!) {
  drivers(
    where: {_or: [{name: {_iregex: $searchTerm}}, {phone_number: {_iregex: $searchTerm}}, {local_unit: {_iregex: $searchTerm}}]}
    limit: 10
  ) {
    id
    name
    phone_number
    local_unit
  }
}
    `;

/**
 * __useSearchDriverQuery__
 *
 * To run a query within a React component, call `useSearchDriverQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchDriverQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchDriverQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useSearchDriverQuery(baseOptions: Apollo.QueryHookOptions<SearchDriverQuery, SearchDriverQueryVariables> & ({ variables: SearchDriverQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchDriverQuery, SearchDriverQueryVariables>(SearchDriverDocument, options);
      }
export function useSearchDriverLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchDriverQuery, SearchDriverQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchDriverQuery, SearchDriverQueryVariables>(SearchDriverDocument, options);
        }
export function useSearchDriverSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchDriverQuery, SearchDriverQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchDriverQuery, SearchDriverQueryVariables>(SearchDriverDocument, options);
        }
export type SearchDriverQueryHookResult = ReturnType<typeof useSearchDriverQuery>;
export type SearchDriverLazyQueryHookResult = ReturnType<typeof useSearchDriverLazyQuery>;
export type SearchDriverSuspenseQueryHookResult = ReturnType<typeof useSearchDriverSuspenseQuery>;
export type SearchDriverQueryResult = Apollo.QueryResult<SearchDriverQuery, SearchDriverQueryVariables>;
export function refetchSearchDriverQuery(variables: SearchDriverQueryVariables) {
      return { query: SearchDriverDocument, variables: variables }
    }
export const UpdateDriverByPkDocument = gql`
    mutation updateDriverByPk($pk_columns: drivers_pk_columns_input!, $_set: drivers_set_input!) {
  update_drivers_by_pk(pk_columns: $pk_columns, _set: $_set) {
    id
  }
}
    `;
export type UpdateDriverByPkMutationFn = Apollo.MutationFunction<UpdateDriverByPkMutation, UpdateDriverByPkMutationVariables>;

/**
 * __useUpdateDriverByPkMutation__
 *
 * To run a mutation, you first call `useUpdateDriverByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDriverByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDriverByPkMutation, { data, loading, error }] = useUpdateDriverByPkMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdateDriverByPkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDriverByPkMutation, UpdateDriverByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDriverByPkMutation, UpdateDriverByPkMutationVariables>(UpdateDriverByPkDocument, options);
      }
export type UpdateDriverByPkMutationHookResult = ReturnType<typeof useUpdateDriverByPkMutation>;
export type UpdateDriverByPkMutationResult = Apollo.MutationResult<UpdateDriverByPkMutation>;
export type UpdateDriverByPkMutationOptions = Apollo.BaseMutationOptions<UpdateDriverByPkMutation, UpdateDriverByPkMutationVariables>;
export const GetOrderbyPkDocument = gql`
    query getOrderbyPK($id: uuid!) {
  order_by_pk(id: $id) {
    id
    dropoffLocation
    deliveryCharge
    cancelReason
    note
    phoneNumber
    receiverName
    direction
    status
    subTotal
    deliveredBy
    updated_at
    created_at
    address
    basket {
      id
      restaurant {
        name
        phone
        id
        location
        carriers {
          id
          name
          phone
          image
        }
      }
      basket_dishes {
        quantity
        id
        dish {
          id
          image
          name
          price
        }
      }
    }
    assignment {
      id
      status
      carrier {
        name
        id
        location
        phone
        status
      }
    }
  }
}
    `;

/**
 * __useGetOrderbyPkQuery__
 *
 * To run a query within a React component, call `useGetOrderbyPkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderbyPkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderbyPkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrderbyPkQuery(baseOptions: Apollo.QueryHookOptions<GetOrderbyPkQuery, GetOrderbyPkQueryVariables> & ({ variables: GetOrderbyPkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderbyPkQuery, GetOrderbyPkQueryVariables>(GetOrderbyPkDocument, options);
      }
export function useGetOrderbyPkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderbyPkQuery, GetOrderbyPkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderbyPkQuery, GetOrderbyPkQueryVariables>(GetOrderbyPkDocument, options);
        }
export function useGetOrderbyPkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrderbyPkQuery, GetOrderbyPkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrderbyPkQuery, GetOrderbyPkQueryVariables>(GetOrderbyPkDocument, options);
        }
export type GetOrderbyPkQueryHookResult = ReturnType<typeof useGetOrderbyPkQuery>;
export type GetOrderbyPkLazyQueryHookResult = ReturnType<typeof useGetOrderbyPkLazyQuery>;
export type GetOrderbyPkSuspenseQueryHookResult = ReturnType<typeof useGetOrderbyPkSuspenseQuery>;
export type GetOrderbyPkQueryResult = Apollo.QueryResult<GetOrderbyPkQuery, GetOrderbyPkQueryVariables>;
export function refetchGetOrderbyPkQuery(variables: GetOrderbyPkQueryVariables) {
      return { query: GetOrderbyPkDocument, variables: variables }
    }
export const GetPendingOrdersDocument = gql`
    subscription getPendingOrders {
  order(where: {status: {_eq: "PENDING"}}) {
    id
    note
    phoneNumber
    receiverName
    status
    subTotal
    deliveredBy
    dropoffLocation
    deliveryCharge
    cancelReason
    address
    direction
    basket {
      id
      restaurant {
        id
        name
        phone
        admin_commission
      }
      basket_dishes {
        id
        quantity
        dish {
          name
          price
          id
        }
      }
    }
    assignment {
      carrier {
        name
        id
        phone
        status
      }
    }
    created_at
    updated_at
  }
}
    `;

/**
 * __useGetPendingOrdersSubscription__
 *
 * To run a query within a React component, call `useGetPendingOrdersSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingOrdersSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingOrdersSubscription({
 *   variables: {
 *   },
 * });
 */
export function useGetPendingOrdersSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GetPendingOrdersSubscription, GetPendingOrdersSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetPendingOrdersSubscription, GetPendingOrdersSubscriptionVariables>(GetPendingOrdersDocument, options);
      }
export type GetPendingOrdersSubscriptionHookResult = ReturnType<typeof useGetPendingOrdersSubscription>;
export type GetPendingOrdersSubscriptionResult = Apollo.SubscriptionResult<GetPendingOrdersSubscription>;
export const UpdateOrderStatusDocument = gql`
    mutation updateOrderStatus($pk_columns: order_pk_columns_input!, $_set: order_set_input!) {
  update_order_by_pk(pk_columns: $pk_columns, _set: $_set) {
    id
    basket {
      id
      receiver {
        notification_token_food
      }
    }
  }
}
    `;
export type UpdateOrderStatusMutationFn = Apollo.MutationFunction<UpdateOrderStatusMutation, UpdateOrderStatusMutationVariables>;

/**
 * __useUpdateOrderStatusMutation__
 *
 * To run a mutation, you first call `useUpdateOrderStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderStatusMutation, { data, loading, error }] = useUpdateOrderStatusMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdateOrderStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderStatusMutation, UpdateOrderStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderStatusMutation, UpdateOrderStatusMutationVariables>(UpdateOrderStatusDocument, options);
      }
export type UpdateOrderStatusMutationHookResult = ReturnType<typeof useUpdateOrderStatusMutation>;
export type UpdateOrderStatusMutationResult = Apollo.MutationResult<UpdateOrderStatusMutation>;
export type UpdateOrderStatusMutationOptions = Apollo.BaseMutationOptions<UpdateOrderStatusMutation, UpdateOrderStatusMutationVariables>;
export const GetIncludedOrdersDocument = gql`
    query getIncludedOrders($includedStates: [String!], $order_by: [order_order_by!], $limit: Int!, $offset: Int!, $_is_null: Boolean, $restaurantId: uuid!) {
  order(
    where: {status: {_in: $includedStates}, settlementId: {_is_null: $_is_null}, basket: {restaurantId: {_eq: $restaurantId}}}
    order_by: $order_by
    limit: $limit
    offset: $offset
  ) {
    id
    note
    phoneNumber
    receiverName
    status
    subTotal
    deliveredBy
    dropoffLocation
    deliveryCharge
    cancelReason
    basket {
      id
      restaurant {
        id
        name
        phone
      }
      basket_dishes {
        id
        quantity
        dish {
          name
          price
          id
        }
      }
    }
    assignment {
      carrier {
        name
        id
        phone
        status
      }
    }
    created_at
    updated_at
  }
}
    `;

/**
 * __useGetIncludedOrdersQuery__
 *
 * To run a query within a React component, call `useGetIncludedOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIncludedOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIncludedOrdersQuery({
 *   variables: {
 *      includedStates: // value for 'includedStates'
 *      order_by: // value for 'order_by'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      _is_null: // value for '_is_null'
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetIncludedOrdersQuery(baseOptions: Apollo.QueryHookOptions<GetIncludedOrdersQuery, GetIncludedOrdersQueryVariables> & ({ variables: GetIncludedOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIncludedOrdersQuery, GetIncludedOrdersQueryVariables>(GetIncludedOrdersDocument, options);
      }
export function useGetIncludedOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIncludedOrdersQuery, GetIncludedOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIncludedOrdersQuery, GetIncludedOrdersQueryVariables>(GetIncludedOrdersDocument, options);
        }
export function useGetIncludedOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIncludedOrdersQuery, GetIncludedOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIncludedOrdersQuery, GetIncludedOrdersQueryVariables>(GetIncludedOrdersDocument, options);
        }
export type GetIncludedOrdersQueryHookResult = ReturnType<typeof useGetIncludedOrdersQuery>;
export type GetIncludedOrdersLazyQueryHookResult = ReturnType<typeof useGetIncludedOrdersLazyQuery>;
export type GetIncludedOrdersSuspenseQueryHookResult = ReturnType<typeof useGetIncludedOrdersSuspenseQuery>;
export type GetIncludedOrdersQueryResult = Apollo.QueryResult<GetIncludedOrdersQuery, GetIncludedOrdersQueryVariables>;
export function refetchGetIncludedOrdersQuery(variables: GetIncludedOrdersQueryVariables) {
      return { query: GetIncludedOrdersDocument, variables: variables }
    }
export const GetAllUnSettledOrdersDocument = gql`
    query getAllUnSettledOrders {
  orders: order(
    where: {settlementId: {_is_null: true}, status: {_eq: "DELIVERED"}}
    order_by: [{created_at: desc}]
  ) {
    id
    subTotal
    deliveryCharge
    deliveredBy
    basket {
      id
      restaurant {
        id
        name
        phone
        admin_commission
      }
    }
    created_at
    updated_at
  }
}
    `;

/**
 * __useGetAllUnSettledOrdersQuery__
 *
 * To run a query within a React component, call `useGetAllUnSettledOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUnSettledOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllUnSettledOrdersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllUnSettledOrdersQuery(baseOptions?: Apollo.QueryHookOptions<GetAllUnSettledOrdersQuery, GetAllUnSettledOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllUnSettledOrdersQuery, GetAllUnSettledOrdersQueryVariables>(GetAllUnSettledOrdersDocument, options);
      }
export function useGetAllUnSettledOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllUnSettledOrdersQuery, GetAllUnSettledOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllUnSettledOrdersQuery, GetAllUnSettledOrdersQueryVariables>(GetAllUnSettledOrdersDocument, options);
        }
export function useGetAllUnSettledOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllUnSettledOrdersQuery, GetAllUnSettledOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllUnSettledOrdersQuery, GetAllUnSettledOrdersQueryVariables>(GetAllUnSettledOrdersDocument, options);
        }
export type GetAllUnSettledOrdersQueryHookResult = ReturnType<typeof useGetAllUnSettledOrdersQuery>;
export type GetAllUnSettledOrdersLazyQueryHookResult = ReturnType<typeof useGetAllUnSettledOrdersLazyQuery>;
export type GetAllUnSettledOrdersSuspenseQueryHookResult = ReturnType<typeof useGetAllUnSettledOrdersSuspenseQuery>;
export type GetAllUnSettledOrdersQueryResult = Apollo.QueryResult<GetAllUnSettledOrdersQuery, GetAllUnSettledOrdersQueryVariables>;
export function refetchGetAllUnSettledOrdersQuery(variables?: GetAllUnSettledOrdersQueryVariables) {
      return { query: GetAllUnSettledOrdersDocument, variables: variables }
    }
export const GetSettledOrdersDocument = gql`
    query getSettledOrders($startDate: timestamp, $endDate: timestamp) {
  settlements: settlement(
    where: {created_at: {_gte: $startDate, _lte: $endDate}}
    order_by: [{created_at: desc}]
  ) {
    id
    restaurantId
    dishAmount
    totalDeliveryCharge
    totalRestaurantEarning
    totalAdminEarning
    created_at
    restaurant {
      id
      name
    }
    orders {
      id
    }
    orders_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetSettledOrdersQuery__
 *
 * To run a query within a React component, call `useGetSettledOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSettledOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSettledOrdersQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetSettledOrdersQuery(baseOptions?: Apollo.QueryHookOptions<GetSettledOrdersQuery, GetSettledOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSettledOrdersQuery, GetSettledOrdersQueryVariables>(GetSettledOrdersDocument, options);
      }
export function useGetSettledOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSettledOrdersQuery, GetSettledOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSettledOrdersQuery, GetSettledOrdersQueryVariables>(GetSettledOrdersDocument, options);
        }
export function useGetSettledOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSettledOrdersQuery, GetSettledOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSettledOrdersQuery, GetSettledOrdersQueryVariables>(GetSettledOrdersDocument, options);
        }
export type GetSettledOrdersQueryHookResult = ReturnType<typeof useGetSettledOrdersQuery>;
export type GetSettledOrdersLazyQueryHookResult = ReturnType<typeof useGetSettledOrdersLazyQuery>;
export type GetSettledOrdersSuspenseQueryHookResult = ReturnType<typeof useGetSettledOrdersSuspenseQuery>;
export type GetSettledOrdersQueryResult = Apollo.QueryResult<GetSettledOrdersQuery, GetSettledOrdersQueryVariables>;
export function refetchGetSettledOrdersQuery(variables?: GetSettledOrdersQueryVariables) {
      return { query: GetSettledOrdersDocument, variables: variables }
    }
export const GetRestaurantUnSettledOrdersDocument = gql`
    query getRestaurantUnSettledOrders($restaurantId: uuid!) {
  orders: order(
    where: {basket: {restaurantId: {_eq: $restaurantId}}, settlementId: {_is_null: true}, status: {_eq: "DELIVERED"}}
    order_by: [{created_at: desc}]
  ) {
    id
    subTotal
    deliveryCharge
    deliveredBy
    basket {
      id
      restaurant {
        id
        name
        image
        phone
        email
        admin_commission
      }
      basket_dishes {
        id
        quantity
        dish {
          name
          price
          id
        }
      }
    }
    created_at
    updated_at
  }
}
    `;

/**
 * __useGetRestaurantUnSettledOrdersQuery__
 *
 * To run a query within a React component, call `useGetRestaurantUnSettledOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantUnSettledOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantUnSettledOrdersQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetRestaurantUnSettledOrdersQuery(baseOptions: Apollo.QueryHookOptions<GetRestaurantUnSettledOrdersQuery, GetRestaurantUnSettledOrdersQueryVariables> & ({ variables: GetRestaurantUnSettledOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRestaurantUnSettledOrdersQuery, GetRestaurantUnSettledOrdersQueryVariables>(GetRestaurantUnSettledOrdersDocument, options);
      }
export function useGetRestaurantUnSettledOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRestaurantUnSettledOrdersQuery, GetRestaurantUnSettledOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRestaurantUnSettledOrdersQuery, GetRestaurantUnSettledOrdersQueryVariables>(GetRestaurantUnSettledOrdersDocument, options);
        }
export function useGetRestaurantUnSettledOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRestaurantUnSettledOrdersQuery, GetRestaurantUnSettledOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRestaurantUnSettledOrdersQuery, GetRestaurantUnSettledOrdersQueryVariables>(GetRestaurantUnSettledOrdersDocument, options);
        }
export type GetRestaurantUnSettledOrdersQueryHookResult = ReturnType<typeof useGetRestaurantUnSettledOrdersQuery>;
export type GetRestaurantUnSettledOrdersLazyQueryHookResult = ReturnType<typeof useGetRestaurantUnSettledOrdersLazyQuery>;
export type GetRestaurantUnSettledOrdersSuspenseQueryHookResult = ReturnType<typeof useGetRestaurantUnSettledOrdersSuspenseQuery>;
export type GetRestaurantUnSettledOrdersQueryResult = Apollo.QueryResult<GetRestaurantUnSettledOrdersQuery, GetRestaurantUnSettledOrdersQueryVariables>;
export function refetchGetRestaurantUnSettledOrdersQuery(variables: GetRestaurantUnSettledOrdersQueryVariables) {
      return { query: GetRestaurantUnSettledOrdersDocument, variables: variables }
    }
export const GetRestaurantSettledOrdersDocument = gql`
    query getRestaurantSettledOrders($startDate: timestamp, $endDate: timestamp, $restaurantId: uuid!) {
  settlements: settlement(
    where: {created_at: {_gte: $startDate, _lte: $endDate}, restaurantId: {_eq: $restaurantId}}
    order_by: [{created_at: desc}]
  ) {
    id
    restaurantId
    dishAmount
    totalDeliveryCharge
    totalRestaurantEarning
    totalAdminEarning
    created_at
    restaurant {
      id
      name
    }
    orders {
      id
    }
    orders_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetRestaurantSettledOrdersQuery__
 *
 * To run a query within a React component, call `useGetRestaurantSettledOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantSettledOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantSettledOrdersQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGetRestaurantSettledOrdersQuery(baseOptions: Apollo.QueryHookOptions<GetRestaurantSettledOrdersQuery, GetRestaurantSettledOrdersQueryVariables> & ({ variables: GetRestaurantSettledOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRestaurantSettledOrdersQuery, GetRestaurantSettledOrdersQueryVariables>(GetRestaurantSettledOrdersDocument, options);
      }
export function useGetRestaurantSettledOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRestaurantSettledOrdersQuery, GetRestaurantSettledOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRestaurantSettledOrdersQuery, GetRestaurantSettledOrdersQueryVariables>(GetRestaurantSettledOrdersDocument, options);
        }
export function useGetRestaurantSettledOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRestaurantSettledOrdersQuery, GetRestaurantSettledOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRestaurantSettledOrdersQuery, GetRestaurantSettledOrdersQueryVariables>(GetRestaurantSettledOrdersDocument, options);
        }
export type GetRestaurantSettledOrdersQueryHookResult = ReturnType<typeof useGetRestaurantSettledOrdersQuery>;
export type GetRestaurantSettledOrdersLazyQueryHookResult = ReturnType<typeof useGetRestaurantSettledOrdersLazyQuery>;
export type GetRestaurantSettledOrdersSuspenseQueryHookResult = ReturnType<typeof useGetRestaurantSettledOrdersSuspenseQuery>;
export type GetRestaurantSettledOrdersQueryResult = Apollo.QueryResult<GetRestaurantSettledOrdersQuery, GetRestaurantSettledOrdersQueryVariables>;
export function refetchGetRestaurantSettledOrdersQuery(variables: GetRestaurantSettledOrdersQueryVariables) {
      return { query: GetRestaurantSettledOrdersDocument, variables: variables }
    }
export const GetSettledOrdersByIdDocument = gql`
    query getSettledOrdersById($settlementId: uuid!) {
  orders: order(where: {settlementId: {_eq: $settlementId}}) {
    id
    subTotal
    deliveryCharge
    deliveredBy
    basket {
      id
      restaurant {
        id
        name
        image
        phone
        email
        admin_commission
      }
      basket_dishes {
        id
        quantity
        dish {
          name
          price
          id
        }
      }
    }
    created_at
    updated_at
  }
}
    `;

/**
 * __useGetSettledOrdersByIdQuery__
 *
 * To run a query within a React component, call `useGetSettledOrdersByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSettledOrdersByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSettledOrdersByIdQuery({
 *   variables: {
 *      settlementId: // value for 'settlementId'
 *   },
 * });
 */
export function useGetSettledOrdersByIdQuery(baseOptions: Apollo.QueryHookOptions<GetSettledOrdersByIdQuery, GetSettledOrdersByIdQueryVariables> & ({ variables: GetSettledOrdersByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSettledOrdersByIdQuery, GetSettledOrdersByIdQueryVariables>(GetSettledOrdersByIdDocument, options);
      }
export function useGetSettledOrdersByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSettledOrdersByIdQuery, GetSettledOrdersByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSettledOrdersByIdQuery, GetSettledOrdersByIdQueryVariables>(GetSettledOrdersByIdDocument, options);
        }
export function useGetSettledOrdersByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSettledOrdersByIdQuery, GetSettledOrdersByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSettledOrdersByIdQuery, GetSettledOrdersByIdQueryVariables>(GetSettledOrdersByIdDocument, options);
        }
export type GetSettledOrdersByIdQueryHookResult = ReturnType<typeof useGetSettledOrdersByIdQuery>;
export type GetSettledOrdersByIdLazyQueryHookResult = ReturnType<typeof useGetSettledOrdersByIdLazyQuery>;
export type GetSettledOrdersByIdSuspenseQueryHookResult = ReturnType<typeof useGetSettledOrdersByIdSuspenseQuery>;
export type GetSettledOrdersByIdQueryResult = Apollo.QueryResult<GetSettledOrdersByIdQuery, GetSettledOrdersByIdQueryVariables>;
export function refetchGetSettledOrdersByIdQuery(variables: GetSettledOrdersByIdQueryVariables) {
      return { query: GetSettledOrdersByIdDocument, variables: variables }
    }
export const InsertSettlementDocument = gql`
    mutation insertSettlement($restaurantId: uuid!, $dishAmount: numeric!, $totalDeliveryCharge: numeric!, $totalRestaurantEarning: numeric!, $totalAdminEarning: numeric!) {
  insert_settlement(
    objects: {restaurantId: $restaurantId, dishAmount: $dishAmount, totalDeliveryCharge: $totalDeliveryCharge, totalRestaurantEarning: $totalRestaurantEarning, totalAdminEarning: $totalAdminEarning}
  ) {
    returning {
      id
    }
  }
}
    `;
export type InsertSettlementMutationFn = Apollo.MutationFunction<InsertSettlementMutation, InsertSettlementMutationVariables>;

/**
 * __useInsertSettlementMutation__
 *
 * To run a mutation, you first call `useInsertSettlementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertSettlementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertSettlementMutation, { data, loading, error }] = useInsertSettlementMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      dishAmount: // value for 'dishAmount'
 *      totalDeliveryCharge: // value for 'totalDeliveryCharge'
 *      totalRestaurantEarning: // value for 'totalRestaurantEarning'
 *      totalAdminEarning: // value for 'totalAdminEarning'
 *   },
 * });
 */
export function useInsertSettlementMutation(baseOptions?: Apollo.MutationHookOptions<InsertSettlementMutation, InsertSettlementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertSettlementMutation, InsertSettlementMutationVariables>(InsertSettlementDocument, options);
      }
export type InsertSettlementMutationHookResult = ReturnType<typeof useInsertSettlementMutation>;
export type InsertSettlementMutationResult = Apollo.MutationResult<InsertSettlementMutation>;
export type InsertSettlementMutationOptions = Apollo.BaseMutationOptions<InsertSettlementMutation, InsertSettlementMutationVariables>;
export const UpdateOrdersWithSettlementDocument = gql`
    mutation updateOrdersWithSettlement($settlementId: uuid!, $orders: [uuid!]!) {
  update_order(
    where: {id: {_in: $orders}}
    _set: {settlementId: $settlementId, status: "COMPLETED"}
  ) {
    affected_rows
  }
}
    `;
export type UpdateOrdersWithSettlementMutationFn = Apollo.MutationFunction<UpdateOrdersWithSettlementMutation, UpdateOrdersWithSettlementMutationVariables>;

/**
 * __useUpdateOrdersWithSettlementMutation__
 *
 * To run a mutation, you first call `useUpdateOrdersWithSettlementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrdersWithSettlementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrdersWithSettlementMutation, { data, loading, error }] = useUpdateOrdersWithSettlementMutation({
 *   variables: {
 *      settlementId: // value for 'settlementId'
 *      orders: // value for 'orders'
 *   },
 * });
 */
export function useUpdateOrdersWithSettlementMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrdersWithSettlementMutation, UpdateOrdersWithSettlementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrdersWithSettlementMutation, UpdateOrdersWithSettlementMutationVariables>(UpdateOrdersWithSettlementDocument, options);
      }
export type UpdateOrdersWithSettlementMutationHookResult = ReturnType<typeof useUpdateOrdersWithSettlementMutation>;
export type UpdateOrdersWithSettlementMutationResult = Apollo.MutationResult<UpdateOrdersWithSettlementMutation>;
export type UpdateOrdersWithSettlementMutationOptions = Apollo.BaseMutationOptions<UpdateOrdersWithSettlementMutation, UpdateOrdersWithSettlementMutationVariables>;
export const GetTotalOrderSalesDocument = gql`
    query getTotalOrderSales($dateFrom: timestamptz!, $dateTo: timestamptz!) {
  order_aggregate(
    where: {_and: [{created_at: {_gte: $dateFrom}}, {created_at: {_lte: $dateTo}}, {status: {_eq: "DELIVERED"}}]}
  ) {
    aggregate {
      sum {
        deliveryCharge
        subTotal
      }
      count(columns: basketId)
    }
  }
}
    `;

/**
 * __useGetTotalOrderSalesQuery__
 *
 * To run a query within a React component, call `useGetTotalOrderSalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTotalOrderSalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTotalOrderSalesQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useGetTotalOrderSalesQuery(baseOptions: Apollo.QueryHookOptions<GetTotalOrderSalesQuery, GetTotalOrderSalesQueryVariables> & ({ variables: GetTotalOrderSalesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTotalOrderSalesQuery, GetTotalOrderSalesQueryVariables>(GetTotalOrderSalesDocument, options);
      }
export function useGetTotalOrderSalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTotalOrderSalesQuery, GetTotalOrderSalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTotalOrderSalesQuery, GetTotalOrderSalesQueryVariables>(GetTotalOrderSalesDocument, options);
        }
export function useGetTotalOrderSalesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTotalOrderSalesQuery, GetTotalOrderSalesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTotalOrderSalesQuery, GetTotalOrderSalesQueryVariables>(GetTotalOrderSalesDocument, options);
        }
export type GetTotalOrderSalesQueryHookResult = ReturnType<typeof useGetTotalOrderSalesQuery>;
export type GetTotalOrderSalesLazyQueryHookResult = ReturnType<typeof useGetTotalOrderSalesLazyQuery>;
export type GetTotalOrderSalesSuspenseQueryHookResult = ReturnType<typeof useGetTotalOrderSalesSuspenseQuery>;
export type GetTotalOrderSalesQueryResult = Apollo.QueryResult<GetTotalOrderSalesQuery, GetTotalOrderSalesQueryVariables>;
export function refetchGetTotalOrderSalesQuery(variables: GetTotalOrderSalesQueryVariables) {
      return { query: GetTotalOrderSalesDocument, variables: variables }
    }
export const UpdateOrderByPkDocument = gql`
    mutation updateOrderByPk($pk_columns: order_pk_columns_input!, $_set: order_set_input!) {
  update_order_by_pk(pk_columns: $pk_columns, _set: $_set) {
    id
  }
}
    `;
export type UpdateOrderByPkMutationFn = Apollo.MutationFunction<UpdateOrderByPkMutation, UpdateOrderByPkMutationVariables>;

/**
 * __useUpdateOrderByPkMutation__
 *
 * To run a mutation, you first call `useUpdateOrderByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderByPkMutation, { data, loading, error }] = useUpdateOrderByPkMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdateOrderByPkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderByPkMutation, UpdateOrderByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderByPkMutation, UpdateOrderByPkMutationVariables>(UpdateOrderByPkDocument, options);
      }
export type UpdateOrderByPkMutationHookResult = ReturnType<typeof useUpdateOrderByPkMutation>;
export type UpdateOrderByPkMutationResult = Apollo.MutationResult<UpdateOrderByPkMutation>;
export type UpdateOrderByPkMutationOptions = Apollo.BaseMutationOptions<UpdateOrderByPkMutation, UpdateOrderByPkMutationVariables>;
export const GetCarrierActiveOrdersDocument = gql`
    query getCarrierActiveOrders($carrierId: uuid!) {
  order(
    where: {assignment: {carrierId: {_eq: $carrierId}, isActive: {_eq: true}}}
  ) {
    id
    note
    phoneNumber
    receiverName
    status
    subTotal
    deliveredBy
    dropoffLocation
    deliveryCharge
    cancelReason
    basket {
      id
      restaurant {
        id
        name
        phone
      }
      basket_dishes {
        id
        quantity
        dish {
          name
          price
          id
        }
      }
    }
    assignment {
      carrier {
        name
        id
        phone
        status
      }
    }
    created_at
    updated_at
  }
}
    `;

/**
 * __useGetCarrierActiveOrdersQuery__
 *
 * To run a query within a React component, call `useGetCarrierActiveOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarrierActiveOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarrierActiveOrdersQuery({
 *   variables: {
 *      carrierId: // value for 'carrierId'
 *   },
 * });
 */
export function useGetCarrierActiveOrdersQuery(baseOptions: Apollo.QueryHookOptions<GetCarrierActiveOrdersQuery, GetCarrierActiveOrdersQueryVariables> & ({ variables: GetCarrierActiveOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCarrierActiveOrdersQuery, GetCarrierActiveOrdersQueryVariables>(GetCarrierActiveOrdersDocument, options);
      }
export function useGetCarrierActiveOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCarrierActiveOrdersQuery, GetCarrierActiveOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCarrierActiveOrdersQuery, GetCarrierActiveOrdersQueryVariables>(GetCarrierActiveOrdersDocument, options);
        }
export function useGetCarrierActiveOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCarrierActiveOrdersQuery, GetCarrierActiveOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCarrierActiveOrdersQuery, GetCarrierActiveOrdersQueryVariables>(GetCarrierActiveOrdersDocument, options);
        }
export type GetCarrierActiveOrdersQueryHookResult = ReturnType<typeof useGetCarrierActiveOrdersQuery>;
export type GetCarrierActiveOrdersLazyQueryHookResult = ReturnType<typeof useGetCarrierActiveOrdersLazyQuery>;
export type GetCarrierActiveOrdersSuspenseQueryHookResult = ReturnType<typeof useGetCarrierActiveOrdersSuspenseQuery>;
export type GetCarrierActiveOrdersQueryResult = Apollo.QueryResult<GetCarrierActiveOrdersQuery, GetCarrierActiveOrdersQueryVariables>;
export function refetchGetCarrierActiveOrdersQuery(variables: GetCarrierActiveOrdersQueryVariables) {
      return { query: GetCarrierActiveOrdersDocument, variables: variables }
    }
export const GetCarrierDeliveredOrdersDocument = gql`
    query getCarrierDeliveredOrders($carrierId: uuid!, $startDate: timestamptz, $endDate: timestamptz) {
  order(
    where: {assignment: {carrierId: {_eq: $carrierId}, isActive: {_eq: false}}, created_at: {_gte: $startDate, _lte: $endDate}}
  ) {
    id
    note
    phoneNumber
    receiverName
    status
    subTotal
    deliveredBy
    dropoffLocation
    deliveryCharge
    cancelReason
    basket {
      id
      restaurant {
        id
        name
        phone
      }
      basket_dishes {
        id
        quantity
        dish {
          name
          price
          id
        }
      }
    }
    assignment {
      carrier {
        name
        id
        phone
        status
      }
    }
    created_at
    updated_at
  }
}
    `;

/**
 * __useGetCarrierDeliveredOrdersQuery__
 *
 * To run a query within a React component, call `useGetCarrierDeliveredOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarrierDeliveredOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarrierDeliveredOrdersQuery({
 *   variables: {
 *      carrierId: // value for 'carrierId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetCarrierDeliveredOrdersQuery(baseOptions: Apollo.QueryHookOptions<GetCarrierDeliveredOrdersQuery, GetCarrierDeliveredOrdersQueryVariables> & ({ variables: GetCarrierDeliveredOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCarrierDeliveredOrdersQuery, GetCarrierDeliveredOrdersQueryVariables>(GetCarrierDeliveredOrdersDocument, options);
      }
export function useGetCarrierDeliveredOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCarrierDeliveredOrdersQuery, GetCarrierDeliveredOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCarrierDeliveredOrdersQuery, GetCarrierDeliveredOrdersQueryVariables>(GetCarrierDeliveredOrdersDocument, options);
        }
export function useGetCarrierDeliveredOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCarrierDeliveredOrdersQuery, GetCarrierDeliveredOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCarrierDeliveredOrdersQuery, GetCarrierDeliveredOrdersQueryVariables>(GetCarrierDeliveredOrdersDocument, options);
        }
export type GetCarrierDeliveredOrdersQueryHookResult = ReturnType<typeof useGetCarrierDeliveredOrdersQuery>;
export type GetCarrierDeliveredOrdersLazyQueryHookResult = ReturnType<typeof useGetCarrierDeliveredOrdersLazyQuery>;
export type GetCarrierDeliveredOrdersSuspenseQueryHookResult = ReturnType<typeof useGetCarrierDeliveredOrdersSuspenseQuery>;
export type GetCarrierDeliveredOrdersQueryResult = Apollo.QueryResult<GetCarrierDeliveredOrdersQuery, GetCarrierDeliveredOrdersQueryVariables>;
export function refetchGetCarrierDeliveredOrdersQuery(variables: GetCarrierDeliveredOrdersQueryVariables) {
      return { query: GetCarrierDeliveredOrdersDocument, variables: variables }
    }
export const GetActiveOrdersDocument = gql`
    subscription getActiveOrders($includedStates: [String!], $order_by: [order_order_by!], $limit: Int!, $offset: Int!, $_is_null: Boolean) {
  order(
    where: {status: {_in: $includedStates}, settlementId: {_is_null: $_is_null}}
    order_by: $order_by
    limit: $limit
    offset: $offset
  ) {
    id
    note
    phoneNumber
    receiverName
    status
    subTotal
    deliveredBy
    dropoffLocation
    deliveryCharge
    cancelReason
    address
    direction
    basket {
      id
      restaurant {
        id
        name
        phone
      }
      basket_dishes {
        id
        quantity
        dish {
          name
          price
          id
        }
      }
    }
    assignment {
      carrier {
        name
        id
        phone
        status
      }
    }
    created_at
    updated_at
  }
}
    `;

/**
 * __useGetActiveOrdersSubscription__
 *
 * To run a query within a React component, call `useGetActiveOrdersSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveOrdersSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveOrdersSubscription({
 *   variables: {
 *      includedStates: // value for 'includedStates'
 *      order_by: // value for 'order_by'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      _is_null: // value for '_is_null'
 *   },
 * });
 */
export function useGetActiveOrdersSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetActiveOrdersSubscription, GetActiveOrdersSubscriptionVariables> & ({ variables: GetActiveOrdersSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetActiveOrdersSubscription, GetActiveOrdersSubscriptionVariables>(GetActiveOrdersDocument, options);
      }
export type GetActiveOrdersSubscriptionHookResult = ReturnType<typeof useGetActiveOrdersSubscription>;
export type GetActiveOrdersSubscriptionResult = Apollo.SubscriptionResult<GetActiveOrdersSubscription>;
export const GetAllProfilesDocument = gql`
    query GetAllProfiles($offset: Int = 0, $limit: Int = 10, $order_by: [user_profiles_order_by!]) {
  user_profiles(offset: $offset, limit: $limit, order_by: $order_by) {
    id
    full_name
    phone
    gender
    location
    updated_at
    created_at
    gender
    completedRides: free_rides_aggregate(where: {status: {_eq: "completed"}}) {
      aggregate {
        count
      }
    }
    totalRides: free_rides_aggregate {
      aggregate {
        count
      }
    }
  }
  user_profiles_aggregate {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetAllProfilesQuery__
 *
 * To run a query within a React component, call `useGetAllProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProfilesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useGetAllProfilesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllProfilesQuery, GetAllProfilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllProfilesQuery, GetAllProfilesQueryVariables>(GetAllProfilesDocument, options);
      }
export function useGetAllProfilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllProfilesQuery, GetAllProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllProfilesQuery, GetAllProfilesQueryVariables>(GetAllProfilesDocument, options);
        }
export function useGetAllProfilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllProfilesQuery, GetAllProfilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllProfilesQuery, GetAllProfilesQueryVariables>(GetAllProfilesDocument, options);
        }
export type GetAllProfilesQueryHookResult = ReturnType<typeof useGetAllProfilesQuery>;
export type GetAllProfilesLazyQueryHookResult = ReturnType<typeof useGetAllProfilesLazyQuery>;
export type GetAllProfilesSuspenseQueryHookResult = ReturnType<typeof useGetAllProfilesSuspenseQuery>;
export type GetAllProfilesQueryResult = Apollo.QueryResult<GetAllProfilesQuery, GetAllProfilesQueryVariables>;
export function refetchGetAllProfilesQuery(variables?: GetAllProfilesQueryVariables) {
      return { query: GetAllProfilesDocument, variables: variables }
    }
export const GetProfileByIdDocument = gql`
    query GetProfileById($id: uuid!) {
  user_profiles_by_pk(id: $id) {
    id
    full_name
    phone
    gender
    created_at
    updated_at
    location
    blood_group
    blood_donation_consent
    user {
      email
    }
  }
}
    `;

/**
 * __useGetProfileByIdQuery__
 *
 * To run a query within a React component, call `useGetProfileByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProfileByIdQuery(baseOptions: Apollo.QueryHookOptions<GetProfileByIdQuery, GetProfileByIdQueryVariables> & ({ variables: GetProfileByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProfileByIdQuery, GetProfileByIdQueryVariables>(GetProfileByIdDocument, options);
      }
export function useGetProfileByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProfileByIdQuery, GetProfileByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProfileByIdQuery, GetProfileByIdQueryVariables>(GetProfileByIdDocument, options);
        }
export function useGetProfileByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProfileByIdQuery, GetProfileByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProfileByIdQuery, GetProfileByIdQueryVariables>(GetProfileByIdDocument, options);
        }
export type GetProfileByIdQueryHookResult = ReturnType<typeof useGetProfileByIdQuery>;
export type GetProfileByIdLazyQueryHookResult = ReturnType<typeof useGetProfileByIdLazyQuery>;
export type GetProfileByIdSuspenseQueryHookResult = ReturnType<typeof useGetProfileByIdSuspenseQuery>;
export type GetProfileByIdQueryResult = Apollo.QueryResult<GetProfileByIdQuery, GetProfileByIdQueryVariables>;
export function refetchGetProfileByIdQuery(variables: GetProfileByIdQueryVariables) {
      return { query: GetProfileByIdDocument, variables: variables }
    }
export const UpdateProfileDocument = gql`
    mutation UpdateProfile($pk_columns: user_profiles_pk_columns_input!, $_set: user_profiles_set_input!) {
  update_user_profiles_by_pk(pk_columns: $pk_columns, _set: $_set) {
    id
  }
}
    `;
export type UpdateProfileMutationFn = Apollo.MutationFunction<UpdateProfileMutation, UpdateProfileMutationVariables>;

/**
 * __useUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileMutation, { data, loading, error }] = useUpdateProfileMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdateProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileMutation, UpdateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProfileMutation, UpdateProfileMutationVariables>(UpdateProfileDocument, options);
      }
export type UpdateProfileMutationHookResult = ReturnType<typeof useUpdateProfileMutation>;
export type UpdateProfileMutationResult = Apollo.MutationResult<UpdateProfileMutation>;
export type UpdateProfileMutationOptions = Apollo.BaseMutationOptions<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const GetMyRestaurantDocument = gql`
    query getMyRestaurant($id: uuid!) {
  restaurant(where: {userId: {_eq: $id}}) {
    id
    name
    location
  }
}
    `;

/**
 * __useGetMyRestaurantQuery__
 *
 * To run a query within a React component, call `useGetMyRestaurantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyRestaurantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyRestaurantQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMyRestaurantQuery(baseOptions: Apollo.QueryHookOptions<GetMyRestaurantQuery, GetMyRestaurantQueryVariables> & ({ variables: GetMyRestaurantQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyRestaurantQuery, GetMyRestaurantQueryVariables>(GetMyRestaurantDocument, options);
      }
export function useGetMyRestaurantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyRestaurantQuery, GetMyRestaurantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyRestaurantQuery, GetMyRestaurantQueryVariables>(GetMyRestaurantDocument, options);
        }
export function useGetMyRestaurantSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyRestaurantQuery, GetMyRestaurantQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyRestaurantQuery, GetMyRestaurantQueryVariables>(GetMyRestaurantDocument, options);
        }
export type GetMyRestaurantQueryHookResult = ReturnType<typeof useGetMyRestaurantQuery>;
export type GetMyRestaurantLazyQueryHookResult = ReturnType<typeof useGetMyRestaurantLazyQuery>;
export type GetMyRestaurantSuspenseQueryHookResult = ReturnType<typeof useGetMyRestaurantSuspenseQuery>;
export type GetMyRestaurantQueryResult = Apollo.QueryResult<GetMyRestaurantQuery, GetMyRestaurantQueryVariables>;
export function refetchGetMyRestaurantQuery(variables: GetMyRestaurantQueryVariables) {
      return { query: GetMyRestaurantDocument, variables: variables }
    }
export const GetRestaurantByPkDocument = gql`
    query getRestaurantByPk($id: uuid!) {
  restaurant_by_pk(id: $id) {
    id
    cover
    address
    created_at
    admin_commission
    delivery_charge
    delivery_commission
    description
    email
    free_distance
    genre
    image
    location
    max_distance
    name
    phone
    rating
    revenue
    short_description
    specialtyId
    isActive
    type
    threshold_amount
    min_order_amount
    opening_hour
    closing_hour
    weekly_off_days
    specialty {
      id
      name
    }
  }
}
    `;

/**
 * __useGetRestaurantByPkQuery__
 *
 * To run a query within a React component, call `useGetRestaurantByPkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantByPkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantByPkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRestaurantByPkQuery(baseOptions: Apollo.QueryHookOptions<GetRestaurantByPkQuery, GetRestaurantByPkQueryVariables> & ({ variables: GetRestaurantByPkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRestaurantByPkQuery, GetRestaurantByPkQueryVariables>(GetRestaurantByPkDocument, options);
      }
export function useGetRestaurantByPkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRestaurantByPkQuery, GetRestaurantByPkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRestaurantByPkQuery, GetRestaurantByPkQueryVariables>(GetRestaurantByPkDocument, options);
        }
export function useGetRestaurantByPkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRestaurantByPkQuery, GetRestaurantByPkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRestaurantByPkQuery, GetRestaurantByPkQueryVariables>(GetRestaurantByPkDocument, options);
        }
export type GetRestaurantByPkQueryHookResult = ReturnType<typeof useGetRestaurantByPkQuery>;
export type GetRestaurantByPkLazyQueryHookResult = ReturnType<typeof useGetRestaurantByPkLazyQuery>;
export type GetRestaurantByPkSuspenseQueryHookResult = ReturnType<typeof useGetRestaurantByPkSuspenseQuery>;
export type GetRestaurantByPkQueryResult = Apollo.QueryResult<GetRestaurantByPkQuery, GetRestaurantByPkQueryVariables>;
export function refetchGetRestaurantByPkQuery(variables: GetRestaurantByPkQueryVariables) {
      return { query: GetRestaurantByPkDocument, variables: variables }
    }
export const GetRestaurantByUserIdDocument = gql`
    query getRestaurantByUserId($userId: uuid!) {
  restaurant(where: {userId: {_eq: $userId}}) {
    id
    cover
    address
    created_at
    admin_commission
    delivery_charge
    delivery_commission
    description
    email
    free_distance
    genre
    image
    location
    max_distance
    name
    phone
    rating
    revenue
    short_description
    specialtyId
    isActive
    type
    threshold_amount
    min_order_amount
    opening_hour
    closing_hour
    weekly_off_days
    specialty {
      id
      name
    }
    carriers {
      id
      name
      image
      isOnline
      verification_status
    }
  }
}
    `;

/**
 * __useGetRestaurantByUserIdQuery__
 *
 * To run a query within a React component, call `useGetRestaurantByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantByUserIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetRestaurantByUserIdQuery(baseOptions: Apollo.QueryHookOptions<GetRestaurantByUserIdQuery, GetRestaurantByUserIdQueryVariables> & ({ variables: GetRestaurantByUserIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRestaurantByUserIdQuery, GetRestaurantByUserIdQueryVariables>(GetRestaurantByUserIdDocument, options);
      }
export function useGetRestaurantByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRestaurantByUserIdQuery, GetRestaurantByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRestaurantByUserIdQuery, GetRestaurantByUserIdQueryVariables>(GetRestaurantByUserIdDocument, options);
        }
export function useGetRestaurantByUserIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRestaurantByUserIdQuery, GetRestaurantByUserIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRestaurantByUserIdQuery, GetRestaurantByUserIdQueryVariables>(GetRestaurantByUserIdDocument, options);
        }
export type GetRestaurantByUserIdQueryHookResult = ReturnType<typeof useGetRestaurantByUserIdQuery>;
export type GetRestaurantByUserIdLazyQueryHookResult = ReturnType<typeof useGetRestaurantByUserIdLazyQuery>;
export type GetRestaurantByUserIdSuspenseQueryHookResult = ReturnType<typeof useGetRestaurantByUserIdSuspenseQuery>;
export type GetRestaurantByUserIdQueryResult = Apollo.QueryResult<GetRestaurantByUserIdQuery, GetRestaurantByUserIdQueryVariables>;
export function refetchGetRestaurantByUserIdQuery(variables: GetRestaurantByUserIdQueryVariables) {
      return { query: GetRestaurantByUserIdDocument, variables: variables }
    }
export const GetAllRestaurantsDocument = gql`
    query getAllRestaurants {
  restaurant {
    id
    email
    revenue
    rating
    admin_commission
    short_description
    isActive
    threshold_amount
    updated_at
    phone
    name
    max_distance
    location
    genre
    free_distance
    description
    delivery_commission
    delivery_charge
    address
    created_at
    userId
    cover
    image
    specialtyId
    isActive
    type
    threshold_amount
    min_order_amount
    opening_hour
    closing_hour
    weekly_off_days
    specialty {
      id
      name
    }
  }
}
    `;

/**
 * __useGetAllRestaurantsQuery__
 *
 * To run a query within a React component, call `useGetAllRestaurantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRestaurantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRestaurantsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllRestaurantsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRestaurantsQuery, GetAllRestaurantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRestaurantsQuery, GetAllRestaurantsQueryVariables>(GetAllRestaurantsDocument, options);
      }
export function useGetAllRestaurantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRestaurantsQuery, GetAllRestaurantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRestaurantsQuery, GetAllRestaurantsQueryVariables>(GetAllRestaurantsDocument, options);
        }
export function useGetAllRestaurantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRestaurantsQuery, GetAllRestaurantsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRestaurantsQuery, GetAllRestaurantsQueryVariables>(GetAllRestaurantsDocument, options);
        }
export type GetAllRestaurantsQueryHookResult = ReturnType<typeof useGetAllRestaurantsQuery>;
export type GetAllRestaurantsLazyQueryHookResult = ReturnType<typeof useGetAllRestaurantsLazyQuery>;
export type GetAllRestaurantsSuspenseQueryHookResult = ReturnType<typeof useGetAllRestaurantsSuspenseQuery>;
export type GetAllRestaurantsQueryResult = Apollo.QueryResult<GetAllRestaurantsQuery, GetAllRestaurantsQueryVariables>;
export function refetchGetAllRestaurantsQuery(variables?: GetAllRestaurantsQueryVariables) {
      return { query: GetAllRestaurantsDocument, variables: variables }
    }
export const SearchResturantDocument = gql`
    query searchResturant($searchTerm: String) {
  restaurant(where: {name: {_iregex: $searchTerm}}) {
    id
    email
    revenue
    rating
    admin_commission
    short_description
    isActive
    threshold_amount
    updated_at
    phone
    name
    max_distance
    location
    genre
    free_distance
    description
    delivery_commission
    delivery_charge
    address
    created_at
    userId
    isActive
    type
    threshold_amount
    min_order_amount
    opening_hour
    closing_hour
    weekly_off_days
  }
}
    `;

/**
 * __useSearchResturantQuery__
 *
 * To run a query within a React component, call `useSearchResturantQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchResturantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchResturantQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useSearchResturantQuery(baseOptions?: Apollo.QueryHookOptions<SearchResturantQuery, SearchResturantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchResturantQuery, SearchResturantQueryVariables>(SearchResturantDocument, options);
      }
export function useSearchResturantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchResturantQuery, SearchResturantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchResturantQuery, SearchResturantQueryVariables>(SearchResturantDocument, options);
        }
export function useSearchResturantSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchResturantQuery, SearchResturantQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchResturantQuery, SearchResturantQueryVariables>(SearchResturantDocument, options);
        }
export type SearchResturantQueryHookResult = ReturnType<typeof useSearchResturantQuery>;
export type SearchResturantLazyQueryHookResult = ReturnType<typeof useSearchResturantLazyQuery>;
export type SearchResturantSuspenseQueryHookResult = ReturnType<typeof useSearchResturantSuspenseQuery>;
export type SearchResturantQueryResult = Apollo.QueryResult<SearchResturantQuery, SearchResturantQueryVariables>;
export function refetchSearchResturantQuery(variables?: SearchResturantQueryVariables) {
      return { query: SearchResturantDocument, variables: variables }
    }
export const InsertRestaurantOneDocument = gql`
    mutation insertRestaurantOne($insert_restaurant_inputs: restaurant_insert_input!) {
  insert_restaurant_one(object: $insert_restaurant_inputs) {
    id
  }
}
    `;
export type InsertRestaurantOneMutationFn = Apollo.MutationFunction<InsertRestaurantOneMutation, InsertRestaurantOneMutationVariables>;

/**
 * __useInsertRestaurantOneMutation__
 *
 * To run a mutation, you first call `useInsertRestaurantOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertRestaurantOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertRestaurantOneMutation, { data, loading, error }] = useInsertRestaurantOneMutation({
 *   variables: {
 *      insert_restaurant_inputs: // value for 'insert_restaurant_inputs'
 *   },
 * });
 */
export function useInsertRestaurantOneMutation(baseOptions?: Apollo.MutationHookOptions<InsertRestaurantOneMutation, InsertRestaurantOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertRestaurantOneMutation, InsertRestaurantOneMutationVariables>(InsertRestaurantOneDocument, options);
      }
export type InsertRestaurantOneMutationHookResult = ReturnType<typeof useInsertRestaurantOneMutation>;
export type InsertRestaurantOneMutationResult = Apollo.MutationResult<InsertRestaurantOneMutation>;
export type InsertRestaurantOneMutationOptions = Apollo.BaseMutationOptions<InsertRestaurantOneMutation, InsertRestaurantOneMutationVariables>;
export const UpdateRestaurantDocument = gql`
    mutation updateRestaurant($pk_columns: restaurant_pk_columns_input!, $_set: restaurant_set_input!) {
  update_restaurant_by_pk(pk_columns: $pk_columns, _set: $_set) {
    id
  }
}
    `;
export type UpdateRestaurantMutationFn = Apollo.MutationFunction<UpdateRestaurantMutation, UpdateRestaurantMutationVariables>;

/**
 * __useUpdateRestaurantMutation__
 *
 * To run a mutation, you first call `useUpdateRestaurantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRestaurantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRestaurantMutation, { data, loading, error }] = useUpdateRestaurantMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdateRestaurantMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRestaurantMutation, UpdateRestaurantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRestaurantMutation, UpdateRestaurantMutationVariables>(UpdateRestaurantDocument, options);
      }
export type UpdateRestaurantMutationHookResult = ReturnType<typeof useUpdateRestaurantMutation>;
export type UpdateRestaurantMutationResult = Apollo.MutationResult<UpdateRestaurantMutation>;
export type UpdateRestaurantMutationOptions = Apollo.BaseMutationOptions<UpdateRestaurantMutation, UpdateRestaurantMutationVariables>;
export const UpdateRestaurantValidityAndStateDocument = gql`
    mutation updateRestaurantValidityAndState($pk_columns: restaurant_pk_columns_input!, $_set: restaurant_set_input!) {
  update_restaurant_by_pk(pk_columns: $pk_columns, _set: $_set) {
    id
  }
}
    `;
export type UpdateRestaurantValidityAndStateMutationFn = Apollo.MutationFunction<UpdateRestaurantValidityAndStateMutation, UpdateRestaurantValidityAndStateMutationVariables>;

/**
 * __useUpdateRestaurantValidityAndStateMutation__
 *
 * To run a mutation, you first call `useUpdateRestaurantValidityAndStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRestaurantValidityAndStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRestaurantValidityAndStateMutation, { data, loading, error }] = useUpdateRestaurantValidityAndStateMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdateRestaurantValidityAndStateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRestaurantValidityAndStateMutation, UpdateRestaurantValidityAndStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRestaurantValidityAndStateMutation, UpdateRestaurantValidityAndStateMutationVariables>(UpdateRestaurantValidityAndStateDocument, options);
      }
export type UpdateRestaurantValidityAndStateMutationHookResult = ReturnType<typeof useUpdateRestaurantValidityAndStateMutation>;
export type UpdateRestaurantValidityAndStateMutationResult = Apollo.MutationResult<UpdateRestaurantValidityAndStateMutation>;
export type UpdateRestaurantValidityAndStateMutationOptions = Apollo.BaseMutationOptions<UpdateRestaurantValidityAndStateMutation, UpdateRestaurantValidityAndStateMutationVariables>;
export const GetResturantByEmailDocument = gql`
    query getResturantByEmail($email: String!) {
  restaurant(where: {email: {_eq: $email}}) {
    id
  }
}
    `;

/**
 * __useGetResturantByEmailQuery__
 *
 * To run a query within a React component, call `useGetResturantByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResturantByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResturantByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetResturantByEmailQuery(baseOptions: Apollo.QueryHookOptions<GetResturantByEmailQuery, GetResturantByEmailQueryVariables> & ({ variables: GetResturantByEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResturantByEmailQuery, GetResturantByEmailQueryVariables>(GetResturantByEmailDocument, options);
      }
export function useGetResturantByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResturantByEmailQuery, GetResturantByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResturantByEmailQuery, GetResturantByEmailQueryVariables>(GetResturantByEmailDocument, options);
        }
export function useGetResturantByEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetResturantByEmailQuery, GetResturantByEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetResturantByEmailQuery, GetResturantByEmailQueryVariables>(GetResturantByEmailDocument, options);
        }
export type GetResturantByEmailQueryHookResult = ReturnType<typeof useGetResturantByEmailQuery>;
export type GetResturantByEmailLazyQueryHookResult = ReturnType<typeof useGetResturantByEmailLazyQuery>;
export type GetResturantByEmailSuspenseQueryHookResult = ReturnType<typeof useGetResturantByEmailSuspenseQuery>;
export type GetResturantByEmailQueryResult = Apollo.QueryResult<GetResturantByEmailQuery, GetResturantByEmailQueryVariables>;
export function refetchGetResturantByEmailQuery(variables: GetResturantByEmailQueryVariables) {
      return { query: GetResturantByEmailDocument, variables: variables }
    }
export const GetAllRidesDocument = gql`
    query GetAllRides($limit: Int = 10, $offset: Int = 0, $startDate: timestamptz = "1970-01-01T00:00:00Z", $endDate: timestamptz = "2100-12-31T23:59:59Z") {
  free_rides(
    order_by: {created_at: desc}
    limit: $limit
    offset: $offset
    where: {created_at: {_gte: $startDate, _lte: $endDate}}
  ) {
    id
    status
    is_active
    pickup_address
    pickup_location
    dropoff_address
    dropoff_location
    created_at
    updated_at
    cancel_reason
    driver {
      id
      name
      phone_number
      local_unit
      street_address
      vehicle {
        id
        vehicle_type
        model
        make
      }
    }
    user_profile {
      id
      full_name
      phone
    }
  }
}
    `;

/**
 * __useGetAllRidesQuery__
 *
 * To run a query within a React component, call `useGetAllRidesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRidesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRidesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetAllRidesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRidesQuery, GetAllRidesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRidesQuery, GetAllRidesQueryVariables>(GetAllRidesDocument, options);
      }
export function useGetAllRidesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRidesQuery, GetAllRidesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRidesQuery, GetAllRidesQueryVariables>(GetAllRidesDocument, options);
        }
export function useGetAllRidesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRidesQuery, GetAllRidesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRidesQuery, GetAllRidesQueryVariables>(GetAllRidesDocument, options);
        }
export type GetAllRidesQueryHookResult = ReturnType<typeof useGetAllRidesQuery>;
export type GetAllRidesLazyQueryHookResult = ReturnType<typeof useGetAllRidesLazyQuery>;
export type GetAllRidesSuspenseQueryHookResult = ReturnType<typeof useGetAllRidesSuspenseQuery>;
export type GetAllRidesQueryResult = Apollo.QueryResult<GetAllRidesQuery, GetAllRidesQueryVariables>;
export function refetchGetAllRidesQuery(variables?: GetAllRidesQueryVariables) {
      return { query: GetAllRidesDocument, variables: variables }
    }
export const GetRidesByStatusDocument = gql`
    query GetRidesByStatus($limit: Int = 10, $offset: Int = 0, $startDate: timestamptz = "1970-01-01T00:00:00Z", $endDate: timestamptz = "2100-12-31T23:59:59Z", $status: String!) {
  free_rides(
    order_by: {created_at: desc}
    limit: $limit
    offset: $offset
    where: {created_at: {_gte: $startDate, _lte: $endDate}, status: {_eq: $status}}
  ) {
    id
    status
    is_active
    pickup_address
    pickup_location
    dropoff_address
    dropoff_location
    created_at
    updated_at
    cancel_reason
    driver {
      id
      name
      phone_number
      local_unit
      street_address
      vehicle {
        id
        vehicle_type
        model
        make
      }
    }
    user_profile {
      id
      full_name
      phone
    }
  }
}
    `;

/**
 * __useGetRidesByStatusQuery__
 *
 * To run a query within a React component, call `useGetRidesByStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRidesByStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRidesByStatusQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetRidesByStatusQuery(baseOptions: Apollo.QueryHookOptions<GetRidesByStatusQuery, GetRidesByStatusQueryVariables> & ({ variables: GetRidesByStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRidesByStatusQuery, GetRidesByStatusQueryVariables>(GetRidesByStatusDocument, options);
      }
export function useGetRidesByStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRidesByStatusQuery, GetRidesByStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRidesByStatusQuery, GetRidesByStatusQueryVariables>(GetRidesByStatusDocument, options);
        }
export function useGetRidesByStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRidesByStatusQuery, GetRidesByStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRidesByStatusQuery, GetRidesByStatusQueryVariables>(GetRidesByStatusDocument, options);
        }
export type GetRidesByStatusQueryHookResult = ReturnType<typeof useGetRidesByStatusQuery>;
export type GetRidesByStatusLazyQueryHookResult = ReturnType<typeof useGetRidesByStatusLazyQuery>;
export type GetRidesByStatusSuspenseQueryHookResult = ReturnType<typeof useGetRidesByStatusSuspenseQuery>;
export type GetRidesByStatusQueryResult = Apollo.QueryResult<GetRidesByStatusQuery, GetRidesByStatusQueryVariables>;
export function refetchGetRidesByStatusQuery(variables: GetRidesByStatusQueryVariables) {
      return { query: GetRidesByStatusDocument, variables: variables }
    }
export const GetRideByDriverIdDocument = gql`
    query GetRideByDriverId($driverId: uuid!, $limit: Int = 10, $offset: Int = 0) {
  free_rides(
    where: {driver_id: {_eq: $driverId}}
    order_by: {created_at: desc}
    limit: $limit
    offset: $offset
  ) {
    status
    id
    is_active
    pickup_address
    pickup_location
    dropoff_address
    dropoff_location
    created_at
    updated_at
    cancel_reason
    driver {
      id
      name
      phone_number
      local_unit
      street_address
      vehicle {
        id
        vehicle_type
        model
        make
      }
    }
    user_profile {
      id
      full_name
      phone
    }
  }
}
    `;

/**
 * __useGetRideByDriverIdQuery__
 *
 * To run a query within a React component, call `useGetRideByDriverIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRideByDriverIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRideByDriverIdQuery({
 *   variables: {
 *      driverId: // value for 'driverId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetRideByDriverIdQuery(baseOptions: Apollo.QueryHookOptions<GetRideByDriverIdQuery, GetRideByDriverIdQueryVariables> & ({ variables: GetRideByDriverIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRideByDriverIdQuery, GetRideByDriverIdQueryVariables>(GetRideByDriverIdDocument, options);
      }
export function useGetRideByDriverIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRideByDriverIdQuery, GetRideByDriverIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRideByDriverIdQuery, GetRideByDriverIdQueryVariables>(GetRideByDriverIdDocument, options);
        }
export function useGetRideByDriverIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRideByDriverIdQuery, GetRideByDriverIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRideByDriverIdQuery, GetRideByDriverIdQueryVariables>(GetRideByDriverIdDocument, options);
        }
export type GetRideByDriverIdQueryHookResult = ReturnType<typeof useGetRideByDriverIdQuery>;
export type GetRideByDriverIdLazyQueryHookResult = ReturnType<typeof useGetRideByDriverIdLazyQuery>;
export type GetRideByDriverIdSuspenseQueryHookResult = ReturnType<typeof useGetRideByDriverIdSuspenseQuery>;
export type GetRideByDriverIdQueryResult = Apollo.QueryResult<GetRideByDriverIdQuery, GetRideByDriverIdQueryVariables>;
export function refetchGetRideByDriverIdQuery(variables: GetRideByDriverIdQueryVariables) {
      return { query: GetRideByDriverIdDocument, variables: variables }
    }
export const GetRideByUserProfileIdDocument = gql`
    query GetRideByUserProfileId($profileId: uuid!, $limit: Int = 10, $offset: Int = 0) {
  free_rides(
    where: {profile_id: {_eq: $profileId}}
    order_by: {created_at: desc}
    limit: $limit
    offset: $offset
  ) {
    cancel_reason
    created_at
    driver_id
    dropoff_address
    dropoff_location
    id
    is_active
    pickup_address
    pickup_location
    profile_id
    driver {
      id
      name
      phone_number
      local_unit
      street_address
      vehicle {
        id
        vehicle_type
        model
        make
      }
    }
    status
    updated_at
    user_profile {
      id
      full_name
      phone
    }
  }
  completed_rides_count: free_rides_aggregate(
    where: {_and: [{status: {_eq: "completed"}}, {profile_id: {_eq: $profileId}}]}
  ) {
    aggregate {
      count
    }
  }
  cancelled_rides_count: free_rides_aggregate(
    where: {_and: [{status: {_eq: "cancelled"}}, {profile_id: {_eq: $profileId}}]}
  ) {
    aggregate {
      count
    }
  }
  total_rides_count: free_rides_aggregate(
    where: {_and: [{profile_id: {_eq: $profileId}}]}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetRideByUserProfileIdQuery__
 *
 * To run a query within a React component, call `useGetRideByUserProfileIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRideByUserProfileIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRideByUserProfileIdQuery({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetRideByUserProfileIdQuery(baseOptions: Apollo.QueryHookOptions<GetRideByUserProfileIdQuery, GetRideByUserProfileIdQueryVariables> & ({ variables: GetRideByUserProfileIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRideByUserProfileIdQuery, GetRideByUserProfileIdQueryVariables>(GetRideByUserProfileIdDocument, options);
      }
export function useGetRideByUserProfileIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRideByUserProfileIdQuery, GetRideByUserProfileIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRideByUserProfileIdQuery, GetRideByUserProfileIdQueryVariables>(GetRideByUserProfileIdDocument, options);
        }
export function useGetRideByUserProfileIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRideByUserProfileIdQuery, GetRideByUserProfileIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRideByUserProfileIdQuery, GetRideByUserProfileIdQueryVariables>(GetRideByUserProfileIdDocument, options);
        }
export type GetRideByUserProfileIdQueryHookResult = ReturnType<typeof useGetRideByUserProfileIdQuery>;
export type GetRideByUserProfileIdLazyQueryHookResult = ReturnType<typeof useGetRideByUserProfileIdLazyQuery>;
export type GetRideByUserProfileIdSuspenseQueryHookResult = ReturnType<typeof useGetRideByUserProfileIdSuspenseQuery>;
export type GetRideByUserProfileIdQueryResult = Apollo.QueryResult<GetRideByUserProfileIdQuery, GetRideByUserProfileIdQueryVariables>;
export function refetchGetRideByUserProfileIdQuery(variables: GetRideByUserProfileIdQueryVariables) {
      return { query: GetRideByUserProfileIdDocument, variables: variables }
    }
export const GetRidesCountDocument = gql`
    query GetRidesCount($startDate: timestamptz = "1970-01-01T00:00:00Z", $endDate: timestamptz = "2100-12-31T23:59:59Z") {
  completed_rides_count: free_rides_aggregate(
    where: {_and: [{status: {_eq: "completed"}}, {created_at: {_gte: $startDate, _lte: $endDate}}]}
  ) {
    aggregate {
      count
    }
  }
  cancelled_rides_count: free_rides_aggregate(
    where: {_and: [{status: {_eq: "cancelled"}}, {created_at: {_gte: $startDate, _lte: $endDate}}]}
  ) {
    aggregate {
      count
    }
  }
  total_rides_count: free_rides_aggregate(
    where: {_and: [{created_at: {_gte: $startDate, _lte: $endDate}}]}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetRidesCountQuery__
 *
 * To run a query within a React component, call `useGetRidesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRidesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRidesCountQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetRidesCountQuery(baseOptions?: Apollo.QueryHookOptions<GetRidesCountQuery, GetRidesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRidesCountQuery, GetRidesCountQueryVariables>(GetRidesCountDocument, options);
      }
export function useGetRidesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRidesCountQuery, GetRidesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRidesCountQuery, GetRidesCountQueryVariables>(GetRidesCountDocument, options);
        }
export function useGetRidesCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRidesCountQuery, GetRidesCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRidesCountQuery, GetRidesCountQueryVariables>(GetRidesCountDocument, options);
        }
export type GetRidesCountQueryHookResult = ReturnType<typeof useGetRidesCountQuery>;
export type GetRidesCountLazyQueryHookResult = ReturnType<typeof useGetRidesCountLazyQuery>;
export type GetRidesCountSuspenseQueryHookResult = ReturnType<typeof useGetRidesCountSuspenseQuery>;
export type GetRidesCountQueryResult = Apollo.QueryResult<GetRidesCountQuery, GetRidesCountQueryVariables>;
export function refetchGetRidesCountQuery(variables?: GetRidesCountQueryVariables) {
      return { query: GetRidesCountDocument, variables: variables }
    }
export const GetAllSpecialitiesDocument = gql`
    query getAllSpecialities($order_by: [specialty_order_by!]) {
  specialty(order_by: $order_by) {
    id
    name
    restaurants_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetAllSpecialitiesQuery__
 *
 * To run a query within a React component, call `useGetAllSpecialitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSpecialitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSpecialitiesQuery({
 *   variables: {
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useGetAllSpecialitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllSpecialitiesQuery, GetAllSpecialitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllSpecialitiesQuery, GetAllSpecialitiesQueryVariables>(GetAllSpecialitiesDocument, options);
      }
export function useGetAllSpecialitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllSpecialitiesQuery, GetAllSpecialitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllSpecialitiesQuery, GetAllSpecialitiesQueryVariables>(GetAllSpecialitiesDocument, options);
        }
export function useGetAllSpecialitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllSpecialitiesQuery, GetAllSpecialitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllSpecialitiesQuery, GetAllSpecialitiesQueryVariables>(GetAllSpecialitiesDocument, options);
        }
export type GetAllSpecialitiesQueryHookResult = ReturnType<typeof useGetAllSpecialitiesQuery>;
export type GetAllSpecialitiesLazyQueryHookResult = ReturnType<typeof useGetAllSpecialitiesLazyQuery>;
export type GetAllSpecialitiesSuspenseQueryHookResult = ReturnType<typeof useGetAllSpecialitiesSuspenseQuery>;
export type GetAllSpecialitiesQueryResult = Apollo.QueryResult<GetAllSpecialitiesQuery, GetAllSpecialitiesQueryVariables>;
export function refetchGetAllSpecialitiesQuery(variables?: GetAllSpecialitiesQueryVariables) {
      return { query: GetAllSpecialitiesDocument, variables: variables }
    }
export const InsertSpecialtyOneDocument = gql`
    mutation insertSpecialtyOne($object: specialty_insert_input!) {
  insert_specialty_one(object: $object) {
    id
  }
}
    `;
export type InsertSpecialtyOneMutationFn = Apollo.MutationFunction<InsertSpecialtyOneMutation, InsertSpecialtyOneMutationVariables>;

/**
 * __useInsertSpecialtyOneMutation__
 *
 * To run a mutation, you first call `useInsertSpecialtyOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertSpecialtyOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertSpecialtyOneMutation, { data, loading, error }] = useInsertSpecialtyOneMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertSpecialtyOneMutation(baseOptions?: Apollo.MutationHookOptions<InsertSpecialtyOneMutation, InsertSpecialtyOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertSpecialtyOneMutation, InsertSpecialtyOneMutationVariables>(InsertSpecialtyOneDocument, options);
      }
export type InsertSpecialtyOneMutationHookResult = ReturnType<typeof useInsertSpecialtyOneMutation>;
export type InsertSpecialtyOneMutationResult = Apollo.MutationResult<InsertSpecialtyOneMutation>;
export type InsertSpecialtyOneMutationOptions = Apollo.BaseMutationOptions<InsertSpecialtyOneMutation, InsertSpecialtyOneMutationVariables>;
export const UpdateSpecilityByPkDocument = gql`
    mutation updateSpecilityByPk($pk_columns: specialty_pk_columns_input!, $_set: specialty_set_input!) {
  update_specialty_by_pk(pk_columns: $pk_columns, _set: $_set) {
    id
  }
}
    `;
export type UpdateSpecilityByPkMutationFn = Apollo.MutationFunction<UpdateSpecilityByPkMutation, UpdateSpecilityByPkMutationVariables>;

/**
 * __useUpdateSpecilityByPkMutation__
 *
 * To run a mutation, you first call `useUpdateSpecilityByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpecilityByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpecilityByPkMutation, { data, loading, error }] = useUpdateSpecilityByPkMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdateSpecilityByPkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSpecilityByPkMutation, UpdateSpecilityByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSpecilityByPkMutation, UpdateSpecilityByPkMutationVariables>(UpdateSpecilityByPkDocument, options);
      }
export type UpdateSpecilityByPkMutationHookResult = ReturnType<typeof useUpdateSpecilityByPkMutation>;
export type UpdateSpecilityByPkMutationResult = Apollo.MutationResult<UpdateSpecilityByPkMutation>;
export type UpdateSpecilityByPkMutationOptions = Apollo.BaseMutationOptions<UpdateSpecilityByPkMutation, UpdateSpecilityByPkMutationVariables>;
export const DeleteSpecialtyByPkDocument = gql`
    mutation deleteSpecialtyByPk($id: uuid!) {
  delete_specialty_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteSpecialtyByPkMutationFn = Apollo.MutationFunction<DeleteSpecialtyByPkMutation, DeleteSpecialtyByPkMutationVariables>;

/**
 * __useDeleteSpecialtyByPkMutation__
 *
 * To run a mutation, you first call `useDeleteSpecialtyByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSpecialtyByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSpecialtyByPkMutation, { data, loading, error }] = useDeleteSpecialtyByPkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSpecialtyByPkMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSpecialtyByPkMutation, DeleteSpecialtyByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSpecialtyByPkMutation, DeleteSpecialtyByPkMutationVariables>(DeleteSpecialtyByPkDocument, options);
      }
export type DeleteSpecialtyByPkMutationHookResult = ReturnType<typeof useDeleteSpecialtyByPkMutation>;
export type DeleteSpecialtyByPkMutationResult = Apollo.MutationResult<DeleteSpecialtyByPkMutation>;
export type DeleteSpecialtyByPkMutationOptions = Apollo.BaseMutationOptions<DeleteSpecialtyByPkMutation, DeleteSpecialtyByPkMutationVariables>;
export const SubscribeToActiveRideRequestsDocument = gql`
    subscription SubscribeToActiveRideRequests {
  free_rides(
    where: {_and: [{is_active: {_eq: true}}, {status: {_eq: "pending"}}]}
    order_by: {created_at: desc}
    limit: 2
  ) {
    id
    created_at
    user_profile {
      full_name
    }
    pickup_address
  }
}
    `;

/**
 * __useSubscribeToActiveRideRequestsSubscription__
 *
 * To run a query within a React component, call `useSubscribeToActiveRideRequestsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToActiveRideRequestsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToActiveRideRequestsSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSubscribeToActiveRideRequestsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SubscribeToActiveRideRequestsSubscription, SubscribeToActiveRideRequestsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToActiveRideRequestsSubscription, SubscribeToActiveRideRequestsSubscriptionVariables>(SubscribeToActiveRideRequestsDocument, options);
      }
export type SubscribeToActiveRideRequestsSubscriptionHookResult = ReturnType<typeof useSubscribeToActiveRideRequestsSubscription>;
export type SubscribeToActiveRideRequestsSubscriptionResult = Apollo.SubscriptionResult<SubscribeToActiveRideRequestsSubscription>;
export const GetUserDocument = gql`
    query getUser($id: uuid!) {
  user(id: $id) {
    id
    email
    displayName
    defaultRole
    metadata
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables> & ({ variables: GetUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export function refetchGetUserQuery(variables: GetUserQueryVariables) {
      return { query: GetUserDocument, variables: variables }
    }
export const GetUserByEmailDocument = gql`
    query getUserByEmail($email: citext!) {
  users(where: {email: {_eq: $email}}) {
    id
    email
  }
}
    `;

/**
 * __useGetUserByEmailQuery__
 *
 * To run a query within a React component, call `useGetUserByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetUserByEmailQuery(baseOptions: Apollo.QueryHookOptions<GetUserByEmailQuery, GetUserByEmailQueryVariables> & ({ variables: GetUserByEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserByEmailQuery, GetUserByEmailQueryVariables>(GetUserByEmailDocument, options);
      }
export function useGetUserByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserByEmailQuery, GetUserByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserByEmailQuery, GetUserByEmailQueryVariables>(GetUserByEmailDocument, options);
        }
export function useGetUserByEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserByEmailQuery, GetUserByEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserByEmailQuery, GetUserByEmailQueryVariables>(GetUserByEmailDocument, options);
        }
export type GetUserByEmailQueryHookResult = ReturnType<typeof useGetUserByEmailQuery>;
export type GetUserByEmailLazyQueryHookResult = ReturnType<typeof useGetUserByEmailLazyQuery>;
export type GetUserByEmailSuspenseQueryHookResult = ReturnType<typeof useGetUserByEmailSuspenseQuery>;
export type GetUserByEmailQueryResult = Apollo.QueryResult<GetUserByEmailQuery, GetUserByEmailQueryVariables>;
export function refetchGetUserByEmailQuery(variables: GetUserByEmailQueryVariables) {
      return { query: GetUserByEmailDocument, variables: variables }
    }
export const SearchUserByEmailDocument = gql`
    query searchUserByEmail($searchTerm: citext) {
  users(where: {email: {_iregex: $searchTerm}}) {
    id
    email
  }
}
    `;

/**
 * __useSearchUserByEmailQuery__
 *
 * To run a query within a React component, call `useSearchUserByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUserByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUserByEmailQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useSearchUserByEmailQuery(baseOptions?: Apollo.QueryHookOptions<SearchUserByEmailQuery, SearchUserByEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchUserByEmailQuery, SearchUserByEmailQueryVariables>(SearchUserByEmailDocument, options);
      }
export function useSearchUserByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchUserByEmailQuery, SearchUserByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchUserByEmailQuery, SearchUserByEmailQueryVariables>(SearchUserByEmailDocument, options);
        }
export function useSearchUserByEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchUserByEmailQuery, SearchUserByEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchUserByEmailQuery, SearchUserByEmailQueryVariables>(SearchUserByEmailDocument, options);
        }
export type SearchUserByEmailQueryHookResult = ReturnType<typeof useSearchUserByEmailQuery>;
export type SearchUserByEmailLazyQueryHookResult = ReturnType<typeof useSearchUserByEmailLazyQuery>;
export type SearchUserByEmailSuspenseQueryHookResult = ReturnType<typeof useSearchUserByEmailSuspenseQuery>;
export type SearchUserByEmailQueryResult = Apollo.QueryResult<SearchUserByEmailQuery, SearchUserByEmailQueryVariables>;
export function refetchSearchUserByEmailQuery(variables?: SearchUserByEmailQueryVariables) {
      return { query: SearchUserByEmailDocument, variables: variables }
    }
export const SearchSellerByEmailDocument = gql`
    query searchSellerByEmail($searchTerm: citext) {
  users(where: {email: {_iregex: $searchTerm}, roles: {role: {_eq: "seller"}}}) {
    id
    email
  }
}
    `;

/**
 * __useSearchSellerByEmailQuery__
 *
 * To run a query within a React component, call `useSearchSellerByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSellerByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSellerByEmailQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useSearchSellerByEmailQuery(baseOptions?: Apollo.QueryHookOptions<SearchSellerByEmailQuery, SearchSellerByEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchSellerByEmailQuery, SearchSellerByEmailQueryVariables>(SearchSellerByEmailDocument, options);
      }
export function useSearchSellerByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchSellerByEmailQuery, SearchSellerByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchSellerByEmailQuery, SearchSellerByEmailQueryVariables>(SearchSellerByEmailDocument, options);
        }
export function useSearchSellerByEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchSellerByEmailQuery, SearchSellerByEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchSellerByEmailQuery, SearchSellerByEmailQueryVariables>(SearchSellerByEmailDocument, options);
        }
export type SearchSellerByEmailQueryHookResult = ReturnType<typeof useSearchSellerByEmailQuery>;
export type SearchSellerByEmailLazyQueryHookResult = ReturnType<typeof useSearchSellerByEmailLazyQuery>;
export type SearchSellerByEmailSuspenseQueryHookResult = ReturnType<typeof useSearchSellerByEmailSuspenseQuery>;
export type SearchSellerByEmailQueryResult = Apollo.QueryResult<SearchSellerByEmailQuery, SearchSellerByEmailQueryVariables>;
export function refetchSearchSellerByEmailQuery(variables?: SearchSellerByEmailQueryVariables) {
      return { query: SearchSellerByEmailDocument, variables: variables }
    }
export const SearchSellersWithoutRestaurantDocument = gql`
    query searchSellersWithoutRestaurant($searchTerm: citext) {
  users(
    where: {_and: [{email: {_iregex: $searchTerm}}, {roles: {role: {_in: ["seller"]}}}, {_not: {restaurant: {id: {_is_null: false}}}}]}
  ) {
    id
    email
  }
}
    `;

/**
 * __useSearchSellersWithoutRestaurantQuery__
 *
 * To run a query within a React component, call `useSearchSellersWithoutRestaurantQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSellersWithoutRestaurantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSellersWithoutRestaurantQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useSearchSellersWithoutRestaurantQuery(baseOptions?: Apollo.QueryHookOptions<SearchSellersWithoutRestaurantQuery, SearchSellersWithoutRestaurantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchSellersWithoutRestaurantQuery, SearchSellersWithoutRestaurantQueryVariables>(SearchSellersWithoutRestaurantDocument, options);
      }
export function useSearchSellersWithoutRestaurantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchSellersWithoutRestaurantQuery, SearchSellersWithoutRestaurantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchSellersWithoutRestaurantQuery, SearchSellersWithoutRestaurantQueryVariables>(SearchSellersWithoutRestaurantDocument, options);
        }
export function useSearchSellersWithoutRestaurantSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchSellersWithoutRestaurantQuery, SearchSellersWithoutRestaurantQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchSellersWithoutRestaurantQuery, SearchSellersWithoutRestaurantQueryVariables>(SearchSellersWithoutRestaurantDocument, options);
        }
export type SearchSellersWithoutRestaurantQueryHookResult = ReturnType<typeof useSearchSellersWithoutRestaurantQuery>;
export type SearchSellersWithoutRestaurantLazyQueryHookResult = ReturnType<typeof useSearchSellersWithoutRestaurantLazyQuery>;
export type SearchSellersWithoutRestaurantSuspenseQueryHookResult = ReturnType<typeof useSearchSellersWithoutRestaurantSuspenseQuery>;
export type SearchSellersWithoutRestaurantQueryResult = Apollo.QueryResult<SearchSellersWithoutRestaurantQuery, SearchSellersWithoutRestaurantQueryVariables>;
export function refetchSearchSellersWithoutRestaurantQuery(variables?: SearchSellersWithoutRestaurantQueryVariables) {
      return { query: SearchSellersWithoutRestaurantDocument, variables: variables }
    }
export const SearchUserWithoutCarrierDocument = gql`
    query searchUserWithoutCarrier($searchTerm: citext) {
  users(
    where: {_and: [{email: {_iregex: $searchTerm}}, {roles: {role: {_in: ["carrier"]}}}, {_not: {carrier: {id: {_is_null: false}}}}]}
  ) {
    id
    email
  }
}
    `;

/**
 * __useSearchUserWithoutCarrierQuery__
 *
 * To run a query within a React component, call `useSearchUserWithoutCarrierQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUserWithoutCarrierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUserWithoutCarrierQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useSearchUserWithoutCarrierQuery(baseOptions?: Apollo.QueryHookOptions<SearchUserWithoutCarrierQuery, SearchUserWithoutCarrierQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchUserWithoutCarrierQuery, SearchUserWithoutCarrierQueryVariables>(SearchUserWithoutCarrierDocument, options);
      }
export function useSearchUserWithoutCarrierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchUserWithoutCarrierQuery, SearchUserWithoutCarrierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchUserWithoutCarrierQuery, SearchUserWithoutCarrierQueryVariables>(SearchUserWithoutCarrierDocument, options);
        }
export function useSearchUserWithoutCarrierSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchUserWithoutCarrierQuery, SearchUserWithoutCarrierQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchUserWithoutCarrierQuery, SearchUserWithoutCarrierQueryVariables>(SearchUserWithoutCarrierDocument, options);
        }
export type SearchUserWithoutCarrierQueryHookResult = ReturnType<typeof useSearchUserWithoutCarrierQuery>;
export type SearchUserWithoutCarrierLazyQueryHookResult = ReturnType<typeof useSearchUserWithoutCarrierLazyQuery>;
export type SearchUserWithoutCarrierSuspenseQueryHookResult = ReturnType<typeof useSearchUserWithoutCarrierSuspenseQuery>;
export type SearchUserWithoutCarrierQueryResult = Apollo.QueryResult<SearchUserWithoutCarrierQuery, SearchUserWithoutCarrierQueryVariables>;
export function refetchSearchUserWithoutCarrierQuery(variables?: SearchUserWithoutCarrierQueryVariables) {
      return { query: SearchUserWithoutCarrierDocument, variables: variables }
    }
export const UpdateVehiclesByPkDocument = gql`
    mutation updateVehiclesByPk($pk_columns: vehicles_pk_columns_input!, $_set: vehicles_set_input!) {
  update_vehicles_by_pk(pk_columns: $pk_columns, _set: $_set) {
    id
  }
}
    `;
export type UpdateVehiclesByPkMutationFn = Apollo.MutationFunction<UpdateVehiclesByPkMutation, UpdateVehiclesByPkMutationVariables>;

/**
 * __useUpdateVehiclesByPkMutation__
 *
 * To run a mutation, you first call `useUpdateVehiclesByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVehiclesByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVehiclesByPkMutation, { data, loading, error }] = useUpdateVehiclesByPkMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdateVehiclesByPkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVehiclesByPkMutation, UpdateVehiclesByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVehiclesByPkMutation, UpdateVehiclesByPkMutationVariables>(UpdateVehiclesByPkDocument, options);
      }
export type UpdateVehiclesByPkMutationHookResult = ReturnType<typeof useUpdateVehiclesByPkMutation>;
export type UpdateVehiclesByPkMutationResult = Apollo.MutationResult<UpdateVehiclesByPkMutation>;
export type UpdateVehiclesByPkMutationOptions = Apollo.BaseMutationOptions<UpdateVehiclesByPkMutation, UpdateVehiclesByPkMutationVariables>;